export interface ImCodes{
    [key: string]: string[];
}

export const IM_CODES:ImCodes={
  "0": ["Dc9","Dc8"],
  "1": ["Dbs","Dbo"],
  "2": ["Dc6","Dc4"],
  "3": ["Dcn","Dcl"],
  "4": ["DbS","DbQ"],
  "5": ["DbC","DbA"],
  "6": ["DcE","DcC"],
  "7": ["Dbw","Dbu"],
  "8": ["Daf","Dab"],
  "9": ["DbY","DbW"],
  "10": ["DcV","DcU"],
  "11": ["Dau","Dat"],
  "12": ["Dcr","Dcp"],
  "13": ["DcY","DcX"],
  "14": ["DbU","DbT"],
  "15": ["Daw","Dav"],
  "16": ["DcG","DcF"],
  "17": ["Dby","Dbx"],
  "18": ["Dad","Dac"],
  "19": ["Dba","DbZ"],
  "20": ["Dcy","Dcs"],
  "21": ["Dcx"],
  "22": ["Dc3"],
  "23": ["Dc2"],
  "24": ["Dcv"],
  "25": ["Dcu"],
  "26": ["Dc0"],
  "27": ["Dcz"],
  "28": ["Dct"],
  "29": ["Dcw"],
  "30": ["Dcf","DcZ"],
  "31": ["Dce"],
  "32": ["Dck"],
  "33": ["Dcj"],
  "34": ["Dcc"],
  "35": ["Dcb"],
  "36": ["Dch"],
  "37": ["Dcg"],
  "38": ["Dca"],
  "39": ["Dcd"],
  "40": ["DbK","DbE"],
  "41": ["DbJ"],
  "42": ["DbP"],
  "43": ["DbO"],
  "44": ["DbH"],
  "45": ["DbG"],
  "46": ["DbM"],
  "47": ["DbL"],
  "48": ["DbF"],
  "49": ["DbI"],
  "50": ["Da4","Day"],
  "51": ["Da3"],
  "52": ["Da9"],
  "53": ["Da8"],
  "54": ["Da1"],
  "55": ["Da0"],
  "56": ["Da6"],
  "57": ["Da5"],
  "58": ["Daz"],
  "59": ["Da2"],
  "60": ["DcO","DcI"],
  "61": ["DcN"],
  "62": ["DcT"],
  "63": ["DcS"],
  "64": ["DcL"],
  "65": ["DcK"],
  "66": ["DcQ"],
  "67": ["DcP"],
  "68": ["DcJ"],
  "69": ["DcM"],
  "70": ["Db6","Db0"],
  "71": ["Db5"],
  "72": ["DcB"],
  "73": ["DcA"],
  "74": ["Db3"],
  "75": ["Db2"],
  "76": ["Db8"],
  "77": ["Db7"],
  "78": ["Db1"],
  "79": ["Db4"],
  "80": ["Dan","Dah"],
  "81": ["Dam"],
  "82": ["Das"],
  "83": ["Dar"],
  "84": ["Dak"],
  "85": ["Daj"],
  "86": ["Dap"],
  "87": ["Dao"],
  "88": ["Dai"],
  "89": ["Dal"],
  "90": ["Dbi","Dbc"],
  "91": ["Dbh"],
  "92": ["Dbn"],
  "93": ["Dbm"],
  "94": ["Dbf"],
  "95": ["Dbe"],
  "96": ["Dbk"],
  "97": ["Dbj"],
  "98": ["Dbd"],
  "99": ["Dbg"],
  "100": ["Dbp"],
  "200": ["Dc5"],
  "300": ["Dcm"],
  "400": ["DbR"],
  "500": ["DbB"],
  "600": ["DcD"],
  "700": ["Dbv"],
  "800": ["Dae"],
  "900": ["DbX"],
  "1000": ["Dbt"],
  "1200": ["Dcq"],
  "2000": ["Dc7"],
  "3000": ["Dco"],
  "4000": ["DbV"],
  "5000": ["DbD"],
  "6000": ["DcH"],
  "7000": ["Dbz"],
  "8000": ["Dag"],
  "9000": ["Dbb"],
  "10000": ["DcW"],
  "15000": ["Dax"],
  "20000": ["Dc1"],
  "30000": ["Dci"],
  "40000": ["DbN"],
  "50000": ["Da7"],
  "60000": ["DcR"],
  "70000": ["Db9"],
  "80000": ["Daq"],
  "90000": ["Dbl"],
  "100000": ["Dbq"],
  "1000000": ["Dbr"],
  "10 o'clock": ["DeW"],
  "10 past 8": ["DeX"],
  "10 to 5": ["DeY"],
  "11 minutes past 5": ["Dd9"],
  "2 o'clock": ["Deg"],
  "20 past 2": ["Dee"],
  "20 to 4": ["Def"],
  "25 past 10": ["Dec"],
  "25 past 11": ["Dea"],
  "25 past 6": ["Deb"],
  "25 to 10": ["Ded"],
  "3 o'clock": ["DeZ"],
  "5 o'clock": ["DeA"],
  "5 past 12": ["DeC"],
  "5 past 6": ["DeB"],
  "5 to 12": ["DeD"],
  "6 o'clock": ["DeV"],
  "7 o'clock": ["DeU"],
  "8'clock": ["Dd8"],
  "9 o'clock": ["DeJ"],
  "a": ["DZl","DZm"],
  "a bad apple": ["D8A","D8B","D8C"],
  "a bookworm": ["D8D","D8E","D8F"],
  "a couch potato": ["D8I","D8J","D8K"],
  "a fish out of water": ["D8M","D8N","D8O"],
  "a little": ["Exw"],
  "a lot of": ["Exx"],
  "a night owl": ["D8W","D8X","D8Y"],
  "abdicate": ["AAA"],
  "abe": ["AAB"],
  "aboard": ["DRR"],
  "aboriginal": ["AAD","AAC"],
  "about": ["AAE"],
  "above": ["DdC","AAF"],
  "abroad": ["Dob"],
  "abstract": ["AAI","AAG"],
  "Abu dhabi": ["AAJ","AAL"],
  "abuse": ["AAN","AAM"],
  "acacia tree": ["AAO","AAP"],
  "academy": ["DRS","AAQ"],
  "accelerate": ["DRT","AAS"],
  "acceleration": ["AAT"],
  "accept": ["DRU","AAX","AAU","AAV","AAW"],
  "accident": ["AAY","AAZ","DRV","AAa"],
  "accommodation": ["AAb","AAc"],
  "accomodation": ["DRW"],
  "accomplish": ["AAh","AAg"],
  "accordian": ["C4b","AAl","AAj","AAk"],
  "according to": ["AAi"],
  "accordion": ["AAj","AAk","AAl","C4b"],
  "account": ["AAr","AAm","AAn"],
  "accountant": ["C4d","C4c","AAq","AAo","AAp","D8G","D8H"],
  "accumulate": ["DRX","AAt","AAs"],
  "accurate": ["AAv","AAw"],
  "accuse": ["DRZ"],
  "achieve": ["AA2","AA5","AA0","AA1"],
  "achievement": ["AA4","AA3"],
  "acid rain": ["AA6"],
  "acorn": ["AA8"],
  "acorns": ["ABB"],
  "acoustics": ["ABC"],
  "acrobat": ["ABK","DRb","ABE","ABH","ABF"],
  "acrobatics": ["ABJ"],
  "across": ["ABL"],
  "act": ["Exo"],
  "acting": ["Exn"],
  "action": ["ABM","ABQ"],
  "action figure": ["ABN"],
  "action film": ["ABO","ABP"],
  "activate": ["ABR"],
  "active": ["ABT","ABS"],
  "actor": ["ABX","ABW","ABU","ABV"],
  "actress": ["ABb","ABa","ABY","ABZ"],
  "acute": ["DRc"],
  "add": ["Dei","Eaa","Dej"],
  "add added": ["ESW","Dei","Dej"],
  "add sugar": ["Dej","Eaa"],
  "added": ["ESW"],
  "added sugar": ["ESW"],
  "addiction": ["DRd","ABf"],
  "addictive": ["ABg"],
  "adding": ["Eaa","Dei","Dej"],
  "adding sugar": ["Eaa","Dej"],
  "addition": ["ABk","ABi","ABj"],
  "address": ["DRe","ABn","ABm"],
  "adjectives": ["ABo"],
  "administrative": ["ABr","ABq"],
  "admire": ["ABt","ABs"],
  "adopt": ["ABx","ABv","ABw"],
  "adult": ["DRf","AB0","ABy","ABz"],
  "advance": ["AB2","AB1"],
  "adventure": ["DRg","AB4","AB5","AB3"],
  "advert": ["Exp"],
  "advertise": ["Dek"],
  "advertise advertised": ["EUm","Dek"],
  "advertise burgers": ["Dek"],
  "advertised": ["EUm"],
  "advertised hamburgers": ["EUm"],
  "advertisement": ["AB6","AB8"],
  "advertising": ["Dek"],
  "advertising burgers": ["Dek"],
  "aerobics": ["AB9"],
  "aeroplane": ["ACE","ACA","ACC","ACD","ACB"],
  "aerospace engineer": ["C4e","C4f"],
  "affect": ["ACK","ACG"],
  "affection": ["DRh","ACH","ACI"],
  "afford": ["DRi","ACL"],
  "Afghanistan": ["ACM","D8L"],
  "afraid": ["ACR","ACQ","ACP"],
  "Africa": ["ACV","ACS","ACT","ACU"],
  "after": ["Exq"],
  "afternoon": ["ACW"],
  "afterwards": ["Exr"],
  "again": ["ACY","ACX"],
  "against": ["DRj","ACZ","ACa"],
  "age": ["DRk","ACb"],
  "aggravated": ["DRl"],
  "agony": ["DRm","ACf","ACe"],
  "agree": ["ACg","DRo","ACi","ACm","ACh"],
  "agreement": ["ACk","ACl"],
  "aim": ["DRp","ACo","ACp","ACq"],
  "air": ["AC3","ACr","EdE","ACs"],
  "air conditioner": ["C4g","ACt","ACx","DwI","ACv","ACu","ACw"],
  "air pollution": ["AC6","AC5","C4h","AC8","C4i"],
  "airborne": ["Exs"],
  "airmail": ["Ext"],
  "airplane": ["AC2","AC1","ACy","AC0","ACz"],
  "airport": ["C4j","ADC","ADF","ADB","ADD","DwJ","ADE","AC9","ADA"],
  "airport terminal": ["ADG","ADH"],
  "airtight": ["Exu"],
  "aisle": ["ADJ"],
  "aladdin": ["ADM","ADK"],
  "alarm": ["ADN","ADP","ADT"],
  "alarm clock": ["C4k","ADQ","DwK","ADS","ADR"],
  "Albania": ["D8P"],
  "albatross": ["ADV"],
  "albert einstein": ["ADX"],
  "album": ["Exv"],
  "alcohol": ["ADb","ADc","ADZ","ADa","DRq"],
  "Algeria": ["D8Q"],
  "alien": ["ADg","DRr","ADd","ADe","ADf"],
  "aliens": ["DRs"],
  "all": ["ADx","ADh"],
  "allergic": ["ADj","ADi","DRt"],
  "allergies": ["DRu","ADl"],
  "allergy": ["ADn","ADm"],
  "alligator": ["ADo","ADq","ADr","ADp"],
  "allow": ["ADw","ADs","ADu"],
  "alone": ["DRv","ADy","ADz"],
  "along": ["DRw"],
  "aloud": ["DRx","AD0"],
  "alpaca": ["AD4","AD2","AD3"],
  "alpha": ["Doc"],
  "alphabet": ["DRy","AD6","AD5"],
  "alternative energy": ["AD8"],
  "altitude": ["DR0","AEB"],
  "always": ["AEC"],
  "am": ["Exy"],
  "amaze": ["DR1","AED"],
  "amazing": ["DR2","AEF","AEE"],
  "amazon": ["AEJ","AEH"],
  "ambassador": ["AEK"],
  "amber": ["AEN"],
  "ambitious": ["AEO"],
  "ambulance": ["C4m","AEP","DwL","AES","AEQ"],
  "ambush": ["AEU"],
  "America": ["AEp","C4p","AEY","AEZ","AEV","DwN","AEX","EPk"],
  "American": ["C4o","EeD","AEo","AEb","AEa"],
  "American flag": ["AEc"],
  "American football": ["C4n","DwM","AEi","AEd","AEe","AEf","AEg","AEh"],
  "americano": ["EgS","AEn","AEj","AEk"],
  "americano iced": ["AEl"],
  "among": ["AEq"],
  "among us": ["AEr"],
  "amphibian": ["C4q"],
  "amplitude": ["AEs"],
  "Amsterdam": ["AEw"],
  "amusement": ["DR4","AEx","AEz","AEy"],
  "amusement park": ["AE1","AE2","DR3","AE0"],
  "amusing": ["DR5","AE4"],
  "an apple a day keeps the doctor away": ["D8R"],
  "an earache": ["Dod"],
  "anaconda": ["AE5","AE7","AE8"],
  "analogy": ["AFA"],
  "ancestor": ["AFD","AFB"],
  "anchor": ["AFF","AFE","AFG"],
  "ancient": ["AFH","AFJ","AFI"],
  "and": ["Ex0","Exz"],
  "Andorra": ["AFL"],
  "angel": ["DR7","DR6","AFP","AFM","AFQ","AFN"],
  "anger": ["DR8","AFS"],
  "Angola": ["D8U"],
  "angrily": ["ERR"],
  "angry": ["C4r","DR9","D8V","AFT","AFV","AFU","AFX"],
  "angry girl": ["AFW"],
  "animal": ["AFa"],
  "animal crossing": ["AFY","AFZ"],
  "animal shelter": ["AFd","AFe"],
  "animals": ["AFb","AFf","AFc"],
  "animation": ["AFh","AFg"],
  "anime": ["AFj","AFi"],
  "ankle": ["C4s","AFk","DwO"],
  "anklet": ["AFl"],
  "announcer": ["DSA","AFo","AFm","AFn"],
  "annoy": ["DSC","AFt"],
  "annoyed": ["AFr","D8Z","C4t","AFq","DSB","AFp","AFs"],
  "annoying": ["Ex1"],
  "annual": ["Ex2"],
  "another": ["AFu"],
  "answer": ["AFv","AFx","AFz","AFw"],
  "ant": ["AGO","C4u","AF1","DwP","AF2","AF0","AF3"],
  "Antarctica": ["AF7","AF6","AF4","AF5"],
  "antelope": ["AF8","AGA","AF9"],
  "antenna": ["AGB","AGD","AGC"],
  "anthem": ["AGF","AGE"],
  "antique shop": ["AGG","AGI","AGH"],
  "antisocial": ["AGJ"],
  "antlers": ["AGN","AGK"],
  "ants": ["AGR","AGP","AGQ"],
  "anxious": ["AGT","AGS"],
  "apartment": ["AGU","AGV","AGW"],
  "apartment block": ["C4v","DwQ"],
  "ape": ["AGb","AGX","AGa"],
  "app": ["AHC","AGc","AGd"],
  "apparition": ["AGe"],
  "appear": ["Doe"],
  "appendix": ["AGg"],
  "appetizers": ["AGi","AGj","AGh"],
  "apple": ["AGk","C4x","AGx","AGl","DwS","AGn","AGp","AGm","AGo"],
  "apple juice": ["AGr","C4w","DwR","AGq","AGs"],
  "apple pie": ["AGw","AGu","AGt"],
  "apple tea": ["AG4"],
  "apple tree": ["Ex3"],
  "apples": ["C4y","AG0","EgT","AGz","AG3","AGy"],
  "applesauce": ["AG2"],
  "appliance": ["AG7","AG5"],
  "application": ["AG9","AG8","AHA","AHB"],
  "appreciate": ["AHD","DSD"],
  "apprentice": ["DSE","AHF"],
  "approach": ["AHH"],
  "apricot": ["AHI","AHK","AHJ"],
  "April": ["Dof"],
  "apron": ["C4z","AHM","DwT","AHL"],
  "aquamarine": ["AHN"],
  "aquarium": ["AHP","AHO"],
  "Arab": ["AHQ","AHT"],
  "arabesque": ["AHR"],
  "arcade game": ["DSF"],
  "archaeologist": ["DSG","AHY","AHW","AHV","AHX"],
  "archeologist": ["DSH"],
  "archery": ["C40","DSI","AHb","AHZ","DwU","AHa"],
  "architect": ["C41","C42","AHf","D8a","AHc","AHe","AHd","D8b"],
  "arctic": ["AHk","AHh"],
  "arctic fox": ["AHj","AHi"],
  "are you a student": ["D8d"],
  "are you angry": ["D8c"],
  "are you bored": ["D8e"],
  "are you cold": ["D8f"],
  "are you tired": ["D8g"],
  "Argentina": ["AHo","C44","DwV","AHn","AHl"],
  "Argentina flag": ["C43"],
  "Argentinean": ["AHp"],
  "Argentinian": ["C45","EeE"],
  "argue": ["Del","Dem","EWW","EdK"],
  "argue argued": ["Del","EUu","Dem"],
  "argue in a courtroom": ["D8i"],
  "argue with someone": ["EWW"],
  "argued": ["EUu"],
  "arguing": ["EdK","Dem","Del"],
  "argument": ["AHq","AHs","AHt","AHr"],
  "arm": ["C48","AH4","DwY","AHv","AHu"],
  "arm chair": ["AHz","AHx","AHy"],
  "armbands": ["AHw"],
  "armchair": ["C46","DwW"],
  "Armenia": ["AH3","AH0"],
  "armpit": ["C47","DwX"],
  "arms": ["C49","C5A","AH5"],
  "army": ["AH9","AH6","AH8","AH7"],
  "aroma": ["DSJ"],
  "around": ["AIF","AIE"],
  "arrange": ["Den","EWX","AIK","AIG","AIH"],
  "arrange arranged": ["Den"],
  "arrange flowers": ["D8j","Den"],
  "arrange some flowers": ["EWX"],
  "arrangement": ["AIJ"],
  "arranging": ["Den"],
  "arranging flowers": ["Den"],
  "arrest": ["Deo","AIO","EWY","AIL"],
  "arrest arrested": ["Deo"],
  "arrest criminals": ["D8k"],
  "arrest someone": ["EWY","Deo"],
  "arrested": ["AIN"],
  "arresting": ["Deo"],
  "arresting someone": ["Deo"],
  "arrival": ["AIP"],
  "arrive": ["Deq","Dep","EWZ"],
  "arrive arrived": ["Dep","Deq"],
  "arrive at the station": ["Dep","EWZ"],
  "arrived": ["DSK"],
  "arriving": ["Dep","Deq"],
  "arriving at the station": ["Dep"],
  "arrogance": ["DSL","AIR","AIQ"],
  "arrogant": ["DSM","AIT","AIS"],
  "arrow": ["AIY","AIW","AIX","AIU","DSN"],
  "art": ["C5D","AIZ","Dwa","AIb","AIu","AIa"],
  "art class": ["Ex4"],
  "art gallery": ["AIg","AIe","AIf"],
  "art room": ["Dog"],
  "artery": ["AId"],
  "artichoke": ["AIj","AIi","AIh"],
  "article": ["AIm","AIk","AIl"],
  "articles": ["AIn"],
  "artist": ["C5C","DSP","D8l","C5B","AIt","D8m","AIq","AIo","AIp"],
  "artistic": ["DSO"],
  "artwork": ["AIw","AIx"],
  "as hard as nails": ["D8n","D8o","D8p"],
  "as old as the hills": ["D8q","D8r","D8s"],
  "as usual": ["AKK","AKL"],
  "as white as snow": ["D8w","D8x","D8y"],
  "ashamed": ["AI0","AI2","AIz"],
  "ashma": ["DSQ"],
  "Asia": ["AI8","AI9","AI3","AI4"],
  "asiatic lion": ["AJA"],
  "ask": ["Des","Der","Ebw","AJB","EWa","AJF"],
  "ask a question": ["Der","Ebw","EWa"],
  "ask asked": ["ETj","Der","Des"],
  "ask for help": ["AJE"],
  "asked": ["ETj","AJD"],
  "asked a question": ["ETj"],
  "asking": ["Ebw","Des","Der"],
  "asking a question": ["Ebw","Der"],
  "asleep": ["AJG","AJJ","AJI","AJH"],
  "asparagus": ["AJL","AJM","AJK"],
  "aspirin": ["AJP","AJN","AJO"],
  "assemble": ["AJQ","AJS","AJU","AJT"],
  "assets": ["AJX","AJV","AJW"],
  "assign": ["AJa"],
  "assignment": ["AJZ","AJY"],
  "assist the boss": ["D8t"],
  "assistance": ["AJb","AJc"],
  "assistant": ["AJf","AJh","AJi","AJg","AJe"],
  "asteroid": ["AJn","AJk","AJo","AJj","AJl","AJm"],
  "asthma": ["AJs","DSR","AJp"],
  "astonish": ["DST"],
  "astonished": ["AJz","DSS","AJx"],
  "astonishment": ["AJ1"],
  "astound": ["AJ4","AJ3"],
  "astronaut": ["C5F","AKC","AJ5","D8v","AJ7","D8u","AJ8","AKB","C5E","AJ6","AJ9","AKA"],
  "astronomer": ["AKE","AKD"],
  "astronomy": ["DSU"],
  "at": ["AKz","AKM"],
  "at home": ["AKa","AKb","AKc"],
  "at night": ["AKx","AKt","AKv","AKy"],
  "at risk": ["AK0","AK1"],
  "at school": ["AK4","AK2","AK6","AK3","AK5"],
  "at the back": ["DdD","Edp"],
  "at the back of the queue": ["Edp"],
  "at the beach": ["ALO"],
  "at the front": ["DdE","Edq"],
  "at the front of the plane": ["Edq"],
  "at the mall": ["ALR"],
  "at the museum": ["ALS"],
  "at your wits end": ["D82","D83","D84"],
  "ate": ["ETk"],
  "ate pizza": ["ETk"],
  "athlete": ["C5H","AKO","C5G","AKP","AKT","D8z","AKR","AKN"],
  "athletic": ["DSV","D81","AKW","AKX","AKU"],
  "athletics": ["AKZ","AKY"],
  "atlas": ["AKf","AKg"],
  "atm": ["C5I","AKs","AKj","Dwb","AKk","AKm"],
  "atmosphere": ["AKn","AKo","AKp","AKr"],
  "attach": ["ALE","AK8","AK9"],
  "attachment": ["ALD"],
  "attack": ["ALG","ALF","ALH","ALI"],
  "attend": ["ALK"],
  "attendance": ["ALJ"],
  "attention": ["ALM","ALN"],
  "attic": ["ALU","ALT","ALX","ALV","ALW"],
  "attitude": ["ALY","ALZ"],
  "attract": ["ALb","ALc","ALj"],
  "attraction": ["Ex5"],
  "attractive": ["ALe","ALi","ALf","ALd","ALg","ALh"],
  "au pair": ["DSY"],
  "auction": ["ALm"],
  "audience": ["ALp","ALo","ALn"],
  "auditorium": ["Doh"],
  "August": ["Doi"],
  "aunt": ["DZK","DSX","ALr","D85","ALq"],
  "auntie": ["DSW"],
  "aurora": ["ALv"],
  "Australia": ["AL4","C5L","ALw","ALz","AL2","AL0","D86","Dwc","AL1"],
  "Australia and Oceania": ["AL3"],
  "Australia flag": ["C5J"],
  "Australian": ["C5K","EeF"],
  "Austria": ["AL9","AL6","AL7"],
  "author": ["C5N","C5M","AMC","D88","D89","AMD"],
  "authority": ["AME","AMG"],
  "automatically": ["AMK"],
  "automobile": ["AMN"],
  "autumn": ["AMU","AMT","AMR","AMO","AMP","AMS","AMQ"],
  "avalanche": ["AMX","AMZ","AMW","AMV","AMY"],
  "avocado": ["C5O","AMd","AMb","AMc","Dwd","AMa"],
  "avocado smoothie": ["AMf"],
  "avocados": ["EgU"],
  "avoid": ["DSZ"],
  "awake": ["DSa"],
  "aware": ["DSb"],
  "awe inspiring": ["DSc","AMg","AMh"],
  "awesome": ["DSd","AMj"],
  "awful": ["AMl","AMk","DSe","AMm"],
  "awkward": ["AMn"],
  "ax": ["Ex6"],
  "axe": ["C5P","AMq","AMs","AMr","AMt","AMu"],
  "axis": ["AMy","AMw"],
  "Azerbaijan": ["AM2","AMz"],
  "b": ["DZn","DZo"],
  "babies": ["Doj"],
  "baboon": ["AM5","DSf","AM4","AM3"],
  "baby": ["DSg","ANG","AM8","AM6","AM7","AM9"],
  "baby bottle": ["AND","ANA","ANB","ANC"],
  "baby brother": ["Dok"],
  "baby cat": ["ANE"],
  "baby dog": ["ANF"],
  "baby sister": ["Dol"],
  "babysitter": ["ANI","ANH"],
  "back": ["ANK","ANJ","ANb"],
  "back to school": ["DSj","ANh","ANg"],
  "backache": ["DSh","ANL","ANM","ANO","ANN"],
  "background": ["DSi","ANQ","ANS","ANR"],
  "backpack": ["C5R","C5Q","Dwf","ANV","Dwg","ANW","ANY","ANZ","ANa","ANT","ANX","ANU"],
  "backstage": ["ANf","ANc"],
  "backwards": ["ANl","ANj","ANi"],
  "backyard": ["ANp","ANm","ANn","ANo"],
  "bacon": ["C5S","ANs","ANq","Dwh","ANt","ANr"],
  "bacteria": ["ANu","ANx"],
  "bad": ["AOM","AN1","ANy","D9A","AN3","AN0","ANz","AN2"],
  "bad news": ["AOL"],
  "bad temper": ["AON"],
  "badge": ["AN9","AN6","AN5","AN7","AN4","AN8"],
  "badges": ["AOC","AOB","AOA"],
  "badly": ["ERL"],
  "badminton": ["C5T","AOJ","Dwi","AOG","AOI","AOF","AOD","AOE","AOH"],
  "bag": ["AOS","C5Y","C5U","Dwj","AOR","AOO","AOU","AOP","AOk","AOQ","AOT"],
  "bag of chips": ["AOh"],
  "bag of flour": ["AOi","AOj"],
  "bagel": ["AOV","C5V","AOZ"],
  "bagels": ["AOb"],
  "baggage": ["AOc","AOg","AOd"],
  "baggage claim": ["AOf"],
  "baggage handler": ["C5W"],
  "baguette": ["C5Z","Dwk"],
  "Bahrain": ["AOo"],
  "bake": ["AOv","AOp"],
  "bake cookies": ["AOq"],
  "baked potato": ["AOs","AOt","AOu"],
  "baker": ["C5b","AOz","D9E","Dwl","AOy","AO0","D9D","AOx","C5a","AO1","AOw"],
  "baker's": ["AO2","C5c","AO7"],
  "bakery": ["C5c","AO7","AO3","AO4","AO5","AO6"],
  "baking": ["Ex7"],
  "baking cookies": ["AO8"],
  "balance": ["APB","AO9","APA"],
  "balcony": ["APJ","APK","APF","APH","API","APG"],
  "bald": ["APM","APP","APL","APN","APO"],
  "ball": ["APt","C5e","APQ","Dwn","APT","APV","APR","APS","APU"],
  "ballerina": ["APb","APY","APW","APX","APa"],
  "ballet": ["APf","APd","APi","APc","APe"],
  "ballet classes": ["APg","APh"],
  "balloon": ["C5d","Dwm","APl","APj","APo","APk","APn","APm"],
  "balloons": ["APp","APq","APr","APs"],
  "balls": ["APu","APv"],
  "bambi": ["AP0"],
  "ban": ["ARB","AP3","AP2","AP4","AP1","AP5"],
  "banana": ["C5g","AP8","AQB","EgV","AQA","AP6","AP7","AP9"],
  "banana milkshake": ["C5f"],
  "bananas": ["C5h","AQE","Dwo","AQC","AQG","AQF","AQH","AQD"],
  "band": ["AQK","AQI","AQJ","AQS","AQL","AQM"],
  "band aid": ["C5j"],
  "bandage": ["C5i","AQQ","AQP","Dwp","AQR","AQO"],
  "bangers and mash": ["AQT"],
  "Bangladesh": ["AQZ"],
  "bangle": ["AQa"],
  "bangles": ["AQf","AQe"],
  "banjo": ["AQg","AQj","C5k","AQi"],
  "bank": ["AQ4","AQm","AQl","AQp","AQn","AQo","AQq","AQr"],
  "bank account": ["AQw","DSk","AQs"],
  "bank robbers": ["DSm"],
  "banknote": ["AQ1","AQ3","AQ2","AQz"],
  "bankrupt": ["DSn","AQ7","AQ5","AQ6"],
  "banner": ["ARA","AQ9","AQ8"],
  "baozi": ["ARD"],
  "bar": ["Dom"],
  "barbecue": ["ARM","ARF","ARJ","C5l","ARE","ARI","ARK","ARL","ARH"],
  "barbeque": ["ARE","C5l","ARM","ARF","ARH","ARI","ARJ","ARK","ARL"],
  "barber": ["ARP","ARO","ARN"],
  "barbers": ["ARQ"],
  "barbershop": ["ART"],
  "barcode": ["ARV","ARX"],
  "barefooted": ["ARY","ARb"],
  "bargain": ["ARc","ARe"],
  "barista": ["D9G","D9H","C5n","C5m"],
  "bark": ["ARk","ARg","ARh","ARf"],
  "barking": ["ARj"],
  "barley": ["ARm"],
  "barman": ["Dwt"],
  "barn": ["ARp","ARr","ARu","ARq","ARt","ARs"],
  "barrel": ["AR0"],
  "barren": ["AR4"],
  "barrister": ["AR8","AR5","AR6","AR7"],
  "bartender": ["D9I","AR9","ASA","ASC"],
  "base": ["ASa"],
  "baseball": ["C5q","ASS","ASF","Dwu","ASG","ASJ","ASI"],
  "baseball cap": ["ASM","ASP","ASL","ASK","ASN","ASO"],
  "baseball field": ["ASQ","ASR"],
  "baseball player": ["Ex8"],
  "baseball stadium": ["ASU"],
  "basement": ["ASZ","ASX","ASV","ASW","ASY"],
  "basil": ["ASg","ASc","ASf"],
  "basin": ["Ex9"],
  "basket": ["C5s","ASv","Dww","ASh","ASi","ASj","ASl","ASk","ASm"],
  "basketball": ["C5r","ASp","ASo","ASu","Dwv","ASt","ASq","ASr","ASs","ASn"],
  "basketball player": ["EyA"],
  "bass": ["ASz"],
  "bassoon": ["ASy"],
  "bat": ["AS0","C5v","AS2","ATQ","Dwx","AS5","AS6","AS3","AS4","AS1"],
  "bath": ["C5t","ATF","AS9","AS8","AS7"],
  "bathe": ["ATC","ATB","ATD"],
  "bathroom": ["C5u","ATM","ATJ","ATI","ATK","ATH","ATL","ATG"],
  "bathtub": ["ATP","ATO","ATN"],
  "batman": ["Don"],
  "bats": ["D9K"],
  "batteries": ["ATS","ATT","ATR"],
  "battery": ["ATY","C5w","ATU","ATX","Dwy","ATW"],
  "battle": ["ATc","ATb","ATZ","ATa"],
  "baubles": ["ATh","ATg","ATf","ATe"],
  "bay": ["ATl","ATi","ATj","ATk"],
  "bbq": ["C5l","ARM","ARE","ARF","ARH","ARI","ARJ","ARK","ARL"],
  "be a dinosaur": ["D9N"],
  "be a pig": ["D9R","D9S","D9T"],
  "be a superstar": ["D9V","D9W"],
  "be all ears": ["D9O","D9P","D9Q"],
  "be been": ["EVP","EVQ"],
  "be happy": ["Det"],
  "be in charge of a sports match": ["D9Y"],
  "be on time": ["AW4"],
  "be quiet": ["AW6","AW7","Ehy"],
  "be the boss of a company": ["D9a"],
  "be unhappy": ["Deu"],
  "be was": ["EUW","Det"],
  "be were": ["EVF"],
  "beach": ["C5x","AT2","ATq","DvN","ATm","ATp","ATo","ATn"],
  "beach ball": ["ATr","ATv","ATu","ATs","ATt"],
  "beach bucket": ["ATw"],
  "beach chair": ["ATx","ATz"],
  "beach mat": ["AT1"],
  "beach towel": ["AT5","AT3"],
  "beach umbrella": ["AT6","AT7","AT9","AUA"],
  "beads": ["AUC","AUB","AUF","AUD","AUE"],
  "beagle": ["AUG"],
  "beak": ["C5y","AUL","AUI","AUK"],
  "bean": ["Doo"],
  "bean sprouts": ["AUY","AUb"],
  "beanbag": ["AUN"],
  "beanie": ["AUQ","AUP","AUO"],
  "beans": ["C50","AUW","AUV","AUU","AUX","AUR","AUS","AUT"],
  "beans on toast": ["C5z"],
  "bear": ["C52","AUn","Dw0","AUc","AUg","AUd","AUh","AUf","AUe"],
  "beard": ["C51","AUl","Dwz","AUk","AUj","AUm","AUi"],
  "bears": ["AUp","AUo"],
  "beast": ["AUs","AUq"],
  "beat": ["AUv","AUw","AUx","AUt","AUu"],
  "beautiful": ["AU2","C53","D9X","AUy","AUz","AU0","AU4","AU1"],
  "beautifully": ["AU3","ERD"],
  "beauty": ["AU8","AU5"],
  "beauty contest": ["AU7"],
  "beauty salon": ["AU9","AVB"],
  "beaver": ["AVD","AVI","AVG","AVE","AVF"],
  "because": ["EyB"],
  "become": ["AVJ"],
  "bed": ["C54","Dw1","AVM","AVO","AVP","AVS","AVL","AVN","AVK"],
  "bed and breakfast": ["AVQ","AVR"],
  "bedroom": ["C55","AVU","AVW","AVV","AVT"],
  "bedside table": ["AVa","AVX","AVY","AVZ"],
  "bedtime": ["AVe","AVc","AVd"],
  "bee": ["C57","AVh","AVt","AVg","Dw3","AVj","AVi","AVk","AVl","AVf"],
  "beef": ["C56","EgW","AVo","AVs","AVm","AVp","AVr","AVn","AVq"],
  "been": ["EVm","EVP","EVQ","EVR"],
  "been a policeman": ["EVP"],
  "been scuba diving": ["EVm"],
  "been sick": ["EVQ"],
  "been to america": ["EVR"],
  "beer": ["AVw","AVy","AVu","AVx","AVz"],
  "bees": ["AV2","AV0","AV1"],
  "beetle": ["C58","AV7","Dw4","AV3","AV5","AV4"],
  "beetroot": ["AV8"],
  "beetroots": ["AWB","AV9","AWA"],
  "before": ["EyC"],
  "beggar": ["AWD","AWE"],
  "begin": ["AWI","AWH"],
  "behind": ["DdF","DdH","DdG","Eds","Edr","AWJ"],
  "behind the bush": ["Edr"],
  "behind the tree": ["Eds"],
  "beige": ["C59","AWL"],
  "beijing": ["AWP","AWN","AWO"],
  "being happy": ["Det"],
  "being polite": ["Dop"],
  "being unhappy": ["Deu"],
  "Belgium": ["AWT","AWQ","AWR"],
  "believe": ["AWV","AWU"],
  "bell": ["AWb","AWY","AWW","AWX","AWZ"],
  "bell pepper": ["Egz"],
  "bell peppers": ["C6A","D3y"],
  "bellboy": ["AWa"],
  "bells": ["AWc"],
  "belly": ["C6C","Dw6","AWf","AWd","AWe"],
  "belly button": ["C6B"],
  "below": ["AWj","AWg","AWh"],
  "belt": ["C6D","AWn","Dw7","AWl","AWm","AWk"],
  "beluga": ["AWo"],
  "bench": ["C6E","AWr","AWw","Dw8","AWu","AWs","AWx","AWv"],
  "bend": ["Doq"],
  "benefit": ["AWy"],
  "benefits": ["AWz"],
  "bengal fox": ["AW0","AW1"],
  "bengal tiger": ["AW3"],
  "berries": ["AXB","AW9","AW8"],
  "berry": ["AXD","AXC"],
  "beside": ["EyD"],
  "best": ["AXE","AXF","AXM"],
  "best friend": ["AXG","AXH"],
  "best friends": ["AXK"],
  "bet": ["AXN","AXP"],
  "betray": ["AXR"],
  "better": ["C6F","ERw","AXS"],
  "between": ["DdI","DdJ","Edt"],
  "between the earth and the sun": ["Edt"],
  "beverage": ["AXV","AXT"],
  "beverages": ["DSo"],
  "Bhutan": ["AXb","AXX"],
  "bib": ["Dor"],
  "bicycle": ["AXd","AXf","AXe","AXc"],
  "big": ["C6K","C6G","D9b","EhE","AXv","EhF"],
  "big ben": ["Dos"],
  "big brother": ["AXg","AXh"],
  "big buddha": ["AXi","AXj"],
  "big dog": ["AXl"],
  "big ears": ["AXm","AXn"],
  "big elephant": ["AXr"],
  "big eyes": ["AXt","AXu"],
  "big sister": ["AXw"],
  "big teeth": ["AXx"],
  "big toe": ["C6L"],
  "big wheel": ["AXz"],
  "bigger": ["C6J","C6H","EgP","C6I"],
  "bike": ["C6M","Dw9","AYD","AX0","AX3","AX4","AX2","AX1"],
  "bike lock": ["AX5","AX6","AX7","AX8"],
  "bike path": ["AX9","AYB"],
  "bike rack": ["AYE","AYF","AYG"],
  "bike rides": ["AYH"],
  "bikini": ["AYL","AYN","AYJ","AYM"],
  "bill": ["Dot"],
  "billboard": ["C6N"],
  "bin": ["C6O","AYR","AYY","AYO","AYP","DxB","AYQ"],
  "bin bag": ["AYS"],
  "binoculars": ["AYX","AYV","AYW","AYU"],
  "biodiversity": ["AYZ","AYa"],
  "biography": ["Dou"],
  "biology": ["C6P","AYd","AYc","DxC","AYb"],
  "bionic": ["AYg","AYe","AYf"],
  "birch": ["AYh"],
  "bird": ["C6Q","AYj","DxD","AYu","C6R","AYn","AYi","AYl","AYm","AYk"],
  "bird bath": ["AYp"],
  "bird house": ["AYs","AYt"],
  "bird table": ["AYy"],
  "birds": ["AYv","D9c","AYx","AYw"],
  "birth": ["AY8"],
  "birthday": ["AY1","AYz","AY0","AY3","AY7","AY2"],
  "birthday cake": ["Dov"],
  "birthday card": ["AY4","AY5"],
  "birthday hat": ["AY6"],
  "birthday party": ["C6S"],
  "birthplace": ["EyE"],
  "biscuit": ["AZB","AY9","AZA"],
  "biscuits": ["AZD","C6T","AZC","AZE"],
  "bison": ["AZJ","AZF"],
  "bit": ["ESX"],
  "bit me": ["ESX"],
  "bitcoin": ["AZK"],
  "bite": ["Dew","AZO","AZL","AZN","Dev","EdC"],
  "bite bit": ["Dew","Dev","ESX"],
  "bite someone": ["EdC","Dew"],
  "bite someones head off": ["D9d","D9e","D9f"],
  "biting": ["Dew","EdC","Dev"],
  "biting someone": ["Dew"],
  "bitter": ["AZR","AZQ","AZP"],
  "black": ["C6f","AZS","AZl"],
  "black and blue": ["C6U"],
  "black and orange": ["C6V"],
  "black and pink": ["C6W"],
  "black and red": ["C6X"],
  "black and white": ["C6Y"],
  "black and yellow": ["C6Z"],
  "black bird": ["AZX","AZZ","AZY"],
  "black cat": ["AZc","D9g"],
  "black coffee": ["C6b"],
  "black currant": ["AZe"],
  "black dress": ["Ef4"],
  "black eye": ["C6d"],
  "black gloves": ["EgE","C6e"],
  "black hair": ["AZh"],
  "black panther": ["AZk"],
  "black widow": ["AZm"],
  "blackbeard": ["AZT"],
  "blackberry": ["AZV","AZU","AZW"],
  "blackboard": ["AZa","C6a","AZb","DxE"],
  "blade": ["AZr","AZq","AZp"],
  "blame": ["AZv","AZs","AZt","AZu"],
  "blanket": ["AZx","AZy","AZw"],
  "blast": ["AZ2","AZ0","AZ1"],
  "blaze": ["AZ5","AZ3"],
  "blazer": ["C6g","DxG"],
  "blender": ["AZ6","AaA","AZ8","AZ9","AZ7"],
  "blew": ["EUj"],
  "blew air": ["EUj"],
  "blind": ["AaF","AaB","AaC","AaD"],
  "blink": ["AaG","AaH"],
  "blizzard": ["C6i","AaK","AaL","AaI","AaJ"],
  "block": ["AaR","AaM","AaN","Dex","AaO","AaP"],
  "block blocked": ["Dex"],
  "block of flats": ["AaQ"],
  "block the sun": ["Dex"],
  "blocking": ["Dex"],
  "blocking the sun": ["Dex"],
  "blocks": ["AaT","AaS"],
  "blog": ["AaV","AaW","AaU"],
  "blond": ["AaY","AaZ","AaX","Dow"],
  "blond hair": ["EyG"],
  "blonde": ["EyF"],
  "blonde hair": ["EyF"],
  "blood": ["Aaa","Aad","Aab","Aac"],
  "blood pressure": ["Aae","Aaf"],
  "blood test": ["Aag"],
  "bloom": ["Aaj","Aai","Aah"],
  "blossom": ["Aal","Aak"],
  "blouse": ["C6j","Aam","Aan","DxH","Aao"],
  "blow": ["Dey","Dez","Ebx","EWd"],
  "blow air": ["Dey","EWd"],
  "blow blew": ["Dey","EUj","Dez"],
  "blow bubbles": ["Aap","Aaq"],
  "blow nose": ["Ebx"],
  "blow your nose": ["Dez"],
  "blowfish": ["Aat","Aar","Aas"],
  "blowing": ["Dez","Ebx","Dey"],
  "blowing air": ["Dey"],
  "blowing your nose": ["Dez"],
  "blue": ["C6q","Aa4","Aau","EhG","EhH"],
  "blue and green": ["C6k"],
  "blue and white": ["C6l"],
  "blue bird": ["Aa0"],
  "blue coats": ["EgF","C6n"],
  "blue eyes": ["Aa3","Aa1","Aa2"],
  "blue hair": ["EhH","EhG"],
  "blue hat": ["C6o","Ef5"],
  "blue pants": ["C6p","EgG"],
  "blue whale": ["Aa7","Aa5","Aa6","Aa9"],
  "blueberries": ["C6m","Aav","Aay","Aax","Aaw"],
  "blueberry": ["Aaz"],
  "blurred": ["AbB"],
  "blushing": ["AbD","AbE","AbC"],
  "boar": ["AbF","AbW"],
  "board": ["AbM","AbL","AbJ","AbV","AbK","AbI"],
  "board game": ["C6r","AbN","AbO","AbP","AbQ"],
  "boarding pass": ["AbS","AbT","DSp","AbR"],
  "boarding school": ["DSq","AbU"],
  "boat": ["C6s","Abd","DxI","Abc","Abb","AbX","AbZ","Aba","AbY"],
  "bobble hat": ["Abe","Abf","Abh","Abi"],
  "body": ["C6t"],
  "body language": ["Abl"],
  "bodyguard": ["Abj","Abk"],
  "boil": ["De0","Abt","EdJ","Abm","EWf"],
  "boil boiled": ["EUr","De0"],
  "boil water": ["EWf","De0"],
  "boiled": ["EUr"],
  "boiled egg": ["Abn","Abo","Abr","Abp","Abq"],
  "boiled eggs": ["C6u","DxJ"],
  "boiling": ["C6w","C6v","De0","Abs","EdJ"],
  "boiling water": ["De0"],
  "bolt": ["Abx","Abv","Abu","Abw"],
  "bone": ["Ab0","Aby","Abz"],
  "bones": ["C6y","Ab1","Ab2","DxL"],
  "bonfire": ["Ab5","Ab3","Ab4"],
  "book": ["C60","DxN","Ab7","Ab8","AcA","Ab6","AcJ","Ab9","AcB"],
  "book bag": ["AcC"],
  "book shelf": ["AcN","AcP","AcM","AcO"],
  "book shelves": ["AcQ","AcR","AcS"],
  "bookcase": ["C6z","DxM","AcI","AcD","AcG","AcE","AcH"],
  "books": ["C61","AcY","DxO","AcK","AcL"],
  "bookshelf": ["Dox"],
  "bookshop": ["AcX","AcU","AcW","AcV","AcT"],
  "bookstore": ["Acc","Acb","Aca","AcZ"],
  "boom": ["Ach"],
  "boomerang": ["Ace","Acg"],
  "boot": ["Acj","Ack","Aci","Acr"],
  "booth": ["Acq","Acp","Aco"],
  "boots": ["C62","Acx","DxP","Acu","Acv","Acw","Acy","Acs","Act"],
  "bored": ["C63","Ac0","Acz","Ac3","D9h","Ac1","Ac2"],
  "boring": ["Ac6","D9i","Ac5","Ac4"],
  "born": ["Ac8","Ac7"],
  "borrow": ["De1","De2","EWg","AdA","AdB","Ac9"],
  "borrow a book": ["De1","EWg"],
  "borrow a pen": ["De2"],
  "borrow borrowed": ["De1","De2"],
  "borrowing": ["De2","De1"],
  "borrowing a book": ["De1"],
  "borrowing a pen": ["De2"],
  "Bosnia": ["AdF","AdD"],
  "Bosnia and Herzegovina": ["D9k"],
  "boss": ["Doy"],
  "bossy": ["EyI","EyH"],
  "both": ["AdG"],
  "bottle": ["C65","AdO","AdJ","AdI","DxR","AdK","AdH"],
  "bottle of ketchup": ["AdL"],
  "bottle of water": ["AdM","AdN"],
  "bottle opener": ["C64"],
  "bottled water": ["EyJ"],
  "bottles": ["AdQ","AdR","AdS"],
  "bottom": ["DdK"],
  "bought": ["ESf","EWL"],
  "bought a tv": ["EWL"],
  "bought some groceries": ["ESf"],
  "boulder": ["AdW"],
  "bounce": ["AdX","AdY"],
  "bouquet": ["Ada","DSr","Adb"],
  "boutique": ["Adc"],
  "bow": ["Adf","Ade","Add","Adv"],
  "bow tie": ["C68","DxU"],
  "bowl": ["Adu","C67","Adg","DxT","Adi","Adh","De3","Adj","Adk","Eab"],
  "bowl bowled": ["De3"],
  "bowl of soup": ["Adr","Ads"],
  "bowl of strawberries": ["Adt"],
  "bowling": ["C66","Adm","De3","Adq","Eab","Adn","DxS"],
  "bowling alley": ["Ado","Adp"],
  "box": ["C7A","DxW","Ady","Adw","Ad5","Adx","Adz"],
  "boxer": ["Ad1"],
  "boxes": ["Doz"],
  "boxing": ["C69","Ad4","DxV","Ad3","Ad2"],
  "boy": ["AeE","Ad6","Ad7","Ad8"],
  "boy scout": ["AeG","AeH"],
  "boyfriend": ["DZL","AeA","AeD","Ad9","AeB","AeC"],
  "boys": ["AeI","AeF"],
  "bracelet": ["AeN","C7B","AeJ","AeM","DxX","AeK","C7C"],
  "bragging": ["DSs"],
  "braids": ["DSt","AeP"],
  "brain": ["DSu","AeR","AeW","AeT","AeV","AeU","AeS"],
  "brake": ["AeX","Aea","AeZ"],
  "branch": ["DSv","Aej","Aeb","Aef","Aee","Aec","Aeg"],
  "branches": ["Aei","Aeh"],
  "brave": ["Aem","Aek","Ael","Aeq"],
  "bravely": ["Aen","Aep","Aeo"],
  "Brazil": ["C7F","Aeu","D9m","DxY","Aes","Aer","Aet"],
  "Brazil flag": ["C7D"],
  "Brazilian": ["C7E","EeG"],
  "bread": ["C7G","Aev","DxZ","Aez","C7H","Aey","Aex","Aew"],
  "bread roll": ["Ae0"],
  "bread rolls": ["C7I"],
  "breadwinner": ["EyK"],
  "break": ["De7","De4","De5","Ae1","Ae4","AfK","Ae2","Ae3"],
  "break a cup": ["De4"],
  "break a window": ["De5"],
  "break broke": ["ESg","De5","De7","De4"],
  "break broken": ["EVd","EVV"],
  "break down": ["De6","Ae6","D9n"],
  "break down broke down": ["De6"],
  "break into": ["AfI","AfJ"],
  "break up": ["De8","D9o"],
  "break up broke up": ["De8"],
  "breaker": ["Ae7"],
  "breakfast": ["Ae8","AfF","Ae9","AfE","AfA","AfD","AfC","AfB"],
  "breaking": ["De7","De4","De5"],
  "breaking a cup": ["De4"],
  "breaking a window": ["De5"],
  "breaking down": ["De6"],
  "breaking news": ["AfG","AfH"],
  "breaking up": ["De8"],
  "breath": ["DSx"],
  "breathe": ["AfM","DSw","AfN","AfO","AfL"],
  "breathtaking": ["AfQ"],
  "breed": ["AfS","AfT"],
  "breeze": ["AfV","AfW","AfU"],
  "breezy": ["EyL"],
  "brick": ["AfY","Afa","AfX","AfZ"],
  "bricks": ["Afc","Afb"],
  "bride": ["Do0"],
  "bridge": ["Afi","Aff","C7J","Afg","Afh","Dxb","Afe","Afd"],
  "briefcase": ["Afj","C7L","C7K","Afn","Afl","Afm"],
  "bright": ["C7N","Afo","D9p","Afp","EhI"],
  "brighter": ["C7M"],
  "bring": ["EyN","EyM"],
  "Britain": ["Afu"],
  "British": ["Afv","Afw"],
  "British pound": ["Afx","Afy"],
  "brittle": ["Af0","Afz"],
  "broadband": ["Af2","Af1"],
  "broccoli": ["Af9","Af3","C7O","Dxd","Af5","Af7","Af6","Af4","Af8"],
  "brochure": ["AgB","AgC","AgA"],
  "broke": ["ESg","AgM","AgD","AgE"],
  "broke a mug": ["ESg"],
  "broken": ["C7R","EhJ","EhK","EVV","EVd","AgF","AgL"],
  "broken arm": ["C7P","EhK","Dxe","AgH"],
  "broken his arm": ["EVd"],
  "broken leg": ["AgK","C7Q","Dxf","AgJ"],
  "broken the window": ["EVV"],
  "brontosaurus": ["AgO","AgN"],
  "bronze": ["AgR","AgP"],
  "broom": ["C7T","AgT","AgV","Dxg","AgX","AgU","AgW"],
  "broomstick": ["AgZ","AgY"],
  "brother": ["DZM","Agd","Aga","Agc","D9s","Agb","D9r"],
  "brothers": ["Agf","Age","Agg"],
  "brow": ["Agq","Agj"],
  "brown": ["C7Y","Agp"],
  "brown belt": ["C7U","Ef6"],
  "brown coat": ["C7V","Ef7"],
  "brown eyes": ["Agl","Agm","Agk"],
  "brown hair": ["Ago","Agn"],
  "brown pants": ["EgH","C7X"],
  "brownies": ["C7W","EgY"],
  "browse": ["De9","Ags","EWi"],
  "browse browsed": ["De9"],
  "browse the Internet": ["EWi","De9"],
  "browsing": ["De9"],
  "browsing the Internet": ["De9"],
  "bruise": ["Agt"],
  "Brunei": ["Agx","Agu"],
  "brush": ["DfB","DfA","Agz","Ag2","DfC","Eac","EWj","Eby"],
  "brush brushed": ["DfB","EVl","ETl","DfA","DfC"],
  "brush hair": ["Ag0","Ag1","Eby"],
  "brush my hair": ["EyO"],
  "brush my teeth": ["Do1"],
  "brush teeth": ["Eac","Ag6","Ag4","Ag3","Ag7","Ag5"],
  "brush your hair": ["DfB"],
  "brush your teeth": ["DfC","EWj"],
  "brushed": ["ETl","EVl"],
  "brushed her hair": ["ETl"],
  "brushed her teeth": ["EVl"],
  "brushing": ["DfB","Eac","DfA","Eby","DfC"],
  "brushing your hair": ["DfB"],
  "brushing your teeth": ["DfC"],
  "bubble": ["AhA","Ag8","Ag9"],
  "bubble tea": ["AhH","AhF","AhG","AhI"],
  "bubbles": ["AhD","AhC","AhE"],
  "bucket": ["C7Z","AhN","Dxh","AhK","AhL","AhJ"],
  "bucket and spade": ["AhM"],
  "bud": ["EyP"],
  "buddhism": ["AhP"],
  "budget": ["AhU","AhS"],
  "budgie": ["AhW","AhX","AhV"],
  "buffalo": ["Aha","Ahb","AhZ","AhY"],
  "buffalo wings": ["Ahc"],
  "bug": ["Ahe","Ahg","Ahf"],
  "bug spray": ["Ahh"],
  "build": ["DfG","Ead","DfD","DfE","DfF","Ahs","Ahk","EWl","Ahj","EWk"],
  "build a building": ["D9u"],
  "build a nest": ["DfD","EWk"],
  "build a robot": ["EWl","DfE"],
  "build a snowman": ["DfF"],
  "build a wall": ["DfG","Ead"],
  "build built": ["ESh","DfF","DfD","DfE","DfG"],
  "builder": ["Ahl","Dxi","Aho","Ahn","Ahm"],
  "building": ["Ahr","Ahq","Ahp","DfG","DfE","Ead","DfD","DfF"],
  "building a nest": ["DfD"],
  "building a robot": ["DfE"],
  "building a snowman": ["DfF"],
  "building a wall": ["Ead","DfG"],
  "buildings": ["EyQ"],
  "built": ["ESh","Do2"],
  "built a wall": ["ESh"],
  "Bulgaria": ["D9w"],
  "bull": ["C7a","D9x","Ahx","Ahu","Aht","Ahv"],
  "bulldog": ["Ahw"],
  "bump": ["Ahz","Ah3","Ahy","Ah0"],
  "bumper cars": ["Ah1","Ah2"],
  "bun": ["AiJ","Ah4","Ah5"],
  "bunch": ["Ah7","Ah9","Ah6"],
  "bunch of bananas": ["Ah8"],
  "bungee jumping": ["AiB","AiC"],
  "bunkbed": ["EyR"],
  "bunnies": ["AiD"],
  "bunny": ["AiI","AiG","AiE","AiH","AiF"],
  "buns": ["AiK"],
  "buoyant": ["AiO","AiM","AiN"],
  "burden": ["AiQ","AiP"],
  "burger": ["AiZ","AiT","C7c","AiS","AiR"],
  "burger and chips": ["AiV"],
  "burger and fries": ["AiY","AiX"],
  "burgers": ["Aic","Aia","Aib"],
  "burial tomb": ["Aid"],
  "burn": ["DfH","Aig","Aif","Aih"],
  "burn burnt": ["DfH"],
  "burn the midnight oil": ["D9y","D9z","D90"],
  "burning": ["DfH","Ehv","Ehu"],
  "burrito": ["Ail","Aii","Dxk","C7d","Aij"],
  "burrow": ["Aim"],
  "bury": ["Do3"],
  "bus": ["C7i","Ai7","Aio","Ain","Dxm","Aip"],
  "bus driver": ["Aiq","Air","Ais"],
  "bus station": ["Ai9","Ai8","AjA"],
  "bus stop": ["AjB","C7j","AjD","Do4","AjF","AjE","AjC"],
  "bush": ["Aiy","C7e","Aiu","Dxl","Aiv"],
  "bushes": ["Aix"],
  "busier": ["C7f"],
  "business": ["Ai3","DS0"],
  "businessman": ["C7h","DSz","D92","D91","Ai2","Ai0","Ai1","C7g","Aiz"],
  "businesswoman": ["DS1","Ai6","Ai4","Ai5"],
  "busy": ["AjI","AjH","D93","AjG"],
  "but": ["EyS"],
  "butcher": ["AjJ","AjL","AjK"],
  "butcher's": ["Do5","AjM","AjO","AjN"],
  "butchers": ["AjM","AjN","AjO"],
  "butchery": ["AjR","Do5","AjM"],
  "butter": ["C7l","Dxo","Aja","AjT","AjU","AjS"],
  "butterflies": ["EyT"],
  "butterflies in your stomach": ["D94","D95","D96"],
  "butterfly": ["C7k","AjV","AjY","Dxn","AjZ","AjX","AjW"],
  "button": ["C7m","Ajd","Dxp","Ajc","Ajb"],
  "buttons": ["Aje"],
  "buy": ["DfL","DfK","DfJ","Eaf","EWn","Eae","DfI","Ajf"],
  "buy a coffee": ["Eae"],
  "buy a TV": ["DfI"],
  "buy bought": ["DfK","DfL","EWL","ESf","DfI","DfJ"],
  "buy coffee": ["DfJ"],
  "buy groceries": ["DfK","Eaf"],
  "buy some food": ["EWn"],
  "buying": ["DfL","Eaf","DfI","DfJ","DfK","Eae"],
  "buying a TV": ["DfI"],
  "buying coffee": ["DfJ"],
  "buying groceries": ["DfK","Eaf"],
  "buzz": ["Ajg"],
  "by the lake": ["Ajk"],
  "by the river": ["Ajl"],
  "by the sea": ["Ajm"],
  "bye": ["Aji","Ajh"],
  "c": ["DZp","DZq"],
  "cab": ["Ajo","Ajn","Ajp","Aj5"],
  "cabbage": ["C7n","Ajq","Ajr","Dxq"],
  "cabbages": ["Ajs"],
  "cabin": ["Ajt","Ajv","Aj0","Ajw"],
  "cabinet": ["Ajz","Ajx","Ajy"],
  "cable": ["Aj1","Aj4"],
  "cable car": ["Aj2","Aj3"],
  "cactus": ["Aj8","Aj6","Aj7"],
  "cafe": ["C7p","AkD","AkA","AkB","Aj9","AkC"],
  "cafe latte": ["C7o","Egp"],
  "cafeteria": ["AkF","AkE"],
  "cage": ["AkJ","AkI","AkH","AkG"],
  "cake": ["AkN","AkQ","C7q","AkP","AkK","AkM","Dxr","AkL","AkO"],
  "cakes": ["AkR"],
  "calculate": ["AkU","AkT","AkS"],
  "calculator": ["C7s","AkV","Aka","AkW","Dxs","C7r","AkY","AkZ","AkX"],
  "calendar": ["Akf","Akd","Ake","Akb","Akc"],
  "calf": ["Akh","Akg"],
  "California": ["D97"],
  "call": ["DfN","DfM","EWo","Aki","Akk","Akl","Akj"],
  "call a friend": ["DfM"],
  "call called": ["ESi","DfN","DfM"],
  "call his grandma": ["D98"],
  "call someone on the phone": ["EWo"],
  "called": ["ESi"],
  "called her": ["ESi"],
  "calling": ["DfN","DfM"],
  "calling a friend": ["DfM"],
  "calm": ["Akm","Akn","Ako"],
  "calorie": ["EyV","EyU"],
  "Cambodia": ["Akt","Akp","D99","Akr","Aks"],
  "camel": ["C7t","Aku","Dxu","Aky","Akv","Akw","Akx"],
  "camera": ["C7w","Dxv"],
  "cameraman": ["C7v","EAB","C7u"],
  "Cameroon": ["EAC"],
  "camouflage": ["Ak1","Ak0"],
  "camp": ["Ak3","AlB","Ak2"],
  "camper": ["Ak6","Ak4","Ak5"],
  "campfire": ["Do6"],
  "camping": ["Ak7","Ak8"],
  "camping tent": ["AlA"],
  "campsite": ["C7x","AlE","AlC","AlD"],
  "can": ["C8A","AlG","AlI","AlF","Al5","Dx0","AlH","Ed3","Edx","Ed2","Ed1","Ed0","Edv"],
  "can climb a tree": ["C71"],
  "can drive": ["C73"],
  "can drive a car": ["Edv"],
  "can i borrow a book": ["EAF"],
  "can i borrow a pen": ["EAG"],
  "can jump": ["C75"],
  "can opener": ["C76"],
  "can play the piano": ["C77","Edx"],
  "can play the trumpet": ["C78"],
  "can play the violin": ["C79"],
  "can speak": ["C8D"],
  "can speak Chinese": ["C8B","Ed0"],
  "can speak English": ["C8C","Ed1"],
  "can swim": ["C8E","C8F","Ed2"],
  "can talk": ["Ed3"],
  "can you speak french": ["EAK"],
  "can you swim": ["EAL"],
  "can you type": ["EAM"],
  "can't": ["EeB","Ed8","Ed9","Ed5","Ed7"],
  "can't climb a tree": ["C8G"],
  "can't drive": ["C8H"],
  "can't drive a car": ["Ed5"],
  "can't play the guitar": ["C8I"],
  "can't read": ["C8J"],
  "can't read a book": ["Ed7"],
  "can't ride a bike": ["C8K","Ed8"],
  "can't swim": ["C8L","Ed9"],
  "can't take a bus": ["C8M"],
  "can't understand": ["C8N"],
  "can't understand Chinese": ["EeB"],
  "can't use a computer": ["C8O"],
  "Canada": ["AlO","C7z","AlJ","Dxw","AlL","AlM","EAD","AlK"],
  "Canada flag": ["C7y"],
  "Canadian": ["C70","EeH"],
  "canary": ["AlP","AlQ"],
  "candies": ["AlT","AlS"],
  "candle": ["C72","AlW","AlV","Dxx","AlX","AlU","AlY"],
  "candles": ["Alc","AlZ","EAE","Ala","Alb"],
  "candy": ["C74","Dxy","Ale","Alk","Alg","Ald","Alf"],
  "candy bar": ["Alh"],
  "candy cane": ["Alj","Ali"],
  "candy store": ["All","Alo"],
  "cane": ["Alq","Alr","Als","Alp"],
  "canned food": ["Alt","Alu"],
  "cannon": ["Aly","Alv"],
  "canoe": ["Al1","Al0","Al4","Alz"],
  "canoeing": ["Al3","Al2"],
  "cant teach an old dog new tricks": ["EAH","EAI","EAJ"],
  "cantaloupe": ["Al9","AmB","Al6","Al7","AmA"],
  "canteen": ["AmD","AmC","AmE"],
  "canvas": ["AmG","AmF"],
  "canyon": ["EyW"],
  "cap": ["C8P","Dx1","AmL","AmJ","AmK","AmI","AmR"],
  "cape": ["AmN","AmO","AmM"],
  "capital": ["AmQ","AmP"],
  "capital a": ["DZl"],
  "capital b": ["DZn"],
  "capital c": ["DZp"],
  "capital city": ["EyX"],
  "capital d": ["DZr"],
  "capital e": ["DZt"],
  "capital f": ["DZv"],
  "capital g": ["DZx"],
  "capital h": ["DZz"],
  "capital i": ["DZ"],
  "capital j": ["DZ3"],
  "capital k": ["DZ5"],
  "capital l": ["DZ7"],
  "capital m": ["DZ9"],
  "capital n": ["DaB"],
  "capital o": ["DaD"],
  "capital p": ["DaF"],
  "capital q": ["DaH"],
  "capital r": ["DaJ"],
  "capital s": ["DaL"],
  "capital t": ["DaN"],
  "capital u": ["DaP"],
  "capital v": ["DaR"],
  "capital w": ["DaT"],
  "capital x": ["DaV"],
  "capital y": ["DaX"],
  "capital z": ["DaZ"],
  "cappuccino": ["C8Q"],
  "captain": ["AmV","AmU","AmT","AmS"],
  "capture": ["AmW","AmX"],
  "car": ["C8Y","And","Dx7","AmZ","Amb","Ama","AmY"],
  "car crash": ["Amp","Amo","Amq"],
  "car park": ["AnS","C8V","AnQ","Dx5","AnP"],
  "car parking": ["AnR"],
  "car racing": ["Ane"],
  "car salesman": ["C8b","C8a","Dx9"],
  "car wash": ["AoA","An9","AoB"],
  "caravan": ["Ame","Amd","Amc"],
  "carbohydrates": ["Ami","Amf","Amg","Amh"],
  "carbon dioxide": ["Amm","Amn","Aml"],
  "carbonated": ["Amj"],
  "carbonated water": ["Amk"],
  "card": ["Am3","Ams","Amr","Amt"],
  "card machine": ["Am2"],
  "cardboard": ["Amv","Amw","Amu"],
  "cardigan": ["C8R","Amz","Amx","Amy","Am0","Dx2"],
  "cards": ["C8S","Am4","Dx3","C8T","Am5"],
  "care": ["DS5","Am6","AnC"],
  "career": ["DS2","Am7"],
  "careful": ["DS4","AnB","Am8"],
  "carefully": ["DS3","Am9","AnA","ERB"],
  "careless": ["Do7"],
  "cargo": ["AnD","AnE"],
  "cargo shorts": ["Dx4","C8U"],
  "caring": ["Do8"],
  "carnation": ["AnI","AnH"],
  "carnivore": ["AnK","AnL"],
  "carol singers": ["EAN"],
  "carousel": ["AnM","AnO","AnN"],
  "carpenter": ["C8W","C8X","AnX","AnU","AnT","AnW","EAO","EAP","Dx6","AnV"],
  "carpet": ["Anb","AnZ","AnY","Ana","Anc"],
  "carriage": ["Ang","Anf"],
  "carried": ["ESj"],
  "carried a bag": ["ESj"],
  "carrot": ["Ani","Anh","EgZ","Ank","Ann","Anj"],
  "carrot cake": ["Anm"],
  "carrots": ["C8Z","Anp","Ano","Dx8"],
  "carry": ["DfP","Anu","Ebz","Ant","DfO","Anq","Ans","Eag","DfQ","Anr","EWp"],
  "carry a bag": ["Eag","DfO","EWp"],
  "carry a box": ["DfP","Ebz"],
  "carry carried": ["DfP","ESj","DfO","DfQ"],
  "carry on": ["EyY"],
  "carrying": ["Ebz","DfO","DfP","Eag","DfQ"],
  "carrying a bag": ["Eag","DfO"],
  "carrying a box": ["Ebz","DfP"],
  "cart": ["Anv","Anw","Anx","An6"],
  "carton": ["Anz","An3","Any","An0"],
  "carton of milk": ["An2","An1"],
  "cartoon": ["An4","An5"],
  "carve": ["An8","An7"],
  "case": ["AoD","AoE","AoC"],
  "cash": ["AoK","AoH","AoF","AoG"],
  "cash register": ["AoL","AoM"],
  "cashier": ["C8c","C8d","AoJ","EAS","DyA","EAT"],
  "cask": ["AoN"],
  "cast": ["AoS"],
  "castle": ["C8e","DyB","AoR","AoO","AoQ","AoP"],
  "casual": ["AoW","AoU","AoT","AoV"],
  "cat": ["C8g","Aoz","AoZ","AoX","EAV","AoY","DyD","Aoa","Aob"],
  "cat and mouse": ["Aoc","Aod","Aof"],
  "catapult": ["Aoj","Aoi"],
  "catch": ["DfR","Eah","Aok","DfT","Aol","DfS","EWq","Aor","Aom"],
  "catch a ball": ["DfR","Eah","Aon"],
  "catch a cold": ["Aop","DS7"],
  "catch a fish": ["DfS","EWq"],
  "catch caught": ["EVL","ESk","DfR","DfS","DfT"],
  "catch fish": ["EAU"],
  "catch the bus": ["EyZ"],
  "catching": ["DfR","Eah","DfS","DfT"],
  "catching a ball": ["DfR","Eah"],
  "catching a fish": ["DfS"],
  "caterpillar": ["Aos","Aov","C8f","Aot","DyC","Aow","Aou"],
  "catfish": ["Aoy","Aox"],
  "cathedral": ["Do9"],
  "cats": ["Ao0"],
  "cattle": ["Ao1","Ao2"],
  "caught": ["EVL","ESk","Ao3"],
  "caught a fish": ["ESk","EVL"],
  "caught red handed": ["EAW","EAX","EAY"],
  "cauldron": ["Ao5","Ao7","Ao6"],
  "cauliflower": ["C8h","ApD","ApA","DyE","Ao8","ApB","Ao9"],
  "cauliflower cheese": ["ApC"],
  "caution": ["ApF","ApE"],
  "cautious": ["ApG"],
  "cave": ["ApJ","ApI","ApH"],
  "cavern": ["ApL"],
  "cd": ["ApP","ApN"],
  "cd player": ["ApO"],
  "cds": ["ApQ"],
  "cease": ["ApR"],
  "cedar": ["ApT","ApS"],
  "ceiling": ["ApX","ApV","ApU","ApW"],
  "celebrate": ["DfV","DfW","DfU","ApZ","ApY","EWr"],
  "celebrate a birthday": ["EAa"],
  "celebrate celebrated": ["DfU","DfV","DfW"],
  "celebrate Christmas": ["EWr","DfU","EhM","EhL"],
  "celebrate Halloween": ["EAd"],
  "celebrate New Year": ["DfV"],
  "celebrating": ["DfW","DfU","DfV"],
  "celebrating Christmas": ["DfU"],
  "celebrating New Year": ["DfV"],
  "celebration": ["Apc"],
  "celery": ["C8i","Apg","DyF","Apf"],
  "celestial": ["DS8"],
  "cell": ["Apu"],
  "cell phone": ["Apq","Apr","Apt","Aps"],
  "cellar": ["Apl","Apk","Apj"],
  "cello": ["App","Apm","Apn"],
  "cells": ["Apw"],
  "cement": ["Apx"],
  "cemetery": ["Ap0","Ap1","Apy"],
  "center": ["DpA"],
  "centipede": ["Ap4","Ap2"],
  "centre": ["DpA"],
  "CEO": ["C8k","C8j"],
  "ceramic": ["Ap9","Ap7","Ap8"],
  "cereal": ["C8l","AqD","AqF","DyG","AqB","AqC"],
  "cereal bar": ["AqE"],
  "ceremony": ["AqH","AqG"],
  "chain": ["AqL","C8m","AqK","AqJ","AqI"],
  "chair": ["C8n","DyI","AqO","AqP","AqQ","AqM","AqN"],
  "chairs": ["AqU","AqV","AqT","AqS","AqR"],
  "chalet": ["AqW","AqX"],
  "chalk": ["Aqd","Aqa","Aqb","AqZ","Aqc"],
  "challenge": ["Aqg","Aqe","Aqf"],
  "challenging": ["Aqh"],
  "chameleon": ["Aqi","Aqm","Aqk","Aqj","Aql"],
  "championship": ["Eya"],
  "chance": ["Aqo","Aqn"],
  "change": ["DfY","Aqr","DfX","EWs","Aqp","Aqq"],
  "change a lightbulb": ["DfX"],
  "change changed": ["DfX","DfY"],
  "change into a butterfly": ["DfY","EWs"],
  "changing": ["DfX","DfY"],
  "changing a lightbulb": ["DfX"],
  "changing into a butterfly": ["DfY"],
  "chaos": ["Aqs"],
  "charge": ["DfZ","EdG","Aqz","Aqx","Dfa"],
  "charge a phone": ["DfZ","Dfa"],
  "charge charged": ["ESY","Dfa","DfZ"],
  "charge your phone": ["EAh"],
  "charged": ["ESY"],
  "charged my phone": ["ESY"],
  "charger": ["Aq0","Aq2","Aq1"],
  "charging": ["EdG","Dfa","DfZ"],
  "charging a phone": ["DfZ","Dfa"],
  "charity": ["Aq6","Aq3","Aq4","Aq5"],
  "charity shop": ["Aq7"],
  "Charles darwin": ["Aq8"],
  "chase": ["Dfb","Aq9","EWu","ArA","ArC","ArB"],
  "chase a mouse": ["EWu","Dfb"],
  "chase chased": ["Dfb"],
  "chasing": ["Dfb"],
  "chasing a mouse": ["Dfb"],
  "chat": ["DpB"],
  "chateau": ["Eyb"],
  "chauffeur": ["C8o"],
  "cheap": ["C8s","EAk","ArD","ArE"],
  "cheaper": ["C8q","C8r"],
  "cheat": ["DS9"],
  "check": ["DTC","Dfc","EWv"],
  "check checked": ["Dfc"],
  "check electricity": ["EAl"],
  "check in": ["DTB"],
  "check teeth": ["EAm"],
  "check the bill": ["DTD"],
  "check the dog": ["EWv","Dfc"],
  "checked": ["DTA"],
  "checking": ["Dfc"],
  "checking the dog": ["Dfc"],
  "cheek": ["ArF"],
  "cheeks": ["DTE"],
  "cheer": ["ArM","DTH"],
  "cheerful": ["DTF","ArG","EAn"],
  "cheerleader": ["DTG","ArK","ArH"],
  "cheese": ["C8u","Are","DyL","ArO","ArQ","ArR","ArP","ArN"],
  "cheese and tomato": ["ArS"],
  "cheese burger": ["C8t"],
  "cheese sandwich": ["Arg","Arf"],
  "cheese toastie": ["Ega","C8v"],
  "cheeseburger": ["ArX","ArU","ArY","ArV"],
  "cheesecake": ["Ard","Arc","ArZ"],
  "cheetah": ["Arj","Ari","Arh"],
  "chef": ["C8x","EAo","Arp","C8w","Arm","EAp","Arn","Arl","DyM","Ark","Aro"],
  "chemical engineer": ["C8y","C8z"],
  "chemical fertilizer": ["Arq"],
  "chemist": ["DpC"],
  "chemist's": ["Eyc"],
  "chemistry": ["C80","DTI","DyN","Aru","Ars","Art"],
  "cherish": ["Arw"],
  "cherries": ["C81","Arx","Arz","Ary","DyO"],
  "cherry": ["Ar2","Egb"],
  "cherry pie": ["Ar0"],
  "chess": ["C82","Ar6","Ar4","Ar5","DyP","Ar3"],
  "chest": ["AsB","Ar7"],
  "chest of drawers": ["Ar8","AsA","Ar9"],
  "chest x ray": ["AsC"],
  "chewing gum": ["AsE"],
  "chewy": ["Eyd"],
  "chichen itza": ["AsF"],
  "chick": ["Asb","AsG","AsH"],
  "chicken": ["AsL","C87","AsT","AsJ","C83","DyQ","AsI","Egc","AsM","AsK","DyR"],
  "chicken and rice": ["C84"],
  "chicken leg": ["AsO","C85","AsN"],
  "chicken nugget": ["AsQ","AsR","AsP"],
  "chicken nuggets": ["AsS","C86"],
  "chicken wing": ["C88","AsU"],
  "chicken wings": ["AsX","AsW","AsV"],
  "chickpeas": ["Asa","AsZ"],
  "child": ["Asf","Ase","Asc","Asd","EAq"],
  "childhood": ["Eye"],
  "children": ["Ash","Asg","Asj","Asi"],
  "Chile": ["EAr"],
  "chili": ["Ask","Asl","Egd","Asm","Asn"],
  "chili peppers": ["Asp","Asq","Asr","Ass"],
  "chilies": ["C89","DyS"],
  "chill": ["Ast"],
  "chilli": ["Ask","Asn","Asm","Asl"],
  "chilli peppers": ["Asp","Asr","Asq","Ass"],
  "chillies": ["DyS","C89"],
  "chilly": ["Asu"],
  "chimney": ["Asy","Asx","C9A","Asw","DyT"],
  "chimp": ["As3"],
  "chimpanzee": ["As1","As0","As2"],
  "chin": ["C9F","As4","DyW","AtF","As5"],
  "China": ["AtA","C9C","As6","As7","EAs","As8","DyU","As9"],
  "China flag": ["C9B"],
  "Chinese": ["C9E","C9D","EeI","DyV","AtE","AtC","AtB"],
  "Chinese new year": ["AtD"],
  "chips": ["AtI","AtL","AtH","DyX","AtJ","AtG","AtK"],
  "chips and dip": ["C9G"],
  "chirp": ["AtN"],
  "chisel": ["AtO","AtR"],
  "chocolate": ["AtT","C9I","AtU","Atg","DyY","AtV","AtS"],
  "chocolate bar": ["AtY","AtX","AtW","AtZ"],
  "chocolate cake": ["Atb","Ata","Atc","Atd","Ate"],
  "chocolate milk": ["Atf"],
  "chocolate milkshake": ["C9H"],
  "choice": ["Ati","Atj","Ath"],
  "choir": ["Atl","Atk"],
  "choke": ["Atm"],
  "choose": ["Ato","Atn"],
  "chop": ["Dfd","Atr","Eai","Atp","Atq"],
  "chop an onion": ["Eai","Dfd"],
  "chop chopped": ["Dfd"],
  "chopping": ["Dfd","Eai"],
  "chopping an onion": ["Eai","Dfd"],
  "chopping board": ["C9J","DyZ"],
  "chopsticks": ["C9K","Dya","Atx","Att","Atu","Atv","Ats"],
  "Christ": ["AuF"],
  "Christ the redeemer": ["AuG"],
  "Christmas": ["C9L","At7","Atz","EhM","Aty","EhL","EhN"],
  "Christmas candle": ["At1","At2","EAt","At0"],
  "Christmas decorations": ["EhX"],
  "Christmas dinner": ["At4","At6","At5","EhL","At3"],
  "Christmas elf": ["Ehb"],
  "Christmas gift": ["Ehg"],
  "Christmas gifts": ["Ehh"],
  "Christmas morning": ["EhM"],
  "Christmas present": ["Ehg"],
  "Christmas presents": ["Ehh"],
  "Christmas reindeer": ["Eh0"],
  "Christmas sleigh": ["Eh4"],
  "Christmas snowman": ["Eh8"],
  "Christmas stocking": ["At8","AuA","AuB","At9","Eh9"],
  "Christmas tree": ["C9M","EiG","AuC","AuE","AuD","EAu"],
  "Christmas turkey": ["EiH"],
  "Christmas wreath": ["EiK"],
  "chrysanthemum": ["AuH","AuI"],
  "chubby": ["AuK","AuJ","AuL","AuM"],
  "church": ["C9N","Dyb","AuN","AuQ","AuP","AuO"],
  "churro": ["AuR","AuS"],
  "Cinderella": ["AuV","AuU"],
  "cinema": ["AuZ","AuX","AuY"],
  "circle": ["Aua","Aub","Auc"],
  "circular saw": ["Auf"],
  "circus": ["Aul","Auk","Auj","Aui"],
  "citadel": ["Aum"],
  "city": ["Aut","Auq","Aun","Aup","Auo"],
  "city hall": ["Aur","Aus"],
  "civil engineer": ["C9P","EAv"],
  "civilization": ["Auv","Auu"],
  "clam": ["Aux","Auw"],
  "clams": ["Au0","Auz"],
  "clap": ["Au5","Au4","Au1","Au3"],
  "clarinet": ["Au7","Au9","Dyc","C9Q"],
  "clasp": ["AvA"],
  "class": ["AvL","AvB"],
  "classic": ["AvI","AvD"],
  "classical": ["AvH","AvE"],
  "classical music": ["Eyf","AvG","AvF"],
  "classmate": ["AvJ"],
  "classmates": ["AvK"],
  "classroom": ["C9R","AvO","AvM","AvN"],
  "claw": ["AvQ","AvP"],
  "claws": ["AvR"],
  "clay": ["DpD"],
  "clay pot": ["Eyg"],
  "clean": ["Dfe","C9W","Dff","AvS","EWw","Ava","EA3"],
  "clean as a whistle": ["EAx","EAy","EAz"],
  "clean cleaned": ["Dfe","ETm","Dff"],
  "clean dishes": ["EA0"],
  "clean teeth": ["Avb"],
  "clean the floor": ["Dfe","EA4"],
  "clean the house": ["Avc","Avd"],
  "clean the window": ["Dff"],
  "clean up": ["Ave","Avf"],
  "clean windows": ["EWw","EA5"],
  "cleaned": ["ETm"],
  "cleaned the floor": ["ETm"],
  "cleaner": ["C9S","AvV","C9V","AvW","C9T","C9U","AvX","AvT","AvU","EA1","ERh","EA2","Dyd"],
  "cleaning": ["Dfe","Dff","AvZ","AvY"],
  "cleaning the floor": ["Dfe"],
  "cleaning the window": ["Dff"],
  "cleanup": ["Avg"],
  "clear": ["Avi","Avh"],
  "clear sky": ["Avj","Avk"],
  "clear the table": ["Eyh"],
  "cleaver": ["C9X","Avl"],
  "clerk": ["Avq","Avp"],
  "clever": ["Avr","Avt","Avs"],
  "click": ["Dfg","Avw"],
  "click clicked": ["ESZ","Dfg"],
  "click on": ["DpE"],
  "click the mouse": ["Dfg"],
  "clicked": ["ESZ"],
  "clicked the mouse": ["ESZ"],
  "clicking": ["Dfg"],
  "clicking the mouse": ["Dfg"],
  "cliff": ["Avx","Avz","Avy"],
  "cliffs": ["Dyf","C9Y","Av1","Av0"],
  "climate": ["Av7","Av4","Av2","Av3"],
  "climate change": ["Av5","Av6"],
  "climb": ["Dfj","Dfh","Dfk","EWy","AwD","Av8","EdL","EWx","Dfi"],
  "climb a mountain": ["Dfi","EdL","EWx"],
  "climb a tree": ["Dfj","EWy"],
  "climb climbed": ["EWO","ESl","Dfh","Dfi","Dfj","Dfk"],
  "climbed": ["EWO","ESl"],
  "climbed a tree": ["ESl"],
  "climbed the mountain": ["EWO"],
  "climber": ["Av9"],
  "climbing": ["Dfk","AwC","Dfj","Dfh","AwB","EdL","Dfi"],
  "climbing a mountain": ["EdL","Dfi"],
  "climbing a tree": ["Dfj"],
  "clinic": ["AwE","AwF"],
  "clip": ["AwG"],
  "clipboard": ["C9Z"],
  "clock": ["C9a","AwK","Dyh","AwL","AwJ","AwH","AwI"],
  "clocks": ["AwM"],
  "close": ["Dfp","Dfo","Dfl","EW0","Eb0","Dfn","Dfm","Eak","EWz"],
  "close a laptop": ["Dfm"],
  "close a window": ["Dfn"],
  "close closed": ["ESa","Dfm","Dfn","Dfo","Dfl","Dfp"],
  "close in the evening": ["EWz"],
  "close laptop": ["Eb0"],
  "close the window": ["Dfp","Eak","EW0"],
  "closed": ["DpF","ESa"],
  "closed my laptop": ["ESa"],
  "closely": ["ERJ"],
  "closet": ["C9b","AwN","Dyi"],
  "closing": ["Eb0","Eak","Dfo","Dfl","Dfm","Dfn","Dfp"],
  "closing a laptop": ["Dfm"],
  "closing a window": ["Dfn"],
  "closing the window": ["Dfp","Eak"],
  "cloth": ["Awc"],
  "clothes": ["AwT","AwO","AwP"],
  "clothes line": ["AwS","AwR"],
  "clothes lines": ["C9c"],
  "clothes rack": ["AwU","AwV","AwW"],
  "clothes shop": ["AwX","AwZ","Awb","AwY","Awa"],
  "clothing store": ["DpG"],
  "cloud": ["Awg","Awd","Awe","Awi","Awf","Awh"],
  "clouds": ["C9d","Awj","Awo","Awn","Awm","Dyk","Awl","Awk"],
  "cloudy": ["Awq","C9f","C9e","Awp","EA6","EhO","Awr"],
  "clown": ["C9h","Awu","Aws","Awv","Awx","EA8","Awt","Dyl","EA7","C9g"],
  "clown mask": ["Aww"],
  "club": ["Awz","Awy"],
  "clue": ["Aw1","Aw0"],
  "clunky": ["Eyi"],
  "cluster": ["Aw2"],
  "coach": ["C9j","DpH","Aw5","Aw6","EBA","C9i","Aw4","Aw3"],
  "coal": ["AxB","AxA","Aw7","Aw9","Aw8"],
  "coal miner": ["EBC","EBB","C9k","C9l"],
  "coast": ["AxC","AxD","AxE"],
  "coat": ["C9o","AxF","Dyo","AxH","AxI","AxK","AxG"],
  "coat hangar": ["C9m"],
  "coat hanger": ["Dym"],
  "coat hook": ["C9n"],
  "coat rack": ["C9p","Dyp","AxM"],
  "coathook": ["AxJ"],
  "cobbler": ["AxQ"],
  "cobblestone": ["AxS","AxR"],
  "cobra": ["AxU","AxT"],
  "cobweb": ["AxY","AxZ"],
  "coca cola": ["Axd","Axb","Axc"],
  "cock": ["Eyj"],
  "cockerel": ["Axg","Axe","Axf"],
  "cockroach": ["Axh","Axj","Axo","Axi","Axk"],
  "cockroaches": ["Axn","Axl","Axm"],
  "cocoa": ["Axp","Axr","Axs"],
  "coconut": ["Axu","Ax4","Axv","Axw","Ege","Egf","Axt","Axx"],
  "coconut juice": ["Axy","Axz"],
  "coconut milk": ["Ax2","Ax3","Ax0","Ax1"],
  "coconuts": ["Ax9","Ax6","Ax7","Ax8"],
  "coding": ["AyB","AyC"],
  "coffee": ["C9r","AyG","AyD","AyJ","Dys","AyF","AyH","AyE","AyI"],
  "coffee machine": ["C9q","Dyr"],
  "coffee shop": ["AyP","AyK","AyM","AyN"],
  "coffee table": ["AyR","AyT","AyS","AyQ"],
  "coffin": ["DpI"],
  "coin": ["AyU","AyX","AyW","AyV"],
  "coins": ["C9s","Ayc","Ayb","Ayd","Dyt","AyY","Aya"],
  "coke": ["DpJ"],
  "cola": ["C9t","Dyu","Ayh","Aye","Ayg","Ayi","Ayf"],
  "cold": ["C9x","C9u","EBE","Aym","Ayk","EhQ","EhP","C9v","Ayl","Ayj"],
  "colder": ["C9w"],
  "collapse": ["Ayo","Dfq","Ayn","Ayp"],
  "collapse collapsed": ["EUg","Dfq"],
  "collapsed": ["EUg"],
  "collapsing": ["Dfq"],
  "collar": ["DpK"],
  "collect": ["Ays","Ayq","Dfr","EW1"],
  "collect collected": ["Dfr"],
  "collect garbage": ["Dfr"],
  "collect shells": ["Eyk"],
  "collect stamps": ["DpL"],
  "collect trash": ["EW1"],
  "collecting": ["Dfr"],
  "collecting garbage": ["Dfr"],
  "collection": ["Ayr"],
  "college": ["Ayz","Ayx","Ayv","Ayy"],
  "Colombia": ["EBG"],
  "colonel": ["Ay0"],
  "colony": ["Ay1"],
  "color": ["Ay3","AzI","Ay2"],
  "color pen": ["AzH"],
  "colored pencil": ["Ay4","Ay5","Ay6","Ay7"],
  "colored pencils": ["Ay6","Ay5","Ay7","Ay4"],
  "colorful": ["Ay9","Ay8","C9y","AzB","EBH","EhR","EhS","AzA"],
  "coloring book": ["AzC","AzE"],
  "coloring picture": ["AzF","AzG"],
  "colors": ["AzJ","AzK","AzL","DpN"],
  "colosseum": ["AzQ","AzO"],
  "colour": ["AzI","Ay2","Ay3"],
  "colour pen": ["AzH"],
  "coloured pencil": ["Ay5","Ay4","Ay6","Ay7"],
  "coloured pencils": ["DpM"],
  "colourful": ["AzB","Ay9","AzA","EBH","C9y","Ay8"],
  "colouring book": ["AzC","AzE"],
  "colouring picture": ["AzG","AzF"],
  "colours": ["DpN","AzJ","AzL","AzK"],
  "column": ["AzR","AzS","AzW"],
  "comb": ["C9z","AzX","Dfs","AzY","Eb1","Dyv","Azc","AzZ","EW2","Dft"],
  "comb combed": ["Dft","Dfs"],
  "comb hair": ["Aza","Eb1"],
  "comb her hair": ["Dfs"],
  "comb my hair": ["Eyl"],
  "comb your hair": ["Dft","EW2"],
  "combine": ["Azb"],
  "combing": ["Eb1","Dft","Dfs"],
  "combing her hair": ["Dfs"],
  "combing your hair": ["Dft"],
  "come": ["Dfu"],
  "come across": ["Eym"],
  "come came": ["Dfu"],
  "come from": ["EW3"],
  "come from America": ["Dfu","EW3","EeD"],
  "come from Argentina": ["EeE"],
  "come from Australia": ["EeF"],
  "come from Brazil": ["EeG"],
  "come from Canada": ["EeH"],
  "come from China": ["EeI"],
  "come from Egypt": ["EeJ"],
  "come from England": ["EeK"],
  "come from France": ["EeL"],
  "come from Germany": ["EeM"],
  "come from India": ["EeN"],
  "come from Ireland": ["EeO"],
  "come from Italy": ["EeP"],
  "come from Japan": ["EeQ"],
  "come from Mexico": ["EeR"],
  "come from Russia": ["EeS"],
  "come from South Africa": ["EeT"],
  "come from Spain": ["EeU"],
  "come from Thailand": ["EeV"],
  "come from Turkey": ["EeW"],
  "come here": ["DpQ"],
  "come home": ["Eyn"],
  "come in": ["Azd"],
  "comedian": ["DpO"],
  "comedy": ["DpP"],
  "comet": ["Azh","Azf","Azg","Aze"],
  "comfort": ["Azj","Azk"],
  "comfortable": ["Azl","DTJ","Azn","Azo","Azm"],
  "comfortably": ["ERS"],
  "comforter": ["Azp"],
  "comic book": ["Azs"],
  "coming": ["Dfu"],
  "coming from America": ["Dfu"],
  "common": ["DpR"],
  "communal": ["DTM"],
  "communal house": ["DTL"],
  "communicate": ["DpS"],
  "communication": ["DpT"],
  "community": ["DTN","Azt"],
  "companion": ["Azx"],
  "company": ["DTP"],
  "compare": ["Azz","Azy"],
  "comparison": ["DTQ"],
  "compass": ["DTS","Az2","Az3","Az1"],
  "compassion": ["DTR"],
  "compatible": ["Az4"],
  "competition": ["Az5"],
  "competitive": ["Az6"],
  "complete": ["Az7","Az8"],
  "complex": ["DTT","A0B","Az9"],
  "complicated": ["A0D","A0C"],
  "comply": ["DTU"],
  "compose": ["DTV"],
  "composer": ["DpU"],
  "comprehend": ["A0E"],
  "comprehension": ["DTW"],
  "computer": ["C90","Dyw","A0G","A0Q","A0F","A0H"],
  "computer game": ["A0J","A0K","A0I"],
  "computer games": ["DpV"],
  "computer lab": ["A0M","A0L"],
  "computer mouse": ["A0O","A0N","A0P"],
  "computer problem": ["A0R"],
  "computer programmer": ["A0T","A0S"],
  "computer room": ["A0U"],
  "computer technician": ["C91","C92","EBI","EBJ","A0V"],
  "computing": ["C93","Dyy"],
  "concentrate": ["Dfv","Eb2"],
  "concentrate concentrated": ["Dfv","ETn"],
  "concentrated": ["ETn"],
  "concentrating": ["Dfv","Eb2"],
  "concentration": ["A0X","DTX"],
  "concept": ["DTY"],
  "concerned": ["DTZ","DTa"],
  "concert": ["A0d","A0a","A0Z"],
  "concert hall": ["A0c","A0b"],
  "condor": ["A0e"],
  "conduct": ["A0i"],
  "conductor": ["A0h","DTb","A0g"],
  "cone": ["DTc","A0j","A0k","A0l"],
  "confident": ["DTd","A0m"],
  "confirm": ["A0q","A0n"],
  "confirmation": ["A0p"],
  "confused": ["C94","A0s","EBK","A0r"],
  "confusing": ["DTf","A0u","A0t"],
  "conga": ["A0v"],
  "connect": ["Dfw","A0w","EW4","A0x"],
  "connect a phone": ["Dfw"],
  "connect a phone to a computer": ["EW4"],
  "connect connected": ["Dfw"],
  "connecting": ["Dfw"],
  "connecting a phone": ["Dfw"],
  "connection": ["Eyp","Eyo"],
  "conservation": ["A0y","DTg","A0z"],
  "console": ["DTh"],
  "conspicuous": ["DTi"],
  "constellation": ["DTj","A02"],
  "constitutional": ["A03"],
  "constitutionalist": ["DTk"],
  "construct": ["Dfx"],
  "construct a building": ["Dfx"],
  "construct constructed": ["EUv","Dfx"],
  "constructed": ["EUv"],
  "constructed a building": ["EUv"],
  "constructing": ["Dfx"],
  "constructing a building": ["Dfx"],
  "construction area": ["A05","A04"],
  "construction site": ["C95","Dyz"],
  "construction worker": ["C96","EBM","C97","EBL","A08","A09"],
  "consumers": ["DTl"],
  "consumption": ["DTm"],
  "container": ["A1B","A1A"],
  "containers": ["DTn"],
  "content": ["Eyq"],
  "contest": ["A1C"],
  "contract": ["DTo","A1G"],
  "contrail": ["DTp","A1J","A1H","A1I"],
  "contribute": ["DTq"],
  "control": ["Dfy","Eal"],
  "control a drone": ["Eal","Dfy"],
  "control controlled": ["ESb","Dfy"],
  "controling": ["Dfy"],
  "controling a drone": ["Dfy"],
  "controlled": ["ESb"],
  "controlled the drone": ["ESb"],
  "controller": ["C98","Dy0"],
  "controlling": ["Eal"],
  "convenience store": ["C99"],
  "conversation": ["DTr","A1K","A1N","A1M"],
  "cook": ["Dfz","Df1","EW5","Eb3","A1T","A1O","Df0"],
  "cook cooked": ["ESm","Df0","Dfz","Df1"],
  "cook dinner": ["EBN"],
  "cook food": ["Df0","EW5"],
  "cooked": ["ESm","DpW"],
  "cooked some food": ["ESm"],
  "cooker": ["DpX"],
  "cookie": ["A1P","DAA","Dy2","A1Q"],
  "cookies": ["A1S","A1R"],
  "cooking": ["Dfz","Df1","Eb3","Df0"],
  "cooking food": ["Df0"],
  "cool": ["Df2","EBP"],
  "cool cooled": ["ESV","Df2"],
  "cool the room": ["Df2"],
  "cooled": ["ESV"],
  "cooled the room": ["ESV"],
  "cooling": ["Df2"],
  "cooling the room": ["Df2"],
  "copper": ["A1V","A1W","A1U"],
  "coral": ["DTs","A1Y","A1X"],
  "coral reef": ["A1a"],
  "cord": ["A1b"],
  "core": ["A1d","A1c"],
  "corgi": ["A1f","A1e"],
  "coriander": ["A1g"],
  "corkscrew": ["DAC"],
  "corn": ["DAD","A1m","Dy4","A1n","A17","A1k","A1o","A1j","A1l"],
  "corn dog": ["A1p"],
  "corn field": ["A1w"],
  "cornbread": ["DTt"],
  "corner": ["DTu","A1t","A1r","A1s","A1u"],
  "corner shop": ["DTv","A1v"],
  "cornflakes": ["A1y","A10","A11","A1z"],
  "cornflower": ["A14"],
  "cornish pasty": ["A15","A16"],
  "corridor": ["DAE","A18","DTw","A19","A2A"],
  "corruption": ["DTx"],
  "cosmos": ["A2B"],
  "cost": ["Df3","EW6","A2C"],
  "cost an arm and a leg": ["EBQ","EBR","EBS"],
  "cost cost": ["Df3"],
  "cost one dollar": ["Df3","EW6"],
  "Costa Rica": ["EBT"],
  "costing": ["Df3"],
  "costume": ["A2F","A2D","A2E"],
  "cosy": ["EBU","A2J","A2G","A2I"],
  "cot": ["A2O","A2K","A2L"],
  "cottage": ["A2R","A2S","A2Q","A2P"],
  "cotton": ["A2U","A2T","A2W","A2V"],
  "couch": ["A2Y","A2X","A2a","A2b","A2Z"],
  "cough": ["Df4","DAF","Eb4","A2c","Dy5"],
  "cough coughed": ["ETo","Df4"],
  "cough syrup": ["A2d"],
  "coughed": ["ETo"],
  "coughing": ["Df4","Eb4"],
  "count": ["Eyr"],
  "counter": ["DpY"],
  "counting": ["A2g","A2e","A2f"],
  "country": ["A2k"],
  "country house": ["A2i"],
  "country music": ["Eys"],
  "countryside": ["A2l","A2m"],
  "couple": ["A2p","A2n","A2o"],
  "coupons": ["A2q"],
  "courage": ["A2r"],
  "courthouse": ["A2s","A2t"],
  "courtyard": ["A2v","A2u"],
  "cousin": ["DZN","EBV","EBW"],
  "cousins": ["A2y","DZO","A2x"],
  "cow": ["DAG","A25","EBX","A20","A2z","Dy6"],
  "coward": ["A21"],
  "cowboy": ["A23","A22","A24"],
  "cows": ["A28","A27","A26"],
  "cozy": ["Eyt"],
  "crab": ["DAH","A3E","A3C","Dy7","A3B","A29","A3A","A3D"],
  "crack": ["A3G","Df5","A3F"],
  "crack cracked": ["Df5"],
  "crack the screen": ["Df5"],
  "cracked": ["EBY","DAI","EhT"],
  "cracked screen": ["EhT"],
  "cracker": ["A3K","A3L","A3I"],
  "crackers": ["DpZ"],
  "cracking": ["Df5"],
  "cracking the screen": ["Df5"],
  "crane": ["A3Q","A3N","A3P"],
  "cranky": ["A3R"],
  "crash": ["Df6","A3T","A3U"],
  "crash a car": ["Df6"],
  "crash crashed": ["Df6"],
  "crashed": ["EVW","ESn"],
  "crashed his car": ["EVW","ESn"],
  "crashing": ["Df6"],
  "crashing a car": ["Df6"],
  "crater": ["A3W","A3V"],
  "crawl": ["A3X","A3Y"],
  "crayon": ["A3Z"],
  "crayons": ["DAJ","A3e","A3b","A3c","Dy8","A3d"],
  "crazy": ["DTy","A3f","A3h","A3i","A3g"],
  "cream": ["A3j"],
  "create": ["Eyu"],
  "create graphics": ["EBZ"],
  "creative": ["A3k"],
  "creativity": ["DTz"],
  "creature": ["A3m","DT0"],
  "credit card": ["DAK","A3r","A3p","A3n","A3q","Dy9"],
  "creepy": ["DT1","A3v","A3s"],
  "creepy clown": ["A3t"],
  "creepy house": ["A3u"],
  "crepe": ["A3w","A3y","A3x"],
  "crescent": ["A3z","A30","A31"],
  "crest": ["A32"],
  "crew": ["A33","A34"],
  "crib": ["Dpa"],
  "cricket": ["DAL","A35","A4B","A36","A37","A38","A39","DzA","A4A"],
  "cried": ["ETp","Dpb"],
  "crime": ["A4C","A4D"],
  "criminal": ["A4E"],
  "cripple": ["A4F"],
  "crisps": ["A4H","A4G"],
  "crispy": ["Eyv"],
  "Croatia": ["EBa"],
  "crocodile": ["DAM","A4N","DzB","A4M","A4L","A4I","A4K","A4J"],
  "croissant": ["A4T","DzC","DAN","A4O"],
  "croissants": ["A4W","A4U","A4V"],
  "crop": ["Eyw"],
  "crops": ["A4Y","A4X"],
  "croquet": ["A4c"],
  "cross": ["Df7","A4e","Eam","A4i","A4d"],
  "cross crossed": ["ESo","Df7"],
  "cross the river": ["EBb"],
  "cross the river carefully": ["ERB"],
  "cross the road": ["Df7","Eam"],
  "cross walk": ["A4m","A4n","A4o","A4p"],
  "crossed": ["ESo"],
  "crossed the road": ["ESo"],
  "crossing": ["A4h","Df7","Eam"],
  "crossing guard": ["A4g","A4f"],
  "crossing the road": ["Eam","Df7"],
  "crossroad": ["A4l","A4j"],
  "crosswalk": ["Dpc"],
  "crossword": ["A4q","A4r"],
  "crow": ["A47","A4s","A4v","A4u"],
  "crowd": ["A4w","A42","A4x"],
  "crowded": ["A41","A4z","A4y","EBc","A40"],
  "crown": ["A46","A43","DAO","A44","DzD","A45"],
  "crude oil": ["A48","A49"],
  "cruise": ["A5C","A5A"],
  "cruise ship": ["Eyx"],
  "crunches": ["A5D"],
  "crush": ["A5E"],
  "crust": ["A5G"],
  "crustacean": ["A5F"],
  "crutches": ["DAP","DzE"],
  "cry": ["Df8","A5J","Eb5"],
  "cry cried": ["ETp","Df8"],
  "cry like a baby": ["EBd"],
  "crying": ["Df8","A5H","Eb5"],
  "crystals": ["A5K"],
  "cub": ["A5T"],
  "Cuba": ["A5P","A5N","A5O","A5M"],
  "cube": ["A5R","A5Q"],
  "cuboid": ["A5S"],
  "cucumber": ["DAQ","A5X","DzF","A5V","A5W","A5U"],
  "cucumbers": ["A5Y"],
  "cuddle": ["Eyy"],
  "cue": ["A5Z"],
  "cultivate": ["DT2","A5b"],
  "cultivation": ["DT3","A5c"],
  "culture": ["Dpd"],
  "cumbersom": ["DT4"],
  "cunning": ["DT5","A5d"],
  "cup": ["DAT","A55","DzH","A5e","A5h","A5f","A5g"],
  "cup cake": ["DAS"],
  "cup of coffee": ["A5x"],
  "cup of hot chocolate": ["A50"],
  "cup of tea": ["A53","A54","A51"],
  "cupboard": ["DAR","DzG","A5i","A5m","A5j","A5l","A5k"],
  "cupcake": ["A5o","A5p","A5n","A5q"],
  "cupcakes": ["A5r","A5t","A5s"],
  "cupid": ["A5u","A5v"],
  "cups": ["A56"],
  "cure": ["DT6"],
  "curfew": ["DT7"],
  "curious": ["DT8","A57"],
  "curly": ["A6A"],
  "curly hair": ["A58","A59"],
  "currency": ["A6D","A6B","A6C"],
  "curry": ["A6G","A6E","A6F"],
  "curry and rice": ["DAU"],
  "curtain": ["A6I","A6H"],
  "curtains": ["DAV","A6J","A6L","A6M","DzI","A6K"],
  "cushion": ["DAW","A6O","DzJ","A6N","A6P","A6Q"],
  "cushions": ["A6S","A6T"],
  "custard apple": ["A6U"],
  "custody": ["DT9"],
  "customer": ["Dpe"],
  "customers": ["DUA"],
  "customize": ["DUB"],
  "customs": ["DUC"],
  "cut": ["DgA","DAX","DgC","EW8","DgB","Eb6","Df9","ESp","DzK"],
  "cut cut": ["DgA","ESp","DgB","Df9","DgC"],
  "cut down": ["EW7","EBh"],
  "cut down a tree": ["Df9"],
  "cut down trees": ["EBi"],
  "cut hair": ["EBj"],
  "cut out": ["Eyz"],
  "cut paper": ["DgB","Eb6","EW8","ESp","DgA"],
  "cute": ["A6W"],
  "cutlery": ["A6X","A6Y"],
  "cutting": ["DgC","DgB","DgA","Eb6","Df9"],
  "cutting down a tree": ["Df9"],
  "cutting paper": ["DgA","Eb6","DgB"],
  "cyan": ["DAY"],
  "cyberbullying": ["DUD"],
  "cycle": ["DgD"],
  "cycle cycled": ["DgD"],
  "cycle in the park": ["EBk"],
  "cycle lane": ["A6Z"],
  "cycle quickly": ["ERC"],
  "cycling": ["DgD","A6d","DzL","DAZ","A6e","A6f"],
  "cylinder": ["A6h","A6g"],
  "cypress tree": ["A6i"],
  "Cyprus": ["EBl"],
  "czar": ["A6j"],
  "Czech flag": ["DAa"],
  "Czech republic": ["A6m","A6k"],
  "d": ["DZr","DZs"],
  "dachshund": ["A6n"],
  "dad": ["A6q","A6o","A6t","A6p","EBn","EBo"],
  "daddy": ["A6s","A6r"],
  "daffodil": ["A6u"],
  "dahlia": ["A6v"],
  "dairy": ["A6x","A6w"],
  "dairy product": ["Ey0"],
  "daisy": ["A60","A6z","A6y"],
  "dam": ["DUF","A65","A61","A62"],
  "damage": ["DUE","A64","A63"],
  "damaged": ["Ey1"],
  "damp": ["A66"],
  "dance": ["DgF","DgE","EdM","EXA","A69","EBp","A67","A68"],
  "dance beautifully": ["ERD"],
  "dance danced": ["EUw","DgF","DgE"],
  "dance with a friend": ["EXA"],
  "danced": ["EUw","Dpf"],
  "dancer": ["DAc","A7B","A7A","DAb","EBr","EBq"],
  "dancing": ["DgF","DgE","EdM","A7C"],
  "danger": ["A7G","A7D","A7E"],
  "dangerous": ["DAd","EBs","EhU","A7F"],
  "dangerously": ["ERO"],
  "dark": ["A7K","A7H"],
  "dark blue": ["DAe"],
  "dark brown": ["DAf"],
  "dark green": ["DAh"],
  "dark hair": ["A7I"],
  "dark red": ["DAi"],
  "darker": ["DAg"],
  "darkness": ["A7J"],
  "darts": ["DzN","A7O","DAj","A7L"],
  "date": ["A7S","A7R"],
  "daughter": ["A7V","DZQ","A7U","A7T","EBt","EBv"],
  "daughter in law": ["EBu","DZP"],
  "daughterinlaw": ["EBu"],
  "dawn": ["A7X","A7Y","A7W"],
  "day": ["Ey2"],
  "daydream": ["A7b","A7Z","A7a"],
  "dazzling": ["A7c"],
  "dead": ["DAk","EBw","EhV","EhW"],
  "deal": ["A7d"],
  "death": ["Dpg"],
  "debate": ["DgG","EdN"],
  "debate debated": ["EUx","DgG"],
  "debated": ["EUx"],
  "debating": ["EdN","DgG"],
  "decay": ["A7e"],
  "December": ["Dph"],
  "decide": ["Dpi"],
  "deck": ["A7i"],
  "deck chair": ["A7f","A7g"],
  "deckchair": ["DAl"],
  "declare": ["DUG"],
  "decline": ["A7l","A7k"],
  "decompose": ["A7m","DUI"],
  "decorate": ["DUJ"],
  "decorations": ["A7n","EhX","EBx"],
  "decorator": ["EBy","EBz","DzP","DAn","DAm"],
  "decrease": ["DgH","A7q"],
  "decrease decreased": ["ETg","DgH"],
  "decreased": ["ETg"],
  "decreasing": ["DgH"],
  "deep": ["A7r"],
  "deeper": ["DAo"],
  "deer": ["DAp","A7v","A7s","A7t","DzQ","A7u"],
  "defeat": ["A7w"],
  "defend": ["A7x"],
  "deforestation": ["A70","A7z","DUK"],
  "degree": ["DUL","A71"],
  "dejected": ["DUM","A72"],
  "delete": ["DUN","A73"],
  "delicious": ["DUO"],
  "delighted": ["Dpj","EB0"],
  "deliver": ["DgJ","DgI","Ean","A76","A74"],
  "deliver a package": ["Ean","DgI"],
  "deliver delivered": ["ESq","DgI","DgJ"],
  "deliver letters": ["EB1"],
  "deliver packages": ["EXB","EB2"],
  "delivered": ["ESq"],
  "delivered a package": ["ESq"],
  "delivering": ["Ean","DgJ","DgI"],
  "delivering a package": ["Ean","DgI"],
  "delivery": ["A77"],
  "delivery man": ["DAq","DAr","EB3","EB4"],
  "deliveryman": ["DzR"],
  "delta": ["A78"],
  "Democratic Republic of Congo": ["EB5"],
  "denim": ["A8B","A8A","A79"],
  "Denmark": ["A8F","A8C","EB6","A8D"],
  "Denmark flag": ["DAs"],
  "dental floss": ["DAt"],
  "dentist": ["DAv","DAu","A8H","EB7","A8G","EB8","DzT"],
  "dentistry": ["A8I"],
  "depart": ["DgK","EXC"],
  "depart departed": ["DgK"],
  "depart the station": ["DgK","EXC"],
  "departing": ["DgK"],
  "departing the station": ["DgK"],
  "department store": ["DUP","A8J"],
  "departure": ["Dpk"],
  "deposit": ["DgL","Eao"],
  "deposit deposited": ["ESr","DgL"],
  "deposit money": ["DgL","Eao"],
  "deposited": ["ESr"],
  "deposited money": ["ESr"],
  "depositing": ["Eao","DgL"],
  "depositing money": ["DgL","Eao"],
  "depressed": ["A8M","A8L","EB9","A8K"],
  "describe": ["Ey3"],
  "desert": ["A8P","A8N","DAw","DzU","A8O"],
  "design": ["DgM","DgN","DgO","DUQ","EXD","Eb7","EXE"],
  "design a building": ["DgM"],
  "design buildings": ["EXD"],
  "design clothes": ["DgN","Eb7","EXE"],
  "design designed": ["ETq","DgM","DgN","DgO"],
  "design electricity": ["ECC"],
  "design machines": ["ECD"],
  "design nuclear power": ["ECE"],
  "design software": ["ECF"],
  "designed": ["ETq"],
  "designed clothes": ["ETq"],
  "designer": ["Dpl"],
  "designing": ["Eb7","DgO","DgM","DgN"],
  "designing a building": ["DgM"],
  "designing clothes": ["Eb7","DgN"],
  "desk": ["DAx","A8S","DzV","A8R","A8T"],
  "desktop computer": ["DAy","DzW"],
  "desolate": ["DUR"],
  "desperate": ["DUS","A8U"],
  "dessert": ["A8V","A8X","A8W"],
  "desserts": ["Dpm"],
  "destination": ["Dpn"],
  "destroy": ["A8Y"],
  "destruction": ["DUT","A8Z"],
  "destructive": ["DUU"],
  "detective": ["A8c","A8d"],
  "determined": ["Dpo"],
  "detox": ["Ey4"],
  "development": ["Ey5"],
  "devils": ["ECG"],
  "devoted": ["DUV"],
  "dew": ["A8g","A8e"],
  "diabetes": ["DUW","A8j","A8h"],
  "dial": ["A8k"],
  "diamond": ["A8m","A8n","A8o","A8l"],
  "diary": ["A8q","A8p"],
  "dice": ["DAz","A8s","A8u","A8t","A8r","DzX"],
  "dictionary": ["A8v","A8x","A8w"],
  "did": ["ETr"],
  "did homework": ["ETr"],
  "die": ["A8z","DgP"],
  "die died": ["EUk","DgP"],
  "die out": ["DUX","A8y"],
  "died": ["EUk"],
  "diet": ["DUZ","DUY","A80"],
  "different": ["A84","DUa","A86","A85","A83","A82"],
  "difficult": ["A88","A87","DUb"],
  "dig": ["DgQ","A9C","Eap","DgR"],
  "dig a hole": ["DgQ","DgR"],
  "dig dug": ["ETx","DgQ","DgR"],
  "dig up coal": ["ECH"],
  "digging": ["A89","DgQ","Eap","DgR"],
  "digging a hole": ["DgQ","DgR"],
  "digital": ["A9A","A9B"],
  "digital camera": ["Dpp"],
  "dimples": ["A9D"],
  "dimsum": ["A9H"],
  "dine": ["A9I"],
  "diner": ["A9M","A9J","A9K","A9L"],
  "dingy": ["A9N"],
  "dining room": ["A9P","A9O","A9Q"],
  "dining table": ["A9S","A9R"],
  "dinner": ["A9T","A9Y","A9V","A9U","A9X","A9W"],
  "dinosaur": ["DA0","A9Z","A9e","ECI","A9b","A9c","A9a","A9d"],
  "dinosaurs": ["A9f","A9g","A9h"],
  "dip": ["A9j","A9m","A9i"],
  "director": ["A9n"],
  "dirt": ["A9p","A9o"],
  "dirtier": ["DA1","DA2"],
  "dirty": ["A9u","DA5","DA4","DA3","ECJ","EhY","A9r","EhZ","Eha","A9t","A9q","A9s"],
  "dirty dishes": ["EhZ"],
  "disagreement": ["DUd","DUc","A9v","A9x","A9y"],
  "disappear": ["A91","DUe","A9z"],
  "disappointed": ["DUf","A94","A95","ECK","A93","A92"],
  "disappointing": ["A97","A96"],
  "disappointment": ["DUh"],
  "disc": ["DzY","DA6"],
  "disco": ["BAA","A98","A99"],
  "discount": ["DgS","BAE","DUi","BAC","BAD"],
  "discount discounted": ["EUy","DgS"],
  "discounted": ["EUy"],
  "discounted the price": ["EUy"],
  "discounting": ["DgS"],
  "discover": ["Dpq"],
  "discovery": ["DUj"],
  "discuss": ["DUl"],
  "discussion": ["DUk","BAF"],
  "disgust": ["BAM"],
  "disgusted": ["DA7","BAJ","BAH","BAK","BAI"],
  "disgusting": ["BAL","ECL"],
  "dish": ["BAN","BAO","BAS","BAP","BAQ"],
  "dishcloth": ["DA8"],
  "dishes": ["BAR"],
  "dishonest": ["Ey6"],
  "dishwasher": ["BAV","BAT","ECM","DA9","BAU","DBA"],
  "dislike": ["DgT","EXF","BAW","BAX","BAY","BAZ"],
  "dislike disliked": ["DgT"],
  "dislike ice cream": ["EXF"],
  "dislike icecream": ["DgT"],
  "disliking": ["DgT"],
  "dismal": ["DUm"],
  "dismay": ["DUn"],
  "disneyland": ["BAe"],
  "display": ["DgU","BAf"],
  "display clothes": ["DgU"],
  "display displayed": ["EUn","DgU"],
  "displayed": ["EUn"],
  "displayed tshirts": ["EUn"],
  "displaying": ["DgU"],
  "displaying clothes": ["DgU"],
  "disposable": ["BAg","DUo","BAh"],
  "dissolve": ["DUp","BAi"],
  "distance": ["BAj","BAk"],
  "distant": ["BAo"],
  "distillation": ["BAq","BAp"],
  "distract": ["DUq","BAr"],
  "distress": ["BAt","BAs"],
  "dive": ["DgV","BAw","Eb8","BAv","BAu"],
  "dive dived": ["ETs"],
  "dive dove": ["DgV"],
  "dive into the water": ["DgV"],
  "dive into water": ["Eb8"],
  "dived": ["ETs"],
  "dived into water": ["ETs"],
  "diver": ["BAy"],
  "diverse": ["BAz","BA0"],
  "diversity": ["DUr"],
  "divide": ["DUt"],
  "divided": ["DUs"],
  "diving": ["BA2","DgV","DBB","Eb8"],
  "diving into the water": ["DgV"],
  "divorce": ["Ey7"],
  "dizzy": ["Dpr"],
  "dj": ["BA6","BA4","BA5"],
  "dna": ["BA9","BA7","BA8"],
  "do": ["DgW","DgY","Eb9","DgX","EXL","EXI","EXH","EXG","EXM","EXK","EXJ"],
  "do a jigsaw": ["DgW","EXG"],
  "do business": ["ECP"],
  "do did": ["ETr","DgW","DgX","DgY","DgZ","Dga","Dgc"],
  "do done": ["EVy","EVe","EWJ"],
  "do exercise": ["ECV","ECU"],
  "do experiments": ["DgX"],
  "do gymnastics": ["Ey8"],
  "do homework": ["Dga","DgY","DgZ","Eb9","EXH","ECX","ECW"],
  "do homework well": ["ERE"],
  "do housework": ["Dpt"],
  "do judo": ["Ey9"],
  "do karate": ["Dgb","EXI"],
  "do laundry": ["Dgc","EXJ"],
  "do magic": ["Dgd","ECY"],
  "do magic tricks": ["EXK"],
  "do maths": ["Dge"],
  "do my homework": ["Dpu"],
  "do operations": ["ECd"],
  "do push ups": ["EXL","Dgf"],
  "do pushups": ["EXL"],
  "do puzzles": ["EzA"],
  "do research": ["Dgg"],
  "do some research": ["EXM"],
  "do the dishes": ["Dpv"],
  "do the laundry": ["EzB"],
  "do the shopping": ["EzC"],
  "do the washing": ["EzD"],
  "do the washing up": ["EzE"],
  "do up": ["Dgh","ECf"],
  "do up didup": ["Dgh"],
  "do yoga": ["Dpz","ECg"],
  "do you drink coffee": ["ECh"],
  "do you have a cat": ["ECi"],
  "do you have an umbrella": ["ECj"],
  "do you know how to drive": ["ECk"],
  "do you like cats": ["ECl"],
  "do you like ice cream": ["ECm"],
  "do you like indian food": ["ECn"],
  "do you like spicy food": ["ECo"],
  "do your homework": ["Dp0"],
  "dock": ["BBF","BBB","BBE"],
  "doctor": ["DBD","BBJ","BBG","ECR","DBC","ECQ","BBI","BBH","Dzc"],
  "document": ["DUu","BBM","BBK","BBL"],
  "documentary": ["Dps"],
  "dodo": ["BBP","BBO"],
  "does your friend have long hair": ["ECS"],
  "does your friend like chocolate": ["ECT"],
  "dog": ["BBa","DBE","Dzd","BBU","BBT","BBR","BBS","BBQ"],
  "dog bed": ["BBV"],
  "dog house": ["BBX","BBY","BBW","BBZ"],
  "dogs": ["BBb"],
  "doing": ["DgY","DgW","Eb9","DgX"],
  "doing a jigsaw": ["DgW"],
  "doing exercise": ["BBc"],
  "doing experiments": ["DgX"],
  "doing homework": ["Dga","Eb9","DgY","DgZ"],
  "doing karate": ["Dgb"],
  "doing laundry": ["Dgc"],
  "doing magic": ["Dgd"],
  "doing maths": ["Dge"],
  "doing push ups": ["Dgf"],
  "doing research": ["Dgg"],
  "doing up": ["Dgh"],
  "doll": ["BBg","BBd","BBj","BBe","BBf"],
  "doll house": ["BBi","BBh"],
  "dolls": ["BBk"],
  "dolphin": ["DBF","BBt","Dze","BBm","BBl","BBr","BBo","BBn","BBq","BBp","BBs"],
  "dolphins": ["BBv","BBu"],
  "dome": ["BBx","BBw"],
  "Dominican republic": ["BB0","BBy"],
  "domino": ["BB6"],
  "dominoes": ["BB1","BB4"],
  "don't have a beard": ["EeX"],
  "don't have a moustache": ["EeY"],
  "don't have a shell": ["Eea"],
  "don't have a tail": ["Eeb"],
  "don't have arms": ["EeZ"],
  "don't have feathers": ["Eec"],
  "don't have hair": ["Eed"],
  "don't have legs": ["Eee"],
  "don't have long hair": ["Eef"],
  "don't have wings": ["Eeg"],
  "don't like cake": ["Eeh"],
  "don't like doing yoga": ["Eei"],
  "don't like drinking coffee": ["Eej"],
  "don't like hamburgers": ["Eek"],
  "don't like maths": ["Eel"],
  "don't like paying money": ["Eem"],
  "don't like playing cards": ["Een"],
  "don't like playing the trumpet": ["Eeo"],
  "don't like table tennis": ["Eep"],
  "don't like taking exams": ["Eeq"],
  "don't like wine": ["Eer"],
  "donate": ["BB7"],
  "done": ["EVy","EVe","EWJ"],
  "done her homework": ["EVy"],
  "done laundry": ["EVe"],
  "done yoga": ["EWJ"],
  "donkey": ["BB9","DBG","BCC","Dzf","BB8","BCA","BCD","BCB"],
  "dont cry over spilt milk": ["ECa","ECb","ECc"],
  "donut": ["DBH","BCE","BCH","Egg","BCI","BCF"],
  "donuts": ["DBI","BCM","BCL","Dzg","BCK"],
  "door": ["DBL","Dzj","BCQ","BCR","BCW","BCP","BCO","BCN"],
  "door handle": ["DBJ","Dzh"],
  "doorbell": ["BCV","BCS","BCT"],
  "doormat": ["DBK"],
  "doors": ["BCX"],
  "dormintory": ["DUv"],
  "dormitory": ["BCY"],
  "dormouse": ["BCZ"],
  "dot": ["EzF"],
  "dots": ["BCa"],
  "double bass": ["BCb","BCc","BCd","BCe"],
  "double bed": ["BCh","BCg","BCf"],
  "double decker bus": ["BCj"],
  "dough": ["BCr","BCo","BCn"],
  "doughnut": ["BCq","BCp"],
  "dove": ["BCw","BCt","BCs","BCu"],
  "down": ["Dpw","Dpy"],
  "download": ["BCy","BC0","BCx","Dpx"],
  "downpour": ["BC1"],
  "downstairs": ["BC2"],
  "downtown": ["BC3"],
  "doze": ["BC7","BC4","BC5"],
  "dozen": ["BC6"],
  "dracula": ["BC9","BC8"],
  "dragon": ["BDO","DBN","BDA","BDB","Dzk","BDC"],
  "dragon boat festival": ["BDD","BDE"],
  "dragon fruit": ["DBM","BDM","BDL","BDK","BDN","Egh"],
  "dragonfly": ["BDH","BDF","BDJ","BDG","BDI"],
  "drain": ["DBO","Dzl"],
  "drama": ["BDP"],
  "drama club": ["EzG"],
  "drank": ["ETt"],
  "drank water": ["ETt"],
  "draw": ["Dgl","Dgj","EXO","BDX","Dgk","EcA","BDQ","Dgi","EXN"],
  "draw a line": ["EXN","Dgi"],
  "draw a picture": ["BDR"],
  "draw drawn": ["EVz"],
  "draw drew": ["ETv","Dgj","Dgk","Dgl","Dgi"],
  "draw images": ["EXO"],
  "draw on the board": ["Dgk","EcA","Dgj"],
  "draw pictures": ["Dp1","ECr"],
  "drawer": ["BDT","BDS"],
  "drawers": ["DBP","BDV","Dzm","BDU"],
  "drawing": ["Dgl","Dgj","BDW","EcA","Dgk","Dgi"],
  "drawing a line": ["Dgi"],
  "drawing a picture": ["EzH"],
  "drawing on the board": ["Dgj","Dgk","EcA"],
  "drawing pictures": ["EzI"],
  "drawn": ["EVz"],
  "drawn on the board": ["EVz"],
  "dreadful": ["EzJ"],
  "dream": ["Dgn","Dgo","Eaq","EXP","Dgm","BDZ","BDa"],
  "dream about basketball": ["EXP","Dgn"],
  "dream dreamed": ["Dgm","ETu","Dgn","Dgo"],
  "dreamed": ["ETu"],
  "dreaming": ["Dgn","Dgo","Dgm","Eaq"],
  "dreaming about basketball": ["Dgn"],
  "dress": ["DBS","Dzp","BDe","BDg","BDd","BDf","BDc","BDb","BDh","BDk"],
  "dress up": ["Dgq","Dgp","EXQ","ECs"],
  "dress up dressed up": ["Dgp","Dgq"],
  "dress up for halloween": ["EXQ"],
  "dresser": ["DBQ","Dzn","BDj","BDi"],
  "dressing gown": ["DBR","Dzo"],
  "dressing table": ["EzK"],
  "dressing up": ["Dgp","Dgq"],
  "drew": ["ETv"],
  "drew on the board": ["ETv"],
  "dried": ["EUi"],
  "drier": ["DBT"],
  "drill": ["DBU","BDp","Dzq","BDn","BDo"],
  "drink": ["Dgu","Dgv","EcB","Dgr","BDu","EdO","BDr","EXS","Dgs","Dgt","BDq","EXR"],
  "drink coffee": ["Dgr","Dgt","EdO","EXR","Dgs"],
  "drink drank": ["ETt","Dgv","Dgr","Dgt","Dgu","Dgs"],
  "drink drunk": ["EV0"],
  "drink water": ["Dgv","EcB","EXS"],
  "drinking": ["Dgu","EcB","Dgv","Dgr","BDs","EdO","Dgt","BDt","Dgs"],
  "drinking coffee": ["Dgr","Dgt","EdO","Dgs"],
  "drinking water": ["Dgv","EcB"],
  "drinks": ["BDv"],
  "drip": ["BDw"],
  "drive": ["Dgy","Dgw","Dgx","BD0","EcC","BDy","EXT","BDx"],
  "drive a bus": ["BDz"],
  "drive a car": ["Dgw","Dgx","EcC","EXT","ECt"],
  "drive a limo": ["ECu"],
  "drive a truck": ["ECv"],
  "drive driven": ["EVS"],
  "drive drove": ["Dgw","Dgx","Dgy","ESs"],
  "driven": ["EVS"],
  "driven his car": ["EVS"],
  "driver": ["DBV","DBW","BD3","ECw","BD2","Dzr","BD1","ECx"],
  "driving": ["Dgy","Dgx","Dgw","EcC","BD5"],
  "driving a car": ["EcC","Dgw","Dgx"],
  "drizzle": ["DBY","DBX"],
  "drone": ["DBZ","BD8","Dzs","BEA","BD6","BD9"],
  "drop": ["Dgz","EcD","BEE","BEB","BEC"],
  "drop a ball": ["EcD","Dgz"],
  "drop dropped": ["ETw","Dgz"],
  "dropped": ["ETw"],
  "dropped a ball": ["ETw"],
  "dropping": ["EcD","Dgz"],
  "dropping a ball": ["EcD","Dgz"],
  "drought": ["BEI","BEG","BEF","BEH"],
  "drove": ["ESs"],
  "drowsy": ["BEK"],
  "drugstore": ["BEL"],
  "drum": ["BEP","BEO","BEM","BEN"],
  "drums": ["DBa","Dzt","BEU","BES","BET","BEQ","BER"],
  "drunk": ["EV0","BEW"],
  "drunk coffee": ["EV0"],
  "dry": ["Dg0","BEa","EXU","ECy","BEX","EdD"],
  "dry clothes": ["Dg0"],
  "dry dried": ["EUi","Dg0"],
  "dry in the sun": ["EXU"],
  "dry the dishes": ["Dp2"],
  "dryer": ["BEY","BEZ"],
  "drying": ["Dg0","EdD"],
  "drying clothes": ["Dg0"],
  "Dublin": ["BEb"],
  "duck": ["DBb","BEl","BEd","Dzu","BEc","BEf","BEe"],
  "duckling": ["BEh","BEi","BEg"],
  "ducklings": ["BEk","BEj"],
  "ducks": ["BEm"],
  "duct tape": ["BEn"],
  "dug": ["ETx"],
  "dug a hole": ["ETx"],
  "dull": ["Dp3"],
  "dump": ["BEu","BEp"],
  "dumpling": ["BEq"],
  "dumplings": ["BEt","DBc","BEs","BEr"],
  "dune": ["BEw"],
  "dung beetle": ["BE1","BE2"],
  "dungarees": ["BEy","BEx"],
  "duration": ["DUw","BE3"],
  "durian": ["BE7","BE5","BE6","BE4"],
  "dust": ["BE9"],
  "dustpan and brush": ["DBd","BE8","Dzv"],
  "dusty": ["DUx"],
  "dvd player": ["Dp4"],
  "dwarf": ["BFB"],
  "dye": ["BFC"],
  "dying": ["DgP"],
  "dynamo": ["BFD"],
  "e": ["DZt","DZu"],
  "eager": ["BFE","BFF"],
  "eagle": ["DBe","BFJ","BFG","Dzw","BFI","BFH"],
  "ear": ["DBj","BFK","BFU","BFL"],
  "ear buds": ["DBf","Dzx"],
  "ear lobe": ["DBg"],
  "ear piercing": ["BFT","BFS"],
  "earache": ["EzL"],
  "early": ["DUy","BFM"],
  "earmuffs": ["DBh"],
  "earn": ["BFN"],
  "earphones": ["DBi","BFO","Dzy","BFQ","BFR","BFP"],
  "earring": ["DBk","Dzz"],
  "earrings": ["DBl"],
  "ears": ["DBm","Dz0"],
  "earth": ["BFW","D6q","DOi","BFV"],
  "earthquake": ["BFX","BFY","BFZ"],
  "earthworm": ["BFc","BFa","BFb"],
  "easier": ["DBn"],
  "easily": ["ERH"],
  "east": ["EzM"],
  "easter": ["BFh","BFd"],
  "easter bunny": ["BFe"],
  "easter egg": ["BFf","BFg"],
  "easy": ["BFi","ECz"],
  "easygoing": ["DUz"],
  "eat": ["Dg1","Dg2","EcE","Dg6","Dg3","Dg8","BFk","EdP","EXV","Dg4","Dg7","BFn","EXY","BFj","Dg5","Dg9","BFl","EC0","EXX","EXW"],
  "eat a burger": ["Dg2","EXV"],
  "eat a spider": ["Dg4","EXW"],
  "eat an apple": ["Dg3","EC1"],
  "eat ate": ["ETk","Dg2","Dg1","Dg8","Dg3","Dg5","Dg6","Dg4","Dg7","Dg9"],
  "eat breakfast": ["Dp5","Dp6"],
  "eat cake": ["Dg5","EdP"],
  "eat carrots": ["EXX"],
  "eat dinner": ["Dp7"],
  "eat eaten": ["EVu","EVM","EVn","EV1"],
  "eat fruit": ["EzN"],
  "eat hastily": ["ERF"],
  "eat like a horse": ["EC2","EC3","EC4"],
  "eat lunch": ["Dg6","EC5"],
  "eat messily": ["ERG"],
  "eat out": ["Dp8"],
  "eat pizza": ["Dg7","EcE"],
  "eat popcorn": ["Dg9"],
  "eat snacks": ["EzO"],
  "eat soup": ["EXY"],
  "eat vegetables": ["EzP"],
  "eaten": ["EVu","EVM","EVn","EV1"],
  "eaten a spider": ["EVu"],
  "eaten an apple": ["EVM"],
  "eaten lunch": ["EVn"],
  "eaten the banana": ["EV1"],
  "eating": ["Dg2","Dg1","EcE","Dg5","BFm","EdP","Dg8","Dg3","Dg6","Dg7","Dg9","Dg4"],
  "eating a burger": ["Dg2"],
  "eating a spider": ["Dg4"],
  "eating an apple": ["Dg3"],
  "eating cake": ["EdP","Dg5"],
  "eating lunch": ["Dg6"],
  "eating pizza": ["Dg7","EcE"],
  "eating popcorn": ["Dg9"],
  "ebook": ["BFs","BFo","BFp","BFq","BFr"],
  "ecommerce": ["BFu"],
  "economy": ["BFv"],
  "ecosystem": ["BFx","BFw"],
  "edge": ["EzQ"],
  "edgy": ["BFy"],
  "education": ["DU0","BFz","BF0","BF1"],
  "eel": ["BF3","BF4","BF2"],
  "eerie": ["EzR"],
  "egg": ["DBp","BF6","D0o","BF8","BGJ","BF9","BF5","BF7"],
  "egg cup": ["BGB","BGC"],
  "egg tarts": ["BGP","BGQ"],
  "eggplant": ["DBo","BGD","BGF","Dz1","BGI","BGE","BGH","BGG"],
  "eggs": ["BGK","BGN","BGO","BGL","BGM","DxJ","Dz2"],
  "Egypt": ["DBs","BGV","BGS","EC7","Dz3","BGT","BGR","BGU"],
  "Egypt flag": ["DBq"],
  "Egyptian": ["DBr","EeJ"],
  "Eid": ["BGW"],
  "eight": ["Daf","Dab"],
  "eight hundred": ["Dae"],
  "eight o'clock": ["Dd8"],
  "eight thousand": ["Dag"],
  "eighteen": ["Dad","Dac"],
  "eighty": ["Dan","Dah"],
  "eighty eight": ["Dai"],
  "eighty five": ["Daj"],
  "eighty four": ["Dak"],
  "eighty nine": ["Dal"],
  "eighty one": ["Dam"],
  "eighty seven": ["Dao"],
  "eighty six": ["Dap"],
  "eighty thousand": ["Daq"],
  "eighty three": ["Dar"],
  "eighty two": ["Das"],
  "El Salvador": ["EDE"],
  "elbow": ["DBt","Dz4"],
  "elder": ["BGX","BGY"],
  "elderly": ["EC8","Ehs"],
  "electric drill": ["BGZ","BGa"],
  "electric guitar": ["BGb","BGc","BGd","BGe","BGf","BGg"],
  "electric piano": ["BGo"],
  "electric toothbrush": ["BGp"],
  "electrical engineer": ["EDA","EC9","DBu","DBv"],
  "electrician": ["DBw","DBx","DU1","EDC","Dz5","EDB","BGi"],
  "electricity": ["BGm","DU2","BGn"],
  "elegant": ["BGq","BGr"],
  "elephant": ["DBy","BGx","Dz6","BGs","BGt","BGu","BGv","BGw"],
  "elephants": ["BGy"],
  "elevator": ["DBz","BG1","BGz","Dz7","BG0"],
  "eleven": ["Dau","Dat"],
  "eleven minutes past five": ["Dd9"],
  "elf": ["BG6","Ehb","BG3","BG5","EDD","BG4"],
  "elm tree": ["BG7"],
  "email": ["BG8","BHB","BHA","BG9"],
  "embarrased": ["DU3"],
  "embarrassed": ["BHE","BHC","DB0","BHD"],
  "embarrassing": ["BHF"],
  "embassy": ["EzS"],
  "emerald": ["BHH","BHG"],
  "emergency": ["Dp9"],
  "emergency exit": ["BHJ","BHI"],
  "emission": ["DU4","BHM"],
  "emo": ["BHO","BHN"],
  "emotions": ["BHP"],
  "emperor": ["BHQ"],
  "employment": ["BHS","BHR"],
  "emptied": ["ESt"],
  "emptied a bin": ["ESt"],
  "empty": ["DhA","EDF","BHW","BHV","BHT","BHU","Ear"],
  "empty emptied": ["ESt"],
  "empty emptyed": ["DhA"],
  "empty the bin": ["DhA","Ear"],
  "emptying": ["Ear","DhA"],
  "emptying the bin": ["Ear","DhA"],
  "encounter": ["DU5"],
  "encourage": ["DhB","BHY","Eas","DU6"],
  "encourage a friend": ["DhB"],
  "encourage encouraged": ["ESu","DhB"],
  "encourage someone": ["Eas"],
  "encouraged": ["ESu"],
  "encouraged his friend": ["ESu"],
  "encouraging": ["DhB","Eas"],
  "encouraging a friend": ["DhB"],
  "end": ["BHa","BHZ"],
  "endangered": ["DU7"],
  "endurance": ["DU8","BHb"],
  "energentic": ["DU9"],
  "energetic": ["BHc"],
  "energy": ["DqA"],
  "energy bar": ["EzT"],
  "energy source": ["BHd"],
  "engine": ["BHg","BHf","BHh","BHe"],
  "engineer": ["Dz8"],
  "England": ["DB2","BHm","BHl","BHj","EDG","Dz9"],
  "England flag": ["DB1"],
  "English": ["DB3","BHo","DB5","D0A","EeK"],
  "English breakfast": ["DB4"],
  "English class": ["BHn"],
  "enhance": ["DVA"],
  "enjoy": ["DVB","DhC","BHp","BHq","BHs","EXZ"],
  "enjoy enjoyed": ["DhC","ETy"],
  "enjoy reading": ["EXZ","DhC"],
  "enjoyable": ["EzU"],
  "enjoyed": ["ETy"],
  "enjoyed reading a book": ["ETy"],
  "enjoying": ["BHr","DhC"],
  "enjoying reading": ["DhC"],
  "enormous": ["BHt","BHv","BHu"],
  "enter": ["EzV"],
  "entertain": ["BHw"],
  "entertain children": ["EDH"],
  "entertainment": ["DVC"],
  "enthusiam": ["DVD"],
  "enthusiasm": ["BHx"],
  "Enthusiastically": ["DVE"],
  "entrance": ["BH0","BHy","BHz"],
  "envelope": ["DB6","D0B","BH3","BH2","BH4","BH1"],
  "envious": ["EzW"],
  "environment": ["BH7","BH5","BH9","BH6"],
  "environmentalist": ["DVF","BH8"],
  "environmentally friendly": ["DVG"],
  "equality": ["DVH","BIB","BIA"],
  "equals sign": ["EzX"],
  "equation": ["BID","BIC"],
  "equator": ["DVJ"],
  "equipment": ["BIF","BIE"],
  "equivalent": ["DVK"],
  "erase": ["EzY"],
  "eraser": ["BIH","BII","BIG","DB7","D0C"],
  "erode": ["DVL","BIK","BIJ"],
  "erosion": ["DVM","BIL"],
  "error message": ["BIO"],
  "erupt": ["DhD"],
  "erupt erupted": ["DhD"],
  "erupting": ["DhD"],
  "eruption": ["BIP","BIR","BIQ"],
  "escalate": ["DVN"],
  "escalator": ["DB8","BIV","BIS","BIT","BIU"],
  "escape": ["BIX","DVO","BIW"],
  "espresso": ["DB9","Egi"],
  "essential": ["EzZ"],
  "esteemed": ["DVP"],
  "estimate": ["DVQ"],
  "Estonia": ["EDI"],
  "Ethiopia": ["EDJ"],
  "ethnic minorities": ["DVR"],
  "ethnic minority": ["DqB"],
  "Europe": ["BIY","BIb","BId","BIa","BIZ"],
  "European union": ["BIc"],
  "evaporate": ["DVS"],
  "evaporation": ["DVT"],
  "even numbers": ["Eza"],
  "evening": ["BIe"],
  "event": ["BIf"],
  "eventually": ["Ezb"],
  "Everest": ["BIi","BIg","BIh"],
  "every": ["Ezc"],
  "everyone": ["BIj"],
  "evil": ["BIl","BIm","BIk"],
  "evolution": ["BIo","BIn"],
  "evolve": ["DVU"],
  "exaggerate": ["DVV"],
  "exam": ["BIr","BIp"],
  "examine": ["BIq","DhE","EXb"],
  "examine a patient": ["DhE"],
  "examine examined": ["DhE"],
  "examine eyes": ["EDK"],
  "examine someone": ["EXb"],
  "examining": ["DhE"],
  "examining a patient": ["DhE"],
  "example": ["DqC"],
  "excavate": ["DVW"],
  "excavation": ["BIs"],
  "exceed": ["BIt"],
  "exchange": ["DhG","DhF","DVY","BIu","EdQ"],
  "exchange exchanged": ["ESd","DhF","DhG"],
  "exchange money": ["DhG","EdQ","DhF"],
  "exchanged": ["ESd"],
  "exchanged money": ["ESd"],
  "exchanging": ["DhF","DhG"],
  "exchanging money": ["EdQ","DhF","DhG"],
  "excited": ["DVZ","DCA","BIv","BIw","EDL"],
  "exciting": ["BIx","BIy","DCB"],
  "executioner": ["BIz"],
  "exercise": ["DhH","EdR","BI3","BI4","BI1","BI2"],
  "exercise exercised": ["DhH","EUz"],
  "exercised": ["EUz"],
  "exercising": ["DhH","EdR"],
  "exhausted": ["DCC","BI7","EDM"],
  "exhibit": ["DVb"],
  "exhibition": ["BI9","DVa","BJA"],
  "exhilarate": ["DVd"],
  "exhilarated": ["DVc"],
  "exile": ["DVe"],
  "exit": ["DqD"],
  "exotic": ["BJF","BJD"],
  "expand": ["BJG"],
  "expel": ["DVg"],
  "expenditure": ["DVh"],
  "expensive": ["DCD","Ehc","DVi","EDN","BJH","BJJ"],
  "experience": ["DqE"],
  "experiment": ["Ezd"],
  "expired": ["DVj"],
  "explain": ["DhI","DVk","BJO","EXc","BJL","BJN"],
  "explain explained": ["DhI"],
  "explain some science": ["EXc"],
  "explaining": ["DhI"],
  "exploration": ["Eze"],
  "explore": ["BJQ","BJP"],
  "explorer": ["DVl","BJR"],
  "explosion": ["BJU","BJS","BJT"],
  "expunge": ["DVm"],
  "extended family": ["Ezf"],
  "extension cord": ["BJV","BJW"],
  "exterior": ["DVn"],
  "extinct": ["DVo"],
  "extract": ["BJX"],
  "extraordinary": ["DVq"],
  "eye": ["DCI","BJj","BJa","BJZ","BJY"],
  "eyebrow": ["DCE","D0E","BJd","BJb"],
  "eyebrows": ["DCF"],
  "eyelash": ["DCH","BJe","BJi","BJf","BJg"],
  "eyelashes": ["DCG","BJh"],
  "eyes": ["DCJ","D0F","BJk","BJm","BJl"],
  "f": ["DZv","DZw"],
  "fabric": ["BJo","BJn"],
  "face": ["DCK","DVr","BJp","BJr","BJs","BJq"],
  "face to face": ["DVs"],
  "facebook": ["DqF"],
  "facial expression": ["BJt","BJv","BJu"],
  "facility": ["BJw"],
  "factory": ["DCL","D0G","BJz","BJy","BJx"],
  "fail": ["DhJ"],
  "fail a test": ["DhJ"],
  "fail an exam": ["DVt"],
  "fail failed": ["DhJ","EVT","ESv"],
  "failed": ["EVT","ESv"],
  "failed a test": ["ESv"],
  "failed the test": ["EVT"],
  "failing": ["DhJ"],
  "failing a test": ["DhJ"],
  "fair": ["Ezg"],
  "fair hair": ["BJ0"],
  "fairy": ["BJ4","BJ3","BJ1","BJ2"],
  "fairy tale": ["Ezh"],
  "fairy tales": ["DVu"],
  "falcon": ["BJ5","BJ6","BJ8","BJ7"],
  "fall": ["BKD","DhM","DhK","DhN","BKC","EXe","BKH","BJ9","BKB","BKA","DhL"],
  "fall asleep": ["DhL"],
  "fall asleep fell asleep": ["DhL"],
  "fall down": ["EDO"],
  "fall fell": ["DhK","EUq","DhN"],
  "fall from a tree": ["EXe"],
  "fall in love": ["BKG","DVv"],
  "fall out": ["DVw"],
  "fall over": ["DhM","Eat"],
  "fall over fell over": ["DhM"],
  "falling": ["DhK","DhN","DhL","DhM"],
  "falling asleep": ["DhL"],
  "falling over": ["Eat","DhM"],
  "falling rocks": ["BKE"],
  "fallorautumn": ["DqG"],
  "family": ["DZR","BKK","BKJ","BKI"],
  "family reunion": ["Ezi"],
  "famine": ["DVx"],
  "famished": ["DVy"],
  "famous": ["DVz"],
  "famous for": ["Ezj"],
  "fan": ["DCM","BKR","D0H","BKM","BKL","BKN","BKO"],
  "fancy": ["DqH"],
  "fangs": ["BKQ","BKP"],
  "fanny pack": ["Ezk"],
  "fans": ["DqI"],
  "fantastic": ["DV0","BKS"],
  "fantasy": ["BKT"],
  "far": ["BKU","BKh"],
  "faraway": ["EDQ"],
  "farm": ["BKg","BKX","BKW","BKZ","BKY","BKV"],
  "farm house": ["BKf"],
  "farmer": ["DCO","EDS","DCN","BKd","BKe","EDR","BKa","BKb","BKc","D0I"],
  "fascinating": ["DV1"],
  "fashion": ["BKl"],
  "fashion designer": ["DCP","D0J","DV2","EDT","DCQ"],
  "fashionable": ["BKi","BKk"],
  "fast": ["DCT","BKm","BKp","EDY","Ehd","BKn"],
  "fast as lightning": ["EDV","EDW","EDX"],
  "fast food": ["Ezl"],
  "fast horse": ["BKo"],
  "faster": ["DCR","DCS"],
  "fat": ["DCU","Ehe","EDc","BKq","BKs","BKr"],
  "fatal": ["BKt"],
  "father": ["BKv","DZT","BKu","EDb"],
  "father christmas": ["EDZ"],
  "Father Christmas": ["Eh3"],
  "father in law": ["EDa","DZS"],
  "fatherinlaw": ["EDa"],
  "fatter": ["DCV"],
  "faucet": ["BKz","DCW","D0K","BK0","BKx"],
  "favorite": ["Ezm"],
  "fawn": ["BK1","BK2"],
  "fax  machine": ["BK3"],
  "fear": ["BK4","BK6"],
  "fearful": ["BK5"],
  "fearless": ["DV3"],
  "feast": ["DV4","BK7"],
  "feather": ["BK8","BLA"],
  "feather duster": ["BK9"],
  "feathers": ["DCX","BLB","D0L"],
  "February": ["DqJ"],
  "fed": ["ETz"],
  "fed the dog": ["ETz"],
  "fed up": ["EDd","EDe","EDf"],
  "feeble": ["DV5"],
  "feed": ["DhP","DhO","BLG","EcF","EXf","BLC","BLD"],
  "feed a cat": ["DhO","EXf"],
  "feed a dog": ["EcF"],
  "feed fed": ["DhO","ETz","DhP"],
  "feed my pet": ["Ezn"],
  "feed the cat": ["DqK"],
  "feed the dog": ["DhP","BLH"],
  "feedback": ["BLE","BLF"],
  "feeding": ["DhP","DhO","EcF"],
  "feeding a cat": ["DhO"],
  "feeding the dog": ["DhP"],
  "feel": ["DhR","DhQ","EXg"],
  "feel anxious": ["DV6"],
  "feel blue": ["EDg","EDh","EDi"],
  "feel bored": ["DhQ"],
  "feel dizzy": ["DV7"],
  "feel felt": ["DhR","ET0","DhQ"],
  "feel sick": ["DhR","DV8","EXg"],
  "feel tired": ["DV9"],
  "feel weak": ["Ezp"],
  "feeling": ["DhR","DhQ"],
  "feeling bored": ["DhQ"],
  "feeling sick": ["DhR"],
  "feelings": ["Ezo"],
  "feet": ["DCY","BLJ","BLK","BLI"],
  "fell": ["EUq"],
  "felt": ["ET0"],
  "felt bored": ["ET0"],
  "felt tip": ["BLL"],
  "female": ["BLN","BLM"],
  "femur": ["DWA","BLO"],
  "fence": ["DCZ","BLQ","BLP","D0M"],
  "fencing": ["DqL"],
  "fern": ["BLS","BLR"],
  "ferocious": ["BLT"],
  "Ferrari": ["DqM"],
  "ferret": ["BLU"],
  "ferris wheel": ["BLV","BLW"],
  "ferry": ["BLX"],
  "fertile": ["DWB","BLY"],
  "festival": ["DWC","BLZ"],
  "fetch": ["BLa"],
  "fever": ["BLc","BLb"],
  "fidget toy": ["BLd","BLe"],
  "field": ["BLj","BLi","BLh","BLg","BLf"],
  "fierce": ["BLk"],
  "fifteen": ["Daw","Dav"],
  "fifteen thousand": ["Dax"],
  "fifth": ["Ezq"],
  "fifty": ["Da4","Day"],
  "fifty eight": ["Daz"],
  "fifty five": ["Da0"],
  "fifty four": ["Da1"],
  "fifty nine": ["Da2"],
  "fifty one": ["Da3"],
  "fifty seven": ["Da5"],
  "fifty six": ["Da6"],
  "fifty thousand": ["Da7"],
  "fifty three": ["Da8"],
  "fifty two": ["Da9"],
  "fig": ["BLn","BLm","BLq","BLl"],
  "fight": ["DhS","BLp","EdS","BLo"],
  "fight fought": ["EU0","DhS"],
  "fighting": ["DhS","EdS"],
  "figs": ["BLr","BLu"],
  "Fiji": ["EDj"],
  "file": ["BLv","BLw","BLx"],
  "fill": ["DhT","DhU","EcG","DWD"],
  "fill a glass": ["DhT","EcG","DhU"],
  "fill filled": ["ESe","DhT","DhU"],
  "fill out": ["DhW","EDk","DhV","EcH"],
  "fill out a form": ["EcH","DhV"],
  "fill out filled out": ["DhV","DhW"],
  "fill up": ["DhX"],
  "fill up filled up": ["DhX"],
  "filled": ["ESe"],
  "filled a glass": ["ESe"],
  "filling": ["EcG","DhU","DhT"],
  "filling a glass": ["EcG","DhT","DhU"],
  "filling out": ["EcH","DhW","DhV"],
  "filling out a form": ["EcH","DhV"],
  "filling up": ["DhX"],
  "film": ["BLz"],
  "film director": ["Ezr"],
  "film movies": ["EDm"],
  "film star": ["DWE","BL0"],
  "filtered coffee": ["BL1"],
  "fin": ["DCd","BL4","BL3","BL2","BMN"],
  "find": ["BL6","BL5"],
  "find found": ["Ezs"],
  "find out": ["DWF"],
  "fine": ["Ezt"],
  "finger": ["DCb","BL7","BL8","D0N","BL9"],
  "finger nail": ["DCa"],
  "fingerprint": ["BMB"],
  "fingerprint scan": ["BMC"],
  "fingers": ["DCc","BMD","BME"],
  "finish": ["BMG","BMH","DhY","DWH","BMF","EXh"],
  "finish class": ["DWG"],
  "finish finished": ["DhY","EV2","EV3"],
  "finish school": ["DhY","EXh"],
  "finish work": ["DWI"],
  "finished": ["EV2","EV3"],
  "finished her homework": ["EV2"],
  "finished the painting": ["EV3"],
  "finishing": ["DhY"],
  "finishing school": ["DhY"],
  "Finland": ["BMM","BMI","BML"],
  "fins": ["BMO"],
  "fire": ["BMj","BMQ","BMP","BMR"],
  "fire engine": ["BMW","DCe","BMX","BMY","D0O"],
  "fire extinguisher": ["DCf","D0P"],
  "fire station": ["BMk"],
  "fire truck": ["BMl"],
  "fireball": ["BMV","BMS","BMT","BMU"],
  "fired": ["DWJ"],
  "firefighter": ["DCh","BMa","DCg","BMb","BMd","EDp","EDo","BMZ","BMc","D0Q"],
  "firefighters": ["DqN"],
  "fireman": ["BMf","BMe"],
  "fireplace": ["DCi","BMi","D0R","BMg"],
  "fireworks": ["BMo","BMn","BMm","DCj","D0S"],
  "first": ["DqO"],
  "first aid kit": ["BMp","BMq"],
  "first left": ["Ezu"],
  "first right": ["Ezv"],
  "fish": ["Ezw","DCp","D0T","DCk","BNH","BMt","BMs","BMr","DCl","BMu","DhZ","D0V","Eau","BMv"],
  "fish and chips": ["BMw","DCm","BMy","Egj","BMx"],
  "fish bowl": ["BM2","BM3","BMz","BM0","BM1"],
  "fish fished": ["DhZ"],
  "fisherman": ["DCo","DCn","BM6","EDr","EDq","BM7","BM4","BM5"],
  "fishing": ["DhZ","BNA","Eau","BM8","BM9"],
  "fishing rod": ["BNC","BNB","BND"],
  "fishmonger": ["BNG","BNF"],
  "fist": ["BNK","BNI","BNJ"],
  "fit": ["BNP","BNL","EDy"],
  "fit as a fiddle": ["EDs","EDt","EDu"],
  "fit like a glove": ["EDv","EDw","EDx"],
  "fitness": ["BNO"],
  "fitness center": ["BNM","BNN"],
  "fitness centre": ["BNN","BNM"],
  "five": ["DbC","DbA"],
  "five hundred": ["DbB"],
  "five o'clock": ["DeA"],
  "five past six": ["DeB","EfR"],
  "five past twelve": ["DeC"],
  "five thousand": ["DbD"],
  "five to twelve": ["DeD","EfS"],
  "fix": ["Dhc","Dha","Eav","Dhb","BNQ","EXi","BNS","BNR","EXj"],
  "fix a car": ["Dha","Eav"],
  "fix a computer": ["Dhb"],
  "fix cars": ["EDz"],
  "fix computers": ["ED0"],
  "fix fixed": ["Dha","Dhb","Dhc"],
  "fix the computer": ["EXi"],
  "fix the water": ["Dhc"],
  "fix the water pipes": ["EXj"],
  "fix water pipes": ["ED1"],
  "fixing": ["Eav","Dhc","Dha","Dhb"],
  "fixing a car": ["Dha","Eav"],
  "fixing a computer": ["Dhb"],
  "fixing the water": ["Dhc"],
  "fizzy drink": ["BNT"],
  "flag": ["DCq","BNW","BNU","BNV","D0W"],
  "flags": ["BNY","BNX"],
  "flame": ["BNd","BNc","BNZ","BNa","BNb"],
  "flamingo": ["BNg","BNf","BNh","BNe"],
  "flap": ["BNi"],
  "flash drive": ["Ezx"],
  "flashlight": ["DCr","D0X","BNj","BNk","BNl","BNm"],
  "flat": ["DCs","ED2","Ehf"],
  "flat screen": ["Ezy"],
  "flat tire": ["BNo"],
  "flat tires": ["Ehf"],
  "flat tyre": ["BNo"],
  "flat tyres": ["Ehf"],
  "flavor": ["BNp"],
  "flavors": ["DWK","BNq"],
  "flavour": ["BNp"],
  "flavours": ["DWK","BNq"],
  "flax": ["BNr"],
  "flew": ["EUf"],
  "flexible": ["BNt","BNs","DWL"],
  "flies": ["DqP"],
  "flight": ["BNw"],
  "flight attendant": ["DCt","DWM","ED4","DCu","ED3","BNu","BNv"],
  "flip chart": ["D0Y","DCv","BNy"],
  "flip flops": ["DCw","D0Z","BNz","BN1","BN0","BN2","BN3"],
  "flippers": ["BN4","BN5"],
  "float": ["DWN","DWO"],
  "flood": ["DCy","BOA","BN7","BN9","BN8","BOB","DCx"],
  "floor": ["BOF","BOE","BOD","BOC"],
  "Florida": ["ED5"],
  "florist": ["DC1","DC0","BOH","ED7","DCz","D0b","ED6","D0a","BOG"],
  "florist's": ["Ezz"],
  "flour": ["BOI","BOK","BOJ"],
  "flow": ["BOW"],
  "flower": ["DC3","BON","D0c","BOL","DC2","BOM","D0d"],
  "flower pot": ["BOO","BOP","BOQ"],
  "flower shop": ["Ez0"],
  "flowerpot": ["BOR"],
  "flowers": ["BOS","BOV","BOT","BOU"],
  "flu": ["BOY","BOX"],
  "fluctuate": ["DWP"],
  "fluent": ["DWQ"],
  "flute": ["BOb","BOZ","BOa"],
  "fly": ["Dhf","BOc","DC4","BOd","EXk","Eaw","Dhd","D0e"],
  "fly a kite": ["Dhd","Eaw"],
  "fly a plane": ["DqQ","ED8"],
  "fly flew": ["Dhe","EUf","Dhf","Dhd"],
  "fly in the sky": ["EXk"],
  "fly over": ["Dhe"],
  "fly over the mountains": ["Dhe"],
  "flying": ["Dhf","Dhd","Eaw"],
  "flying a kite": ["Dhd","Eaw"],
  "flying over": ["Dhe"],
  "flying over the mountains": ["Dhe"],
  "flying vehicles": ["Ez1"],
  "foal": ["BOe","BOf"],
  "fog": ["BOk","BOi","BOh","BOg"],
  "foggy": ["BOj"],
  "fold": ["DqR"],
  "folder": ["DC5","D0f","BOo","BOp","BOn","BOl"],
  "folktale": ["Ez2"],
  "follow": ["Dhg","BOq","EXl"],
  "follow followed": ["Dhg","ESc"],
  "follow mother": ["EXl","Dhg"],
  "followed": ["ESc"],
  "followed mother": ["ESc"],
  "following": ["Dhg"],
  "following mother": ["Dhg"],
  "fond of": ["DWR"],
  "fondu": ["BOr"],
  "fondue": ["BOr"],
  "food": ["DqT","DqS"],
  "food pyramid": ["BOs"],
  "foods": ["BOt"],
  "fool": ["BOu","BOw"],
  "foot": ["DC6","D0g","BOy","BO9","BOx"],
  "football": ["BOz","BO3","BO1","BO0"],
  "football player": ["BO2"],
  "footballer": ["DqU"],
  "footpath": ["BO5","BO8"],
  "footprints": ["BPD","BPA","BPC","BPB"],
  "forager": ["DWS"],
  "forbid": ["DWT","BPE"],
  "force": ["DWU","BPF"],
  "forearm": ["BPG"],
  "forecast": ["BPI"],
  "forehead": ["BPJ"],
  "foreigner": ["Ez3"],
  "forest": ["BPP","BPK","DC9","D0h","BPL"],
  "forest fire": ["BPO","DC8","BPN","DC7","BPM"],
  "forever": ["DWV","BPQ"],
  "forget": ["Dhh","EXm","DWW"],
  "forget forgot": ["Dhh","ESw"],
  "forget forgotten": ["EVU"],
  "forget me not": ["BPR"],
  "forget your car key": ["EXm"],
  "forget your key": ["Dhh"],
  "forgeting": ["Dhh"],
  "forgot": ["ESw","DqV"],
  "forgot his key": ["ESw"],
  "forgotten": ["EVU"],
  "forgotten his keys": ["EVU"],
  "fork": ["DDA","BPT","D0i","BPS"],
  "formal": ["DWX","BPU","BPV"],
  "fortress": ["BPW"],
  "fortune": ["BPX","DWZ"],
  "forty": ["DbK","DbE"],
  "forty eight": ["DbF"],
  "forty five": ["DbG"],
  "forty four": ["DbH"],
  "forty nine": ["DbI"],
  "forty one": ["DbJ"],
  "forty seven": ["DbL"],
  "forty six": ["DbM"],
  "forty thousand": ["DbN"],
  "forty three": ["DbO"],
  "forty two": ["DbP"],
  "forward": ["BPZ","DWa"],
  "fossil": ["BPa","BPb"],
  "fossil fuels": ["DWb"],
  "fought": ["EU0"],
  "found": ["Ez4"],
  "fountain": ["DDC","BPe","BPc","D0k","BPd"],
  "fountain pen": ["DDB"],
  "four": ["DbS","DbQ"],
  "four hundred": ["DbR"],
  "four thousand": ["DbV"],
  "fourteen": ["DbU","DbT"],
  "fourth": ["DqW"],
  "fox": ["DDD","BPj","D0l","BPh","BPg","BPi","BPf"],
  "fracture": ["DWc","BPk"],
  "frame": ["DWd","BPl"],
  "France": ["BPp","DDF","BPm","BPn","D0m","ED9"],
  "France flag": ["DDE"],
  "frankenstein": ["BPt","BPs","BPr","BPq"],
  "freckles": ["BPv","BPw","BPx"],
  "freeze": ["BP0","BPy","BPz"],
  "freezer": ["BP1"],
  "freezing": ["DDH","DDG","BP2"],
  "French": ["DDI","EeL"],
  "french fries": ["BP3","BP5","BP4"],
  "french horn": ["BP8"],
  "frequency": ["BP9"],
  "Frequently": ["DWe"],
  "fresh": ["DqX"],
  "Friday": ["DDL","DDK","DDJ"],
  "fridge": ["DDM","BQD","D0n","BQC","BQB","BQA"],
  "fried chicken": ["BQE","BQG","DDN","BQF"],
  "fried egg": ["BQI","BQH","BQL","D0o","BQK"],
  "fried eggs": ["BQN","BQM","BQO"],
  "fried food": ["BQP"],
  "fried rice": ["BQR","BQQ","DDO","BQT","BQS"],
  "friend": ["BQX","BQU","BQV"],
  "friendly": ["BQW"],
  "friends": ["DWf","BQZ","BQY","BQb","BQe","BQa"],
  "friendship": ["BQd","BQc"],
  "fries": ["DWg","DDP","BQg","D0p","BQf"],
  "frighten": ["DWi"],
  "frightened": ["DWh","BQh","BQj","EEC"],
  "frightening": ["BQl","BQm","BQk"],
  "frisbee": ["BQn","BQp","BQo"],
  "frisk": ["DWj"],
  "frog": ["DDQ","BQs","EED","BQr","BQq","D0q"],
  "frogs": ["DqY"],
  "front door": ["BQw","BQx","BQu","BQy","BQt"],
  "frost": ["BQ0","BQz"],
  "frosty": ["DWk","BQ2","BQ1"],
  "frown": ["Dhi","BQ4"],
  "frown frowned": ["Dhi"],
  "frowning": ["Dhi"],
  "frozen": ["BQ6","BQ8","BQ7"],
  "fruit": ["DDR","BQ9","BRF","DqZ","EEE","BRA"],
  "fruit juice": ["BRB","BRC","BRE","BRD"],
  "fruit salad": ["BRG","BRH","BRI"],
  "fruit smoothie": ["DDS"],
  "fruit stall": ["BRM"],
  "fruit stand": ["BRN"],
  "frustrated": ["BRP","BRO"],
  "fry": ["Dhj","BRQ","BRR","BRU"],
  "fry fried": ["Dhj"],
  "frying": ["BRS","Dhj","BRT"],
  "frying pan": ["DDT","D0r"],
  "fuchsia": ["BRW","BRV"],
  "fuel": ["BRX","DWl"],
  "full": ["Ez5"],
  "full moon": ["BRY","BRZ"],
  "fume": ["BRe","BRf"],
  "fun": ["Dqd","Dqa","Dqb"],
  "funfair": ["BRg","BRi","BRh"],
  "fungi": ["BRk","BRj","BRl"],
  "funnel": ["Dqc"],
  "funny": ["BRo","DWm","BRn","BRp","EEF","BRm"],
  "fur": ["DDU"],
  "furious": ["BRs","DWn","BRr","BRq"],
  "furnace": ["DWo","BRt"],
  "furniture": ["BRv"],
  "furry": ["BRw"],
  "fuses": ["BRx"],
  "futsal": ["BRy"],
  "g": ["DZx","DZy"],
  "galaxy": ["BR1","BR2","BRz","BR0"],
  "gallery": ["BR5","BR4"],
  "game": ["BR8","BR7","BR9","BR6"],
  "game console": ["Dqe"],
  "game designer": ["DWp"],
  "game show": ["DWq"],
  "games": ["Dqf"],
  "games console": ["DDV","BSA","BSB","BSC"],
  "garage": ["DDW","BSD","D0t"],
  "garbage": ["BSG","BSP","BSE","BSH","BSF","BSI"],
  "garbage can": ["BSJ","BSL","BSM","BSN"],
  "garbage truck": ["BSQ","BSR"],
  "garbageman": ["DDY","DDX","EEG","BSO"],
  "garden": ["DDb","BST","BSW","BSS"],
  "gardener": ["DDa","DDZ","BSU","EEJ","EEI","D0u"],
  "gardening": ["BSV"],
  "gargoyle": ["BSZ","BSX","BSY"],
  "garlic": ["BSe","DDc","BSb","D0v","BSa","BSd","BSc"],
  "gas": ["BSf"],
  "gas station": ["BSh","DDd","BSg","BSi","D0w"],
  "gate": ["BSl","DDe","BSn","D0x","BSj","BSm","BSp","BSo","BSk"],
  "gather": ["DWr","BSq"],
  "gathering": ["Dqg"],
  "gave": ["ESx"],
  "gave her a gift": ["ESx"],
  "gaze": ["BSr","DWs"],
  "gazelle": ["BSt","BSu","BSs"],
  "gecko": ["BSw","BSy","BSx"],
  "geese": ["BSz","BS1","BS0"],
  "gem": ["BS2","BS3","BS6","BS5"],
  "generation": ["Ez6"],
  "generous": ["DWt"],
  "gentlemen": ["BS7"],
  "geography": ["DDf","BTB","BS8","BTA","D0y","BS9"],
  "Georgia": ["EEK"],
  "German": ["DDg","EeM"],
  "German shepherd": ["BTC"],
  "Germany": ["BTH","DDi","EEL","D0z","BTD","BTF","BTE"],
  "Germany flag": ["DDh"],
  "germs": ["BTK","BTJ","BTI"],
  "get": ["Dhk","Dhl","EcI","EXr","EcJ","EXu","EXs","EXq","EXo"],
  "get a book": ["Dhk","EcI"],
  "get a burger": ["EEM"],
  "get a drink": ["Dhl"],
  "get a haircut": ["Dhm","Dhn","EXo","EcJ"],
  "get a massage": ["EEN"],
  "get an injection": ["Dho"],
  "get dressed": ["Dhp","EXq","EEO"],
  "get dressed got dressed": ["Dhp"],
  "get eyes checked": ["Dhq"],
  "get got": ["Dhk","ET1","EVp","Dhl"],
  "get his phone fixed": ["EEP"],
  "get home": ["Dqh"],
  "get juice from the fridge": ["EXr"],
  "get married": ["Dhr"],
  "get married got married": ["Dhr"],
  "get off": ["Ez7"],
  "get on": ["Dhu","Dhs","Eax","EER","Dht"],
  "get on a bus": ["Dht","EER","Eax"],
  "get on got on": ["Dhs","Dhu"],
  "get over": ["Ez8"],
  "get some rest": ["Ez9"],
  "get some sleep": ["E0A"],
  "get to": ["Dhv"],
  "get to got to": ["Dhv"],
  "get to work": ["Dhv","EXs"],
  "get up": ["Dhx","Dhw","EXt","Eay","EEU"],
  "get up early": ["EXt"],
  "get up got up": ["Dhw","Dhx"],
  "get your eyes checked": ["EXu"],
  "get your nails painted": ["Dhy"],
  "getting": ["EcI","Dhl","EcJ","Dhk"],
  "getting a book": ["Dhk","EcI"],
  "getting a drink": ["Dhl"],
  "getting a haircut": ["EcJ","Dhm","Dhn"],
  "getting an injection": ["Dho"],
  "getting dressed": ["Dhp"],
  "getting eyes checked": ["Dhq"],
  "getting married": ["Dhr"],
  "getting on": ["Dhs","Eax","Dhu","Dht"],
  "getting on a bus": ["Dht","Eax"],
  "getting to": ["Dhv"],
  "getting to work": ["Dhv"],
  "getting up": ["Dhw","Eay","Dhx"],
  "getting your nails painted": ["Dhy"],
  "Ghana": ["EEV"],
  "gherkin": ["BTL"],
  "gherkins": ["BTN","BTM"],
  "ghost": ["BTO","BTP","BTR","EEW","BTQ"],
  "ghosts": ["EEX"],
  "giant": ["BTS"],
  "gift": ["DDj","BTU","BTT","Ehg","EEY","BTV"],
  "gift shop": ["Dqi"],
  "gifts": ["BTY","Ehh","BTW","BTX"],
  "gigantic": ["BTa"],
  "gills": ["Dqj"],
  "ginger": ["BTp","DDk","BTd","BTb","D01"],
  "ginger hair": ["BTm"],
  "gingerbread": ["BTl","BTe"],
  "gingerbread house": ["BTg","BTf","BTh"],
  "gingerbread man": ["BTk","Ehi","BTi","BTj"],
  "giraffe": ["DDl","BTr","BTs","D02","BTq","BTu","BTt"],
  "girder": ["BTx","BTv","BTw"],
  "girl": ["BTz","BTy","BT1","BT0"],
  "give": ["Dhz","Eaz","BT8","BT3","EXv","Dh0","BT4","Dh1","BT2"],
  "give a gift": ["Dhz","Dh0","Eaz","EXv"],
  "give a hand": ["BT5","BT6"],
  "give a presentation": ["Dh1"],
  "give flowers": ["BT7"],
  "give gave": ["ESx","Dhz","Dh0","Dh1"],
  "give given": ["EVo"],
  "give out": ["Dh2"],
  "give out gave out": ["Dh2"],
  "give out money": ["Dh2"],
  "give someone a hand": ["EEc","EEd","EEe"],
  "give someone the cold shoulder": ["EEf","EEg","EEh"],
  "give up": ["E0B"],
  "given": ["EVo"],
  "given a presentation": ["EVo"],
  "giving": ["Dhz","Eaz","Dh1","Dh0"],
  "giving a gift": ["Dhz","Eaz","Dh0"],
  "giving a presentation": ["Dh1"],
  "giving out": ["Dh2"],
  "giving out money": ["Dh2"],
  "glacier": ["BUB","BT9","BUA"],
  "glad": ["BUC","BUI","BUD"],
  "gladiator": ["BUH","BUE"],
  "glass": ["DDo","BUW","BUN","D05","BUK","BUM","BUJ","BUL"],
  "glass of milk": ["BUT","BUS"],
  "glass water": ["BUZ"],
  "glasses": ["DDn","BUR","DDm","D03","BUO","BUQ","Ehz","D04","BUP"],
  "glitch": ["DWu"],
  "global": ["BUd","DWv","BUc"],
  "global warming": ["BUe"],
  "globe": ["DDp","D06","BUf","BUg"],
  "gloomy": ["BUh","BUi"],
  "glove": ["BUj","BUk"],
  "gloves": ["DDq","BUl","D07","BUo","BUn","BUm"],
  "glue": ["BUq","BUp","DWw"],
  "glue stick": ["BUr"],
  "gluten free": ["DWx"],
  "go": ["Dh8","Dh9","EdT","EX1","EXz","EXx","EX0","EXy"],
  "go back": ["Dqk"],
  "go been": ["EVm","EVR"],
  "go camping": ["EEi"],
  "go cycling": ["Dql"],
  "go diving": ["Dh3"],
  "go fishing": ["Dqm","EEj"],
  "go for a walk": ["Dqn"],
  "go hiking": ["Dh4"],
  "go hiking in the mountains": ["EXx"],
  "go home": ["Dqo"],
  "go horseback riding": ["E0C"],
  "go into space": ["EEk"],
  "go jogging": ["Dqp"],
  "go on a journey": ["E0D"],
  "go online": ["E0E"],
  "go out": ["E0F"],
  "go rock climbing": ["EEm"],
  "go running": ["E0G"],
  "go sailing": ["E0H"],
  "go scuba diving": ["EXy"],
  "go shopping": ["Dh5"],
  "go shopping went shopping": ["Dh5"],
  "go sightseeing": ["Dqv"],
  "go skating": ["Dqw"],
  "go skiing": ["Dqx","EEo","EEn"],
  "go straight": ["E0I","E0J"],
  "go surfing": ["E0K"],
  "go swimming": ["Dqy"],
  "go to": ["Dh6","Dh7"],
  "go to a cafe": ["Dh6","EXz"],
  "go to bed": ["Dh7","EX0","EEp"],
  "go to school": ["Dh8","EdT"],
  "go to sleep": ["E0L"],
  "go to the beach": ["E0M"],
  "go to the cinema": ["Dqz"],
  "go to the gym": ["E0N"],
  "go to the movies": ["E0O"],
  "go to the park": ["E0P"],
  "go to the WC": ["Dh9","EX1"],
  "go to the zoo": ["Dq0"],
  "go to went to": ["Dh7"],
  "go to work": ["Dq1"],
  "go viral": ["DW0"],
  "go went": ["Dh8","EVE","Dh4","Dh3"],
  "goal": ["BUt","BUs"],
  "goat": ["DDr","BUw","BUu","D08","BUy","BUx","BUv"],
  "goats": ["BU0","BUz"],
  "god": ["BU1"],
  "goggles": ["DDs","BU4","BU3","BU5","D09","BU2"],
  "going": ["Dh8","Dh9","EdT"],
  "going diving": ["Dh3"],
  "going hiking": ["Dh4"],
  "going shopping": ["Dh5"],
  "going to": ["Dh6","Dh7"],
  "going to a cafe": ["Dh6"],
  "going to bed": ["Dh7"],
  "going to buy a tv": ["Ees"],
  "going to clean the windows": ["Eet"],
  "going to cut down the tree": ["Eeu"],
  "going to do laundry": ["Eev"],
  "going to drink coffee": ["Eew"],
  "going to eat a banana": ["Eex"],
  "going to fly a kite": ["Eey"],
  "going to have a picnic": ["Eez"],
  "going to jump into the water": ["Ee0"],
  "going to land": ["Ee1"],
  "going to play football": ["Ee2"],
  "going to play tennis": ["Ee3"],
  "going to school": ["Dh8","EdT"],
  "going to shave his beard": ["Ee4"],
  "going to sleep": ["Ee5"],
  "going to swim": ["Ee6"],
  "going to take a bath": ["Ee7"],
  "going to take a photo": ["Ee8"],
  "going to take a train": ["Ee9"],
  "going to the WC": ["Dh9"],
  "going to walk the dog": ["EfA"],
  "going to watch a movie": ["EfB"],
  "gold": ["BVJ","BU8","DDt","BU6","BU7"],
  "golden eagle": ["BVB","BVC"],
  "goldfish": ["BVE","BVD","BVI","BVG","BVF"],
  "goldfish bowl": ["BVH"],
  "golf": ["DDu","D1A","BVN","BVL","BVM","BVK"],
  "good": ["BVT","EEl","DWz"],
  "good bye": ["Dqq"],
  "good evening": ["Dqr"],
  "good idea": ["BVR","BVS"],
  "good morning": ["Dqs"],
  "good night": ["Dqt","Dqu"],
  "goodbye": ["BVQ","BVP","DWy","BVO"],
  "google": ["BVU"],
  "goose": ["BVW","BVV","BVa","BVX"],
  "gooseberry": ["BVZ","BVY"],
  "gorilla": ["DDv","BVf","BVe","D1B","BVd","BVc","BVb"],
  "gosling": ["BVi","BVg","BVh"],
  "got": ["ET1","EVp"],
  "got a book": ["ET1"],
  "got an injection": ["EVp"],
  "government": ["BVk","BVj"],
  "gown": ["BVl"],
  "gps": ["BVo","BVm","BVn"],
  "grab": ["Dq2"],
  "graceful": ["BVq","DW1"],
  "gradually": ["BVs"],
  "graduate": ["DW2","DiA","BVu"],
  "graduate college": ["DiA"],
  "graduate from college": ["EEq"],
  "graduate graduated": ["EWP","DiA"],
  "graduated": ["EWP"],
  "graduated from college": ["EWP"],
  "graduating": ["DiA"],
  "graduating college": ["DiA"],
  "graduation": ["BVy"],
  "graduation ceremony": ["BVx"],
  "grain": ["BV1","BV0","BVz"],
  "grains": ["Dq3"],
  "grandad": ["DW4","DW3"],
  "granddaughter": ["DW5","DZU","DW6","BV2","EEr","BV3"],
  "grandfather": ["DZV","DW7","BV4","BV6","EEs","BV5","DW8"],
  "grandma": ["DXA","BV9","DW9","BV7","BV8"],
  "grandmother": ["BWA","DZW","DXB","EEt"],
  "grandpa": ["DXC","BWC","BWB"],
  "grandparents": ["DXD","BWE","BWD"],
  "grandson": ["DXE","DZX","BWH","BWG","BWF","EEu"],
  "granite": ["BWI","BWJ"],
  "granny": ["DXG","BWN","BWM"],
  "grape juice": ["BWT","BWU"],
  "grapefruit": ["DDw","BWO","BWP","BWS","BWQ","D1C","Egk","BWR"],
  "grapes": ["DDx","BWZ","D1D","BWW","BWY","BWX","BWV"],
  "graphic designer": ["DDy","DDz","D1E","BWa"],
  "grasp": ["BWb"],
  "grass": ["BWj","BWe","BWd","BWc"],
  "grasshopper": ["DD0","BWh","BWg","D1F","BWf","BWi"],
  "grassland": ["Dq4"],
  "grate": ["BWl"],
  "grateful": ["E0Q"],
  "grater": ["DD1","D1G"],
  "gravel": ["BWq"],
  "graveyard": ["BWv","BWr","BWs","BWt"],
  "gravity": ["DXH"],
  "gravy": ["BWx","BWw"],
  "gray": ["BWy","DD6"],
  "graze": ["BW0"],
  "grazing": ["BW3","BW2"],
  "great": ["E0R"],
  "great grandfather": ["DXI","BW4"],
  "great grandmother": ["DXJ"],
  "great wall of china": ["BW7","BW5","BW6"],
  "great white shark": ["BW8"],
  "Greece": ["BXC","BW9","EEy","BXA","BXB"],
  "Greece flag": ["DD2"],
  "greedy": ["Dq5"],
  "Greek": ["Dq6"],
  "green": ["DD3","BXX"],
  "green bean": ["BXE","BXD","BXG"],
  "green beans": ["Dq7"],
  "green eyes": ["BXH"],
  "green frog": ["BXI"],
  "green pepper": ["BXT"],
  "green peppers": ["BXV"],
  "green salad": ["BXY"],
  "green scarf": ["DD4","Ef8"],
  "green shorts": ["DD5","EgI"],
  "green tea": ["BXa","BXb"],
  "greengrocer": ["BXM","BXJ","BXK","BXL"],
  "greengrocer's": ["E0S"],
  "greengrocers": ["Dq8"],
  "greenhouse": ["BXP","BXQ","BXO","BXS"],
  "greenhouse effect": ["BXR"],
  "greet": ["DiB","EX2"],
  "greet greeted": ["ET2","DiB"],
  "greet people": ["EX2"],
  "greeted": ["ET2"],
  "greeted guests": ["ET2"],
  "greeting": ["DiB"],
  "greetings": ["DXK"],
  "grew": ["EUl"],
  "grey": ["DD6","BWy"],
  "grill": ["BXc"],
  "grim": ["BXd"],
  "grim reaper": ["EE0","EE1"],
  "grin": ["BXe","BXf"],
  "grip": ["BXh"],
  "grocery": ["BXi"],
  "grocery store": ["BXj"],
  "groom": ["Dq9","BXk"],
  "ground": ["BXl"],
  "ground floor": ["DXL"],
  "groundwater": ["DXM"],
  "group": ["BXp","BXn","BXo"],
  "grow": ["DiC","BXs"],
  "grow food": ["BXq","EE2"],
  "grow grew": ["EUl","DiC"],
  "grow up": ["E0V"],
  "growing": ["DiC"],
  "growling": ["BXr"],
  "grown up": ["E0T"],
  "growth": ["E0U"],
  "grumpy": ["BXu","EE3","BXt"],
  "guacamole": ["DD7"],
  "guard": ["DiD","DiE","EdU"],
  "guard a building": ["EE4"],
  "guard guarded": ["EU1","DiD","DiE"],
  "guard the door": ["EdU","DiE"],
  "guarded": ["EU1"],
  "guarded a door": ["EU1"],
  "guarding": ["EdU","DiD","DiE"],
  "guarding the door": ["EdU","DiE"],
  "Guatemala": ["EE5"],
  "guava": ["BXw","BXx","BXv","BXy"],
  "guest": ["DXN"],
  "guests": ["DXO"],
  "guide": ["DiF","BX0","EX4"],
  "guide book": ["BXz"],
  "guide guided": ["DiF"],
  "guide tourists": ["DiF","EX4"],
  "guiding": ["DiF"],
  "guiding tourists": ["DiF"],
  "guinea pig": ["BX3","BX2","BX1","BX4"],
  "guitar": ["DD8","BX5","BX9","D1H","BX8","BX6","BX7"],
  "gull": ["BYD","BYB","BYC"],
  "gum": ["BYE","BYF","BYG","BYJ"],
  "gummybears": ["BYH","BYI"],
  "gust": ["E0W"],
  "guy": ["BYK"],
  "gym": ["DD9","BYN","BYR","BYM","BYL"],
  "gymnasium": ["BYO"],
  "gymnastics": ["BYQ","BYP"],
  "h": ["DZz","DZ0"],
  "habitable": ["DXP"],
  "habitat": ["BYS"],
  "hack": ["BYU","BYT"],
  "hacksaw": ["BYY","BYW"],
  "had": ["EWK","EV4","EVq","ET3","EVr"],
  "had a cat": ["EVq"],
  "had a haircut": ["EV4"],
  "had a job interview": ["EVr"],
  "had breakfast": ["EWK"],
  "had two pens": ["ET3"],
  "hail": ["DEB","DEA","BYa","BYZ"],
  "hair": ["DEG","D1L","BYl","BYb"],
  "hair dryer": ["DEF","BYi","BYh","D1K","BYj"],
  "hair salon": ["DEH","BYn","BYo","BYm"],
  "hair stylist": ["BYq","BYp"],
  "hairbrush": ["DEC","D1I","BYd","BYe","BYc"],
  "haircut": ["E0X"],
  "hairdresser": ["DED","BYf","EE7","BYg","DEE","EE8","D1J"],
  "hairline": ["BYk"],
  "Haiti": ["EE9"],
  "half": ["BYr"],
  "half past 12": ["DeH"],
  "half past 2": ["DeI"],
  "half past 5": ["DeF"],
  "half past 7": ["DeG"],
  "half past five": ["DeF"],
  "half past seven": ["DeG","EfT"],
  "half past twelve": ["DeH","EfU"],
  "half past two": ["DeI","EfV"],
  "hall": ["BYs","BY1","BYt","BYu"],
  "halloween": ["BY0","BYx","BYv","BYw"],
  "halloween candy": ["BYz","BYy"],
  "hallway": ["BY4","BY3","BY2"],
  "halt": ["BY6","BY5"],
  "ham": ["DEK","BY9","BY8","BZR","BY7"],
  "hamburger": ["BZF","BZC","BZA","D1M","BZD","BZB","BZE"],
  "hamburgers": ["BZG"],
  "hamlet": ["BZH"],
  "hammer": ["DEI","BZJ","BZI","BZM","BZK","D1N","DiG"],
  "hammer a nail": ["DiG"],
  "hammer hammered": ["DiG"],
  "hammering": ["DiG"],
  "hammering a nail": ["DiG"],
  "hammock": ["BZQ","DEJ","BZP","BZN","BZO"],
  "hamster": ["BZT","BZY","BZV","BZS","BZU"],
  "hamster cage": ["BZX"],
  "hand": ["DEN","D1R","BZZ","BZl","BZa"],
  "hand drill": ["BZh"],
  "hand dryer": ["D1Q","DEM"],
  "hand in": ["DiH","Ea0","EFA"],
  "hand in handed in": ["DiH"],
  "hand in homework": ["DiH","Ea0"],
  "hand out": ["DiI","EcK"],
  "hand out fliers": ["EcK","DiI"],
  "hand out handed out": ["DiI"],
  "handbag": ["DEL","BZf","D1P","BZb","BZe","BZd","BZc"],
  "handball": ["BZg"],
  "handing in": ["Ea0","DiH"],
  "handing in homework": ["Ea0","DiH"],
  "handing out": ["EcK","DiI"],
  "handing out fliers": ["EcK","DiI"],
  "handle": ["E0Z"],
  "handlebar": ["E0Y"],
  "handlebars": ["BZk","BZj"],
  "handrail": ["DEO"],
  "hands": ["DEP","BZu","BZo","BZm","BZn"],
  "hands up": ["BZv"],
  "handsaw": ["BZq"],
  "handshake": ["E0a"],
  "handsome": ["BZs","BZt","BZr"],
  "handyman": ["EFD","DER"],
  "hang": ["BZ2","BZw","BZx"],
  "hang out": ["DiK","DiJ","EX5","EFE"],
  "hang out hung out": ["DiJ","DiK"],
  "hang out with friends": ["DiK","EX5","EFF"],
  "hang up": ["DiL","DiM","EcL","Ea1"],
  "hang up a coat": ["Ea1"],
  "hang up clothes": ["DiL","EcL"],
  "hang up hung up": ["DiL","DiM"],
  "hanger": ["BZ0","BZy"],
  "hangers": ["BZ1"],
  "hanging out": ["DiK","DiJ"],
  "hanging out with friends": ["DiK"],
  "hanging up": ["EcL","Ea1","DiM","DiL"],
  "hanging up clothes": ["EcL","DiL"],
  "happier": ["DES"],
  "happily": ["ERW"],
  "happiness": ["DXQ","BZ3"],
  "happy": ["DET","BZ6","Ehk","BZ5","DXR","EFH","BZ7","Ehj","BZ4"],
  "harbor": ["BaA","BZ8","BZ9","BaC","BaB"],
  "harbour": ["BZ8","BZ9","BaA","BaB","BaC"],
  "hard": ["BaD","EFI","ERU"],
  "hard working": ["DrA"],
  "hardwood": ["BaE"],
  "hardworking": ["DXS","BaF"],
  "hare": ["BaI","BaG","BaH"],
  "harmful gas": ["DXT"],
  "harmless": ["DXU"],
  "harmonica": ["DEU","BaL","D1T","BaJ"],
  "harness": ["E0b"],
  "harp": ["DEV","BaO","BaN","BaQ","D1U","BaR","BaP"],
  "harvest": ["BaT","BaS"],
  "hastily": ["ERF"],
  "hat": ["DEY","DEX","DEW","BaU","D1V","BaW","BaX","BaV"],
  "hate": ["E0c"],
  "haunted house": ["BaY","Bab","Baa","BaZ"],
  "have": ["Dif","Die","EYB","EX6","EX7","EYA"],
  "have a baby": ["DiN"],
  "have a barbecue": ["DrB"],
  "have a bath": ["E0d"],
  "have a bbq": ["DiO"],
  "have a birthday party": ["EFK"],
  "have a campfire": ["DiP"],
  "have a cat": ["DiQ","EX6"],
  "have a chip on your shoulder": ["EFM","EFN","EFO"],
  "have a dog": ["DiR","EX7"],
  "have a fever": ["E0e"],
  "have a fin": ["EfC"],
  "have a heart of gold": ["EFP","EFQ","EFR"],
  "have a meeting": ["DiS"],
  "have a music lesson": ["DrC"],
  "have a party": ["DiU"],
  "have a photo taken": ["EX9","DiV"],
  "have a picnic": ["DrD"],
  "have a shell": ["EfD"],
  "have a snack": ["E0f"],
  "have a snowball fight": ["DiW"],
  "have a sore throat": ["E0g"],
  "have a sweet tooth": ["EFU","EFV","EFW"],
  "have a tail": ["EfE"],
  "have an online meeting": ["DiT"],
  "have bad breath": ["DiX"],
  "have breakfast": ["DiZ","DiY","EYA","EFY","EFX"],
  "have class": ["Dia","EFZ"],
  "have coffee": ["Dib"],
  "have coffee with friends": ["EFa"],
  "have cooking class": ["Dic"],
  "have dinner": ["DrE"],
  "have eight legs": ["EfF"],
  "have four legs": ["EfG"],
  "have fun": ["DrF"],
  "have had": ["DiQ","EVq","EWK","DiO","Die","ET3","DiP","EVr","EV4"],
  "have her photo taken": ["EFb"],
  "have his eyes checked": ["EFc"],
  "have lessons": ["E0h"],
  "have long ears": ["EfH"],
  "have long hair": ["EfI"],
  "have lunch": ["Did"],
  "have money to burn": ["EFd","EFe","EFf"],
  "have the time of your life": ["EFg","EFh","EFi"],
  "have two arms": ["EfJ"],
  "have two ears": ["EfK"],
  "have two eyes": ["EfL"],
  "have two pens": ["Die"],
  "have two phones": ["EYB","Dif"],
  "have your ducks in a row": ["EFj","EFk","EFl"],
  "having": ["Dif","Die"],
  "having a baby": ["DiN"],
  "having a bbq": ["DiO"],
  "having a campfire": ["DiP"],
  "having a cat": ["DiQ"],
  "having a dog": ["DiR"],
  "having a meeting": ["DiS"],
  "having a party": ["DiU"],
  "having a photo taken": ["DiV"],
  "having a snowball fight": ["DiW"],
  "having an online meeting": ["DiT"],
  "having bad breath": ["DiX"],
  "having breakfast": ["DiZ","DiY"],
  "having class": ["Dia"],
  "having coffee": ["Dib"],
  "having cooking class": ["Dic"],
  "having lunch": ["Did"],
  "having two pens": ["Die"],
  "having two phones": ["Dif"],
  "hawk": ["Bag","Bae","Baf","Bad"],
  "hay": ["Bal","Bak","Bai","Bah","Baj"],
  "hay fever": ["DXV"],
  "haystack": ["E0i"],
  "hazel": ["Bao"],
  "hazelnuts": ["Ban","Bam"],
  "he": ["E0o"],
  "he adds sugar to his coffee": ["Eaa"],
  "he bowls": ["Eab"],
  "he brushes his teeth": ["Eac"],
  "he builds a wall": ["Ead"],
  "he buys a coffee": ["Eae"],
  "he buys groceries": ["Eaf"],
  "he carries a bag": ["Eag"],
  "he catches a ball": ["Eah"],
  "he chops an onion": ["Eai"],
  "he climbs": ["Eaj"],
  "he closes the window": ["Eak"],
  "he controls a drone": ["Eal"],
  "he crosses the road": ["Eam"],
  "he delivers a package": ["Ean"],
  "he deposits money at a bank": ["Eao"],
  "he digs": ["Eap"],
  "he dreams": ["Eaq"],
  "he empties the bin": ["Ear"],
  "he encourages his friend": ["Eas"],
  "he falls over": ["Eat"],
  "he fishes": ["Eau"],
  "he fixes a car": ["Eav"],
  "he flies a kite": ["Eaw"],
  "he gets on a bus": ["Eax"],
  "he gets up": ["Eay"],
  "he gives her a gift": ["Eaz"],
  "he hands in his homework": ["Ea0"],
  "he hangs up his coat": ["Ea1"],
  "he has already caught a fish": ["EFs"],
  "he has already eaten an apple": ["EFt"],
  "he has already washed his car": ["EFu"],
  "he has already washed the dishes": ["EFv"],
  "he has been a policeman since he was ": ["EFw"],
  "he has been sick since yesterday": ["EFx"],
  "he has been to america": ["EFy"],
  "he has driven his car since o'clock": ["EFz"],
  "he has failed the test times": ["EF0"],
  "he has forgotten his keys times": ["EF1"],
  "he has just broken the window": ["EF2"],
  "he has just crashed his car": ["EF3"],
  "he has just lost the game": ["EF4"],
  "he has just scored a goal": ["EF5"],
  "he has made a sandwich": ["EF6"],
  "he has made a speech times": ["EF7"],
  "he has never planted a tree": ["EF8"],
  "he has never shaved his head": ["EF9"],
  "he has read the book": ["EGF"],
  "he has seen an elephant": ["EGG"],
  "he has supported liverpool since ": ["EGH"],
  "he hasn't broken his arm": ["EGA"],
  "he hasn't done laundry for weeks": ["EGB"],
  "he hasn't ordered a pizza": ["EGC"],
  "he hasn't slept for days": ["EGD"],
  "he hasn't watched tv for one year": ["EGE"],
  "he hides behind the tree": ["Ea2"],
  "he holds up a sign": ["Ea3"],
  "he is adding sugar to his coffee": ["Eaa"],
  "he is bowling": ["Eab"],
  "he is brushing his teeth": ["Eac"],
  "he is building a wall": ["Ead"],
  "he is buying a coffee": ["Eae"],
  "he is buying groceries": ["Eaf"],
  "he is carrying a bag": ["Eag"],
  "he is catching a ball": ["Eah"],
  "he is chicken": ["EGI","EGJ","EGK"],
  "he is chopping an onion": ["Eai"],
  "he is climbing": ["Eaj"],
  "he is closing the window": ["Eak"],
  "he is cold": ["EhQ"],
  "he is controlling a drone": ["Eal"],
  "he is crossing the road": ["Eam"],
  "he is delivering a package": ["Ean"],
  "he is depositing money at a bank": ["Eao"],
  "he is digging": ["Eap"],
  "he is dreaming": ["Eaq"],
  "he is emptying the bin": ["Ear"],
  "he is encouraging his friend": ["Eas"],
  "he is falling over": ["Eat"],
  "he is fat": ["Ehe"],
  "he is fishing": ["Eau"],
  "he is fixing a car": ["Eav"],
  "he is flying a kite": ["Eaw"],
  "he is getting on a bus": ["Eax"],
  "he is getting up": ["Eay"],
  "he is giving her a gift": ["Eaz"],
  "he is handing in his homework": ["Ea0"],
  "he is hanging up his coat": ["Ea1"],
  "he is happy": ["Ehk"],
  "he is hiding behind the tree": ["Ea2"],
  "he is holding up a sign": ["Ea3"],
  "he is jumping over a puddle": ["Ea4"],
  "he is kicking a ball": ["Ea5"],
  "he is kneeling down": ["Ea6"],
  "he is laying out the table": ["Ea7"],
  "he is leaving": ["Ea8"],
  "he is lifting weights": ["Ea9"],
  "he is locking the door": ["EbA"],
  "he is looking at the clock": ["EbB"],
  "he is lying down": ["EbC"],
  "he is making a sandwich": ["EbD"],
  "he is making coffee": ["EbE"],
  "he is old": ["Eht"],
  "he is ordering food": ["EbF"],
  "he is painting a picture": ["EbG"],
  "he is picking apples": ["EbH"],
  "he is picking up litter": ["EbI"],
  "he is playing chess": ["EbJ"],
  "he is playing pool": ["EbK"],
  "he is playing the guitar": ["EbL"],
  "he is pointing at the clock": ["EbM"],
  "he is pulling a rope": ["EbN"],
  "he is pushing a car": ["EbO"],
  "he is putting his books in his bag": ["EbP"],
  "he is putting on a coat": ["EbQ"],
  "he is putting on shoes": ["EbR"],
  "he is putting out a fire": ["EbS"],
  "he is reading a newspaper": ["EbU"],
  "he is reading aloud": ["EbT"],
  "he is refusing money": ["EbV"],
  "he is relaxing": ["EbW"],
  "he is repairing a phone": ["EbX"],
  "he is rescuing someone": ["EbY"],
  "he is riding a bike": ["EbZ"],
  "he is riding a motorbike": ["Eba"],
  "he is sad": ["Eh1"],
  "he is shaving": ["Ebb"],
  "he is shutting the door": ["Ebc"],
  "he is signing his name": ["Ebd"],
  "he is squeezing an orange": ["Ebe"],
  "he is stealing a wallet": ["Ebf"],
  "he is strong": ["EiA"],
  "he is sweeping the floor": ["Ebg"],
  "he is swimming": ["Ebh"],
  "he is taking off his coat": ["Ebi"],
  "he is taking out the trash": ["Ebj"],
  "he is telling her a secret": ["Ebk"],
  "he is throwing a ball": ["Ebl"],
  "he is throwing away a bottle": ["Ebm"],
  "he is turning on the tv": ["Ebn"],
  "he is typing": ["Ebo"],
  "he is unhappy": ["Eh1"],
  "he is using a tablet": ["Ebp"],
  "he is using his phone": ["Ebq"],
  "he is washing his face": ["Ebr"],
  "he is washing his hands": ["Ebs"],
  "he is washing the dishes": ["Ebt"],
  "he is writing": ["Ebu"],
  "he is yawning": ["Ebv"],
  "he jumps over a puddle": ["Ea4"],
  "he kicks a ball": ["Ea5"],
  "he kneels down": ["Ea6"],
  "he lays out the table": ["Ea7"],
  "he leaves": ["Ea8"],
  "he lies down": ["EbC"],
  "he lifts weights": ["Ea9"],
  "he locks the door": ["EbA"],
  "he looks at the clock": ["EbB"],
  "he makes a sandwich": ["EbD"],
  "he makes coffee": ["EbE"],
  "he orders food": ["EbF"],
  "he paints a picture": ["EbG"],
  "he picks apples": ["EbH"],
  "he picks up litter": ["EbI"],
  "he plays chess": ["EbJ"],
  "he plays pool": ["EbK"],
  "he plays the guitar": ["EbL"],
  "he points at the clock": ["EbM"],
  "he pulls a rope": ["EbN"],
  "he pushes a car": ["EbO"],
  "he puts his books in his bag": ["EbP"],
  "he puts on a coat": ["EbQ"],
  "he puts on shoes": ["EbR"],
  "he puts out a fire": ["EbS"],
  "he reads a newspaper": ["EbU"],
  "he reads aloud": ["EbT"],
  "he refuses money": ["EbV"],
  "he relaxes": ["EbW"],
  "he repairs a phone": ["EbX"],
  "he rescues someone": ["EbY"],
  "he rides a bike": ["EbZ"],
  "he rides a motorbike": ["Eba"],
  "he shaves": ["Ebb"],
  "he shuts the door": ["Ebc"],
  "he signs his name": ["Ebd"],
  "he squeezes an orange": ["Ebe"],
  "he steals a wallet": ["Ebf"],
  "he sweeps the floor": ["Ebg"],
  "he swims": ["Ebh"],
  "he takes off his coat": ["Ebi"],
  "he takes out the trash": ["Ebj"],
  "he tells her a secret": ["Ebk"],
  "he throws a ball": ["Ebl"],
  "he throws away a bottle": ["Ebm"],
  "he turns on the tv": ["Ebn"],
  "he types": ["Ebo"],
  "he uses a tablet": ["Ebp"],
  "he uses his phone": ["Ebq"],
  "he washes his face": ["Ebr"],
  "he washes his hands": ["Ebs"],
  "he washes the dishes": ["Ebt"],
  "he writes": ["Ebu"],
  "he yawns": ["Ebv"],
  "head": ["DEd","DEZ","D1Z","Ba0","Bap"],
  "head of lettuce": ["Bat"],
  "head over heels in love": ["EFm","EFn","EFo"],
  "headache": ["DEa","D1W","Bar","DXW","Baq"],
  "headband": ["Bas"],
  "headphone": ["E0j"],
  "headphones": ["DEc","Bav","DEb","D1X","Bax","D1Y","Baz","Baw"],
  "headscarf": ["E0k"],
  "headset": ["Ba1","DEe","Ba4","Ba3"],
  "health": ["Ba5"],
  "healthier": ["DEf"],
  "healthy": ["Ba6","EFp"],
  "hear": ["Dig","Ba8"],
  "hear a noise": ["Dig"],
  "hear heard": ["Dig","ESy"],
  "heard": ["ESy"],
  "heard a noise": ["ESy"],
  "hearing": ["Ba7","Dig"],
  "hearing a noise": ["Dig"],
  "heart": ["BbI","BbC","BbB","Ba9","BbD","BbA"],
  "heart attack": ["BbF","BbE","BbH","BbG"],
  "heartbroken": ["EFq"],
  "heat": ["BbN","BbK","BbJ"],
  "heater": ["DEg","D1b"],
  "heating": ["BbL","BbM"],
  "heavier": ["DEh","DEi"],
  "heavy": ["DEk","DEj","BbP","EFr","BbS","Ehl","BbR","BbQ","BbO"],
  "hedge": ["Bbb","BbU"],
  "hedgehog": ["Bba","BbZ","BbY","BbW","BbX"],
  "heel": ["DEl","D1c"],
  "height": ["Bbc","DXX","Bbd"],
  "held": ["ET4"],
  "held a baby": ["ET4"],
  "helicopter": ["DEm","Bbj","D1d","Bbf","Bbh","Bbe","Bbg","Bbi"],
  "hell": ["Bbl","Bbk"],
  "hello": ["E0m","E0l"],
  "helmet": ["DEn","Bbp","Bbo","Bbn","D1e","Bbm"],
  "help": ["Bbr","Bbq"],
  "help my mum": ["E0n"],
  "help sick people": ["EGL"],
  "helpful": ["DXY"],
  "hen": ["Bbt","Bbs"],
  "her bag is heavy": ["Ehl"],
  "her hair is long": ["Ehn"],
  "her shirt is dirty": ["EhY"],
  "her sweater is big": ["EhE"],
  "herbal": ["Bbx","Bbw","Bbu"],
  "herbivore": ["DXZ"],
  "here": ["E0p"],
  "hero": ["DrG"],
  "heron": ["Bbz","Bby"],
  "hesitate": ["DXa"],
  "hexagon": ["Bb1","Bb2"],
  "hibernate": ["DXb","Bb3","Bb4"],
  "hibernation": ["DXc"],
  "hiccup": ["Bb5"],
  "hid": ["ESz"],
  "hidden": ["BcA","Bb9"],
  "hide": ["Ea2","Dih","BcB","BcD","BcC"],
  "hide and seek": ["DrH"],
  "hide behind the tree": ["Dih"],
  "hide hid": ["Dih","ESz"],
  "hideing": ["Dih"],
  "hiding": ["Ea2"],
  "hiding behind the tree": ["Dih"],
  "hieroglyphics": ["BcH","BcF"],
  "high": ["DEr","BcJ","BcT","EiC","BcI"],
  "high heels": ["DEp","D1f"],
  "high jump": ["DEq","D1g"],
  "higher": ["DEo"],
  "highlands": ["BcO","BcP","BcM"],
  "highlight": ["Dii","EcM"],
  "highlight highlighted": ["ET5","Dii"],
  "highlight lines": ["EcM","Dii"],
  "highlighted": ["ET5"],
  "highlighted some lines": ["ET5"],
  "highlighter": ["BcS","BcQ","BcR"],
  "highlighting": ["EcM","Dii"],
  "highlighting lines": ["EcM","Dii"],
  "hike": ["BcW","BcV","BcU"],
  "hike hiked": ["EWN"],
  "hiked": ["EWN"],
  "hiked in the mountains": ["EWN"],
  "hiking": ["Bcd","BcX"],
  "hiking boots": ["Bca","BcZ","Bcb"],
  "hiking trail": ["Bcf"],
  "hilarious": ["DXd"],
  "hill": ["Bck","Bcl","Bcj","Bci"],
  "hills": ["Bco","Bcm","Bcn"],
  "himalaya": ["Bcq","Bcp"],
  "hip": ["E0s","E0q"],
  "hip hop": ["E0r"],
  "hippo": ["DEs","Bcr","D1h","Bcu","Bct","Bcs"],
  "hippopotamus": ["DrI"],
  "hippos": ["Bcw","Bcv"],
  "hips": ["DXe"],
  "hired": ["Bcx"],
  "his": ["E0t"],
  "his arm is broken": ["EhK"],
  "his hair is blue": ["EhH"],
  "his shirt is colorful": ["EhR"],
  "his sweater is small": ["Eh6"],
  "historic": ["Bc1","Bc0","Bcz","Bcy"],
  "history": ["DEt","Bc4","Bc2","D1i"],
  "history book": ["Bc3"],
  "hit": ["Dij","Dik","Bc6","Bc5","ES0","EYC"],
  "hit a ball": ["Dij","ES0"],
  "hit a nail": ["Dik","EYC"],
  "hit hit": ["Dij","ES0","Dik"],
  "hit the sack": ["EGM","EGN","EGO"],
  "hitting": ["Dij","Dik"],
  "hitting a ball": ["Dij"],
  "hitting a nail": ["Dik"],
  "hive": ["Bc7","BdA","Bc8"],
  "hobby": ["DXf","BdB"],
  "hockey": ["DEu","BdC","BdG","D1j","BdF","BdE","BdD"],
  "hoe": ["BdI","BdH"],
  "hold": ["Dim","Din","Dil","BdL","EYD","EcN"],
  "hold a baby": ["EcN","Dil"],
  "hold a ball": ["Dim","EYD"],
  "hold hands": ["BdK","Din","EdV"],
  "hold held": ["Din","ET4","Dil","Dim"],
  "hold on": ["Dio","EGP"],
  "hold on held on": ["Dio"],
  "hold out": ["Dip"],
  "hold out held out": ["Dip"],
  "hold up": ["Ea3","Diq"],
  "hold up a sign": ["Ea3","Diq"],
  "hold up held up": ["Diq"],
  "holding": ["Dim","Dil","EcN","Din"],
  "holding a baby": ["EcN","Dil"],
  "holding a ball": ["Dim"],
  "holding hands": ["EdV","Din"],
  "holding on": ["Dio"],
  "holding out": ["Dip"],
  "holding up": ["Ea3","Diq"],
  "holding up a sign": ["Ea3","Diq"],
  "hole": ["BdO","BdP","BdQ","BdN","BdM"],
  "hole punch": ["BdS","BdR"],
  "holiday": ["BdV","BdU"],
  "hollow": ["BdW"],
  "holly": ["BdX"],
  "home": ["Bda","Bdf","BdZ","BdY"],
  "homeland": ["Bdb"],
  "homeless": ["Bdd","Bde","Bdc"],
  "hometown": ["DXg"],
  "homework": ["Bdi","Bdg","Bdh"],
  "Honduras": ["EGR"],
  "honest": ["E0u"],
  "honey": ["DEv","Bdj","Bdm","Bdl"],
  "honeybee": ["E0v"],
  "Hong Kong flag": ["DEw"],
  "hoodie": ["DEx","D1k","Bdp","Bdr","Bdn","Bds"],
  "hook": ["Bdt","Bdv","Bdu"],
  "hooves": ["Bdx"],
  "hop": ["DXj"],
  "hope": ["Bdz","DXi"],
  "hopeful": ["Bdy"],
  "hopscotch": ["E0w"],
  "horizon": ["DXk","Bd1"],
  "hormone": ["DXl"],
  "horns": ["Bd3","Bd4","Bd2"],
  "horror": ["Bd5"],
  "horse": ["DEy","Bd7","D1l","Bd9","Bd6","Bd8"],
  "horse racing": ["BeC","BeA","BeB"],
  "horse riding": ["DEz","BeE","D1m","BeD","BeF"],
  "horses": ["BeI","BeJ","BeG","BeH"],
  "hose": ["BeK","BeN","BeM"],
  "hospital": ["DE0","D1n","BeR","BeP","BeO","BeQ"],
  "hostel": ["BeS","DXm"],
  "hostile": ["DXn"],
  "hot": ["DE7","DE1","EGU","Ehm","DE2","Bep","BeT"],
  "hot air balloon": ["BeV","BeU","BeW"],
  "hot and spicy": ["BeX"],
  "hot chocolate": ["DE3","Beb","D1o","Bec","Bed","Bea"],
  "hot cross buns": ["Bee","Beg"],
  "hot dog": ["Bej","Beh","DE4","Bei","Bek","D1p","Bel"],
  "hot dogs": ["Bem"],
  "hot soup": ["Beq","Ber"],
  "hotel": ["Beo","Ben"],
  "hotel manager": ["DE6","EGT"],
  "hotter": ["DE8"],
  "hound": ["Bet"],
  "hounds": ["Bey","Bew","Bex"],
  "hour": ["DrJ"],
  "house": ["DE9","Be5","D1q","Be1","Bez","Be0","Be2"],
  "house husband": ["E0x"],
  "household chores": ["DXo"],
  "housekeeper": ["Be3","Be4"],
  "housewife": ["Be8","Be6","Be9","Be7"],
  "housework": ["E0y"],
  "how": ["Ddk"],
  "how are you": ["DrK"],
  "how do you go to school": ["Ddk"],
  "how do you spell your name": ["EGW"],
  "how expensive is the book": ["EGX"],
  "how far": ["Ddl"],
  "how far is London": ["Ddl"],
  "how heavy": ["Ddm"],
  "how heavy are you": ["Ddm"],
  "how heavy is he": ["EGZ"],
  "how many apples do you want": ["EGa"],
  "how much": ["Ddn"],
  "how much is the book": ["Ddn"],
  "how much is the skateboard": ["EGb"],
  "how old": ["Ddo"],
  "how old are you": ["Ddo"],
  "how old is he": ["EGd"],
  "how tall": ["Ddp"],
  "how tall are you": ["Ddp"],
  "however": ["E0z"],
  "huddle": ["BfB","BfA"],
  "hug": ["Dis","Dir","BfC","EdW","BfF","EYE","BfD"],
  "hug a friend": ["EYE"],
  "hug hugged": ["Dir","EU2","Dis"],
  "hug someone": ["Dis"],
  "huge": ["EGe"],
  "hugged": ["EU2"],
  "hugging": ["EdW","Dis","Dir"],
  "hugging someone": ["Dis"],
  "hula hoop": ["E00"],
  "hulk": ["DXp"],
  "hum": ["E02"],
  "human": ["E01"],
  "humid": ["DrL"],
  "hummingbird": ["BfG","BfI","BfH"],
  "hump": ["BfJ"],
  "hundred": ["DrM"],
  "hung up": ["ET6"],
  "hung up clothes": ["ET6"],
  "Hungary": ["EGf"],
  "hungry": ["BfK","EGg"],
  "hunt": ["BfQ","BfL"],
  "hunter": ["BfM","BfP","BfN"],
  "hurricane": ["BfR","BfT","DFB","BfS","DFA"],
  "hurry": ["E03"],
  "hurt": ["DFC","EGh","BfU"],
  "husband": ["BfY","DZY","BfX","BfV","BfW","EGi"],
  "hut": ["Bfc","Bfb","Bfd","BfZ","Bfa"],
  "hyacinth": ["Bff","Bfe"],
  "hyena": ["Bfg","Bfi","Bfj"],
  "i": ["DZ1","DZ2"],
  "I am happy": ["DrN"],
  "ice": ["DFG","BgL","D1s","Bfk","Bfm","Bfl"],
  "ice age": ["Bfo"],
  "ice coffee": ["DFD","Egl"],
  "ice cream": ["DFE","Bfq","Bfu","D1r","Bfr","Bfs","DFF","Bft"],
  "ice cream stand": ["Bfv"],
  "ice cream van": ["Bfw","Bfx","Bfy"],
  "ice cube": ["Bfz"],
  "ice cubes": ["Bf0","Bf1"],
  "ice giant": ["BgA"],
  "ice hockey": ["BgB","BgD","BgC"],
  "ice lolly": ["BgK","BgJ"],
  "ice rink": ["BgN","BgM"],
  "ice skate": ["BgO","BgP","BgQ"],
  "ice skates": ["BgS","BgR","BgT"],
  "ice skating": ["BgW","BgV","BgU"],
  "ice tea": ["DFH","Egm"],
  "iceberg": ["Bfp"],
  "iced coffee": ["Bf4"],
  "iced tea": ["Bf6","Bf8"],
  "Iceland": ["BgI","BgG","BgH","BgF"],
  "icicle": ["BgY"],
  "icicles": ["Bgd","BgZ"],
  "icy": ["Bgg","Bge","Bgh","Bgf"],
  "id": ["Bgn","Bgi","Bgk","Bgj"],
  "ID card": ["DFI","D1t"],
  "idea": ["Bgl"],
  "identify": ["Bgm"],
  "igloo": ["Bgo","Bgp","Bgr","Bgq"],
  "igneous": ["Bgs"],
  "ignore": ["Dit","EcO"],
  "ignore ignored": ["Dit","ET7"],
  "ignore someone": ["EcO","Dit"],
  "ignored": ["ET7"],
  "ignored him": ["ET7"],
  "ignoring": ["EcO","Dit"],
  "ignoring someone": ["EcO","Dit"],
  "iguana": ["Bgv","Bgt","Bgu"],
  "ill": ["Bgw","Bgx"],
  "Illinois": ["EHW"],
  "illiterate": ["DXq"],
  "illuminated": ["Bg0","Bgy","Bgz"],
  "illustration": ["Bg3","Bg2"],
  "illustrator": ["DFJ","EHY","D1u","DFK"],
  "image": ["Bg4"],
  "imagine": ["Bg5"],
  "impact": ["DXs"],
  "impatient": ["DXt"],
  "imperative": ["DXu"],
  "implant": ["DXv"],
  "important": ["Bg7","Bg6"],
  "imposter": ["DXw"],
  "impractical": ["DXx"],
  "impure": ["Bg8"],
  "in": ["DdQ","DdL","Bho","DdM","EfO","EfP"],
  "in charge": ["DXy"],
  "in front": ["DdP"],
  "in front of": ["DdN","DdO","EfN","EfM"],
  "in front of the coffee shop": ["EfM"],
  "in front of the tv": ["EfN"],
  "in love": ["Bhl","Bhm","Bhn"],
  "in the afternoon": ["E07"],
  "in the bag": ["EfO"],
  "in the evening": ["E08"],
  "in the fridge": ["EfP"],
  "in the middle": ["DdR","EfQ"],
  "in the middle of the line": ["EfQ"],
  "in the morning": ["E09"],
  "inappropriate": ["Bg9"],
  "income": ["DXz"],
  "inconvenient": ["DX0"],
  "increase": ["BhB","BhA"],
  "India": ["BhG","DFN","EHe","D1v","BhC","BhD","BhE"],
  "India flag": ["DFL"],
  "Indian": ["DFM","EeN"],
  "Indian elephant": ["BhF"],
  "indicate": ["DX1"],
  "indignant": ["DX2"],
  "indigo": ["DFO"],
  "individual": ["BhH","BhI"],
  "Indonesia": ["BhM","BhJ","EHf"],
  "Indonesia flag": ["DFP"],
  "industry": ["BhQ"],
  "inexpensive": ["DX3"],
  "infant": ["BhR","BhT"],
  "infection": ["BhU"],
  "inflict": ["DX4"],
  "information": ["BhV","BhX"],
  "information board": ["BhW"],
  "information technology": ["E04"],
  "ingredients": ["Bha","BhY","BhZ"],
  "inhaling": ["DX6"],
  "inherit": ["DX7"],
  "initial": ["DX8"],
  "initiative": ["DX9"],
  "injection": ["Bhb"],
  "injure": ["DYA"],
  "injury": ["Bhf","Bhd","Bhc","Bhe"],
  "ink": ["Bhh","Bhg","Bhi"],
  "inline skates": ["Bhk","Bhj"],
  "inner core": ["DYB"],
  "innovation": ["DYC"],
  "insect": ["DFQ","Bhp"],
  "insects": ["DrO","EHj"],
  "insert": ["Diu"],
  "insert inserted": ["ETY","Diu"],
  "inserted": ["ETY"],
  "inserted a usb stick": ["ETY"],
  "inserting": ["Diu"],
  "inside": ["Bhq"],
  "inspirational": ["Bhr"],
  "instant coffee": ["DFR"],
  "instant noodles": ["DFS","Bht"],
  "instrument": ["E05"],
  "instruments": ["DrP"],
  "insurance": ["DYD","Bhx"],
  "integration": ["DYE"],
  "intelligent": ["Bh0","Bhz","Bhy"],
  "interactive whiteboard": ["Bh1","Bh2"],
  "interested": ["Bh3"],
  "interesting": ["DYF","EHm"],
  "interior": ["Bh4"],
  "international": ["E06"],
  "internet": ["Bh6","Bh5"],
  "interpret": ["EYF","Div"],
  "interpret chinese to english": ["EYF"],
  "interpret interpreted": ["Div"],
  "interpreter": ["DFT","EHo"],
  "interpreting": ["Div"],
  "interview": ["Dix","Diw","EYG","Bh7","Bh8"],
  "interview interviewed": ["EU3","Diw","Dix"],
  "interview people": ["EHp"],
  "interview someone": ["EYG","Dix"],
  "interviewed": ["EU3"],
  "interviewed her": ["EU3"],
  "interviewing": ["Dix","Diw"],
  "interviewing someone": ["Dix"],
  "intestines": ["Bh9","BiA"],
  "introduce": ["DrQ"],
  "intuition": ["BiB"],
  "invent": ["BiC"],
  "invention": ["DrR"],
  "inventor": ["BiD","DYG"],
  "investment": ["BiE"],
  "invisible": ["DrS"],
  "invitation": ["DYH"],
  "invite": ["DYI"],
  "iphone": ["BiG","BiF"],
  "Iran": ["BiK","EHr"],
  "Ireland": ["BiQ","DFW","BiL","D1x","BiN","BiP"],
  "Ireland flag": ["DFV"],
  "Irish": ["DFX","EeO"],
  "iron": ["Diy","EcP","BiR"],
  "iron a shirt": ["Diy","EcP"],
  "iron ironed": ["Diy"],
  "ironing": ["Diy","EcP"],
  "ironing a shirt": ["EcP","Diy"],
  "irritated": ["DYJ"],
  "irritating": ["DYK"],
  "is it hot today": ["EHt"],
  "is it raining": ["EHu"],
  "is the music loud": ["EHv"],
  "is was": ["Deu"],
  "is your bag heavy": ["EHw"],
  "is your dog dangerous": ["EHx"],
  "is your friend beautiful": ["EHy"],
  "island": ["BiU","BiS","DFY","D1y","BiT"],
  "isolated": ["DYL"],
  "it": ["E1A"],
  "it is cloudy": ["EhO"],
  "it is sunny": ["EiB"],
  "it's five past six": ["EfR"],
  "it's five to twelve": ["EfS"],
  "it's half past seven": ["EfT"],
  "it's half past twelve": ["EfU"],
  "it's half past two": ["EfV"],
  "it's nine o'clock": ["EfW"],
  "it's quarter past eleven": ["EfX"],
  "it's quarter past one": ["EfY"],
  "it's quarter past six": ["EfZ"],
  "it's quarter past twelve": ["Efa"],
  "it's quarter to eight": ["Efb"],
  "it's quarter to five": ["Efc"],
  "it's quarter to four": ["Efd"],
  "it's ten past eight": ["Efe"],
  "it's ten to five": ["Eff"],
  "it's three o'clock": ["Efg"],
  "it's twenty five past eleven": ["Efh"],
  "it's twenty five to ten": ["Efi"],
  "it's twenty past two": ["Efj"],
  "it's twenty to four": ["Efk"],
  "Italian": ["DFZ","EeP"],
  "Italy": ["Bia","DFb","BiV","D1z","BiZ","EHz","BiW","BiY"],
  "Italy flag": ["DFa"],
  "itch": ["Bib"],
  "itchy": ["DrT"],
  "itinerary": ["DYM"],
  "its cold": ["DrU"],
  "its sunny": ["DrV"],
  "j": ["DZ3","DZ4"],
  "jack fruit": ["Bih","Big"],
  "jack in the box": ["Bii"],
  "jack o lantern": ["DrX"],
  "jacket": ["DFc","D10","Bid","Bie","Bif","Bic"],
  "jackfruit": ["DrW"],
  "jackolantern": ["EH0"],
  "jade": ["Bik","Bij"],
  "jaguar": ["Bio","Bim","Bin","Bil"],
  "jailbreak": ["DYN"],
  "jam": ["Bip","Biw","Biq","Bir"],
  "Jamaica": ["Biv","Bis","Biu"],
  "janitor": ["DFd","DFe"],
  "January": ["DrY"],
  "Japan": ["Bi2","DFh","Bix","EH4","Bi1","D11","Biy"],
  "Japan flag": ["DFg"],
  "Japanese": ["DFf","EeQ"],
  "jar": ["Bi3","Bi7","Bi5","Bi6","Bi4"],
  "jasmine": ["Bi8","Bi9"],
  "javelin": ["DFi"],
  "jaw": ["BjA"],
  "jazz": ["BjC","BjB"],
  "jealous": ["DFj","DYO","EH5"],
  "jeans": ["DFk","BjI","D13","BjE","BjG","BjD","BjF"],
  "jeep": ["BjM","BjJ","BjK","BjL"],
  "jello": ["BjO","BjN"],
  "jelly": ["BjP","BjU"],
  "jellybeans": ["BjQ","BjR"],
  "jellyfish": ["BjT","BjS"],
  "jester": ["BjV","BjW"],
  "jet": ["Bja","BjZ","Bjb"],
  "jewel": ["Bje","Bjc","Bjd"],
  "jewelry": ["DrZ"],
  "jewelry store": ["Bjg","Bjf"],
  "jigsaw": ["Bjj","DFl","Bjh","Bji"],
  "jingle bells": ["Bjk","Bjl","Bjn"],
  "job": ["Bjo"],
  "jockey": ["Bjr"],
  "jog": ["Bjt","Diz","Bj1","Bjs","Bju","Bjw"],
  "jog jogged": ["Diz"],
  "jogging": ["Diz","Bjy","Bj0","Bjz","Bjx"],
  "join": ["Di0","Bj2"],
  "join a book club": ["Di0"],
  "join in": ["E1B"],
  "join joined": ["Di0"],
  "joining": ["Di0"],
  "joining a book club": ["Di0"],
  "joints": ["Bj3"],
  "joke": ["DYP"],
  "jolly": ["DYQ"],
  "journalist": ["DFm","Bj4","DFn","EH6","EH7"],
  "journey": ["Bj5","Bj7","Bj8","Bj6"],
  "joy": ["BkA","BkB","Bj9"],
  "judge": ["BkC","BkE","BkF","BkD"],
  "judo": ["BkJ","BkH","BkK","BkI","BkG"],
  "jug": ["DFo","BkS","D14","BkN","BkM","BkL"],
  "juggle": ["BkP","BkO"],
  "juggler": ["BkQ","BkR"],
  "juice": ["BkT","BkV","BkU"],
  "July": ["Dra"],
  "jump": ["Di4","Di2","EdX","EYI","BkW","BkX","BkY","Bkg","Di1","EYJ","Di3"],
  "jump jumped": ["Di2","Di3","EVv","ES1","Di1","Di4"],
  "jump on a trampoline": ["EYI"],
  "jump out of the water": ["EYJ"],
  "jump over": ["Ea4"],
  "jump over a puddle": ["Di3","Ea4"],
  "jump rope": ["Bkj","Bkh","Bkk","Bki"],
  "jumped": ["EVv","ES1"],
  "jumped on a trampoline": ["EVv"],
  "jumped over a puddle": ["ES1"],
  "jumper": ["Bkc","Bkd","Bkb","Bka","BkZ"],
  "jumping": ["Di4","Di2","EdX","Bkf","Di1","Bke","Di3"],
  "jumping over": ["Ea4"],
  "jumping over a puddle": ["Ea4","Di3"],
  "June": ["Drb"],
  "jungle": ["Bkn","Bko","Bkl"],
  "junk food": ["Bkp","Bkq","Bkr"],
  "jupiter": ["Bkt","Bks"],
  "k": ["DZ5","DZ6"],
  "kangaroo": ["DFp","D15","Bky","Bkv","Bkw","Bkz","Bkx","Bku"],
  "karate": ["DFq","Bk2","Bk0","D16","Bk3","Bk1"],
  "kayak": ["Bk5","Bk9","Bk4"],
  "kayaking": ["Bk8","Bk7","Bk6"],
  "kebab": ["Egn"],
  "kebabs": ["D17"],
  "keep": ["BlA"],
  "keep track of money": ["EH8"],
  "keep warm": ["E1C"],
  "Kenya": ["BlF","BlB","BlC","BlE","EH9","BlD"],
  "ketchup": ["DFr","BlG","D18","BlI","BlH"],
  "kettle": ["DFs","BlK","D19","BlM","BlL","BlJ"],
  "key": ["BlO","BlN","BlV","BlP"],
  "keyboard": ["BlU","BlT","DFu","DFt","BlS","D2A","BlQ","BlR","D2B"],
  "keyring": ["BlZ","BlY","BlX","BlW"],
  "keys": ["DFv","Blb","Bla","D2C"],
  "khaki": ["DFw"],
  "kick": ["Di5","Ea5","Ble","Bld","Blf","Blg","Blc","Blh"],
  "kick a ball": ["Di5","Ea5"],
  "kick kicked": ["ES2","Di5"],
  "kicked": ["ES2"],
  "kicked the ball": ["ES2"],
  "kicking": ["Di5","Ea5"],
  "kicking a ball": ["Di5","Ea5"],
  "kid": ["Bll"],
  "kidney": ["Bli","Blj"],
  "kidneys": ["Blk"],
  "kids": ["Blm"],
  "kill": ["E1D"],
  "killer whale": ["Bln","Blp","Blq","Blo"],
  "kilogram": ["Blr","Bls"],
  "kind": ["Blt"],
  "king": ["Blu","Bl0","Blv"],
  "king cobra": ["Blw"],
  "kingfisher": ["Blx"],
  "kiss": ["Bl3","Bl4","Bl1","Bl2"],
  "kit": ["BmF"],
  "kitchen": ["DFx","Bl6","Bl8","Bl7","Bl5"],
  "kite": ["Bl9","DFy","BmE","D2D","BmA","BmC","BmB"],
  "kite flying": ["BmD"],
  "kites": ["Drc"],
  "kitten": ["BmK","BmH","BmG","BmI","BmJ"],
  "kittens": ["BmM","BmL"],
  "kiwi": ["BmR","BmN","BmO"],
  "kiwi fruit": ["BmP","DFz","BmQ"],
  "kiwifruit": ["D2E"],
  "knead": ["BmT","Di6","BmS"],
  "knead dough": ["Di6"],
  "knead kneaded": ["Di6"],
  "kneading": ["Di6"],
  "kneading dough": ["Di6"],
  "knee": ["DF0","D2F","BmU"],
  "kneel": ["Di7"],
  "kneel down": ["Ea6","Di7"],
  "kneel knelt": ["Di7"],
  "kneeling": ["Di7"],
  "kneeling down": ["Ea6","Di7"],
  "knees": ["Drd"],
  "knew": ["E1E"],
  "knife": ["DF1","BmW","BmX","D2G","BmV"],
  "knight": ["BmZ","Bmb","BmY","Bma"],
  "knit": ["Di8","EYK"],
  "knit a scarf": ["EYK"],
  "knit knitted": ["Di8"],
  "knitting": ["Di8","Bme","Bmc"],
  "knives": ["Bmf"],
  "knock": ["E1F"],
  "know": ["Di9","EYL"],
  "know knew": ["Di9"],
  "know the answer": ["Di9","EYL"],
  "knowing": ["Di9"],
  "knowing the answer": ["Di9"],
  "knowledge": ["Bmg"],
  "knuckle": ["DF2"],
  "knuckles": ["DF3"],
  "koala": ["Bml","Bmh","Bmj","Bmi","Bmk"],
  "Korea": ["Bmp","Bmm","EIA","Bmo"],
  "Korea flag": ["DF4"],
  "kumquat": ["Bms","Bmt","Bmr","Bmq"],
  "kung fu": ["Bmu","Bmw","Bmx"],
  "l": ["DZ7","DZ8"],
  "lab technician": ["Bm5","Bm6"],
  "laboratory": ["Bm1","Bmz","Bmy","Bm0"],
  "labrador": ["Bm4","Bm3","Bm2"],
  "lace": ["Bm8","Bm7"],
  "laces": ["Bm9"],
  "ladder": ["DF5","D2H","BnD","BnA","BnC","BnB"],
  "ladies": ["BnF","BnE"],
  "ladle": ["Dre"],
  "lady": ["BnH","BnS","BnI","BnG"],
  "ladybird": ["BnK","BnN","BnL","BnJ"],
  "ladybug": ["BnO","BnP"],
  "ladybugs": ["BnQ","BnR"],
  "lake": ["BnV","DF6","BnY","D2I","BnU","BnW","BnX","BnT"],
  "lamb": ["Bnc","DF7","Bnb","Ego","BnZ","D2J","Bna"],
  "lamp": ["DF8","DF9","D2K","Bne","Bnd","Bnf"],
  "land": ["Bnr","Bng","Bnh","Bni","Bnj"],
  "landfill": ["Bnk","Bno","Bnl","Bnn"],
  "landmark": ["Bnq","Bnp"],
  "landscape": ["Drf"],
  "landslide": ["Bnv","Bnt","Bnu"],
  "lane": ["Bnw","Bny","Bnx"],
  "language": ["Bnz"],
  "languages": ["Bn0"],
  "lantern": ["Bn2","Bn3","Bn1"],
  "lanterns": ["Bn4","Bn5","Bn6"],
  "laptop": ["DGB","BoB","DGA","D2L","BoA","Bn8","D2M","Bn9","Bn7"],
  "large": ["BoD","BoC","EhE","EIB","EhF"],
  "last": ["E1G"],
  "late": ["BoE","EIC"],
  "latte": ["BoH","Egp","BoI","BoJ","BoK"],
  "Latvia": ["EID"],
  "laugh": ["DjA","BoM","BoN","BoS"],
  "laugh laughed": ["DjA"],
  "laughing": ["DjA","BoP","BoQ","BoO"],
  "laughter": ["BoW","BoU","BoT"],
  "laundromat": ["BoZ","BoY"],
  "laundry": ["Bob","Bod","Boc","Boa"],
  "laundry room": ["Drg"],
  "lava": ["Bog","Boe","Bof"],
  "lavender": ["Boi","Boh"],
  "law": ["E1H"],
  "lawn": ["Bou","Bok","Bon","Bol"],
  "lawn mower": ["DGC","Bop","Boq","Bot","Boo"],
  "lawyer": ["DGE","Bow","Bov","DGD","Boy","EIF","Box","EIE"],
  "lay": ["EYN","DjB","ES3"],
  "lay down": ["ES3"],
  "lay eggs": ["DjB","EYN"],
  "lay laid": ["DjB"],
  "lay out": ["Ea7","DjC"],
  "lay out a table": ["DjC"],
  "lay out laid out": ["DjC"],
  "lay out the table": ["Ea7"],
  "layer": ["E1I"],
  "layers": ["Boz"],
  "laying": ["DjB"],
  "laying eggs": ["DjB"],
  "laying out": ["Ea7","DjC"],
  "laying out a table": ["DjC"],
  "lazy": ["Bo0","Bo3","Bo2","Bo1"],
  "leaf": ["DGF","Bo4","Bo6","D2O","Bo5","Bo7"],
  "learn": ["DjE","EYO","DjD","Bo9","Bo8"],
  "learn Japanese": ["EYO","DjD"],
  "learn learned": ["DjD","ET8"],
  "learn learnt": ["DjE"],
  "learn maths": ["DjE"],
  "learn to drive": ["EIG"],
  "learned": ["ET8"],
  "learned maths": ["ET8"],
  "learning": ["DjE","DjD"],
  "learning Japanese": ["DjD"],
  "learning maths": ["DjE"],
  "leash": ["BpC"],
  "leather": ["BpE","BpF"],
  "leave": ["DjF","DjH","Ea8","EYP","DjG"],
  "leave left": ["ES4","DjF","DjH","DjG"],
  "leave school": ["DjG","EIH"],
  "leave work": ["DjH","EYP"],
  "leaves": ["BpK","BpG","BpJ","BpI","BpH"],
  "leaving": ["DjF","Ea8","DjG","DjH"],
  "leaving school": ["DjG"],
  "leaving work": ["DjH"],
  "lecturer": ["BpM"],
  "leek": ["BpN","BpO"],
  "left": ["ES4"],
  "leg": ["DGH","D2P","BpU","BpP"],
  "leggings": ["DGG"],
  "lego": ["BpT","BpQ","BpS","BpR"],
  "legs": ["DGJ","DGI","BpX","BpW","BpV"],
  "lemon": ["DGL","BpZ","D2R","Bpa","Bpg","BpY"],
  "lemon juice": ["Bpe"],
  "lemon tea": ["Bpn","DGN","Bpm"],
  "lemonade": ["DGK","Bpc","Bpd","D2Q","Bpb"],
  "lemons": ["DGM","Bpl","Bpk","Egq","Bpj"],
  "lend": ["Bpq","EYQ","Bpr"],
  "lend a book": ["DjI","EYQ"],
  "lend lent": ["DjI"],
  "lending a book": ["DjI"],
  "length": ["Bps"],
  "lentils": ["Bpx","Bpv","Bpw","Bpt","Bpu"],
  "leopard": ["Bp2","Bpy","Bpz","Bp1","Bp0"],
  "let go": ["Drh"],
  "letter": ["DGO","D2S"],
  "letter a": ["DZm"],
  "letter b": ["DZo"],
  "letter c": ["DZq"],
  "letter d": ["DZs"],
  "letter e": ["DZu"],
  "letter f": ["DZw"],
  "letter g": ["DZy"],
  "letter h": ["DZ0"],
  "letter i": ["DZ2"],
  "letter j": ["DZ4"],
  "letter k": ["DZ6"],
  "letter l": ["DZ8"],
  "letter m": ["DaA"],
  "letter n": ["DaC"],
  "letter o": ["DaE"],
  "letter p": ["DaG"],
  "letter q": ["DaI"],
  "letter r": ["DaK"],
  "letter s": ["DaM"],
  "letter t": ["DaO"],
  "letter u": ["DaQ"],
  "letter v": ["DaS"],
  "letter w": ["DaU"],
  "letter x": ["DaW"],
  "letter y": ["DaY"],
  "letter z": ["Daa"],
  "letters": ["Bp5","Bp6","Bp4"],
  "lettuce": ["Bp9","DGP","BqA","D2T","Bp7","Bp8"],
  "level": ["BqB"],
  "librarian": ["BqC"],
  "library": ["DGQ","BqF","BqD","BqE"],
  "Libya": ["EII"],
  "licence": ["BqG"],
  "license": ["BqG"],
  "lick": ["BqH","BqI"],
  "lid": ["BqN","BqM"],
  "lie": ["BqP","BqO"],
  "lie down": ["DjJ","EYR","DjK","EbC"],
  "lie down lay down": ["DjK"],
  "lie down on the sofa": ["EYR"],
  "lie lay": ["DjJ","ES3"],
  "life jacket": ["Bqa","BqZ"],
  "lifebelt": ["BqS"],
  "lifeboat": ["BqV","BqU"],
  "lifeguard": ["DGS","EIL","BqY","BqW","BqX"],
  "lifestyle": ["E1J"],
  "lift": ["Bqc","DjL","DjM","Ea9","EYS"],
  "lift lifted": ["ES5","DjL","DjM"],
  "lift weights": ["EYS","Ea9","DjM"],
  "lift weights easily": ["ERH"],
  "lifted": ["ES5"],
  "lifted weights": ["ES5"],
  "lifting": ["Ea9","DjL","DjM"],
  "lifting weights": ["Ea9","DjM"],
  "light": ["Bqh","DGc","Bqi","EIO","Bqg","DjN","Bqv","D2Y"],
  "light a candle": ["DjN"],
  "light blue": ["DGT"],
  "light brown": ["DGU"],
  "light bulb": ["DGV","D2U","Bqk","Bqj"],
  "light bulbs": ["Bql","Bqm"],
  "light green": ["DGY"],
  "light lighted": ["ETb","DjN"],
  "light red": ["DGd"],
  "lighted": ["ETb"],
  "lighted a candle": ["ETb"],
  "lighter": ["DGW","DGX","D2V"],
  "lighthouse": ["DGZ","Bqp","Bqr","D2W","Bqo","Bqq"],
  "lighting": ["DjN"],
  "lighting a candle": ["DjN"],
  "lightning": ["Bqu","DGb","Bqs","Bqt","D2X","DGa"],
  "lights": ["Bqy","Bqz","Bqx","Bqw"],
  "like": ["DjQ","Bq0","Bq1","DjO","DjP","EYT","EYU"],
  "like apples": ["DjO","EYT"],
  "like chocolate": ["Efl"],
  "like doing exercise": ["Efm"],
  "like football": ["DjP","EYU"],
  "like giving gifts": ["Efn"],
  "like icecream": ["DjQ"],
  "like liked": ["ET9","DjO","DjQ","DjP"],
  "like listening to music": ["Efo"],
  "like milk": ["Efp"],
  "like pizza": ["Efq"],
  "like playing the drums": ["Efr"],
  "like reading books": ["Efs"],
  "like surfing": ["Eft"],
  "liked": ["ET9"],
  "liked ice cream": ["ET9"],
  "liking": ["DjQ","DjO","DjP"],
  "lily": ["Bq3","Bq4","Bq2"],
  "lime": ["Bq6","DGe","D2Z","Bq7","BrB","Bq5","Egr"],
  "lime juice": ["Bq8"],
  "limes": ["BrC","DGf"],
  "limo": ["D2a","DGg"],
  "line": ["DGh","D2b"],
  "line up": ["Dri"],
  "lines": ["E1K"],
  "link": ["BrE"],
  "lion": ["DGi","D2c","BrJ","BrH","BrF","BrI","BrG"],
  "lions": ["BrL","BrK","BrN","BrM"],
  "lip": ["Drj"],
  "lip stick": ["DGj"],
  "lips": ["BrS","BrO","BrR","BrQ","BrP"],
  "lipstick": ["BrW","BrU","D2d","BrT","BrV"],
  "liquid": ["BrZ","BrX","BrY"],
  "list": ["Drl"],
  "listen": ["DjS","DjR","Brb","EYV","EdY","EIP","Bra","Brd"],
  "listen carefully": ["ERI"],
  "listen listened": ["DjR","EWM","DjS"],
  "listen to": ["Drk"],
  "listen to music": ["DjS","Brf","EYV","EdY","Bre","Brg"],
  "listen to people's problems": ["EIQ"],
  "listened": ["EWM"],
  "listened to music": ["EWM"],
  "listening": ["DjS","DjR","EdY"],
  "listening to music": ["DjS","Brc","EdY"],
  "literature": ["Bri","Brk","Brh","Brj"],
  "Lithuania": ["Bro"],
  "litter": ["Brp","Brs","Brq","Brr"],
  "little": ["EIS"],
  "little brother": ["Brt"],
  "little sister": ["Bru"],
  "live": ["DjT","EYW"],
  "live in London": ["DjT","EYW"],
  "live lived": ["EVt","DjT"],
  "lived": ["EVt"],
  "lived in London": ["EVt"],
  "lively": ["E1L"],
  "liver": ["Brv","Brw"],
  "Liverpool": ["Drm"],
  "living": ["DjT"],
  "living in London": ["DjT"],
  "living room": ["DGk","Brx","Br0","Brz","Br1","Bry","Br2"],
  "lizard": ["DGl","Br5","Br7","D2e","Br3","Br6","Br4"],
  "llama": ["Drn"],
  "loaf": ["Dro"],
  "loaf of bread": ["Br8","BsA","Br9","BsB"],
  "loaves": ["BsF","BsD"],
  "lobby": ["BsI"],
  "lobster": ["DGm","BsP","BsK","D2f","BsL","BsM","BsO"],
  "location": ["E1M"],
  "lock": ["BsR","DjV","Bsb","EYX","DjU","BsQ","BsS","EbA"],
  "lock a door": ["DjU"],
  "lock locked": ["DjV","ETc","DjU"],
  "lock the door": ["EbA","EYX","DjV"],
  "locked": ["ETc"],
  "locked the door": ["ETc"],
  "locker": ["BsT","BsV","BsW","BsU"],
  "lockers": ["DGn"],
  "locket": ["BsY"],
  "locking": ["EbA","DjV","DjU"],
  "locking a door": ["DjU"],
  "locking the door": ["EbA","DjV"],
  "locust": ["Bsc"],
  "lodge": ["Bse"],
  "log": ["Bsh","Bsg"],
  "logo": ["Drp"],
  "logs": ["Bsj","Bsi"],
  "lollipop": ["Bsn","D2h","Bso","Bsk","Bsl","Bsm"],
  "lollipops": ["Drq"],
  "London": ["Drr"],
  "lonely": ["Bss","Bsp","Bsr"],
  "long": ["DGr","Bsy","Ehn","EIT","Eho"],
  "long hair": ["Bsu","Bsw","Bst","Ehn","Eho","Bsv"],
  "long jump": ["DGq","D2i"],
  "long neck": ["Bsx"],
  "longer": ["DGp","DGo"],
  "look": ["DjX","Dja","EYZ","EYY","Bsz"],
  "look after": ["DjW","Bs0","EcQ"],
  "look after animals": ["EIU"],
  "look after children": ["EcQ"],
  "look after looked after": ["DjW"],
  "look after passengers": ["EIW"],
  "look after sick people": ["EIY"],
  "look at": ["DjZ","EIa","DjY","Bs2","Bs1","EdZ","EbB"],
  "look at a clock": ["DjY"],
  "look at a picture": ["EIZ"],
  "look at art": ["EYY"],
  "look at each other": ["EdZ","DjZ"],
  "look at looked at": ["DjX"],
  "look at pictures": ["DjX"],
  "look at the clock": ["EbB"],
  "look closely": ["ERJ"],
  "look for": ["E1N"],
  "look in the mirror": ["EYZ","Dja"],
  "look looked": ["Dja","DjZ","EU5","DjY"],
  "look through": ["Djb"],
  "look through a telescope": ["Djb"],
  "look up": ["E1O"],
  "looked": ["EU5"],
  "looked at each other": ["EU5"],
  "looking": ["DjX","Dja"],
  "looking after": ["DjW","EcQ"],
  "looking at": ["EdZ","EbB","DjY","DjZ"],
  "looking at a clock": ["DjY"],
  "looking at each other": ["DjZ","EdZ"],
  "looking at pictures": ["DjX"],
  "looking in the mirror": ["Dja"],
  "looking through": ["Djb"],
  "looking through a telescope": ["Djb"],
  "lorry": ["Bs9","Bs8","Bs7","Bs6","Bs5"],
  "lose": ["Djc"],
  "lose lost": ["EVX","Djc","ES6"],
  "lose the game": ["Djc"],
  "losing": ["Djc"],
  "losing the game": ["Djc"],
  "lost": ["ES6","EVX"],
  "lost the game": ["EVX","ES6"],
  "lotus": ["BtA"],
  "loud": ["DGs","BtC","BtE","BtF","BtD"],
  "loudly": ["E1P"],
  "love": ["Djd","BtI","EYa","BtH","BtG","BtJ"],
  "love cats": ["EYa"],
  "love loved": ["Djd"],
  "love the cat": ["Djd"],
  "lovely": ["Drs"],
  "loving": ["Djd"],
  "low": ["E1Q"],
  "lower": ["DGt","ER4"],
  "loyal": ["BtK"],
  "luck": ["BtL"],
  "lucky": ["BtM"],
  "lucky money": ["Drt"],
  "luggage": ["DGu","BtS","BtN","BtR","D2j","BtO","BtP","BtQ"],
  "lumberjack": ["DGw","EIb","D2k"],
  "lunch": ["BtW","BtT"],
  "lunch box": ["BtU","BtV"],
  "lunchbox": ["Dru"],
  "lungs": ["BtX","BtZ","BtY"],
  "Luxembourg": ["Btc","Bta"],
  "luxury": ["Btf"],
  "lychee": ["Bth","Bti","Btj","Btg"],
  "lying down": ["DjJ","DjK","EbC"],
  "lyric": ["E1S","E1R"],
  "m": ["DZ9","DaA"],
  "machine": ["Btn","Btl","Btm","Btk"],
  "machu picchu": ["Bto"],
  "mad": ["Btt","Btp"],
  "mad as hell": ["EIe","EIf","EIg"],
  "Madagascar": ["Bts","Btr","Btq"],
  "made": ["EVa","EVZ","ES7","EWI"],
  "made a sandwich": ["EVZ"],
  "made a snowman": ["EWI"],
  "made a speech": ["EVa"],
  "made coffee": ["ES7"],
  "magazine": ["Btx","Btu","Btw","Btv"],
  "magazines": ["Bty"],
  "magenta": ["DGx"],
  "magic": ["Bt5","Btz","Bt0"],
  "magic show": ["E1T"],
  "magician": ["DGz","DGy","Bt4","EIh","Bt3"],
  "magnet": ["DG0","Bt6","Bt9","Bt8","D2l","Bt7"],
  "magnifying glass": ["BuA","BuB","BuC","BuE","BuF","BuD"],
  "mahjong": ["BuI","BuH"],
  "maid": ["DG2","BuJ","DG1","BuL","BuK"],
  "mail": ["BuM","BuU","BuN"],
  "mail carrier": ["Drv"],
  "mailbox": ["BuO","BuR","BuS","BuP","BuQ"],
  "mailman": ["DG4","D2m","EIm"],
  "main course": ["Drw"],
  "maintain": ["E1U"],
  "maintain a building": ["EIn"],
  "maize": ["BuX","BuV"],
  "majority": ["Drx"],
  "make": ["Djj","Dje","Djf","EbE","EbD","Dji","EYb","Djh","EYd","Djg"],
  "make a cake": ["Dry"],
  "make a model": ["Dje"],
  "make a model plane": ["EYb"],
  "make a sandcastle": ["E1V"],
  "make a sandwich": ["Djf","EbD"],
  "make a snowman": ["Drz"],
  "make a speech": ["Djg"],
  "make a web": ["Djh","EYd"],
  "make a website": ["EIq"],
  "make bread": ["EIr"],
  "make clothes": ["EIs"],
  "make coffee": ["Dji","EbE"],
  "make computer software": ["EIu"],
  "make drinks": ["EIv"],
  "make friends": ["Dr0"],
  "make made": ["Dje","EWI","EVZ","Djf","Djh","Dji","Djj","EVa","ES7"],
  "make models": ["E1W"],
  "make music": ["EIw"],
  "make my bed": ["Dr1","Dr2"],
  "make some food": ["Djj"],
  "make the bed": ["E1X"],
  "make things with wood": ["EIx"],
  "make up": ["E1Y"],
  "make websites": ["EIy"],
  "making": ["EbD","Djj","Dje","EbE","Djf","Djg","Djh","Dji"],
  "making a model": ["Dje"],
  "making a sandwich": ["Djf","EbD"],
  "making a speech": ["Djg"],
  "making a web": ["Djh"],
  "making coffee": ["EbE","Dji"],
  "making some food": ["Djj"],
  "Malaysia": ["Bua","BuY","BuZ","EIz"],
  "Malaysia flag": ["DG5"],
  "Mali": ["EI0"],
  "mall": ["Bub","Buc","Bui","Bue","Bud"],
  "mallet": ["Buh","Buf","Bug"],
  "mammal": ["DG6"],
  "mammals": ["Dr3","EI1"],
  "mammoth": ["Bul","Bum","Buj","Buk"],
  "man": ["Dr6"],
  "manage": ["Dr4"],
  "manage a hotel": ["EI2"],
  "manage a sports team": ["EI3"],
  "manager": ["Dr5"],
  "mandolin": ["Buq","Bun","Buo","Bup"],
  "mane": ["DG7","Bus","Bur"],
  "mango": ["Buu","DG9","Buw","Buv","Bux","Egs","Buz","Buy"],
  "mangoes": ["DG8","D2n"],
  "mangosteen": ["Bu4","Bu0","Bu1","Bu3","Bu2"],
  "mantis": ["Bu5","Bu8"],
  "manufacture": ["BvA"],
  "many": ["Dr7"],
  "many hands make light work": ["EI4","EI5","EI6"],
  "map": ["DHA","BvD","D2o","BvC","BvB"],
  "marathon": ["BvG","BvF"],
  "marble": ["BvI","BvJ"],
  "marbles": ["BvN","BvK","BvL","BvM"],
  "march": ["BvP","BvO"],
  "March": ["Dr8"],
  "marigold": ["BvR","BvQ"],
  "marine": ["BvT"],
  "marker": ["DHB","BvV","BvW","D2p","BvU"],
  "markers": ["BvY","BvX"],
  "market": ["BvZ","Bvb","Bvd","Bvc","Bva"],
  "marriage": ["Bvh","Bvg","Bve"],
  "married": ["Bvi"],
  "marry": ["Bvk","Bvj","Bvl"],
  "mars": ["Bvn","Bvs","Bvm"],
  "marshmallow": ["Bvr","Bvp","Bvq","Bvo"],
  "martian": ["Bvt"],
  "mascot": ["Bvv"],
  "mashed potato": ["E1Z"],
  "mashed potatoes": ["Bvy","Bvw","Bvx"],
  "mask": ["Bv1","Bv2","Bv0","Bvz"],
  "massage": ["EYe","Djk"],
  "massage massaged": ["Djk"],
  "massage people": ["EI7"],
  "massage someone": ["EYe"],
  "massaging": ["Djk"],
  "masseuse": ["DHC"],
  "mat": ["Bv4","Bv3","BwJ"],
  "match": ["BwD","Bv5","Bv7","Bv6"],
  "matchbox": ["Bv9"],
  "matches": ["BwC","BwA"],
  "math": ["BwG","BwE"],
  "mathematics": ["BwF"],
  "maths": ["DHE","EdF","D2r","BwH","BwI"],
  "mature": ["BwK"],
  "maximum speed": ["BwL"],
  "May": ["DsA"],
  "mayo": ["BwN"],
  "mayonnaise": ["BwM"],
  "mayor": ["Dr9"],
  "meal": ["BwO","BwQ","BwP"],
  "mean": ["DsB"],
  "meanwhile": ["E1a"],
  "measure": ["BwR","BwS"],
  "meat": ["BwV","BwU","Bwb","BwT"],
  "meatball": ["BwW"],
  "meatballs": ["BwZ","BwX","BwY","Bwa"],
  "mechanic": ["DHI","DHF","Bwf","EJD","Bwd","Bwe","EJA","Bwc","D2s"],
  "mechanical engineer": ["DHG","DHH"],
  "medal": ["DHJ","Bwi","Bwh"],
  "medals": ["Bwk"],
  "media": ["DsC"],
  "medicine": ["Bwl","DHK","Bwn","Bwo","D2u","Bwm"],
  "meerkat": ["Bws","Bwq","Bwp"],
  "meet": ["Djl","Eda"],
  "meet each": ["Eda"],
  "meet each other": ["Eda"],
  "meet friends": ["DsD"],
  "meet met": ["Djl","EU6"],
  "meet someone": ["Djl"],
  "meeting": ["Bwu","Bwt","Bwv","Djl","Eda"],
  "meeting room": ["Bwy"],
  "meeting someone": ["Djl"],
  "melancholy": ["Bw1"],
  "melon": ["Bw4","Bw6","Bw5","Bw7"],
  "melt": ["BxA","Bw8","Bw9"],
  "memory": ["BxB"],
  "memory stick": ["DsE"],
  "men": ["E1b"],
  "mend": ["BxC"],
  "mental": ["BxD"],
  "menu": ["DsF"],
  "meow": ["E1c"],
  "mercury": ["DsH"],
  "mermaid": ["BxF","BxH","DHL","BxG","BxE"],
  "merry go round": ["DsI"],
  "mess": ["DsK"],
  "message": ["DsJ"],
  "messages": ["DHM"],
  "messier": ["ER5","DHN"],
  "messily": ["ERG"],
  "messy": ["BxK","DHO","EJE","Ehp","BxI"],
  "messy bathroom": ["Ehp"],
  "met": ["EU6"],
  "metal": ["BxL","BxP","BxN","BxM"],
  "metal detector": ["BxO"],
  "meteor": ["BxS","BxQ","BxR"],
  "method": ["E1e","E1d"],
  "metro": ["E1g","E1f"],
  "metropolitan": ["BxU","BxT"],
  "Mexican": ["DHP","EeR"],
  "Mexico": ["BxZ","DHR","D2v","BxX","EJF","BxY"],
  "Mexico flag": ["DHQ"],
  "mice": ["Bxb","Bxa"],
  "microchip": ["Bxd"],
  "microphone": ["DHS","Bxg","D2w","Bxh","Bxe"],
  "microscope": ["DHT","Bxl","Bxk","D2x","Bxi"],
  "microwave": ["DHU","Bxp","Bxo","Bxm","D2y","Bxn"],
  "microwave oven": ["DsL"],
  "midday": ["E1h"],
  "middle": ["DdS"],
  "midnight": ["DsM"],
  "mild": ["DHV","DHW"],
  "milk": ["DHX","Bxt","Bxq","D2z","Bxs","Bxr"],
  "milkshake": ["Bxu","Bxw","Bxv","D20"],
  "milkshakes": ["Bxy","Bxx"],
  "milky way": ["Bxz"],
  "millipede": ["Bx3"],
  "mime": ["Bx4"],
  "minecraft": ["Bx5"],
  "miner": ["ByA"],
  "mineral water": ["Bx6","Bx7","Bx8","Bx9"],
  "mini": ["ByC"],
  "mini car": ["ByB"],
  "minivan": ["ByD"],
  "mints": ["DHY"],
  "minus": ["ByE"],
  "minute": ["E1i"],
  "mirror": ["DHZ","D21","ByG","DHa","ByH","ByI","D22","ByF"],
  "miserable": ["ByJ"],
  "miss": ["E1j"],
  "mistake": ["DsN"],
  "mistletoe": ["EJG","ByK","ByL"],
  "mittens": ["DHb","ByM","D23","ByO","ByN"],
  "mix": ["ByP","ByQ"],
  "mixer": ["DHc","D24"],
  "mixture": ["DsO"],
  "mobile": ["DsP"],
  "mobile game": ["DHd"],
  "mobile phone": ["ByR","ByT"],
  "model": ["Djm","DHe","DHg","ByU","EJH","ByV","EYf"],
  "model clothes": ["EYf","Djm"],
  "model modeled": ["Djm"],
  "model plane": ["DHf"],
  "modeling": ["Djm"],
  "modeling clothes": ["Djm"],
  "modern": ["ByX","ByW"],
  "moisture": ["Bya","ByY"],
  "mole": ["Byd","Byb","Byc"],
  "mollusca": ["DHh"],
  "molten": ["Byf"],
  "mom": ["Byj","Byi"],
  "mona lisa": ["Byn"],
  "Monaco": ["Bym"],
  "Monday": ["DHk","DHi","DHj"],
  "money": ["DHl","Byp","D25","Byo"],
  "Mongolia": ["EJK"],
  "Mongolia flag": ["DHm"],
  "monitor": ["Byq","D26","Byr","Bys","Byt"],
  "monkey": ["DHn","Byw","D27","Byv","Byu"],
  "monkeys": ["Byx"],
  "monster": ["DsQ"],
  "Montenegro": ["EJL"],
  "monument": ["By0","Byz","Byy"],
  "moon": ["By3","By1","By9","By2","D6r","By4","DOj"],
  "moon cake": ["DsR"],
  "mooncake": ["By8","By6","By5","By7"],
  "moose": ["DsS"],
  "mop": ["DHp","Djn","D29","EYg","BzA","BzB","BzC","BzI"],
  "mop mopped": ["Djn"],
  "mop the floor": ["Djn","EYg","BzJ"],
  "moped": ["D28","DHo","BzH","BzD"],
  "mopping": ["Djn"],
  "mopping the floor": ["Djn"],
  "more beautiful": ["DHr","DHq"],
  "more boring": ["DHs"],
  "more casual": ["ERf","DHt"],
  "more colorful": ["DHv","DHu"],
  "more colourful": ["DHu","DHv"],
  "more dangerous": ["DHw"],
  "more difficult": ["ERn","DHx"],
  "more exciting": ["ERr","DHy"],
  "more expensive": ["DH0","DHz"],
  "more formal": ["DH1"],
  "morning": ["DYR","BzM"],
  "morning glory": ["BzK"],
  "Morocco": ["BzP","EJM","BzO"],
  "mortgage": ["BzQ"],
  "mosque": ["BzR"],
  "mosquito": ["BzU","BzV","BzT","BzS"],
  "motel": ["BzY","BzX"],
  "moth": ["Bzd","BzZ","Bza"],
  "mother": ["Bzc","DZa","Bzb","EJO"],
  "mother in law": ["DZZ","EJN"],
  "motherinlaw": ["EJN"],
  "motorbike": ["DH2","D3A","Bzg","Bze","Bzh","Bzi","Bzf"],
  "motorboat": ["Bzk"],
  "motorcycle": ["Bzo","Bzp","Bzn"],
  "motorhome": ["Bzt","Bzr","Bzs"],
  "mountain": ["B0A","DH3","Bzu","Bzw","D3B","Bzx","Bzv","Bzy","EdA"],
  "mountain bike": ["Bzz","Bz1","Bz2"],
  "mountain biking": ["Bz4","Bz5","Bz6"],
  "mountainous": ["Bz7","Bz8"],
  "mountains": ["B0D","B0C","B0B"],
  "mouse": ["DH5","B0I","DH4","D3C","B0F","B0G","D3D","B0H","B0E","EdB"],
  "mousetrap": ["B0J"],
  "moustache": ["DH6","D3E","B0L","B0M"],
  "mouth": ["DH7","D3F","B0N","B0P","B0O","B0Q"],
  "mouth watering": ["E1k"],
  "move": ["Djo","Djq","Djp","Edb","EYh","EcR","B0R"],
  "move a chair": ["Edb","Djo"],
  "move a sofa": ["EYh"],
  "move luggage": ["EJP"],
  "move moved": ["EU7","Djo","Djp","Djq"],
  "move the mouse": ["EcR","Djp"],
  "move the sofa": ["Djq"],
  "moved": ["EU7"],
  "moved an armchair": ["EU7"],
  "movie": ["B0S","B0T"],
  "movie theater": ["B0U","DH8","D3G"],
  "movies": ["DsT"],
  "moving": ["Djq","Djo","Edb","EcR","Djp"],
  "moving a chair": ["Edb","Djo"],
  "moving the mouse": ["EcR","Djp"],
  "moving the sofa": ["Djq"],
  "moving walkway": ["E1l"],
  "Mozambique": ["EJQ"],
  "mp player": ["B0V","B0W"],
  "much": ["E1m"],
  "mud": ["B0b","B0a","B0Z","B0Y","B0X"],
  "muffin": ["DH9","D3H","B0h","B0d","B0e","B0c","B0f","B0g"],
  "muffins": ["DsU"],
  "mug": ["DIA","D3I","B0n","B0m","B0i","B0j","B0k","B0l"],
  "mule": ["B0o","B0p"],
  "multiply": ["B0q"],
  "mum": ["B0r","B0s","EJT"],
  "mummies": ["EJR"],
  "mummy": ["DsV"],
  "mural": ["E1n"],
  "muscle": ["B0u","B0t"],
  "muscles": ["DsW"],
  "muscular": ["B0v","B0w"],
  "museum": ["B0z","B0y","B0x"],
  "mushroom": ["B04","B02","B01","Egt","B00","B03"],
  "mushrooms": ["DIB","B07","D3J","B06","B05","B08"],
  "music": ["DIE","B1I","D3L","B1C","B1A","B09","B1D","B1B"],
  "music room": ["DsY"],
  "musical": ["DsX"],
  "musician": ["DIC","DID","EJU","B1H","B1E","B1G","D3K","B1F"],
  "musketeer": ["B1J"],
  "musketeers": ["B1K"],
  "mustache": ["D3E","B0M","DH6","B0L"],
  "mustard": ["DIF","B1O","B1L","B1M","B1N"],
  "mute": ["B1Q","B1P"],
  "my": ["E1o"],
  "my aunt": ["DZK","D85"],
  "my boyfriend": ["DZL"],
  "my brother": ["DZM","D9r"],
  "my cousin": ["EBV","DZN"],
  "my cousins": ["DZO"],
  "my daughter": ["EBt","DZQ"],
  "my daughter in law": ["EBu","DZP"],
  "my family": ["DZR"],
  "my father": ["EDb","DZT"],
  "my father in law": ["EDa","DZS"],
  "my granddaughter": ["EEr","DZU"],
  "my grandfather": ["EEs","DZV"],
  "my grandmother": ["EEt","DZW"],
  "my grandson": ["EEu","DZX"],
  "my husband": ["EGi","DZY"],
  "my mother": ["EJO","DZa"],
  "my mother in law": ["EJN","DZZ"],
  "my nephew": ["EJb","DZb"],
  "my niece": ["EJk","DZc"],
  "my parents": ["EKN","DZd"],
  "my sister": ["EM2","DZe"],
  "my son": ["ENV","DZg"],
  "my son in law": ["ENW","DZf"],
  "my twin sister": ["EPW","DZh"],
  "my uncle": ["DZi","EPZ"],
  "my wife": ["EQo","DZj"],
  "Myanmar": ["B1U","EJW","B1R"],
  "Myanmar flag": ["B1T"],
  "mysterious": ["B1V","B1W"],
  "myth": ["E1p"],
  "n": ["DaB","DaC"],
  "nail": ["DIH","B1Z","D3N","B1X"],
  "nail clippers": ["DIG","B1Y"],
  "nail polish": ["B1a","B1d","B1b"],
  "nails": ["B1g","B1e","B1f"],
  "name": ["E1q"],
  "Namibia": ["EJX"],
  "nanny": ["DIJ","DII","EJY","B1h"],
  "nap": ["B1n","B1i","B1j"],
  "napkin": ["B1m","B1l","B1k"],
  "napkins": ["DsZ"],
  "narrow": ["B1o"],
  "nationality": ["Dsa"],
  "natural": ["B1p","B1r","B1q"],
  "nature": ["B1u","B1s","B1t"],
  "naughty": ["B1v"],
  "navigate": ["B1w","B1x"],
  "near": ["E1r"],
  "neat": ["B1y"],
  "neck": ["DIM","D3P","B15","B1z","B10"],
  "necklace": ["DIK","DIL","D3O","B11","B12","B13","B14"],
  "necktie": ["B17"],
  "nectarine": ["B2A","B18","B19"],
  "need": ["E1s"],
  "needle": ["DIO","B2C","B2D","D3Q","B2B"],
  "needle and thread": ["DIN"],
  "neighbor": ["Dsb","Dsc"],
  "neighborhood": ["B2E","B2F","B2G"],
  "neighbour": ["Dsc","Dsb"],
  "neon sign": ["B2H","B2I","B2J"],
  "Nepal": ["EJa"],
  "nephew": ["DZb","EJb"],
  "neptune": ["B2K"],
  "nervous": ["DIP","EJd","EJc"],
  "nest": ["B2L","B2O","B2N","B2M"],
  "net": ["B2Q","B2R","B2P","B2S"],
  "Netherlands": ["EJe"],
  "Netherlands flag": ["DIQ"],
  "new": ["EJf"],
  "new year party": ["B2b"],
  "New York": ["Dsf"],
  "New zealand": ["B2c","B2f","EJh","B2e","B2d"],
  "newborn": ["E1t"],
  "newer": ["DIR"],
  "news": ["Dse"],
  "news reporter": ["B2W","B2X"],
  "newsagents": ["E1u","Dsd"],
  "newspaper": ["DIS","B2V","B2T","B2U","D3R"],
  "newt": ["B2a","B2Z"],
  "next": ["Dsg"],
  "next to": ["DdT","DdV","Efu","DdU","Efv"],
  "next to the bookcase": ["Efu"],
  "next to the stove": ["Efv"],
  "Nicaragua": ["EJj"],
  "nice": ["E1v"],
  "niece": ["DZc","EJk"],
  "Nigeria": ["B2i","B2h","B2g"],
  "Nigeria flag": ["DIT"],
  "night": ["B2p","B2k","B2j"],
  "night market": ["B2n"],
  "night stand": ["E1w"],
  "nightmare": ["B2m","B2l"],
  "nine": ["DbY","DbW"],
  "nine hundred": ["DbX"],
  "nine o'clock": ["DeJ","EfW"],
  "nine thousand": ["Dbb"],
  "nineteen": ["Dba","DbZ"],
  "ninety": ["Dbi","Dbc"],
  "ninety eight": ["Dbd"],
  "ninety five": ["Dbe"],
  "ninety four": ["Dbf"],
  "ninety nine": ["Dbg"],
  "ninety one": ["Dbh"],
  "ninety seven": ["Dbj"],
  "ninety six": ["Dbk"],
  "ninety thousand": ["Dbl"],
  "ninety three": ["Dbm"],
  "ninety two": ["Dbn"],
  "ninth": ["E1x"],
  "no": ["E1z"],
  "no entry": ["B2q"],
  "no parking": ["Dsi"],
  "noise": ["E1y"],
  "noisier": ["DIU"],
  "noisily": ["ERT"],
  "noisy": ["B2r","Ehq","EJm"],
  "noodle soup": ["B2w","B2x","B2y","B2z"],
  "noodles": ["DIV","B2t","B2u","D3S","B2v","B20","B2s"],
  "noon": ["Dsh"],
  "North america": ["B21"],
  "North Korea": ["EJn"],
  "northern lights": ["B22","B23"],
  "Norway": ["B28","B24","B25"],
  "nose": ["DIX","B29","D3U","B3A"],
  "nose bleed": ["DIW","D3T"],
  "not": ["E11"],
  "note": ["B3E"],
  "note down": ["E10"],
  "notebook": ["B3D","B3B","B3C"],
  "notepad": ["DIY","D3V"],
  "notes": ["B3G"],
  "nothing": ["Dsj"],
  "notice": ["Dsk"],
  "novel": ["B3H","B3I","B3K","B3J"],
  "November": ["Dsl"],
  "now": ["Dsm"],
  "nuclear engineer": ["DIa"],
  "nuclear family": ["E12"],
  "nuggets": ["B3L","B3M"],
  "number": ["E13"],
  "numbers": ["B3O","B3P","B3N"],
  "nurse": ["DIc","EJs","B3Q","B3S","DIb","EJr","B3R","D3W"],
  "nut": ["B3T"],
  "nutrient": ["E14"],
  "nuts": ["B3X","B3W","B3U","DId","B3V"],
  "o": ["DaD","DaE"],
  "oar": ["B3Z","B3Y"],
  "oasis": ["B3c","B3a","B3b"],
  "oats": ["B3f","B3d","B3e","B3g"],
  "obedient": ["B3h"],
  "obelisk": ["B3k","B3i","B3j"],
  "oboe": ["B3n","B3l"],
  "observation": ["B3p","B3o"],
  "observatory": ["B3q"],
  "observe": ["B3s","B3r"],
  "obsidian": ["B3v","B3u"],
  "obstacle": ["B3y","B3w","B3x"],
  "ocean": ["B30","B3z","B31"],
  "octagon": ["B33","B32"],
  "October": ["Dsn"],
  "octopus": ["B36","DIe","B34","D3X","B35","B38","B39","B37"],
  "odd": ["Dso"],
  "odd numbers": ["E15"],
  "offer": ["B4B","B4A"],
  "office": ["DIf","B4F","B4H","B4E","B4D","B4C","B4G"],
  "office worker": ["DIh","DIg","EJu","B4J","EJt","B4I"],
  "office workers": ["B4K"],
  "official": ["E16"],
  "often": ["DYS"],
  "oil": ["B4P","B4L","B4N","B4O","B4M"],
  "oil rig": ["B4Q","B4R","B4S","B4T"],
  "oil tanker": ["B4U"],
  "oil well": ["B4V"],
  "ok": ["Dsp"],
  "okay": ["B4W"],
  "old": ["DIm","B4Y","DIi","B4a","EJv","B4j","DIj","Ehs","Eht","Ehr","B4Z","B4X"],
  "old city": ["B4b"],
  "old fashioned": ["B4e","B4d","B4c"],
  "old man": ["B4h","B4g"],
  "old woman": ["B4k","B4l"],
  "older": ["DIl","DIk"],
  "olive": ["B4p","Egu","B4m"],
  "olive oil": ["B4n","B4o"],
  "olives": ["DIo","B4r","D3Y","B4q","B4s"],
  "olympic": ["B4u","B4v"],
  "olympics": ["B4x","B4w"],
  "omelette": ["B40","B4y"],
  "on": ["DdW","Ef1","DdX","DdY","Ef0"],
  "on fire": ["DIp","Ehv","Ehu"],
  "on the fence": ["EJz","EJ0","EJ1"],
  "on the left": ["DdZ","Ddb","Efx","Dda","Efw"],
  "on the left of the building": ["Efw"],
  "on the left of the sofa": ["Efx"],
  "on the right": ["Ddd","Dde","Ddc","Efy","Efz"],
  "on the right of the classroom": ["Efy"],
  "on the right of the flag": ["Efz"],
  "on the roof": ["Ef0"],
  "on the table": ["Ef1"],
  "on top": ["DYU"],
  "one": ["Dbs","Dbo"],
  "one hundred": ["Dbp"],
  "one hundred thousand": ["Dbq"],
  "one million": ["Dbr"],
  "one thousand": ["Dbt"],
  "onfire": ["EJw"],
  "onion": ["DIq","B45","B44","B41","B42","Egv","B43"],
  "onions": ["DIr","B48","B49","D3Z","B46"],
  "online": ["B5D"],
  "online class": ["B5A","B5B"],
  "only": ["DYT"],
  "opal": ["B5E"],
  "open": ["Djt","Djv","Djs","Djr","EYj","EcT","Ehx","Dju","EcS","DYX","EYi","EJ4","DIs","Ehw"],
  "open a bottle": ["EcS","Djr"],
  "open a window": ["Djs","EcT"],
  "open door": ["Ehx","Ehw"],
  "open in the morning": ["EYi"],
  "open minded": ["DYW"],
  "open opened": ["Djt","EUA","Djr","Djs","Dju","Djv"],
  "open the book": ["Dsq"],
  "open the door": ["Djt","EYj"],
  "open the store": ["Dju"],
  "open the window": ["Djv"],
  "open window": ["DYY"],
  "open your book": ["Dsr"],
  "open your mouth": ["E17"],
  "opened": ["EUA"],
  "opened the window": ["EUA"],
  "opening": ["EcT","Djv","Djt","EcS","Djr","Djs","Dju"],
  "opening a bottle": ["EcS","Djr"],
  "opening a window": ["EcT","Djs"],
  "opening presents": ["DYV"],
  "opening the door": ["Djt"],
  "opening the store": ["Dju"],
  "opening the window": ["Djv"],
  "opera": ["DYZ","B5F"],
  "opossum": ["E18"],
  "opportunity": ["E19"],
  "oppose": ["DYa"],
  "opposite": ["B5I","B5J","B5H"],
  "opposition": ["DYb"],
  "optician": ["DIt","DIu","B5K"],
  "optics": ["DYc"],
  "optometrist": ["B5N"],
  "orange": ["DIv","B5Q","B5X","B5R","DIz","Egw"],
  "orange hats": ["DIw","EgJ"],
  "orange juice": ["DIx","B5V","D3a","B5U","B5T","DIy","B5S","B5W"],
  "orange shirt": ["DI0","Ef9"],
  "oranges": ["DI1","B5Y","B5Z","D3b"],
  "orbit": ["DYd"],
  "orc": ["EJ8","EJ7"],
  "orchard": ["B5e","B5c","B5b"],
  "orchid": ["B5g","B5f"],
  "order": ["Djw","Djx","EbF","B5i","EYk","B5h"],
  "order a pizza": ["Djw","EYk"],
  "order food": ["Djx","EbF"],
  "order ordered": ["Djw","EVf","ES8","Djx"],
  "ordered": ["EVf","ES8"],
  "ordered a pizza": ["EVf"],
  "ordered some food": ["ES8"],
  "ordering": ["EbF","Djx","Djw"],
  "ordering a pizza": ["Djw"],
  "ordering food": ["EbF","Djx"],
  "organ": ["E2B"],
  "organize": ["E2A"],
  "organize holidays": ["EKA"],
  "organutan": ["E2C"],
  "ornaments": ["Dss"],
  "ostrich": ["B5l","B5j","B5m","B5k"],
  "otter": ["B5p","B5o","B5n"],
  "our": ["E2D"],
  "out": ["E2E"],
  "outlet": ["B5q"],
  "outside": ["B5r"],
  "outskirts": ["B5s"],
  "outstanding": ["B5t"],
  "oval": ["B5x","B5w","B5v","B5u"],
  "oven": ["B51","B5y","B50","B5z"],
  "over": ["E2G"],
  "over the moon": ["EKB","EKC","EKD"],
  "over the water": ["E2I"],
  "overcast": ["B55","DI2","B54","EhO"],
  "overcome": ["E2F"],
  "overpopulation": ["B57","B56"],
  "overseas": ["E2H"],
  "oversleep": ["B58"],
  "overtake": ["B59"],
  "overweight": ["B6C","B6A","B6B"],
  "owl": ["B6E","DI3","B6H","EKE","B6F","D3c","B6D","B6G"],
  "owner": ["B6J","B6I"],
  "ox": ["B6M","B6K","B6L"],
  "oxygen": ["E2J"],
  "oyster": ["B6O","B6P"],
  "ozone layer": ["B6R"],
  "p": ["DaF","DaG"],
  "pack": ["Djy","EYl"],
  "pack a bag": ["Djy","EYl"],
  "pack packed": ["Djy"],
  "package": ["B6W","B6T","B6S","B6U","B6V"],
  "packaging": ["B6X"],
  "packing": ["Djy"],
  "packing a bag": ["Djy"],
  "pad": ["B6c","B6Y"],
  "paddle": ["B6b","B6a","B6Z"],
  "paddles": ["DI4"],
  "padlock": ["DI5"],
  "page": ["B6d"],
  "pagoda": ["Dst"],
  "paid": ["Dsu","ETe"],
  "paid some money": ["ETe"],
  "pail": ["B6f","B6e"],
  "pain": ["B6i","B6g","B6h"],
  "painful": ["E2K"],
  "painless": ["E2L"],
  "paint": ["Dj2","B6j","B62","Djz","B6l","EYm","Dj3","EbG","B6k","Dj1","Dj0","EYn"],
  "paint a picture": ["Djz","EYm","B6n","Dj1","EbG","B6m","Dj0"],
  "paint beautifully": ["ERK"],
  "paint brush": ["Dsv"],
  "paint painted": ["EUB","Djz","Dj2","Dj0","Dj1","Dj3"],
  "paint pictures": ["Dsw"],
  "paint roller": ["B65","B63"],
  "paint the wall": ["EYn","Dj3"],
  "paintbrush": ["DI6","B6p","B6s","B6r","D3e","B6o","B6q"],
  "painted": ["EUB"],
  "painted a picture": ["EUB"],
  "painter": ["B6v","B6t","B6u"],
  "painting": ["Dj2","Djz","B6w","B6x","Dj1","EbG","Dj0","Dj3","B60"],
  "painting a picture": ["B6z","EbG","Djz","Dj0","Dj1"],
  "painting the wall": ["Dj3"],
  "paintings": ["B61"],
  "paints": ["B67","B66"],
  "pajamas": ["B68","CI1"],
  "Pakistan": ["EKI"],
  "Pakistan flag": ["DI7"],
  "palace": ["B7A","B7E","B7C","B69","B7B","B7D"],
  "pale": ["B7H","B7G","B7F"],
  "palm": ["E2M"],
  "palm tree": ["B7I","B7J","B7K"],
  "pan": ["B7M","B7e","B7L"],
  "Panama": ["B7Q","B7N"],
  "pancake": ["B7S","B7R"],
  "pancakes": ["DI8","B7U","B7W","B7V","B7T"],
  "pancreas": ["B7X"],
  "panda": ["B7b","DI9","B7Z","B7a","D3f","B7Y"],
  "pandas": ["B7c"],
  "pangolin": ["B7d"],
  "panini": ["DJA"],
  "pants": ["DJB","DJC","B7f","D3g","B7i","B7h","B7j","B7g"],
  "papaya": ["B7o","B7m","B7l","B7k"],
  "papaya salad": ["B7q"],
  "paper": ["DJE","B7r","D3i","B70"],
  "paper clip": ["B7u","B7v","B7w"],
  "paper clips": ["B7x","B7z","DJD","D3h"],
  "paper towel": ["B72","B71"],
  "paper towels": ["DJF","B73"],
  "paperbag": ["B7t"],
  "Papua New Guinea": ["EKK"],
  "parachute": ["B74","B75"],
  "parade": ["B76"],
  "paradise": ["B78","B77"],
  "paragraph": ["B79"],
  "parallel": ["B8A"],
  "paramedic": ["B8C","DJG","EKL","DJH","EKM"],
  "parasol": ["B8F","B8D","B8E"],
  "parcel": ["B8G"],
  "parent": ["B8H"],
  "parents": ["DZd","B8J","B8I","EKN"],
  "Paris": ["Dsx"],
  "park": ["B8K","DJI","B8S","B8L","B8M"],
  "parking garage": ["B8P","B8N"],
  "parking lot": ["B8Q","B8R"],
  "parrot": ["DJJ","B8W","D3k","B8U","B8T","B8V"],
  "partly cloudy": ["Dsy"],
  "partner": ["Dsz"],
  "party": ["B8X","B8Y"],
  "party hat": ["Ds0"],
  "pass": ["Dj4"],
  "pass a test": ["Dj4"],
  "pass passed": ["EV5","Dj4"],
  "passed": ["EV5"],
  "passed the test": ["EV5"],
  "passenger": ["B8a","B8Z"],
  "passengers": ["B8c","B8b"],
  "passing": ["Dj4"],
  "passing a test": ["Dj4"],
  "passion fruit": ["B8d","B8f","B8g"],
  "passport": ["B8j","B8i","B8h"],
  "password": ["Ds1"],
  "pasta": ["DJK","B8n","B8l","B8m","D3l","B8k"],
  "pastries": ["B8q","B8o"],
  "pastry": ["B8r","B8s"],
  "pasture": ["B8w","B8t","B8u","B8v"],
  "pat": ["B84"],
  "path": ["B8x","B8z","B8y"],
  "patient": ["B80","B83","B81","B82"],
  "patriot": ["B88"],
  "pattern": ["B89","B9B","B9A"],
  "pavement": ["B9F","B9C","B9E"],
  "paw": ["B9I","B9H","B9G","B9J"],
  "paws": ["B9L","B9K"],
  "pay": ["Dj6","EcU","B9N","B9P","EYo","Dj5","B9O","B9M"],
  "pay attention": ["Ds2"],
  "pay money": ["EcU","Dj5","EYo"],
  "pay paid": ["ETe","Dj6","Dj5"],
  "paying": ["Dj6","EcU","Dj5"],
  "paying money": ["EcU","Dj5"],
  "pc": ["B9Q"],
  "pe": ["E2N"],
  "pea": ["B9o"],
  "peace": ["B9V","B9R","B9S"],
  "peaceful": ["B9U","B9T"],
  "peach": ["B9W","DJN","B9c","Egx","DJL"],
  "peach blossom": ["B9X"],
  "peaches": ["DJM","B9b","B9a","D3m","B9Z"],
  "peacock": ["B9f","DJO","B9e","D3n"],
  "peanut": ["B9n","B9g"],
  "peanut butter": ["DJP","B9i","B9h","B9j","B9k","B9l","B9m"],
  "peanuts": ["Ds3","D3o"],
  "pear": ["DJQ","B9v","B9r","B9p","Egy","B9q"],
  "pearl": ["B9s"],
  "pearls": ["B9t"],
  "pears": ["DJR","B9w","B9y","B9x","D3p"],
  "peas": ["DJS","B9z","B91","D3q","B90","DJT"],
  "pebbles": ["B95","B92","B93"],
  "pedal": ["B96"],
  "pedals": ["B98"],
  "peddler": ["B99"],
  "pedestal": ["CAB","CAA"],
  "pedestrian": ["CAC","CAH"],
  "pedestrian crossing": ["CAF","CAD","CAG"],
  "pedestrians": ["CAJ"],
  "peel": ["Dj7","CAK","CAL","EcV","CAN","CAM"],
  "peel a banana": ["Dj7","EcV"],
  "peel peeled": ["Dj7"],
  "peeler": ["DJU","D3r"],
  "peeling": ["EcV","Dj7"],
  "peeling a banana": ["EcV","Dj7"],
  "peg": ["DJV","CAQ","CAO","D3s","CAP"],
  "pegs": ["CAR"],
  "pelican": ["CAS","CAU","CAT"],
  "pen": ["DJa","DJW","D3t","CAW","D3x","CAv","CAV","CAX"],
  "pencil": ["DJY","CAd","CAZ","CAY","D3v","CAa"],
  "pencil box": ["CAb"],
  "pencil case": ["DJX","CAc","D3u"],
  "pencil sharpener": ["CAh","CAg","CAi"],
  "pencils": ["CAf","CAe","CAj"],
  "pendant": ["CAm","CAk","CAl"],
  "penguin": ["DJZ","CAp","CAo","CAn","D3w"],
  "penguins": ["CAr","CAq"],
  "peninsula": ["CAs"],
  "pens": ["CAy","CAw","CAx"],
  "pentagon": ["CAz"],
  "people": ["CA0"],
  "pepper": ["CA3","CA2","Egz","CA4","CA1","CA9"],
  "peppermint": ["CA7"],
  "pepperoni": ["CA8"],
  "peppers": ["CBD","CBB","CBA","D3y","CBC"],
  "perfect": ["CBE"],
  "perform": ["CBF","CBJ"],
  "perform on stage": ["EKO"],
  "performance": ["E2O","CBH","CBI","CBG"],
  "perfume": ["CBM","CBK","CBL"],
  "person": ["E2P"],
  "personal trainer": ["DJb","DJc"],
  "Peru": ["CBN","CBQ","CBP","EKR"],
  "pet": ["CBS","CBR","CBY","CBT"],
  "pet food": ["CBV","CBW"],
  "pet shop": ["E2Q"],
  "pet store": ["DJe","D3z"],
  "petrol": ["CBb","CBc","CBZ"],
  "petrol station": ["CBd","CBe","CBf"],
  "pets": ["CBh","CBg"],
  "pharmacist": ["DJg","CBj","DJf","CBk","CBi","EKS"],
  "pharmacy": ["DJh","CBl"],
  "Philippines": ["CBp","CBm","EKU","CBn"],
  "Philippines flag": ["DJi"],
  "phone": ["DJl","DJj","CBt","CBq","ETd","CBr","D33","D31","CBs"],
  "phone charger": ["DJk"],
  "phone rang": ["ETd"],
  "photo": ["CB2"],
  "photo album": ["CBu"],
  "photocopier": ["CBx"],
  "photograph": ["E2R"],
  "photographer": ["DJm","CB0","DJn","EKV","CBy","CBz","D34","EKW"],
  "photography": ["CB1"],
  "phrase": ["CB3"],
  "physical education": ["DJo","D35"],
  "physical therapy": ["CB4"],
  "physics": ["DJp","CB6","CB5","D36"],
  "physiotherapy": ["CB7"],
  "piano": ["DJq","CB8","CCA","CCB","D37","CB9","CCC"],
  "pick": ["Dj8","CCE","CCD","EbH","EcW","Dj9"],
  "pick apples": ["Dj8","EbH"],
  "pick flowers": ["Dj9","EcW"],
  "pick picked": ["ES9","Dj8","Dj9"],
  "pick up": ["DkA","EKX","EbI"],
  "pick up litter": ["EbI"],
  "pick up picked up": ["DkA"],
  "picked": ["ES9"],
  "picked apples": ["ES9"],
  "picking": ["Dj8","Dj9","EcW","EbH"],
  "picking apples": ["Dj8","EbH"],
  "picking flowers": ["EcW","Dj9"],
  "picking up": ["EbI","DkA"],
  "picnic": ["CCH","CCI","CCG","CCF"],
  "picture": ["DJr","CCK","D38","CCL","CCJ"],
  "pictures": ["CCM"],
  "picturesque": ["CCP","CCO"],
  "pie": ["DJt","CCQ","CCZ","DJs","CCR","D39","CCS"],
  "piece": ["CCY"],
  "piece of cake": ["CCX","CCU","CCW"],
  "pier": ["CCb","CCa"],
  "pig": ["DJu","D4A","CCr","CCf","CCe","CCg","CCh"],
  "pig pen": ["CCq"],
  "pigeon": ["CCj","CCk","CCi"],
  "piglet": ["CCo","CCn","CCp","CCm"],
  "pile": ["CCu","CCt"],
  "pill": ["CCv","CC4","CCw"],
  "pillow": ["DJv","D4B","CCz","CCy","CCx"],
  "pillows": ["CC3","CC0","CC2","CC1"],
  "pills": ["CC7","CC5","CC6"],
  "pilot": ["DJx","CDB","DJw","EKZ","EKY","CDA","CC9","CC8","D4C"],
  "pin": ["CDC","CDS"],
  "pinball": ["CDD"],
  "pine": ["CDM"],
  "pineapple": ["DJy","CDG","CDJ","D4D","CDE","CDF"],
  "pineapple juice": ["CDH","CDI"],
  "pineapples": ["CDL","CDK"],
  "pinecone": ["Ds4"],
  "ping pong": ["CDN","CDO","CDP","CDQ"],
  "pink": ["DJz"],
  "pink shirt": ["EgA"],
  "pink tshirt": ["DJ0"],
  "pinocchio": ["CDR"],
  "pins": ["DJ1"],
  "pinwheel": ["E2S"],
  "pip": ["E2U","E2T"],
  "pipe": ["Ds5"],
  "piranha": ["CDT"],
  "pirate": ["CDV","CDW","CDU","EKa"],
  "pirate ship": ["CDY","CDX"],
  "pitch": ["Ds6"],
  "pitcher": ["CDa","CDZ"],
  "pizza": ["CDd","DJ3","DJ2","CDg","D4F","CDc","CDe","CDf","CDb"],
  "place": ["E2V"],
  "plaid": ["CDh"],
  "plain": ["CDi"],
  "plan": ["E2W"],
  "plane": ["DJ4","D4G","CDk","CDm","CDl","CDo","CDn","CDj"],
  "planet": ["CDp","DJ5","D4H"],
  "planets": ["CDs","CDq","CDr"],
  "plant": ["DJ6","DkB","D4I","CDv","CDy","EYp","CDt","CDw","CDu","CDx"],
  "plant a tree": ["EYp","DkB","EKb"],
  "plant flowers": ["E2X"],
  "plant planted": ["EVb","DkB"],
  "planted": ["EVb"],
  "planted a tree": ["EVb"],
  "planting": ["DkB"],
  "planting a tree": ["DkB"],
  "plants": ["CDz","CD0","CD1"],
  "plastic": ["CD7","CD2","CD3"],
  "plastic bag": ["CD5","CD6","CD4"],
  "plastic straw": ["CD8"],
  "plate": ["DJ7","CEB","CED","D4J","CEC"],
  "plates": ["CEF","CEE"],
  "platform": ["CEG","CEH"],
  "platypus": ["Ds7"],
  "play": ["DkC","Edf","DkG","DkP","DkD","DkE","DkM","DkF","DkK","Edd","EYv","DkR","DkJ","DkT","Ede","EYr","DkI","DkL","DkQ","EbL","EYq","Edc","EbJ","EYx","EYw","DkS","EbK","EYt","DkH","EYu","EYs","DkN"],
  "play a boardgame": ["DkC"],
  "play a game": ["DkD"],
  "play a guitar": ["DkE"],
  "play a video game": ["DkF"],
  "play an instrument": ["E2Y"],
  "play baseball": ["EKc"],
  "play basketball": ["DkG","EYq"],
  "play board games": ["EYr","EKd"],
  "play cards": ["DkI","DkH","Edc"],
  "play cards played cards": ["DkH"],
  "play chess": ["DkJ","EbJ"],
  "play computer games": ["EYs"],
  "play football": ["DkK","Edd"],
  "play frisbee": ["E2a"],
  "play games": ["E2b"],
  "play games on your phone": ["EYt"],
  "play guitar": ["E2c"],
  "play hide and seek": ["E2d"],
  "play hockey": ["Ds8"],
  "play in the park": ["E2h"],
  "play music": ["DkL","EYu"],
  "play on a swing": ["DkM","EYv"],
  "play outside": ["E2i"],
  "play played": ["DkT","EU8","DkC","DkK","EV6","DkF","DkG","EWR","DkD","DkE","DkI","DkJ","DkL","DkN"],
  "play pool": ["EbK","DkN"],
  "play saxophone": ["DkO"],
  "play soccer": ["DkP","EYw"],
  "play sport": ["EKf"],
  "play table tennis": ["EKg"],
  "play tag": ["E2j"],
  "play tennis": ["DkQ","Ede","EKh"],
  "play tennis badly": ["ERL"],
  "play the drums": ["Ds9"],
  "play the flute": ["EKi"],
  "play the flute well": ["ERM"],
  "play the guitar": ["DkR","EbL","EKj","EYx"],
  "play the guitar badly": ["ERN"],
  "play the piano": ["DtA"],
  "play the trumpet": ["DkS"],
  "play the violin": ["EKk"],
  "play video games": ["DkT","Edf"],
  "play volleyball": ["EKl"],
  "play with friend": ["DtB"],
  "play with friends": ["DtC"],
  "played": ["EU8","EV6","EWR"],
  "played a board game": ["EWR"],
  "played soccer": ["EU8"],
  "played the trumpet": ["EV6"],
  "player": ["E2Z"],
  "playful": ["CEI"],
  "playground": ["DJ8","CEL","CEK"],
  "playing": ["DkC","DkT","DkE","DkP","DkK","Edf","DkD","DkG","DkJ","DkM","Edd","DkS","DkF","DkH","DkI","DkQ","DkR","Ede","Edc","EbL","EbK","EbJ","DkL","DkN"],
  "playing a boardgame": ["DkC"],
  "playing a game": ["DkD"],
  "playing a guitar": ["DkE"],
  "playing a video game": ["DkF"],
  "playing badminton": ["E2e"],
  "playing basketball": ["DkG"],
  "playing cards": ["DkH","DkI","Edc"],
  "playing chess": ["DkJ","EbJ"],
  "playing football": ["DkK","Edd"],
  "playing games": ["E2f"],
  "playing music": ["DkL"],
  "playing on a swing": ["DkM"],
  "playing pool": ["EbK","DkN"],
  "playing saxophone": ["DkO"],
  "playing soccer": ["DkP"],
  "playing tennis": ["DkQ","Ede"],
  "playing the guitar": ["DkR","EbL"],
  "playing the piano": ["E2g"],
  "playing the trumpet": ["DkS"],
  "playing video games": ["DkT","Edf"],
  "pleasant": ["CEM"],
  "please": ["DtD"],
  "pleased": ["EKm"],
  "plenty of fish in the sea": ["EKn","EKo","EKp"],
  "pliers": ["CEP","CEN","CEO"],
  "plough": ["CEV","CEU","CEQ"],
  "plow": ["CEV","CEQ","CEU"],
  "plug": ["DJ9","CEX","CEY","CEa","D4K","DKB"],
  "plug hole": ["D4L","DKA"],
  "plug in": ["Dkh","CEZ","EYy","DkU"],
  "plug in a laptop": ["EYy","DkU"],
  "plug in plugged in": ["Dkh"],
  "plug plugged": ["DkU"],
  "plugging in": ["Dkh","DkU"],
  "plugging in a laptop": ["DkU"],
  "plum": ["CEc","CEb","DKE","Eg0","CEh"],
  "plumber": ["DKD","DKC","CEe","EKs","EKr","CEd","D4N","CEf"],
  "plump": ["CEg","CEi"],
  "plums": ["DKF","CEm","CEl","D4O","CEj","CEk"],
  "plunger": ["CEn"],
  "plus": ["CEq","CEp"],
  "plus sign": ["E2k"],
  "pluto": ["CEr"],
  "poached egg": ["CEs"],
  "poached eggs": ["CEt"],
  "pocket": ["CEw","CEu","CEv"],
  "poem": ["CEz","CEx"],
  "poet": ["CE0"],
  "point": ["CE2","DkW","EbM","CE1"],
  "point at": ["DkV"],
  "point at a clock": ["DkV"],
  "point at the clock": ["EbM"],
  "point at the tv": ["DkW"],
  "point pointed": ["ETA","DkV","DkW"],
  "pointed": ["ETA"],
  "pointed at a tv": ["ETA"],
  "pointing": ["DkW","EbM"],
  "pointing at": ["DkV"],
  "pointing at a clock": ["DkV"],
  "pointing at the tv": ["DkW"],
  "poison": ["DtE"],
  "poisonous": ["CE4","CE3"],
  "Poland": ["CE9","CE6","EKt","CE7"],
  "Poland flag": ["DKG"],
  "polar bear": ["CFC","CFB","CFA"],
  "pole": ["DtF"],
  "police": ["CFK"],
  "police car": ["CFE","CFF","CFD"],
  "police man": ["D4P"],
  "police officer": ["DKI","CFH","DKH","EKv","CFG","CFI","CFJ","EKu"],
  "police station": ["CFL"],
  "police woman": ["DtG"],
  "policeman": ["D4P"],
  "policewoman": ["DtG"],
  "polish": ["CFM"],
  "polite": ["E2l"],
  "politician": ["DKK","DKJ","EKw","CFN"],
  "polka dot": ["CFO"],
  "pollute": ["CFQ","CFS"],
  "polluted": ["CFR"],
  "pollution": ["CFV","CFT","CFU"],
  "polo shirt": ["DKL","D4R"],
  "pomegranate": ["CFX","CFa","CFY","CFW","CFZ"],
  "pomelo": ["CFd","CFc","CFb"],
  "pond": ["CFf","CFj","CFg","CFi","CFe","CFh"],
  "pony": ["CFm","CFl","CFk","CFo"],
  "ponytail": ["CFp","CFq"],
  "ponytails": ["CFs"],
  "pool": ["DKN","CFv","DKM","CFw","CFt","CFu","D4S"],
  "pool party": ["E2m"],
  "poor": ["CFx","EKy"],
  "pop": ["E2n"],
  "pop music": ["CF2"],
  "pop star": ["CF9"],
  "popcorn": ["DKO","D4T","CF1","CF0","CFz","CFy"],
  "poppy": ["CF4","CF5","CF6","CF3"],
  "popsicle": ["CF7","CF8"],
  "population": ["CGB","CGA"],
  "porch": ["CGE","CGC","CGD"],
  "porcupine": ["CGH","CGF"],
  "pork": ["DKQ","Eg2","CGJ","CGK","CGM","CGI"],
  "pork belly": ["CGL"],
  "pork chop": ["DKP","Eg1"],
  "porridge": ["CGQ","CGO","CGN"],
  "port": ["CGV","CGR","CGT","CGS","CGU"],
  "portrait": ["DtH"],
  "Portugal": ["CGZ","CGW","CGX","EKz","CGY"],
  "Portugual flag": ["DKR"],
  "positive": ["CGa","CGb"],
  "post office": ["DKS"],
  "postcard": ["CGc","CGe","CGd"],
  "poster": ["CGh","CGf","CGg","CGi"],
  "postman": ["CGj"],
  "pot": ["CG0","CGl","CGm","CGk"],
  "pot calling the kettle black": ["EK0","EK1","EK2"],
  "potato": ["CGn","CGy","CGp","Eg3","CGo"],
  "potato chips": ["DKT","CGq","CGs","CGr","CGt"],
  "potatoes": ["DKU","CGx","D4V","CGu","CGv","CGw"],
  "potion": ["CGz"],
  "potted plant": ["CG1","CG2"],
  "pottery": ["DtI"],
  "poultry": ["CG3","CG4"],
  "pour": ["DkX","DkY","CG5","CG8","EcX","CG6","CG7","EYz"],
  "pour a drink": ["EYz"],
  "pour coffee": ["EcX","DkX"],
  "pour poured": ["DkX","EUC","DkY"],
  "poured": ["EUC"],
  "poured coffee": ["EUC"],
  "pouring": ["EcX","DkY","DkX"],
  "pouring coffee": ["EcX","DkX"],
  "poverty": ["CG9"],
  "powder": ["E2o"],
  "power": ["CHD"],
  "power socket": ["CHE"],
  "powerful": ["CHC","CHA","CHB"],
  "practice": ["E2p"],
  "practice the piano": ["DtJ"],
  "practice the saxophone": ["EK3"],
  "prawn": ["CHG","CHF","CHH"],
  "prawns": ["CHL","CHK","CHJ","CHI"],
  "pray": ["CHO","CHN","CHP"],
  "predator": ["CHR","CHQ","CHS","CHT"],
  "prefer": ["E2q"],
  "preparation": ["CHU"],
  "prepare": ["DtK"],
  "present": ["CHW","Ehg","CHV","DkZ","CHZ","EY0"],
  "present a TV show": ["EK4"],
  "present information": ["EY0"],
  "present presented": ["DkZ"],
  "presenter": ["CHY"],
  "presenting": ["DkZ"],
  "presents": ["CHa","CHb","Ehh","CHd","EK5","CHc"],
  "preserve": ["CHf","CHe"],
  "president": ["CHg"],
  "press": ["Dka","Dkb","EcY"],
  "press a button": ["EcY","Dka"],
  "press pressed": ["ETf","Dka","Dkb"],
  "press the button": ["Dkb"],
  "pressed": ["ETf"],
  "pressed a button": ["ETf"],
  "pressing": ["EcY","Dkb","Dka"],
  "pressing a button": ["EcY","Dka"],
  "pressing the button": ["Dkb"],
  "pretty": ["CHi"],
  "pretzel": ["DKV","Eg4","CHj","CHk","CHm"],
  "prey": ["CHo","CHp","CHq"],
  "price": ["CHr","CHs"],
  "prickly": ["DtL"],
  "priest": ["DtM"],
  "primitive": ["CHu","CHt"],
  "prince": ["CHv"],
  "princess": ["CHw","CHx"],
  "principal": ["CHz","CHy"],
  "principal's office": ["CH0"],
  "print": ["Dkc","CH1","CH5"],
  "print printed": ["Dkc"],
  "printer": ["DKW","CH2","CH4","D4W"],
  "printing": ["Dkc"],
  "prison": ["DtN"],
  "prize": ["CH7","CH6","CH8"],
  "problem": ["DtO"],
  "product": ["DtP"],
  "professional": ["CIA","CH9"],
  "professor": ["CIC","CIB"],
  "profitable": ["CID"],
  "program": ["DtQ"],
  "programmer": ["CIE"],
  "progress": ["CIF"],
  "project": ["E2r"],
  "projector": ["CIH","CIG","CII"],
  "promise": ["CIJ"],
  "properties": ["E2s"],
  "protect": ["CIK"],
  "proud": ["DKX","EK6","CIL"],
  "prune": ["CIM"],
  "pub": ["CIN","CIO","CIR"],
  "public": ["E2t"],
  "public restroom": ["CIP"],
  "public transport": ["CIQ"],
  "pudding": ["CIS","CIT"],
  "puddle": ["DtR"],
  "pull": ["Dkd","EbN"],
  "pull a rope": ["Dkd","EbN"],
  "pull pulled": ["ETB","Dkd"],
  "pull ups": ["CIU"],
  "pulled": ["ETB"],
  "pulled a rope": ["ETB"],
  "pulling": ["Dkd","EbN"],
  "pulling a rope": ["Dkd","EbN"],
  "pulling your hair out": ["EK7","EK8","EK9"],
  "pump": ["CIV","Dke","CId"],
  "pump gas": ["Dke"],
  "pump pumped": ["Dke"],
  "pumping": ["Dke"],
  "pumping gas": ["Dke"],
  "pumpkin": ["DKY","CIc","CIZ","D4X","CIW","CIX","CIY"],
  "pumpkin pie": ["CIa","CIb"],
  "punch": ["Dkf","CIe"],
  "punch a monster": ["Dkf"],
  "punch punched": ["Dkf"],
  "punching": ["Dkf"],
  "punching a monster": ["Dkf"],
  "pup": ["CIn"],
  "pupil": ["CIh","CIf","CIg"],
  "puppet": ["CIk","CIi"],
  "puppeteer": ["CIj"],
  "puppies": ["CIm","CIl"],
  "puppy": ["CIr","CIo","CIp","CIq"],
  "purchase": ["E2u"],
  "purple": ["DKZ"],
  "purple socks": ["DKa","EgK"],
  "purse": ["DKb","CIt","CIw","CIv","CIs","D4Y","CIu"],
  "push": ["Dkg","EbO","CIx"],
  "push a car": ["Dkg","EbO"],
  "push pushed": ["ETC","Dkg"],
  "push ups": ["CIy","CIz"],
  "pushed": ["ETC"],
  "pushed a car": ["ETC"],
  "pushing": ["Dkg","EbO"],
  "pushing a car": ["EbO","Dkg"],
  "put": ["Dkl","Dkk","Dki","EbP","Dkm","EY3","EY2","EY4"],
  "put a bottle in the bin": ["EY2","Dki"],
  "put away": ["Dkj","EcZ","ELB"],
  "put away groceries": ["EcZ"],
  "put away put away": ["Dkj"],
  "put books in a bag": ["Dkk"],
  "put books in bag": ["EbP"],
  "put food in a microwave": ["Dkl"],
  "put food in the microwave": ["EY3"],
  "put ketchup on a burger": ["EY4","Dkm"],
  "put on": ["Dkn","Dko","Dkp","EbQ","ETD","EbR"],
  "put on a coat": ["Dkn","EbQ"],
  "put on a hat": ["ETD"],
  "put on put on": ["Dko"],
  "put on shoes": ["Dkp","EbR"],
  "put out": ["Dkr","EbS","Dkq"],
  "put out a fire": ["Dkq","EbS"],
  "put out fires": ["ELD"],
  "put out put out": ["Dkr"],
  "put put": ["Dkk","Dkl","Dki","Dkm"],
  "put up": ["Dks","Edg"],
  "put up decorations": ["Edg"],
  "put up put up": ["Dks"],
  "putting": ["EbP","Dki","Dkk","Dkl","Dkm"],
  "putting a bottle in the bin": ["Dki"],
  "putting away": ["EcZ","Dkj"],
  "putting books in a bag": ["Dkk"],
  "putting food in a microwave": ["Dkl"],
  "putting ketchup on a burger": ["Dkm"],
  "putting on": ["Dkn","EbR","EbQ","Dko","Dkp"],
  "putting on a coat": ["Dkn","EbQ"],
  "putting on shoes": ["Dkp","EbR"],
  "putting out": ["EbS","Dkr","Dkq"],
  "putting out a fire": ["EbS","Dkq"],
  "putting up": ["Dks","Edg"],
  "puzzle": ["CI0"],
  "puzzles": ["DtS"],
  "pyjamas": ["CI1","B68"],
  "pyramid": ["CI5","CI4","CI3","CI2"],
  "python": ["CI6"],
  "q": ["DaH","DaI"],
  "q tips": ["CI7"],
  "quail": ["CI8","CJA","CI9"],
  "quarter past 1": ["DeL"],
  "quarter past 10": ["DeM"],
  "quarter past 11": ["DeK"],
  "quarter past 2": ["DeN"],
  "quarter past eleven": ["DeK","EfX"],
  "quarter past one": ["DeL","EfY"],
  "quarter past six": ["EfZ"],
  "quarter past ten": ["DeM"],
  "quarter past twelve": ["Efa"],
  "quarter past two": ["DeN"],
  "quarter to 1": ["DeR"],
  "quarter to 10": ["DeS"],
  "quarter to 12": ["DeT"],
  "quarter to 4": ["DeQ"],
  "quarter to 5": ["DeP"],
  "quarter to 8": ["DeO"],
  "quarter to eight": ["DeO","Efb"],
  "quarter to five": ["DeP","Efc"],
  "quarter to four": ["Efd","DeQ"],
  "quarter to one": ["DeR"],
  "quarter to ten": ["DeS"],
  "quarter to twelve": ["DeT"],
  "queen": ["CJB"],
  "question": ["CJC","CJD"],
  "queue": ["CJE"],
  "quick": ["CJF","ELG"],
  "quickly": ["DtT","ERC"],
  "quiet": ["DKd","ELH","Ehy","CJG"],
  "quieter": ["DKc"],
  "quietly": ["ERY"],
  "quilt": ["DtU"],
  "quit": ["CJI","CJH"],
  "quiz": ["CJJ"],
  "r": ["DaJ","DaK"],
  "rabbit": ["DKe","CJL","D4Z","CJN","CJM","CJK","CJO"],
  "rabbits": ["DtV"],
  "raccoon": ["CJP","CJR","CJS","CJQ"],
  "race": ["CJU","CJT"],
  "rack": ["CJa","CJW","CJV"],
  "racket": ["CJZ","CJX","CJY"],
  "radiate": ["CJd","CJc"],
  "radio": ["CJe","CJf"],
  "radish": ["CJj","CJg","CJi","CJh"],
  "rafting": ["DtW"],
  "rag": ["CJk"],
  "rail": ["E2v"],
  "railroad": ["CJn","CJm","CJl"],
  "railway": ["DtX"],
  "railway station": ["CJo","CJp"],
  "rain": ["DKj","Dkt","DKf","D4c","CJq","CJs","CJ6","CJr"],
  "rain boots": ["CJt"],
  "rain rained": ["Dkt"],
  "rainbow": ["DKh","CJu","CJx","DKg","D4a","CJv","CJw"],
  "raincoat": ["DKi","D4b","CJy","CJz"],
  "rained": ["ETZ"],
  "rainforest": ["CJ1","CJ3","CJ2","CJ0"],
  "raining": ["Dkt","CJ5","CJ4"],
  "raining cats and dogs": ["ELI","ELJ","ELK"],
  "rainy": ["CJ8","CJ7","ELL"],
  "raise money": ["E2w"],
  "raisin": ["CJ9","CKB"],
  "raisins": ["CKE","CKD","CKC"],
  "rake": ["CKF","CKG","CKH","CKI"],
  "ram": ["CKJ","CKL","CKK"],
  "ran": ["EUD"],
  "ranch": ["CKP","CKO","CKM"],
  "random": ["CKQ"],
  "ranger": ["CKR"],
  "rarely": ["DtY"],
  "rash": ["DKk","CKS","D4d"],
  "raspberries": ["CKT","CKU","CKV"],
  "raspberry": ["CKZ","CKW","CKX"],
  "raspberry juice": ["CKY"],
  "rat": ["DKl","D4e","CKc","CKe","CKb","CKa","CKd"],
  "rattlesnake": ["CKf"],
  "ray": ["DtZ"],
  "razor": ["DKm"],
  "re": ["E25"],
  "reach": ["CKi","CKg"],
  "reaching": ["CKh"],
  "react": ["CKj"],
  "read": ["Dkz","Dkv","Dku","Eca","EY6","CKo","ETE","CKk","CKl","Dkw","Dkx","EbT","EbU","Dky","EVi"],
  "read a book": ["Dku","Dkv","Eca","EY6","Dkw","ETE","ELM"],
  "read a newspaper": ["Dky","EbU"],
  "read aloud": ["Dkx","EbT"],
  "read aloud read aloud": ["Dkx"],
  "read books": ["Dta"],
  "read comics": ["Dtb"],
  "read out": ["ELN"],
  "read read": ["Dkz","ETE","Dkv","Dky","Dku","EVi","Dkw"],
  "read the book": ["EVi"],
  "reading": ["Dkz","Dkv","Eca","Dku","CKm","CKn","Dkw","EbU","EbT","Dkx","Dky"],
  "reading a book": ["Dku","Dkv","Eca","Dkw"],
  "reading a newspaper": ["Dky","EbU"],
  "reading aloud": ["Dkx","EbT"],
  "reading books": ["Dtc"],
  "ready": ["CKp"],
  "real estate agent": ["ELP","ELO","DKn","DKo"],
  "realize": ["CKq"],
  "receipt": ["CKr","CKs"],
  "receive": ["Dk1","Dk0","CKt","EY7"],
  "receive a package": ["EY7","Dk1"],
  "receive an email": ["Dk0"],
  "receive received": ["ETh","Dk0","Dk1"],
  "received": ["ETh"],
  "received an email": ["ETh"],
  "receiving": ["Dk1","Dk0"],
  "receiving a package": ["Dk1"],
  "receiving an email": ["Dk0"],
  "reception": ["CKz","CKu"],
  "reception desk": ["CKw"],
  "receptionist": ["CKy","CKx","ELR","DKq","ELQ","DKp"],
  "recipie": ["DYe"],
  "recliner": ["DKr"],
  "recommend": ["DYf"],
  "record": ["Dtd"],
  "recorder": ["CK0"],
  "rectangle": ["CK1"],
  "rectangular": ["CK2"],
  "recycle": ["CK5","CK4","CK3"],
  "recycling": ["CK9"],
  "recycling bank": ["CK6"],
  "recycling bin": ["CK7","CK8"],
  "red": ["DKy"],
  "red and blue": ["DKs"],
  "red and green": ["DKt"],
  "red and white": ["DKu"],
  "red and yellow": ["DKv"],
  "red apple": ["CLA"],
  "red glasses": ["DKw","EgL"],
  "red hair": ["CLB","CLD","CLC","CLE"],
  "red jacket": ["EgB"],
  "red pepper": ["CLG","CLH","CLF"],
  "red shoes": ["EgM"],
  "red socks": ["DKz"],
  "reel": ["CLI"],
  "referee": ["DK0","DK1","CLJ","CLK","ELT","ELS","CLL"],
  "reflect": ["Dk3","EY8","CLP","Dk2"],
  "reflect reflected": ["EUs","Dk3","Dk2"],
  "reflect the light": ["EY8"],
  "reflected": ["EUs"],
  "reflected the light": ["EUs"],
  "reflecting": ["Dk3","Dk2"],
  "reflective vest": ["CLN","CLO"],
  "refreshing": ["E2x"],
  "refrigerator": ["CLS","CLQ","CLR"],
  "refuse": ["CLU","Dk4","CLT","EbV"],
  "refuse money": ["EbV","Dk4"],
  "refuse refused": ["ETF","Dk4"],
  "refused": ["ETF"],
  "refused money": ["ETF"],
  "refusing": ["Dk4","EbV"],
  "refusing money": ["EbV","Dk4"],
  "region": ["CLV"],
  "regions": ["CLW"],
  "regret": ["CLX"],
  "rehearse": ["CLY"],
  "reindeer": ["ELU","CLb","CLZ","CLa","Eh0"],
  "relationship": ["CLd","CLc"],
  "relative": ["E2y"],
  "relatives": ["CLe","CLf"],
  "relax": ["Dk6","EbW","Dk5","CLp","EY9","CLh","CLg"],
  "relax on the beach": ["EY9"],
  "relax on the sofa": ["ELW"],
  "relax relaxed": ["ETG","Dk6","Dk5"],
  "relaxed": ["ETG","CLk","CLj","CLi"],
  "relaxing": ["Dk6","Dk5","CLm","CLo","CLn","EbW","CLl"],
  "reliable": ["E2z"],
  "relieved": ["E20"],
  "religious": ["CLq"],
  "religious education": ["E21"],
  "remember": ["E22"],
  "remind": ["E23"],
  "remote": ["DK2","CLs","CLx","D4i","CLr"],
  "remote control": ["CLt","CLu","CLv","CLw"],
  "renewable": ["CLz","CLy"],
  "renminbi": ["CL0"],
  "rent a motorboat": ["E24"],
  "repair": ["Dk7","EbX","CL2","Dk9","CL1"],
  "repair a phone": ["Dk7","EbX"],
  "repair repaired": ["ETH","Dk7","Dk9"],
  "repair the AC": ["Dk9"],
  "repair things": ["ELX"],
  "repaired": ["ETH"],
  "repaired a phone": ["ETH"],
  "repairing": ["EbX","Dk9","Dk7"],
  "repairing a phone": ["EbX","Dk7"],
  "repairing the AC": ["Dk9"],
  "repeat": ["Dte"],
  "reply": ["CL3"],
  "report": ["Dtf"],
  "report the news": ["ELa"],
  "reporter": ["DK4","DK3","CL4","ELZ","ELY","D4j"],
  "reptile": ["DK5","CL5","CL7"],
  "reptiles": ["ELb"],
  "rescue": ["CL9","DlA","EbY","CL8","DlB"],
  "rescue people": ["ELc"],
  "rescue rescued": ["DlB","ETI","DlA"],
  "rescue someone": ["EbY","DlB"],
  "rescued": ["ETI"],
  "rescued someone": ["ETI"],
  "rescuing": ["EbY","DlA","DlB"],
  "rescuing someone": ["EbY","DlB"],
  "reservation": ["Dtg"],
  "reserve": ["E26"],
  "resign": ["CMB"],
  "respect": ["CMC"],
  "responsible": ["Dth"],
  "rest": ["DlC","EZC","CMI"],
  "rest on the sofa": ["EZC"],
  "rest rested": ["DlC"],
  "restaurant": ["CMG","DK6","CME","CMD","CMF"],
  "resting": ["DlC","CMH"],
  "restroom": ["CMK","CMJ"],
  "resume": ["CML"],
  "rhino": ["DK7","CMP","CMO","D4k","CMM","CMN"],
  "rhinoceros": ["Dti"],
  "rhubarb": ["CMT","CMS"],
  "rib": ["CMa"],
  "rib cage": ["CMY"],
  "ribbon": ["CMW","CMV","CMU","CMX"],
  "ribs": ["CMe","CMd","CMc"],
  "rice": ["DK9","CMk","D4l","CMg","CMf","CMj","CMh","CMi"],
  "rice and vegetables": ["DK8"],
  "rice pudding": ["CMl"],
  "rich": ["CMm","ELd"],
  "rickshaw": ["CMq","CMp","CMn"],
  "ridden": ["EV7"],
  "ridden a scooter": ["EV7"],
  "ride": ["DlD","DlE","Ecb","DlF","EbZ","DlG","CMw","Eba","EZD","EZE"],
  "ride a bicycle": ["Dtj"],
  "ride a bike": ["DlD","CMs","EbZ","CMr","EZD","ELe"],
  "ride a horse": ["DlE","CMt","Ecb"],
  "ride a jetski": ["E27"],
  "ride a motorbike": ["DlF","CMu","Eba","ELf"],
  "ride a motorbike dangerously": ["ERO"],
  "ride a scooter": ["DlG","EZE"],
  "ride a skateboard": ["CMv","ELg"],
  "ride a skateboard safely": ["ERP"],
  "ride my bike": ["Dtk"],
  "ride ridden": ["EV7"],
  "ride rode": ["DlD","ETJ","DlE","DlG","DlF"],
  "rider": ["E28"],
  "riding": ["DlD","DlE","EbZ","DlF","DlG","Ecb","Eba"],
  "riding a bike": ["DlD","EbZ"],
  "riding a horse": ["DlE","Ecb"],
  "riding a motorbike": ["Eba","DlF"],
  "riding a scooter": ["DlG"],
  "right": ["Dtl","ELh"],
  "ring": ["CMy","D4m","CM2","CM1","CMz","DlI","EdH","CM0","DlH"],
  "ring rang": ["DlH","DlI"],
  "ringing": ["EdH","DlI","DlH"],
  "rings": ["E29"],
  "rinse": ["CM3"],
  "riot": ["CM6","CM4","CM5"],
  "rip": ["CNB","CM7"],
  "ripe": ["CM8","CNA","CM9"],
  "riper": ["DLA"],
  "rise": ["DlJ","EdI","CNC","EZG"],
  "rise in the morning": ["EZG"],
  "rise rose": ["DlJ"],
  "rising": ["DlJ","EdI"],
  "rival": ["CND"],
  "river": ["CNG","DLB","CNE","CNF","D4n","CNK","CNH"],
  "river bank": ["CNI","CNJ"],
  "river rapids": ["CNL","CNN"],
  "road": ["CNQ","DLC","CNP","CNO","D4o"],
  "road rage": ["CNR"],
  "roadworks": ["CNS"],
  "roar": ["CNU","CNT"],
  "roast": ["CNX"],
  "roast beef": ["DLD"],
  "roast chicken": ["CNV","CNW"],
  "roast vegetables": ["CNY"],
  "robe": ["Dtm"],
  "robin": ["CNb","CNa","CNZ"],
  "robot": ["CNe","CNf","CNc","CNd"],
  "rock": ["CNu","CNg"],
  "rock climbing": ["CNh","CNk","CNj","CNi"],
  "rock pool": ["CNv"],
  "rocket": ["DLE","CNm","D4p","CNn","CNq","CNo","CNp"],
  "rocking horse": ["CNt","CNr"],
  "rocks": ["CN0","CN2","CNy","CNx","CNz","CNw"],
  "rod": ["Dtn"],
  "rode": ["ETJ"],
  "rode a motorbike": ["ETJ"],
  "roll": ["CN3","COP","CN4"],
  "roll out the red carpet": ["ELi","ELj","ELk"],
  "roller blades": ["CN6","CN5","CN7"],
  "roller blading": ["CN9","COA"],
  "roller coaster": ["COC","COD","COG","COE","COB","COF","COH"],
  "roller skate": ["COI"],
  "roller skates": ["Dtq"],
  "roller skating": ["COJ"],
  "rollerblade": ["E3A"],
  "rollerblading": ["Dto"],
  "rollerblads": ["Dtp"],
  "rolling pin": ["COK","COO","COL","COM"],
  "romance": ["COV","COQ","COR","COT","COU"],
  "Romania": ["COZ"],
  "romantic": ["COd","ELm","COa","COc","COb"],
  "roof": ["COe","COg","COh","COf","COi"],
  "room": ["COk"],
  "roommates": ["COj"],
  "roomservice": ["COl"],
  "rooster": ["COn","COp","COo","COm"],
  "root": ["E3B"],
  "roots": ["COt","COr","COq","COs"],
  "rope": ["COx","COv","COy","COu","COw"],
  "rosary": ["CO1","COz","CO0"],
  "rose": ["CO5","CO4","CO2","CO3"],
  "roses": ["CO8","CO7","CO6"],
  "rotate": ["CPA","CO9"],
  "rough": ["Dtr"],
  "round": ["Dtt","Dts"],
  "roundabout": ["CPB","CPC"],
  "route": ["Dtu"],
  "row": ["DlK","EZH"],
  "row a boat": ["DlK","CPD","EZH"],
  "row rowed": ["DlK"],
  "rowing": ["DlK"],
  "rowing a boat": ["DlK"],
  "royal": ["CPE"],
  "rubber": ["CPF"],
  "rubbish": ["CPI","CPG","CPH"],
  "rucksack": ["DLF","D4q"],
  "rude": ["E3C"],
  "rug": ["DLH","CPO","CPJ","D4s"],
  "rugby": ["DLG","CPM","CPN","CPK","D4r","CPL"],
  "ruins": ["E3D"],
  "rule": ["E3E"],
  "ruler": ["DLI","CPQ","CPR","D4t","CPP"],
  "run": ["DlM","DlP","Ecc","CPV","DlL","ELs","CPS","EVs","DlN"],
  "run a marathon": ["DlN","EVs"],
  "run in the park": ["ELn"],
  "run like the wind": ["ELq"],
  "run out": ["DlO","ELr"],
  "run out ran out": ["DlO"],
  "run quickly": ["ERQ"],
  "run ran": ["DlM","EUD","DlL","DlP","DlN"],
  "run run": ["EVs"],
  "running": ["DlM","DlP","CPU","Ecc","D4u","DlL","DLJ","CPT","DlN"],
  "running a marathon": ["DlN"],
  "running out": ["DlO"],
  "runny nose": ["E3F"],
  "rural": ["CPX"],
  "rural area": ["CPZ"],
  "rush": ["CPe"],
  "rush hour": ["CPd","CPb"],
  "Russia": ["DLM","CPi","CPf","ELt","CPg","D4v"],
  "Russia flag": ["DLK"],
  "Russian": ["DLL","EeS"],
  "s": ["DaL","DaM"],
  "sack": ["Dtv"],
  "sacred": ["CPk","CPj"],
  "sad": ["DLO","CPm","Eh1","CPl","ELu","CPr","Eh2"],
  "sadder": ["DLN"],
  "saddle": ["CPp","CPo","CPn"],
  "sadness": ["CPq"],
  "safari": ["DYg"],
  "safe": ["CPs","CPu","CPt","ELv"],
  "safely": ["ERP"],
  "safer": ["DLP"],
  "safety": ["DYh","CPv"],
  "said": ["EUE"],
  "said hello": ["EUE"],
  "sail": ["DlQ","CPw","EZJ","CP5"],
  "sail a boat": ["DlQ","CPx","EZJ"],
  "sail sailed": ["DlQ"],
  "sailboat": ["CPy"],
  "sailing": ["DlQ","DYi","CP1","CPz"],
  "sailing a boat": ["DlQ"],
  "sailing boat": ["CP0"],
  "sailor": ["DLR","CP4","CP2","CP3"],
  "saint": ["CP6","CP7"],
  "salad": ["DLS","CQC","D4w","CP8","CP9","CQA","CQB"],
  "salami": ["CQG","CQE","CQF"],
  "sales clerk": ["CQH"],
  "salesperson": ["Dtw"],
  "salmon": ["CQK","CQM","CQL","CQI","DLT","CQJ"],
  "salsa": ["CQP","CQO"],
  "salt": ["CQQ","CQR","CQU","DLU"],
  "salt and pepper": ["CQS","D4x","CQT"],
  "salty": ["CQV"],
  "salute": ["CQX"],
  "same": ["CQb","CQa"],
  "Samoa": ["ELz"],
  "samosas": ["DLV"],
  "sand": ["CQc","CQx","CQd","CQe","CQf"],
  "sand castle": ["CQl","CQm","CQn","CQo","CQk"],
  "sand dunes": ["CQr","CQq"],
  "sandals": ["DLW","CQj","D4y","CQi","CQg","CQh"],
  "sandbox": ["E3G"],
  "sandcastle": ["Dtx"],
  "sandpaper": ["CQu"],
  "sandpit": ["CQw","CQv"],
  "sandstorm": ["CQ2","CQ1","CQz","CQ0"],
  "sandwich": ["E3H","DLX","D4z","CQ5","CQ3","CQ4","CRB","CQ6"],
  "sandwiches": ["CRA","CQ9","CQ8","CQ7"],
  "sang": ["EUF"],
  "sang a song": ["EUF"],
  "santa": ["CRK","Eh3","CRF","CRE","CRD","CRC","EL0"],
  "santa claus": ["CRG","CRH","CRI","CRJ"],
  "Santa Claus": ["Eh3"],
  "Santa's sleigh": ["Eh4"],
  "sapling": ["CRQ","CRL","CRM","CRN","CRO","CRP"],
  "sapphire": ["CRU"],
  "sarcophagus": ["CRY"],
  "sardines": ["CRe","CRa","CRc","CRb"],
  "sat": ["EUG"],
  "sat down": ["EUG"],
  "satchel": ["DLY"],
  "satellite": ["CRk","CRh","CRg","CRi","CRj","CRf"],
  "satellite dish": ["DLZ"],
  "satsumas": ["CRl"],
  "Saturday": ["DLc","DLa","DLb"],
  "saturn": ["CRs","CRp","CRr","CRo","CRn"],
  "sauce": ["CRv","CRw","CRx","CRu"],
  "saucepan": ["DLd","D42"],
  "Saudi Arabia": ["EL1"],
  "sausage": ["DLe","Eg6","CRz","CRy"],
  "sausages": ["CR0","DLf","CR2","D43","CR1"],
  "savannah": ["CR3","CR6","CR4","CR5"],
  "save": ["E3I"],
  "save injured people": ["EL2"],
  "save money": ["CR7"],
  "savoury": ["CR9","CR8"],
  "saw": ["DLg","EUH","D44","CSC","CSA"],
  "saw an elephant": ["EUH"],
  "saxophone": ["DLh","CSI","CSD","D45","CSF","CSH","CSE"],
  "say": ["DlS","DlR","EZK"],
  "say hello": ["DlS","DlR","EZK"],
  "say said": ["DlR","DlS","EUE"],
  "saying": ["DlR","DlS"],
  "saying hello": ["DlR","DlS"],
  "says": ["Ecd"],
  "says 'hello'": ["Ecd"],
  "scale": ["Dty"],
  "scales": ["CSJ"],
  "scan": ["CSL"],
  "scanner": ["CSK"],
  "scar": ["DLk","D47"],
  "scarecrow": ["CSM","CSR","CSO","EL3","EL4","CSQ"],
  "scared": ["DLi","CST","EL5","CSS"],
  "scarf": ["CSX","D46","CSU","CSV","DLj","CSW"],
  "scary": ["CSZ","CSY"],
  "scatterbrained": ["E3J"],
  "scenery": ["CSc","CSa","CSb"],
  "scent": ["CSd","CSf"],
  "schedule": ["Dtz"],
  "scholar": ["CSj","CSg","CSh","CSi"],
  "school": ["CSv","CSl","CSk"],
  "school bag": ["CSm","CSn","CSo","CSp","CSq"],
  "school bus": ["DLl","CSr","CSt","CSs","CSu"],
  "school schedule": ["CSw","CSy","CSx"],
  "school trip": ["CS0","CSz"],
  "schoolbag": ["Dt0"],
  "science": ["DYj","CS5"],
  "science fiction": ["CS3","CS1","CS4","CS2"],
  "science lab": ["Dt1"],
  "scientist": ["DLm","EL6","DLn","CS6","CTA","CS7","D48","CS8","CS9"],
  "scientists": ["DYk","CTB","CTC"],
  "scissors": ["DLo","D49","CTE","CTD","CTF"],
  "scoop": ["CTI","CTG"],
  "scooter": ["DLp","CTN","D5A","CTK","CTJ","CTL","CTM"],
  "scorch": ["CTO"],
  "score": ["DlT"],
  "score a goal": ["DlT"],
  "score scored": ["EVY","DlT"],
  "scored": ["EVY"],
  "scored a goal": ["EVY"],
  "scoring": ["DlT"],
  "scoring a goal": ["DlT"],
  "scorpion": ["DLq","D5B","CTV","CTR"],
  "Scotland": ["EL8"],
  "scrambled egg on toast": ["Eg7","DLr"],
  "scrambled eggs": ["CTZ","CTY","CTW"],
  "scratch": ["E3K"],
  "scream": ["DlU","CTc","CTa","CTb"],
  "scream screamed": ["EUI","DlU"],
  "screamed": ["EUI"],
  "screaming": ["DlU"],
  "screen": ["CTd","CTg","CTf","CTe","ETK"],
  "screen cracked": ["ETK"],
  "screw": ["CTn","DLt"],
  "screwdriver": ["CTm","DLs","CTj"],
  "script": ["Dt2"],
  "scuba diver": ["CTp","CTo"],
  "scuba diving": ["CTq"],
  "sculpture": ["CTr","CTt","CTs"],
  "sea": ["CUJ","CTu","CTw","CTv","DvP"],
  "sea horse": ["Dt3"],
  "sea lion": ["CT8","CT9","CUB","CUA"],
  "sea turtle": ["CUX","CUW","CUa","CUZ","CUY"],
  "sea weed": ["CUc"],
  "seacoast": ["E3L"],
  "seafood": ["CTx"],
  "seagull": ["CTy","CT1","CTz"],
  "seahorse": ["CT4","CT3","CT2"],
  "seal": ["CT7","CT5","CUC","CT6"],
  "seals": ["CUE"],
  "seam": ["CUI"],
  "seaplane": ["E3M"],
  "seaport": ["E3N"],
  "search": ["Dt4"],
  "search engine": ["E3O"],
  "seashell": ["E3P"],
  "seaside": ["CUL","CUM","CUN","CUK"],
  "seasons": ["E3Q"],
  "seat": ["CUV","CUP","CUO","CUQ","CUS","CUR"],
  "seat belt": ["CUU","CUT"],
  "seaweed": ["Dt5"],
  "second": ["Dt6"],
  "secret": ["Dt7"],
  "secretary": ["DLv","CUe","DLu","CUd","EL9","EMA"],
  "security guard": ["DLx","DLw","EMC","CUf","CUh","CUi","EMB","D5E","CUg"],
  "see": ["DlW","DlX","DlV","DlY"],
  "see a ghost": ["DlV"],
  "see an elephant": ["DlX","DlW"],
  "see saw": ["EUH","DlW","DlX","DlV","DlY"],
  "see seen": ["EVj"],
  "see the Eiffel Tower": ["DlY"],
  "seed": ["CUo","CUk","CUj","CUm","CUl","CUn"],
  "seeds": ["CUp"],
  "seeing": ["DlY","DlV","DlW","DlX"],
  "seeing a ghost": ["DlV"],
  "seeing an elephant": ["DlW","DlX"],
  "seeing the Eiffel Tower": ["DlY"],
  "seen": ["EVj"],
  "seen an elephant": ["EVj"],
  "seesaw": ["CUq","CUs","CUt","CUr"],
  "selfish": ["Dt8"],
  "sell": ["DlZ","Ece","Dla","CUu","Dlc","EZN","EZL","Dlb"],
  "sell apples": ["DlZ","Ece"],
  "sell cars": ["EZL","Dla"],
  "sell drinks": ["Dlb"],
  "sell homes": ["EME"],
  "sell medicine": ["EZN","Dlc"],
  "sell sold": ["Dla","EUP","DlZ","Dlb","Dlc"],
  "sell things": ["EMG"],
  "selling": ["DlZ","Ece","Dlc","Dla","Dlb"],
  "selling apples": ["Ece","DlZ"],
  "selling cars": ["Dla"],
  "selling drinks": ["Dlb"],
  "selling medicine": ["Dlc"],
  "send": ["Dle","Dld","EZP","Dlf","CUv","EZO","CUw"],
  "send a message": ["Dld","EZO"],
  "send an email": ["Dlf","EZP","Dle"],
  "send sent": ["ETi","Dld","Dle","Dlf"],
  "sending": ["Dlf","Dld","Dle"],
  "sending a message": ["Dld"],
  "sending an email": ["Dlf","Dle"],
  "sensor": ["E3R"],
  "sent": ["ETi"],
  "sent an email": ["ETi"],
  "September": ["Dt9"],
  "Serbia": ["EMH"],
  "serious": ["DuA"],
  "servant": ["CUx"],
  "servants": ["CUy"],
  "serve": ["Dlh","Dlg","Ecf"],
  "serve a country": ["EMI"],
  "serve food": ["Dlg","Ecf"],
  "serve served": ["EUJ","Dlg","Dlh"],
  "served": ["EUJ"],
  "served some food": ["EUJ"],
  "server": ["E3S"],
  "serving": ["Ecf","Dlh","Dlg"],
  "serving food": ["Ecf","Dlg"],
  "set the table": ["DuB"],
  "seven": ["Dbw","Dbu"],
  "seven hundred": ["Dbv"],
  "seven o'clock": ["DeU"],
  "seven thousand": ["Dbz"],
  "seventeen": ["Dby","Dbx"],
  "seventh": ["E3T"],
  "seventy": ["Db6","Db0"],
  "seventy eight": ["Db1"],
  "seventy five": ["Db2"],
  "seventy four": ["Db3"],
  "seventy nine": ["Db4"],
  "seventy one": ["Db5"],
  "seventy seven": ["Db7"],
  "seventy six": ["Db8"],
  "seventy thousand": ["Db9"],
  "seventy three": ["DcA"],
  "seventy two": ["DcB"],
  "sew": ["Dli","CU6","CU0","EZR","CUz"],
  "sew clothes": ["EZR","Dli"],
  "sew sewed": ["Dli"],
  "sew some clothes": ["EMK"],
  "sewing": ["Dli","CU5"],
  "sewing clothes": ["Dli"],
  "sewing machine": ["CU1","CU3","CU2","CU4"],
  "shade": ["CU8","CU7"],
  "shades": ["CVB","CVC"],
  "shadow": ["CVD","CVF","CVE"],
  "shake": ["Dlj","CVH","Dlk","CVL","CVG"],
  "shake hands": ["Dlk","Dlj","Edh","CVI","CVK","CVJ"],
  "shake shook": ["EU9","Dlj","Dlk"],
  "shaker": ["CVM"],
  "shaking": ["Dlk","Dlj"],
  "shaking hands": ["Dlj","Dlk","Edh"],
  "shallow": ["DuC"],
  "shampoo": ["DLy","CVO","CVQ","D5F","CVP"],
  "shapes": ["CVR"],
  "share": ["Dll"],
  "share a pizza": ["Dll"],
  "share pizza#": ["CVS"],
  "share shared": ["Dll"],
  "sharing": ["Dll"],
  "sharing a pizza": ["Dll"],
  "shark": ["DLz","CVT","CVV","D5G","CVU"],
  "sharp": ["DL2","CVW","CVX","CVc"],
  "sharpener": ["DL0","CVZ","D5H","CVY","CVb","CVa"],
  "sharper": ["DL1"],
  "shave": ["Dlm","Dln","Ebb"],
  "shave shaved": ["Dlm","EVc","Dln"],
  "shave your head": ["Dln"],
  "shaved": ["EVc"],
  "shaved his head": ["EVc"],
  "shaving": ["Ebb","Dlm","CVe","Dln"],
  "shaving your head": ["Dln"],
  "shawl": ["DuD"],
  "she": ["E3U"],
  "she asks a question": ["Ebw"],
  "she blows her nose": ["Ebx"],
  "she brushes her hair": ["Eby"],
  "she carries a box": ["Ebz"],
  "she closes her laptop": ["Eb0"],
  "she combs her hair": ["Eb1"],
  "she concentrates": ["Eb2"],
  "she cooks": ["Eb3"],
  "she coughs": ["Eb4"],
  "she cries": ["Eb5"],
  "she cuts paper": ["Eb6"],
  "she designs clothes": ["Eb7"],
  "she dives into the water": ["Eb8"],
  "she does homework": ["Eb9"],
  "she draws on the board": ["EcA"],
  "she drinks water": ["EcB"],
  "she drives a car": ["EcC"],
  "she drops a ball": ["EcD"],
  "she eats pizza": ["EcE"],
  "she feeds a dog": ["EcF"],
  "she fills a glass with water": ["EcG"],
  "she fills out a form": ["EcH"],
  "she gets a book": ["EcI"],
  "she gets a haircut": ["EcJ"],
  "she hands out fliers": ["EcK"],
  "she hangs up clothes": ["EcL"],
  "she highlights lines": ["EcM"],
  "she holds a baby": ["EcN"],
  "she ignores him": ["EcO"],
  "she irons a shirt": ["EcP"],
  "she is asking a question": ["Ebw"],
  "she is blowing her nose": ["Ebx"],
  "she is brushing her hair": ["Eby"],
  "she is carrying a box": ["Ebz"],
  "she is closing her laptop": ["Eb0"],
  "she is combing her hair": ["Eb1"],
  "she is concentrating": ["Eb2"],
  "she is cooking": ["Eb3"],
  "she is coughing": ["Eb4"],
  "she is crying": ["Eb5"],
  "she is cutting paper": ["Eb6"],
  "she is designing clothes": ["Eb7"],
  "she is diving into the water": ["Eb8"],
  "she is doing homework": ["Eb9"],
  "she is drawing on the board": ["EcA"],
  "she is drinking water": ["EcB"],
  "she is driving a car": ["EcC"],
  "she is dropping a ball": ["EcD"],
  "she is eating pizza": ["EcE"],
  "she is feeding a dog": ["EcF"],
  "she is filling a glass with water": ["EcG"],
  "she is filling out a form": ["EcH"],
  "she is getting a book": ["EcI"],
  "she is getting a haircut": ["EcJ"],
  "she is handing out fliers": ["EcK"],
  "she is hanging up clothes": ["EcL"],
  "she is highlighting lines": ["EcM"],
  "she is holding a baby": ["EcN"],
  "she is hot": ["Ehm"],
  "she is ignoring him": ["EcO"],
  "she is ironing a shirt": ["EcP"],
  "she is looking after children": ["EcQ"],
  "she is moving the mouse": ["EcR"],
  "she is opening a bottle": ["EcS"],
  "she is opening a window": ["EcT"],
  "she is paying money": ["EcU"],
  "she is peeling a banana": ["EcV"],
  "she is picking flowers": ["EcW"],
  "she is pouring coffee": ["EcX"],
  "she is pressing a button": ["EcY"],
  "she is putting away the groceries": ["EcZ"],
  "she is reading a book": ["Eca"],
  "she is riding a horse": ["Ecb"],
  "she is running": ["Ecc"],
  "she is saying 'hello'": ["Ecd"],
  "she is selling apples": ["Ece"],
  "she is serving food": ["Ecf"],
  "she is shouting": ["Ecg"],
  "she is showing her id": ["Ech"],
  "she is singing": ["Eci"],
  "she is sitting": ["Ecj"],
  "she is skating": ["Eck"],
  "she is skiing": ["Ecl"],
  "she is sleeping": ["Ecm"],
  "she is smelling a flower": ["Ecn"],
  "she is smiling": ["Eco"],
  "she is speaking English": ["Ecp"],
  "she is studying": ["Ecq"],
  "she is taking a photo": ["Ecr"],
  "she is taking a shower": ["Ecs"],
  "she is taking some pizza": ["Ect"],
  "she is talking on the phone": ["Ecu"],
  "she is tall": ["EiD"],
  "she is telling off the boy": ["Ecv"],
  "she is thinking": ["Ecw"],
  "she is tired": ["EiF"],
  "she is trying on a dress": ["Ecx"],
  "she is turning down some cake": ["Ecy"],
  "she is turning on the light": ["Ecz"],
  "she is tying her shoes": ["Ec0"],
  "she is using a computer": ["Ec1"],
  "she is visiting her grandparents": ["Ec2"],
  "she is waking up": ["Ec3"],
  "she is walking the dog": ["Ec4"],
  "she is waving her hand": ["Ec5"],
  "she is wearing glasses": ["Ehz"],
  "she is wiping the table": ["Ec6"],
  "she is withdrawing money": ["Ec7"],
  "she is writing": ["Ec8"],
  "she looks after children": ["EcQ"],
  "she moves the mouse": ["EcR"],
  "she opens a bottle": ["EcS"],
  "she opens a window": ["EcT"],
  "she pays money": ["EcU"],
  "she peels a banana": ["EcV"],
  "she picks flowers": ["EcW"],
  "she pours coffee": ["EcX"],
  "she presses a button": ["EcY"],
  "she puts away the groceries": ["EcZ"],
  "she reads a book": ["Eca"],
  "she rides a horse": ["Ecb"],
  "she runs": ["Ecc"],
  "she says 'hello'": ["Ecd"],
  "she sells apples": ["Ece"],
  "she serves food": ["Ecf"],
  "she shouts": ["Ecg"],
  "she shows her id": ["Ech"],
  "she sings": ["Eci"],
  "she sits": ["Ecj"],
  "she skates": ["Eck"],
  "she skis": ["Ecl"],
  "she sleeps": ["Ecm"],
  "she smells a flower": ["Ecn"],
  "she smiles": ["Eco"],
  "she speaks english": ["Ecp"],
  "she studies": ["Ecq"],
  "she takes a photo": ["Ecr"],
  "she takes a shower": ["Ecs"],
  "she takes some pizza": ["Ect"],
  "she talks on the phone": ["Ecu"],
  "she tells off the boy": ["Ecv"],
  "she thinks": ["Ecw"],
  "she ties her shoes": ["Ec0"],
  "she tries on a dress": ["Ecx"],
  "she turns down some cake": ["Ecy"],
  "she turns on the light": ["Ecz"],
  "she uses a computer": ["Ec1"],
  "she visits her grandparents": ["Ec2"],
  "she wakes up": ["Ec3"],
  "she walks the dog": ["Ec4"],
  "she waves her hand": ["Ec5"],
  "she wipes the table": ["Ec6"],
  "she withdraws money": ["Ec7"],
  "she writes": ["Ec8"],
  "shed": ["DL3","CVf","D5I","CVg","CVh"],
  "sheep": ["DL4","CVl","D5J","CVj","CVo","CVk","CVm"],
  "sheepdog": ["DYl"],
  "sheet": ["CVr","CVq"],
  "sheets": ["CVs"],
  "shelf": ["CVt","CVu","CVw","CVv","CVx"],
  "shell": ["CV0","CV1","DL5","CVy","CVz"],
  "shells": ["CV3","CV2","CV4"],
  "shelter": ["CV6","CV8","CV5","CV7"],
  "shelves": ["DL6","CV9","D5K","CWA","CWC","CWB"],
  "shepherd": ["CWD","CWF","CWE"],
  "shield": ["DL7","CWK","CWG","CWI","CWJ"],
  "shine": ["CWL","CWM"],
  "shiny": ["CWN"],
  "ship": ["CWQ","CWO","CWP"],
  "shipwreck": ["E3V"],
  "shirt": ["DL9","DL8","D5M","CWR","CWS"],
  "shitzu": ["CWT","CWU"],
  "shock": ["CWZ"],
  "shocked": ["CWW","CWY","CWX"],
  "shoe": ["CWa","CWc","CWb"],
  "shoe shop": ["CWi","CWh"],
  "shoe store": ["CWl","CWk"],
  "shoes": ["DMC","DMB","D5N","DMA","CWf","CWj","CWd","CWe","CWg"],
  "shook": ["EU9"],
  "shook hands": ["EU9"],
  "shop": ["Dlo","Edi"],
  "shop assistant": ["DMD","DME","EMq","EMr"],
  "shop shopped": ["Dlo"],
  "shopping": ["Dlo","CWu","CWm","Edi"],
  "shopping cart": ["DMF"],
  "shopping center": ["CWn","DMG","DuE","CWo"],
  "shopping centre": ["DuE","CWn","DMG","CWo"],
  "shopping list": ["CWp"],
  "shopping mall": ["CWs","CWq","CWr","CWt"],
  "shops": ["CWv"],
  "shore": ["DuF"],
  "short": ["DuH","DuG","EMs","EMt"],
  "short hair": ["CWw","CWx"],
  "shorter": ["DMJ","DMH","DMI","ESE"],
  "shorts": ["DMK","CW1","D5Q","CW0","CWy","CWz"],
  "shoulder": ["DML","D5R","CW2"],
  "shoulders": ["CW4","CW3"],
  "shout": ["Dlp","Ecg","CW7","EMu"],
  "shout angrily": ["ERR"],
  "shout shouted": ["Dlp"],
  "shouting": ["Dlp","Ecg","CW6"],
  "shovel": ["CXB","CW8","CXA","CW9"],
  "show": ["Dlq","Dlr","EZU","Ech"],
  "show a phone": ["EZU","Dlq"],
  "show id": ["Ech"],
  "show showed": ["EUK","Dlq","Dlr"],
  "show your ID": ["Dlr"],
  "showed": ["EUK"],
  "showed her id": ["EUK"],
  "shower": ["CXG","DMM","CXF","D5S","CXE","CXD","CXC"],
  "showing": ["Ech","Dlr","Dlq"],
  "showing a phone": ["Dlq"],
  "showing your ID": ["Dlr"],
  "shrimp": ["CXH","DMN","CXL","CXJ","CXK","D5T","Eg8","CXI"],
  "shrugged": ["CXN","CXM"],
  "shut": ["Dls","EZV","Ebc"],
  "shut shut": ["Dls"],
  "shut the door": ["Dls","Ebc","EZV"],
  "shutting": ["Ebc","Dls"],
  "shutting the door": ["Ebc","Dls"],
  "shuttlecock": ["DuI"],
  "shy": ["CXP","EMv"],
  "sibling": ["CXQ"],
  "siblings": ["CXR"],
  "sick": ["CXS","CXU","DMO","EMw","CXT"],
  "side dish": ["CXW","CXV"],
  "sidewalk": ["DuJ"],
  "sight": ["DuK"],
  "sightseeing": ["CXZ","CXa"],
  "sign": ["CXc","Dlu","CXb","Dlt","Ebd"],
  "sign his name": ["Dlt"],
  "sign name": ["Ebd"],
  "sign signed": ["EUe","Dlt","Dlu","Dlv"],
  "sign your name": ["Dlu"],
  "signed": ["EUe"],
  "signed my name": ["EUe"],
  "significant": ["DuL"],
  "signing": ["Dlu","Dlt","Ebd"],
  "signing his name": ["Dlt"],
  "signing your name": ["Dlu"],
  "signpost": ["CXe","CXg","CXf"],
  "silence": ["CXh","CXi"],
  "silent": ["CXj"],
  "silk": ["CXk"],
  "silly": ["CXl","CXm"],
  "silver": ["CXn","CXo","DMP"],
  "sim card": ["E3W"],
  "sing": ["Dlx","Dlv","Eci","Dlw","CXp","EZW","CX3","CXq"],
  "sing a song": ["CXv","EZW"],
  "sing karaoke": ["Dlw"],
  "sing sang": ["EUF","Dlw","Dlx"],
  "sing songs": ["EM0"],
  "sing sung": ["EWA"],
  "Singapore": ["CXu","CXt","CXr","EMx","CXs"],
  "Singapore flag": ["DMQ"],
  "singer": ["DMS","CXx","DMR","D5U","EMy","CXy","CXw","EMz","CXz"],
  "singing": ["Dlw","Dlv","Dlx","Eci","CX2","CX0","CX1"],
  "singing karaoke": ["Dlw"],
  "single": ["E3X"],
  "sink": ["DMT","CX8","CX4","D5V","CX7","CX5","CX6"],
  "sip": ["CX9"],
  "sister": ["DZe","CYA","EM1","EM2","EM5"],
  "sister in law": ["EM3","EM4"],
  "sisterinlaw": ["EM3","EM4"],
  "sit": ["CYI","Ecj","CYD","CYB","CYC","EZX"],
  "sit down": ["Dly","EM7","CYG","EM6","CYF"],
  "sit down comfortably": ["ERS"],
  "sit down sat down": ["Dly"],
  "sit on": ["Dlz"],
  "sit on a sofa": ["Dlz"],
  "sit on the sofa": ["EZX"],
  "sit sat": ["Dlz","EUG"],
  "sit up": ["CYK"],
  "sitcom": ["DuM"],
  "sitting": ["Ecj"],
  "sitting down": ["Dly"],
  "sitting on": ["Dlz"],
  "sitting on a sofa": ["Dlz"],
  "sitting room": ["CYJ"],
  "six": ["DcE","DcC"],
  "six hundred": ["DcD"],
  "six o'clock": ["DeV"],
  "six thousand": ["DcH"],
  "sixteen": ["DcG","DcF"],
  "sixth": ["E3Y"],
  "sixty": ["DcO","DcI"],
  "sixty eight": ["DcJ"],
  "sixty five": ["DcK"],
  "sixty four": ["DcL"],
  "sixty nine": ["DcM"],
  "sixty one": ["DcN"],
  "sixty seven": ["DcP"],
  "sixty six": ["DcQ"],
  "sixty thousand": ["DcR"],
  "sixty three": ["DcS"],
  "sixty two": ["DcT"],
  "skate": ["Dl1","CYQ","Dl0","Eck"],
  "skate park": ["DuN"],
  "skate skated": ["EUL","Dl0","Dl1"],
  "skateboard": ["DMV","CYL","D5X","CYM","CYP"],
  "skateboarding": ["DMU","CYO","D5W","CYN"],
  "skated": ["EUL"],
  "skates": ["CYR"],
  "skating": ["Dl1","CYS","Dl0","Eck"],
  "skating rink": ["CYT"],
  "skeleton": ["CYV","CYW","CYU","EM8"],
  "skeletons": ["EM9"],
  "sketch": ["CYX"],
  "ski": ["Dl2","CYY","Ecl","CYf","CYZ"],
  "ski jacket": ["CYc"],
  "ski skied": ["Dl2"],
  "skiing": ["Dl2","CYb","CYa","Ecl","DMW","D5Y"],
  "skin": ["CYd"],
  "skinny": ["DuO"],
  "skip": ["CYi","CYe"],
  "skipping": ["CYg"],
  "skipping rope": ["CYh"],
  "skirt": ["DMX","CYj","CYn","D5Z","CYm","CYo","CYk","CYl"],
  "skis": ["DMY","CYp"],
  "skull": ["CYs","CYr","CYt","CYq"],
  "skunk": ["DMZ","CYx","CYw","D5a","CYu","CYv"],
  "sky": ["CY1","CYy","CYz","CY0","DvQ"],
  "skybridge": ["E3Z"],
  "skydiving": ["DuP"],
  "skyscraper": ["CY3","CY4"],
  "skyscrapers": ["CY7","CY6"],
  "skyscrappers": ["DMa"],
  "slate": ["E3a"],
  "sled": ["CY8","CZG","CY9","CZA"],
  "sledge": ["CZB","CZC","CZF","CZE"],
  "sleep": ["Dl6","Dl3","Ecm","CZP","Dl4","CZH","END","Dl5","CZI","EZY"],
  "sleep in class": ["Dl5","EZY"],
  "sleep like a log": ["ENA","ENB","ENC"],
  "sleep slept": ["ETM","Dl3","EVw","Dl5","Dl4","Dl6"],
  "sleeping": ["Dl6","Ecm","Dl3","Dl4","CZN","Dl5","CZJ","CZK"],
  "sleeping bag": ["CZL","CZM"],
  "sleeping in class": ["Dl5"],
  "sleepover": ["CZO"],
  "sleepy": ["CZS","CZQ","CZR"],
  "sleigh": ["CZX","Eh4","CZT","CZU","ENE"],
  "slept": ["EVw","ETM"],
  "slept in class": ["EVw"],
  "slice": ["CZY","CZZ","CZa","CZe","CZb"],
  "slice of cake": ["CZc"],
  "slice of pie": ["CZd"],
  "slide": ["DMb","CZg","D5c","CZh","CZf"],
  "slim": ["CZi"],
  "slip": ["DuQ"],
  "slippers": ["DMc","CZl","CZk","D5d","CZm","CZj"],
  "slope": ["CZn"],
  "sloth": ["DuR"],
  "Slovakia": ["CZr","CZo","ENF"],
  "Slovenia": ["ENG"],
  "slow": ["CZt","DMe","CZs","ENH"],
  "slower": ["DMd"],
  "slowly": ["DuS","ERV"],
  "small": ["DMj","DMf","ENI","Eh6","Eh5"],
  "smaller": ["DMi","DMg","ESG"],
  "smart": ["CZw"],
  "smart watch": ["DMk","D5e"],
  "smartphone": ["CZu","CZv"],
  "smash": ["CZy","CZx"],
  "smell": ["Dl7","Ecn","Dl8","DmA","EZa","EZb","Dl9"],
  "smell a flower": ["Dl7","Ecn"],
  "smell bad": ["Eh7","EZa","Dl8","Dl9"],
  "smell flowers": ["DmA"],
  "smell nice": ["EZb"],
  "smell smelled": ["EUM","Dl7","Dl8","Dl9","DmA"],
  "smelled": ["EUM"],
  "smelled a flower": ["EUM"],
  "smelling": ["Ecn","DmA","Dl7","Dl8","Dl9"],
  "smelling a flower": ["Ecn","Dl7"],
  "smelling bad": ["Dl8","Dl9"],
  "smelling flowers": ["DmA"],
  "smelly": ["DMl","ENJ","Eh7"],
  "smile": ["DmC","DmB","Eco","CZ0","CZz"],
  "smile smiled": ["EUN","DmC","DmB"],
  "smiled": ["EUN"],
  "smiling": ["CZ1","Eco","DmC","DmB","CZ3"],
  "smoke": ["CZ4","CZ5"],
  "smooth": ["DuT"],
  "smoothie": ["CZ7","CZ9","CZ6","CaA","CZ8"],
  "snack": ["DuV","DuU"],
  "snacks": ["DuW"],
  "snail": ["DMm","CaE","CaC","D5f","CaB","CaD"],
  "snake": ["DMn","CaI","CaK","D5g","CaF","CaH","CaG","CaJ"],
  "snakes": ["CaL","CaM"],
  "sneaker": ["CaO","CaN"],
  "sneakers": ["DMo","CaP","D5h","CaQ","CaR"],
  "sneaky": ["CaS"],
  "sneeze": ["DmD","CaU","CaT"],
  "sneeze sneezed": ["EUO","DmD"],
  "sneezed": ["EUO"],
  "sneezing": ["DmD","CaV"],
  "sniff": ["CaW"],
  "sniper": ["CaX"],
  "snooker": ["CaZ"],
  "snore": ["Caa","ENK"],
  "snore noisily": ["ERT"],
  "snorkel": ["Cab","Cad","DMp","Cag","D5i","Cac"],
  "snorkeling": ["Caf","Cae"],
  "snow": ["DmE","Cah","DMr","Cak","D5j","Cai","DMq","CbR","Caj"],
  "snow globe": ["Ca5","Ca7","Ca6"],
  "snow leopard": ["CbG","CbH","CbD"],
  "snow shoes": ["CbT"],
  "snow snowed": ["ETa","DmE"],
  "snowball": ["Can","Cal"],
  "snowball fight": ["Cam"],
  "snowboard": ["Caw","Cao"],
  "snowboarder": ["Caq","Cap"],
  "snowboarding": ["Cau","Cav","Cas","Cat"],
  "snowed": ["ETa"],
  "snowflake": ["Ca0","Cay","ENL","Cax","Caz"],
  "snowflakes": ["Ca4","Ca2","Ca3"],
  "snowing": ["CbA","DmE","CbB","Ca9"],
  "snowman": ["CbM","Eh8","CbO","CbN","CbL","ENM","CbK","CbI"],
  "snowmen": ["CbP"],
  "snowstorm": ["CbU","CbW","CbV"],
  "snowy": ["CbZ","CbX","ENN","CbY"],
  "soak up": ["E3b"],
  "soap": ["DMs","Cbe","D5k","Cbd","Cbc","Cba","Cbb"],
  "soccer": ["DMt","Cbs","D5l","Cbg","Cbh","Cbf","Cbi"],
  "soccer ball": ["Cbm","Cbk","Cbj","Cbl"],
  "soccer field": ["Cbn","Cbo"],
  "soccer player": ["Cbp","Cbr","Cbq"],
  "sociable": ["DuX"],
  "social media": ["Cbt"],
  "social studies": ["E3c"],
  "sock": ["Cbx","Cbu","Cbv","Cbw"],
  "socket": ["DMu","D5m"],
  "socket adapter": ["E3d"],
  "socks": ["DMw","DMv","Cbz","D5n","Cby","Cb1","Cb0"],
  "soda": ["Cb5","DMx","Cb3","Cb4","Cb2","Cb6"],
  "sofa": ["DMy","D5o","Cb9","CcA","Cb7","Cb8"],
  "soft": ["CcC","ENO","CcB"],
  "software developer": ["ENQ","DM0"],
  "software engineer": ["DM1","ENR"],
  "soil": ["CcE","CcH","CcG","CcD","CcF"],
  "solar eclipse": ["CcJ","CcK"],
  "solar system": ["CcM","CcN"],
  "sold": ["EUP","DuY"],
  "sold apples": ["EUP"],
  "soldier": ["DM3","DM4","CcR","CcQ","ENU","D5p","CcO","ENT","CcP"],
  "soldiers": ["CcT","CcS","CcU"],
  "solid": ["CcW"],
  "solitary": ["CcY","CcX"],
  "solve": ["CcZ"],
  "some": ["E3e"],
  "son": ["Ccc","DZg","Cca","ENV","ENX"],
  "son in law": ["ENW","DZf"],
  "song": ["Ccb"],
  "soninlaw": ["ENW"],
  "sore throat": ["DM5","D5q","Ccd"],
  "sorry": ["DuZ"],
  "soul": ["Ccf","Cce"],
  "soup": ["Cch","DM6","Ccg","Ccj","D5r","Cci"],
  "soup spoon": ["Cck","Ccl","Ccm"],
  "sour": ["E3f"],
  "south": ["E3g"],
  "South Africa": ["Ccq","DM9","Ccp","Ccn","ENY"],
  "South Africa flag": ["DM7"],
  "South African": ["DM8","EeT"],
  "South America": ["Ccs","Ccr"],
  "South Korea": ["Ccv","Cct"],
  "souvenir": ["Ccw"],
  "soy sauce": ["Ccy","Ccx","Ccz"],
  "spa": ["E3i"],
  "space": ["Cc3","Cc0","Cc2","Cc1"],
  "space shuttle": ["Cc7","Cc9"],
  "space station": ["CdA","CdB"],
  "space suit": ["CdC","CdD","CdE"],
  "spacecraft": ["Dua"],
  "spaceship": ["Cc6","Cc4","Cc5"],
  "spacious": ["CdF","CdG"],
  "spade": ["DNA","CdJ","CdH","D5t"],
  "spaghetti": ["CdM","CdL","DNC","D5v","CdO","CdK","CdN"],
  "spaghetti bolognese": ["D5u","DNB"],
  "Spain": ["CdS","DNE","CdP","D5w","ENZ","CdQ"],
  "Spain flag": ["DND"],
  "Spanish": ["DNG","DNF","EeU","D5x"],
  "spanner": ["E3h"],
  "spare ribs": ["CdT","CdU"],
  "spark": ["CdY"],
  "sparkler": ["CdV"],
  "sparkling water": ["CdX","CdW"],
  "sparrow": ["Cdb","CdZ"],
  "spatula": ["DNH"],
  "speak": ["DmH","DmG","Ecp","DmI","DmF","EZd"],
  "speak about politics": ["ENa"],
  "speak Chinese": ["DmF"],
  "speak different languages": ["ENb"],
  "speak English": ["DmG","Ecp"],
  "speak Spanish": ["DmI","EZd"],
  "speak spoke": ["DmG","DmF","DmH","DmI","ETN"],
  "speak spoken": ["EV8"],
  "speaker": ["E3j"],
  "speakers": ["DNI","Cdf","Cde","D5z"],
  "speaking": ["DmH","DmG","Ecp","DmF","DmI"],
  "speaking Chinese": ["DmF"],
  "speaking English": ["DmG"],
  "speaking Spanish": ["DmI"],
  "spear": ["Cdh","Cdj"],
  "special": ["Dub"],
  "species": ["Duc"],
  "speed camera": ["Cdk"],
  "speed limit": ["Cdn","Cdm"],
  "spell": ["Cdo"],
  "sphere": ["Dud"],
  "sphinx": ["Cdp","Cdr"],
  "spicy": ["Cdu","Cdt","Cds"],
  "spider": ["DNJ","D50","Cdy","Cdw","Cdx","ENc","Cdv"],
  "spider web": ["Cd4","Cd2","Cd1"],
  "spiders": ["Cdz","Cd0"],
  "spike": ["Cd5"],
  "spiky": ["Cd9","Cd6","Cd7"],
  "spiky hair": ["Cd8"],
  "spill": ["DmJ","CeA"],
  "spill spilt": ["EUt","DmJ"],
  "spill water": ["DmJ"],
  "spilling": ["DmJ"],
  "spilling water": ["DmJ"],
  "spilt": ["EUt"],
  "spin": ["Duf"],
  "spinach": ["CeH","CeD","CeF","CeE","CeG"],
  "spine": ["CeJ","CeI"],
  "spinkle": ["Due"],
  "spit": ["CeK"],
  "splash": ["CeN","CeM","CeL"],
  "split": ["CeO"],
  "spoil": ["CeP","CeQ"],
  "spoke": ["ETN"],
  "spoken": ["EV8"],
  "spoken chinese": ["EV8"],
  "sponge": ["CeS","CeR","CeT"],
  "spoon": ["DNK","CeU","CeX","D51","CeW","CeV"],
  "sport": ["E3k"],
  "sports": ["Duj"],
  "sports car": ["CeY","Cea","CeZ"],
  "sports center": ["Dug","Duh"],
  "sports centre": ["Duh","Dug"],
  "sports field": ["Dui"],
  "sports shop": ["E3l"],
  "sporty": ["Duk"],
  "spots": ["Dul"],
  "spray": ["DmK","EZe"],
  "spray sprayed": ["DmK"],
  "spray water": ["EZe"],
  "spraying": ["DmK"],
  "spread": ["DmL","EZf"],
  "spread butter": ["EZf","DmL"],
  "spread spread": ["DmL"],
  "spreading": ["DmL"],
  "spreading butter": ["DmL"],
  "spring": ["Dum"],
  "spring onion": ["Cec"],
  "spring onions": ["Ced"],
  "spring roll": ["Cef","Ceg"],
  "spring rolls": ["DNL"],
  "sprinkle": ["E3m"],
  "sprinkler": ["Ceh"],
  "spy": ["Cej","Cei"],
  "square": ["Cek"],
  "squash": ["Cen","Cel","Cem"],
  "squats": ["Ceo","Cep"],
  "squeeze": ["Cer","DmM","Ces","Ceq","Ebe"],
  "squeeze an orange": ["DmM","Ebe"],
  "squeeze squeezed": ["DmM"],
  "squeezing": ["Ebe","DmM"],
  "squeezing an orange": ["Ebe","DmM"],
  "squid": ["Cev","Ceu","Cet","Cew"],
  "squirrel": ["Ce0","DNM","D52","Cez","Cex"],
  "Sri Lanka": ["ENd","Ce1","Ce3"],
  "stable": ["Ce6","Ce5"],
  "stack of books": ["Ce7"],
  "stadium": ["CfB","Ce8","DNN","CfA","D53","Ce9"],
  "stage": ["CfD","CfC"],
  "stair": ["CfG","CfF","CfE"],
  "stairs": ["DNO","CfH","CfL","CfI","CfM","CfK"],
  "stall": ["E3n"],
  "stamp": ["CfP","CfO","CfN","CfQ"],
  "stamps": ["CfR"],
  "stand": ["DmN"],
  "stand stood": ["DmN","EUQ"],
  "stand up": ["DmO","ENe"],
  "stand up stood up": ["DmO"],
  "standing": ["DmN"],
  "standing in line": ["Dun"],
  "standing up": ["DmO"],
  "stapler": ["DNP","CfT","CfU","CfS","D54"],
  "star": ["CfW","Cfh","CfV"],
  "star fish": ["CfY","CfX","CfZ"],
  "star fruit": ["Cfa","Cfc","Cfb","Cfd"],
  "stare": ["DmP","EZh"],
  "stare out the window": ["EZh","DmP"],
  "stare stared": ["DmP"],
  "starfish": ["Duo"],
  "staring": ["DmP"],
  "staring out the window": ["DmP"],
  "starling": ["Cfg","Cfe","Cff"],
  "starry night": ["Cfi"],
  "stars": ["DNQ","Cfk","Cfj","Cfl","D55","Cfm"],
  "start": ["DmQ","Cfo","DmR","EZi"],
  "start a race": ["DmQ"],
  "start school": ["DmR","EZi"],
  "start started": ["DmQ","EWQ","DmR"],
  "started": ["EWQ"],
  "started the race": ["EWQ"],
  "starting": ["DmQ","DmR"],
  "starting a race": ["DmQ"],
  "starting school": ["DmR"],
  "station": ["Cfs","Cfp","Cfq","Cft","Cfr"],
  "statue": ["Cfw","DNR","Cfy","Cfx","D56","Cfu","Cfv"],
  "stay": ["EZj"],
  "stay at home": ["Dup"],
  "stay in": ["DmS"],
  "stay in bed": ["DmS","EZj"],
  "stay stayed": ["DmS"],
  "stay up late": ["E3o"],
  "staying in": ["DmS"],
  "staying in bed": ["DmS"],
  "steak": ["DNT","Cf4","Cf1","D57","Cfz","Cf3","Cf2","Cf0"],
  "steak and chips": ["DNS"],
  "steal": ["DmT","Ebf"],
  "steal a wallet": ["DmT","Ebf"],
  "steal stole": ["ETO","DmT"],
  "stealing": ["DmT","Ebf"],
  "stealing a wallet": ["Ebf","DmT"],
  "steam": ["Duq"],
  "steam engine": ["Cf5","Cf6"],
  "steel": ["E3p"],
  "steep": ["Cf9","Cf7"],
  "stem": ["Dur"],
  "step": ["E3q"],
  "step ladder": ["CgC"],
  "steps": ["CgG","CgE","CgH","CgF"],
  "stereo": ["DNU","D58"],
  "stethoscope": ["DNV","CgK","CgJ"],
  "stew": ["CgL","CgM"],
  "stick": ["CgP","CgO","CgN","CgU"],
  "stick insect": ["CgS","CgQ","CgR"],
  "stick out like a sore thumb": ["ENf","ENg","ENh"],
  "stickers": ["Dus"],
  "sticks": ["Dut"],
  "sticky": ["CgV"],
  "sticky rice": ["Duu"],
  "sticky tape": ["CgW"],
  "stilt house": ["CgX"],
  "sting": ["DmU","CgZ","Cga"],
  "sting stung": ["ESU","DmU"],
  "stinging": ["DmU"],
  "stingray": ["Duv"],
  "stir": ["Cgc","DmV","Cgb"],
  "stir stirred": ["DmV"],
  "stiring": ["DmV"],
  "stocking": ["Cgd","Cge","Cgf","Eh9","ENi"],
  "stole": ["ETO"],
  "stole a wallet": ["ETO"],
  "stomach": ["Cgg"],
  "stomach ache": ["DNW","D6A"],
  "stomachache": ["E3r"],
  "stomp": ["Duw"],
  "stone": ["Cgh","Cgi"],
  "stood": ["EUQ"],
  "stood up": ["EUQ"],
  "stool": ["DNX","D6B"],
  "stop": ["Cgj","DmX","DmW","EZk","Cgk"],
  "stop at the lights": ["DmW"],
  "stop at the red light": ["EZk"],
  "stop sign": ["DNY"],
  "stop stopped": ["DmW","EUh","DmX"],
  "stopped": ["EUh"],
  "stopping": ["DmW","DmX"],
  "stopping at the lights": ["DmW"],
  "store": ["DNZ","Cgl"],
  "stork": ["Cgq","Cgo"],
  "storm": ["DNb","DYm","DNa","Cgs","Cgt","Cgr"],
  "stormy": ["Cgw","Cgv","Cgu"],
  "story": ["Cgz"],
  "storybook": ["Cgx","Cgy"],
  "storyteller": ["Cg0"],
  "stove": ["DNc","Cg4","Cg1","Cg3","D6D","Cg2"],
  "straight": ["Cg5","Cg8","Cg6"],
  "straight hair": ["Cg7"],
  "strange": ["Cg9","ChA","ChB"],
  "straw": ["DNf","ChC","ChD","D6F","ChG","ChV","ChF"],
  "straw hat": ["ChU"],
  "strawberries": ["DNd","ChJ","ChH","D6E","ChL","ChI","ChK"],
  "strawberry": ["ChP","DNe","Eg9","ChN","ChM"],
  "strawberry juice": ["ChO"],
  "stream": ["ChZ","ChW","ChY","ChX"],
  "street": ["Che","Cha","Chc","Chb","Chd"],
  "street light": ["DNg","D6G"],
  "strength": ["Chf"],
  "stressed": ["Chg","Chh"],
  "stretch": ["DmY","Chi","Chk","Cho"],
  "stretch stretched": ["DmY"],
  "stretcher": ["DNh"],
  "stretching": ["DmY"],
  "strict": ["Chq","Chp"],
  "strike": ["Chr","Chs"],
  "string": ["Chv","Cht","Chu","Chw"],
  "striped": ["Chy","Chx"],
  "stripes": ["Ch0","Chz"],
  "stripy": ["Ch1"],
  "strong": ["DNj","Ch2","EiA","ENm"],
  "strong as an ox": ["ENj","ENk","ENl"],
  "stronger": ["DNi"],
  "stubborn": ["Dux"],
  "student": ["Ch3","Ch7","Ch5","Ch6","Ch4"],
  "students": ["Ch9","CiA","Ch8","CiB"],
  "studied": ["EV9","EVA"],
  "studied maths": ["EV9"],
  "studio": ["CiC"],
  "study": ["Dmb","DYn","DNk","Dma","Ecq","DmZ","ENp","CiD","CiF","CiE"],
  "study at college": ["ENn"],
  "study at school": ["E3s"],
  "study english": ["E3t"],
  "study hard": ["ERU"],
  "study in the library": ["ENo"],
  "study Spanish": ["ENq"],
  "study studied": ["Dmb","EV9","DmZ","Dma","EVA"],
  "studying": ["Dmb","Dma","Ecq","DmZ"],
  "stung": ["ESU"],
  "stung me": ["ESU"],
  "stuntman": ["CiH","CiG"],
  "subject": ["E3u"],
  "subjects": ["DYo"],
  "submarine": ["DYp","CiK","CiI","CiL"],
  "submersible": ["DYq"],
  "subtitle": ["E3v"],
  "subtract": ["CiN"],
  "suburban": ["CiO"],
  "subway": ["CiR","CiS","CiQ","CiT"],
  "successful": ["Duy"],
  "Sudan": ["ENr"],
  "sugar": ["CiW","DNl","CiV","CiU"],
  "sugary food": ["DYr"],
  "suggestions": ["DYs"],
  "suit": ["DNn","Cij","D6J","CiY","CiZ","CiX"],
  "suit and tie": ["Cie"],
  "suitcase": ["DNm","D6I","Cii","Cif","Cih"],
  "sulk": ["Cik"],
  "summer": ["Duz"],
  "sun": ["Cim","Cil","CjE","D6t","DOn"],
  "sun cream": ["Du1"],
  "sun hat": ["Ci2","Ci4","Ci1","Ci3"],
  "sunbathe": ["Dmc","Cip","Cin"],
  "sunbathe sunbathed": ["Dmc"],
  "sunbathing": ["Dmc"],
  "sunblock": ["E3w"],
  "sunburn": ["Du0"],
  "suncream": ["Ciq"],
  "Sunday": ["DNq","DNo","DNp"],
  "Sunday roast": ["Cir"],
  "sunflower": ["Cis","Cit"],
  "sunflowers": ["Ciw","Ciu"],
  "sung": ["EWA"],
  "sung the song": ["EWA"],
  "sunglasses": ["DNr","Ci0","Ciy","Ciz","D6K","Cix"],
  "sunlight": ["Ci5","Ci8","Ci6","Ci7"],
  "sunnier": ["ESI","DNs"],
  "sunny": ["DNu","DYt","CjA","ENs","EiB","DNt","CjB","CjC","CjD","Ci9"],
  "sunrise": ["CjI","CjH","CjF","CjG"],
  "sunscreen": ["DNv","DYu","CjL","CjK"],
  "sunset": ["CjN","CjQ","CjP","CjM"],
  "sunshine": ["CjT","CjS","CjR"],
  "superhero": ["DNw","CjX","CjV","CjW"],
  "superman": ["Du2"],
  "supermarket": ["DNx","CjZ","CjY","Cja"],
  "supernova": ["Cjb"],
  "supper": ["E3x"],
  "support": ["Dmd","EZn"],
  "support a team": ["Dmd"],
  "support liverpool": ["EZn"],
  "support supported": ["EVk","Dmd"],
  "supported": ["EVk"],
  "supported liverpool": ["EVk"],
  "supporting": ["Dmd"],
  "supporting a team": ["Dmd"],
  "surf": ["Cje","Cjd","Cjl"],
  "surf board": ["Cjf","Cjg"],
  "surf the internet": ["Du4"],
  "surfboard": ["Du3"],
  "surfing": ["DNy","Cjj","Cjh","Cjk","D6L","Cji"],
  "surgeon": ["DN0","ENt","DNz","Cjo","Cjm","ENu","D6M","Cjn"],
  "surgery": ["Cjr","Cjp"],
  "surprise": ["Du5"],
  "surprised": ["Cju","DN1","Cjs","ENv","Cjt"],
  "survive": ["E3y"],
  "sushi": ["DN2","Cjx","Cjv","Cjw","D6N"],
  "suspension": ["DYv"],
  "suspicious": ["Cjy"],
  "swam": ["ETP"],
  "swamp": ["Cj0","Cj2","Cj3","Cj1","Cjz"],
  "swan": ["Cj6","DN3","Cj5","D6O","Cj4"],
  "sweat": ["CkD","Cj7","Cj8"],
  "sweater": ["DN4","CkA","D6P","CkB","Cj9","CkC"],
  "sweatshirt": ["CkH","CkE","CkF","CkG"],
  "Sweden": ["CkL","CkI","ENw","CkJ"],
  "sweep": ["Dme","Dmf","CkN","CkO","Ebg","CkM","EZo"],
  "sweep swept": ["Dme","ETQ","Dmf"],
  "sweep the floor": ["Dmf","Ebg","EZo"],
  "sweeping": ["Ebg","Dme","Dmf"],
  "sweeping the floor": ["Dmf","Ebg"],
  "sweet": ["Du6"],
  "sweet potato": ["CkW","CkZ","CkV","CkX"],
  "sweet potatoes": ["CkY"],
  "sweet shop": ["Ckd","Cke"],
  "sweetcorn": ["DN5","CkR","CkQ"],
  "sweetheart": ["CkT"],
  "sweets": ["Ckf","Ckc","Ckb","Cka"],
  "swept": ["ETQ"],
  "swept the floor": ["ETQ"],
  "swim": ["Dmh","Ckg","Ebh","Dmg","Ckr","EZp"],
  "swim in the sea": ["Du7"],
  "swim in the water": ["EZp"],
  "swim swam": ["Dmh","ETP","Dmg"],
  "swimmer": ["Cki","Ckh"],
  "swimming": ["Dmh","Ckl","DN7","Ckj","Ckk","Ebh","Dmg","D6Q"],
  "swimming cap": ["DN6"],
  "swimming costume": ["E3z"],
  "swimming pool": ["Cko","Ckn","Ckm","Ckp"],
  "swimming trunks": ["DN8","Ckq","D6R"],
  "swimsuit": ["Cks","DN9","D6S"],
  "swing": ["Dmi","DOA","D6T","Ckw","Ckx","Cku","Ckt","Ckv"],
  "swing swung": ["Dmi"],
  "swinging": ["Dmi"],
  "swings": ["Cky"],
  "switch": ["DOB","D6U"],
  "Switzerland": ["Ck2","Ckz","ENx"],
  "swivel chair": ["D6V","DOC"],
  "sword": ["DOD","D6W"],
  "swordfish": ["Ck3","Ck4","Ck5"],
  "syringe": ["DOE","D6X"],
  "syrup": ["Ck7","Ck6"],
  "system": ["E30"],
  "t": ["DaN","DaO"],
  "t rex": ["Cst","Csu"],
  "t shirt": ["E4c","Ctj","Cth","Ctl","Ctn"],
  "table": ["DOF","D6Y","ClC","ClA","Ck9","Ck8","ClB","ClG"],
  "table tennis": ["DOG","ClO","D6Z","ClL","ClM","ClK","ClN"],
  "tablecloth": ["ClF","ClE","ClD"],
  "tablespoon": ["ClH"],
  "tablet": ["DOH","ClJ","D6a","ClI","ClP"],
  "taco": ["DOI","D6b"],
  "tacos": ["ClT","ClQ","ClR","ClS"],
  "tadpole": ["ClW","ClU","ClV"],
  "taekwondo": ["ClY","ClX"],
  "tag": ["E31"],
  "tail": ["DOL","D6c","ClZ","Cla"],
  "tailor": ["DOJ","DOK","ENy"],
  "Taiwan": ["Cld","Clb","EN0"],
  "Taiwan flag": ["DOM"],
  "Taj mahal": ["Clg","Clf"],
  "take": ["Dm0","Dmv","Dm1","Dm2","EZr","Dmu","EZx","Ecs","Edj","EZw","EZv","EZu","EZt","EZs","EZq"],
  "take a bath": ["Dmj","EZq","EN1"],
  "take a cookie": ["Dmk","EZr"],
  "take a nap": ["Clh"],
  "take a photo": ["Dmm","Cli","Dml","Edj","EZt","Dmn","Dmo","Clk","Clj"],
  "take a picture": ["Du8","EZu"],
  "take a shower": ["Dmr","Dmp","Dmq","EZv","Ecs","EN2"],
  "take a test": ["Dms"],
  "take an exam": ["EZs"],
  "take away": ["Du9"],
  "take care": ["Dmt","EN4"],
  "take care of": ["DvA"],
  "take care of a garden": ["EN3"],
  "take care took care": ["Dmt"],
  "take medicine": ["Dmu","EZw"],
  "take money": ["EZx","Dmv"],
  "take off": ["Dmw","Dmx","Ebi","EN6","EN7"],
  "take off a coat": ["EN7","Ebi"],
  "take off took off": ["Dmw"],
  "take out": ["Dmz","Dmy","Ebj","EN8"],
  "take out the rubbish": ["E32"],
  "take out the trash": ["Dmz","Ebj","EN8"],
  "take out took out": ["Dmy","Dmz"],
  "take photos": ["EOA"],
  "take pictures": ["DvB"],
  "take some pizza": ["Dm0","Dm1"],
  "take taken": ["EWB","EWC"],
  "take the bus": ["Dm2","EOB"],
  "take took": ["EVH","Dml","Dmo","Dm0","Dmk","Dmv","Dmj","Dmp","Dmu"],
  "take vitamins": ["E33"],
  "taken": ["EWC","EWB"],
  "taken a bath": ["EWB"],
  "taken a shower": ["EWC"],
  "takes": ["Ect"],
  "takes some pizza": ["Ect"],
  "taking": ["Dmu","Dm0","Dm2","Ecs","Edj","Dmv","Dm1"],
  "taking a bath": ["Dmj"],
  "taking a cookie": ["Dmk"],
  "taking a photo": ["Dml","Dmm","Dmo","Dmn"],
  "taking a shower": ["Dmp","Ecs","Dmq","Dmr"],
  "taking a test": ["Dms"],
  "taking care": ["Dmt"],
  "taking medicine": ["Dmu"],
  "taking money": ["Dmv"],
  "taking off": ["Dmw","Dmx","Ebi"],
  "taking out": ["Ebj","Dmy","Dmz"],
  "taking out the trash": ["Dmz","Ebj"],
  "taking photos": ["DvC"],
  "taking some pizza": ["Ect","Dm0","Dm1"],
  "taking the bus": ["Dm2"],
  "talent show": ["DvE"],
  "talented": ["DvD"],
  "talk": ["Dm7","Edl","EZz","Dm4","Dm3","Dm6","Cll","EZy","Dm5"],
  "talk on a headset": ["EZy"],
  "talk on the phone": ["Dm6","Dm5","Edk"],
  "talk talked": ["Dm4","EVB","Dm3","Dm5","Dm7"],
  "talk to": ["Dm8"],
  "talk to a friend": ["EZz","Dm8"],
  "talk together": ["EOF"],
  "talkative": ["E34"],
  "talked": ["EVB"],
  "talked to each other": ["EVB"],
  "talking": ["Dm7","Edl","Dm6","Dm3","Dm4","Dm5"],
  "talking on the phone": ["Dm5","Dm6","Edk"],
  "talking to": ["Dm8"],
  "talking to a brick wall": ["EOC","EOD","EOE"],
  "talking to a friend": ["Dm8"],
  "tall": ["DOO","EiD","EOG","EiC"],
  "tall buildings": ["EiC"],
  "taller": ["DON"],
  "tambourine": ["DOP","D6d","Clm","Cln"],
  "tangerine": ["Clq","Clo","DOQ","Clp","D6e"],
  "tangerines": ["DOR","Clt"],
  "tangle": ["Clv"],
  "tangled": ["Clu"],
  "tank": ["Clz","Clx","Cly"],
  "tanktop": ["Cl0"],
  "Tanzania": ["Cl3"],
  "tap": ["Cl5","Cl4","CmD","Cl6"],
  "tape": ["DOT","CmC","Cl9","D6g","Cl8","Cl7"],
  "tape measure": ["CmA","DOS","D6f"],
  "tarantula": ["CmH","CmI","CmE","CmF","CmG"],
  "taste": ["DnA","Dm9","EZ1","EZ0"],
  "taste bad": ["EZ0","Dm9"],
  "taste good": ["DnA","EZ1"],
  "taste tasted": ["Dm9","DnA"],
  "tasting": ["DnA","Dm9"],
  "tasting bad": ["Dm9"],
  "tasting good": ["DnA"],
  "tasty": ["E35"],
  "taught": ["EUR"],
  "taught english": ["EUR"],
  "taxi": ["CmJ","CmK","CmM","CmL"],
  "taxi driver": ["E36"],
  "taxi rank": ["CmN"],
  "tea": ["DOX","Cmc","CmQ","D6i","CmP","CmO"],
  "tea set": ["Cmj","Cmk","Cmi"],
  "tea towel": ["DOZ"],
  "teach": ["DnC","DnB","EZ2"],
  "teach a student": ["EOI"],
  "teach class": ["EZ2"],
  "teach English": ["DnB"],
  "teach students": ["EOM"],
  "teach taught": ["DnB","DnC","EUR"],
  "teacher": ["DOV","CmV","EOL","DOU","CmS","EOK","CmT","CmR","D6h","CmU"],
  "teachers": ["DvF"],
  "teaching": ["DnC","DnB"],
  "teaching English": ["DnB"],
  "teacup": ["CmW"],
  "teacups": ["CmX"],
  "teal": ["DOW"],
  "team": ["Cmb","CmY","Cma","CmZ"],
  "teapot": ["Cmd","DOY","Cmg","D6j","Cme","Cmf"],
  "tear": ["DnD","Cmh"],
  "tear tore": ["EVI","DnD"],
  "tear up": ["DnE"],
  "tear up tore up": ["DnE"],
  "tearing": ["DnD"],
  "tearing up": ["DnE"],
  "teaspoon": ["Cmm","Cml"],
  "technician": ["Cmo","Cmn"],
  "technology": ["DvG"],
  "teddy": ["Cmy","Cmp","Cmr","Cmq","Cms"],
  "teddy bear": ["Cmu","Cmw","Cmt","Cmv","Cmx"],
  "teenagers": ["Cm0","Cmz"],
  "teepee": ["Cm3","Cm2"],
  "teeth": ["DOa","D6l","Cm5","Cm6","Cm7"],
  "telephone": ["DvH"],
  "telescope": ["DOb","CnA","Cm9","Cm8","D6m"],
  "television": ["CnF","CnD","DOc","CnE","CnB","CnC"],
  "tell": ["DnH","Ebk","DnF","DnG"],
  "tell a secret": ["DnF","Ebk"],
  "tell off": ["Ecv","EOO"],
  "tell off a boy": ["DnG"],
  "tell off someone": ["Ecv"],
  "tell told": ["ETS","DnF","DnH","DnG"],
  "telling": ["Ebk","DnH","DnF","DnG"],
  "telling a secret": ["Ebk","DnF"],
  "telling off": ["Ecv"],
  "telling off a boy": ["DnG"],
  "temperate": ["E37"],
  "temperature": ["E38"],
  "temple": ["CnH","CnG"],
  "ten": ["DcV","DcU"],
  "ten o'clock": ["DeW"],
  "ten past eight": ["DeX","Efe"],
  "ten thousand": ["DcW"],
  "ten to five": ["DeY","Eff"],
  "tender": ["E39"],
  "tennis": ["DOd","CnJ","CnI","D6n","CnP","CnL","CnK"],
  "tennis ball": ["CnM"],
  "tennis court": ["CnN","CnO"],
  "tennis racket": ["CnQ","CnR"],
  "tent": ["CnS","DOe","CnT","CnX","CnW","CnV","D6o","CnU"],
  "tenth": ["E4A"],
  "terrace": ["E4B"],
  "terrible": ["DvI"],
  "test": ["E4C"],
  "Texas": ["EOP"],
  "text": ["CnY"],
  "text message": ["DvK"],
  "textbook": ["DvJ"],
  "Thai": ["DOh","EeV"],
  "Thailand": ["Cnd","DOg","EOQ","CnZ","Cnc","D6p","Cnb","Cna"],
  "Thailand flag": ["DOf"],
  "thankful": ["E4D"],
  "thanksgiving": ["DvL"],
  "Thanksgiving dinner": ["Cne"],
  "that": ["E4E"],
  "the bathroom is messy": ["Ehp"],
  "the beach": ["DvN","C5x","AT2","ATm","ATn","ATo","ATp","ATq"],
  "the bikes are fast": ["Ehd"],
  "the birds are flying over the mountain": ["Ec9"],
  "the black sheep of the family": ["EOR","EOS","EOT"],
  "the book is old": ["Ehr"],
  "the book is worn out": ["Ehr"],
  "the boots smell bad": ["Eh7"],
  "the buildings are high": ["EiC"],
  "the buildings are tall": ["EiC"],
  "the car is waiting at the lights": ["EdA"],
  "the cat chases a mouse": ["EdB"],
  "the cat is chasing a mouse": ["EdB"],
  "the chair is big": ["EhF"],
  "the chair is on fire": ["Ehu"],
  "the chairs are on fire": ["Ehv"],
  "the clocks are upside down": ["EiI"],
  "the clothes are drying": ["EdC"],
  "the dishes are dirty": ["EhZ"],
  "the dog is biting his hand": ["EdD"],
  "the dog is wet": ["EiJ"],
  "the door is open": ["Ehx"],
  "the doors are open": ["Ehw"],
  "the early bird catches the worm": ["EOU","EOV","EOW"],
  "the earth": ["DOi","D6q","BFW","BFV"],
  "the fan blows air": ["EdE"],
  "the fan is blowing air": ["EdE"],
  "the girl is learning maths": ["EdF"],
  "the girl learns maths": ["EdF"],
  "the grass is always greener on the other side": ["EOX","EOY","EOZ"],
  "the library is quiet": ["Ehy"],
  "the lights are bright": ["EhI"],
  "the moon": ["DOj","D6r","By9","By1","By2","By3","By4"],
  "the news": ["E4G"],
  "the office": ["E4H"],
  "the pencils are broken": ["EhJ"],
  "the phone charges": ["EdG"],
  "the phone is charging": ["EdG"],
  "the phone is ringing": ["EdH"],
  "the phone rings": ["EdH"],
  "the plant is dead": ["EhV"],
  "the plants are dead": ["EhW"],
  "the ring is expensive": ["Ehc"],
  "the room is messy": ["Ehp"],
  "the same": ["E4J"],
  "the screen is cracked": ["EhT"],
  "the sea": ["DvP","CTu","CUJ","CTv","CTw"],
  "the sky": ["DvQ","CY1","CYy","CYz","CY0"],
  "the store hasn't opened yet": ["EOc"],
  "the sun": ["DOn","D6t","CjE","Cil","Cim"],
  "the sun is rising": ["EdI"],
  "the sun rises": ["EdI"],
  "the tires are flat": ["Ehf"],
  "the train hasn't arrived yet": ["EOd"],
  "the tyres are flat": ["Ehf"],
  "the UK": ["DvR"],
  "the water boils": ["EdJ"],
  "the water is boiling": ["EdJ"],
  "theater": ["DvM","Cni","Cnf","Cng","Cnh"],
  "theatre": ["Cni","DvM","Cng","Cnh","Cnf"],
  "their": ["E4F"],
  "their hair is blue": ["EhG"],
  "their hair is long": ["Eho"],
  "their shirts are colorful": ["EhS"],
  "their sweaters are small": ["Eh5"],
  "theme park": ["DvO"],
  "therapist": ["DOk","EOb","EOa"],
  "there": ["E4I"],
  "thermometer": ["DOm","Cnn","Cnm","D6s","Cnj","Cnl"],
  "these": ["E4K"],
  "they are arguing": ["EdK"],
  "they are climbing a mountain": ["EdL"],
  "they are cold": ["EhP"],
  "they are dancing": ["EdM"],
  "they are debating": ["EdN"],
  "they are drinking coffee": ["EdO"],
  "they are eating cake": ["EdP"],
  "they are exchanging money": ["EdQ"],
  "they are exercising": ["EdR"],
  "they are fighting": ["EdS"],
  "they are going to school": ["EdT"],
  "they are guarding the door": ["EdU"],
  "they are happy": ["Ehj"],
  "they are holding hands": ["EdV"],
  "they are hugging": ["EdW"],
  "they are jumping": ["EdX"],
  "they are listening to music": ["EdY"],
  "they are looking at each other": ["EdZ"],
  "they are meeting each other": ["Eda"],
  "they are moving a chair": ["Edb"],
  "they are old": ["Ehs"],
  "they are playing cards": ["Edc"],
  "they are playing football": ["Edd"],
  "they are playing tennis": ["Ede"],
  "they are playing video games": ["Edf"],
  "they are putting up decorations": ["Edg"],
  "they are sad": ["Eh2"],
  "they are shaking hands": ["Edh"],
  "they are shopping": ["Edi"],
  "they are taking a photo": ["Edj"],
  "they are talking": ["Edl"],
  "they are talking on the phone": ["Edk"],
  "they are tired": ["EiE"],
  "they are unhappy": ["Eh2"],
  "they are waiting for a bus": ["Edm"],
  "they are watching tv": ["Edn"],
  "they argue": ["EdK"],
  "they climb a mountain": ["EdL"],
  "they dance": ["EdM"],
  "they debate": ["EdN"],
  "they drink coffee": ["EdO"],
  "they eat cake": ["EdP"],
  "they exchange money": ["EdQ"],
  "they exercise": ["EdR"],
  "they fight": ["EdS"],
  "they go to school": ["EdT"],
  "they guard the door": ["EdU"],
  "they hold hands": ["EdV"],
  "they hug": ["EdW"],
  "they jump": ["EdX"],
  "they listen to music": ["EdY"],
  "they look at each other": ["EdZ"],
  "they meet each other": ["Eda"],
  "they move a chair": ["Edb"],
  "they play cards": ["Edc"],
  "they play football": ["Edd"],
  "they play tennis": ["Ede"],
  "they play video games": ["Edf"],
  "they put up decorations": ["Edg"],
  "they shake hands": ["Edh"],
  "they shop": ["Edi"],
  "they take a photo": ["Edj"],
  "they talk": ["Edl"],
  "they talking on the phone": ["Edk"],
  "they wait for a bus": ["Edm"],
  "they watch tv": ["Edn"],
  "thief": ["Cno","Cnq"],
  "thigh": ["Cnr"],
  "thimble": ["Cnu","Cns","Cnt"],
  "thin": ["DOp","Cnv","EOv","Cnw","Cnx","Cn1"],
  "thin as a rake": ["EOr","EOs","EOt"],
  "thing": ["E4L"],
  "think": ["DnJ","Ecw","Cnz","Cn0","EZ3"],
  "think about": ["DnI"],
  "think about money": ["DnI","EZ3"],
  "think about thought about": ["DnI"],
  "think thought": ["DnJ","EUS"],
  "thinking": ["DnJ","Ecw"],
  "thinking about": ["DnI"],
  "thinking about money": ["DnI"],
  "thinner": ["DOo"],
  "third": ["DvS"],
  "third left": ["E4M"],
  "thirsty": ["Cn3","EOw","Cn2"],
  "thirteen": ["DcY","DcX"],
  "thirty": ["Dcf","DcZ"],
  "thirty eight": ["Dca"],
  "thirty five": ["Dcb"],
  "thirty four": ["Dcc"],
  "thirty nine": ["Dcd"],
  "thirty one": ["Dce"],
  "thirty seven": ["Dcg"],
  "thirty six": ["Dch"],
  "thirty thousand": ["Dci"],
  "thirty three": ["Dcj"],
  "thirty two": ["Dck"],
  "this": ["E4N"],
  "thorn": ["Cn4","Cn5"],
  "thorns": ["Cn6"],
  "thought": ["EUS"],
  "thoughtful": ["DvT"],
  "three": ["Dcn","Dcl"],
  "three hundred": ["Dcm"],
  "three o'clock": ["DeZ","Efg"],
  "three thousand": ["Dco"],
  "threw away": ["ETR"],
  "threw away a bottle": ["ETR"],
  "throat": ["DvU"],
  "throne": ["Cn9","Cn7","Cn8"],
  "throw": ["DnK","Ebl","CoC","CoA"],
  "throw a ball": ["DnK","Ebl","CoB"],
  "throw away": ["DnM","DnL","EZ4","Ebm"],
  "throw away a bottle": ["Ebm","DnL"],
  "throw away threw away": ["DnM"],
  "throw away trash": ["EZ4","DnM"],
  "throw threw": ["DnK","DnL"],
  "throwing": ["DnK","Ebl"],
  "throwing a ball": ["DnK","Ebl"],
  "throwing away": ["Ebm","DnL","DnM"],
  "throwing away a bottle": ["Ebm","DnL"],
  "throwing away trash": ["DnM"],
  "thumb": ["DOq","CoF","D6u","CoE","CoD"],
  "thunder": ["CoH"],
  "thunder and lightning": ["CoG"],
  "thunderstorm": ["DvV"],
  "Thursday": ["DOt","DOr","DOs"],
  "tic tac toe": ["CoQ","CoR"],
  "tick": ["CoJ","CoI","CoP"],
  "ticket": ["DOu","CoM","CoO","CoN","D6v","CoL","CoK"],
  "tickets": ["DvW"],
  "tidier": ["ESL","DOv"],
  "tidy": ["DnO","DnN","CoT","EZ5","EOz","CoS","CoU"],
  "tidy hotel rooms": ["EOy"],
  "tidy my room": ["DvX"],
  "tidy the bed": ["DnN","EZ5"],
  "tidy the room": ["DnO"],
  "tidy tidied": ["DnN","DnO"],
  "tidy up": ["DnP","EO0"],
  "tidy up tidied up": ["DnP"],
  "tidying": ["DnO","DnN"],
  "tidying the bed": ["DnN"],
  "tidying the room": ["DnO"],
  "tidying up": ["DnP"],
  "tie": ["DOw","CoV","CoW","D6w","DnR","CoX","CoY","Ec0","EZ6","DnS","DnQ"],
  "tie her shoes": ["DnQ"],
  "tie shoes": ["Ec0"],
  "tie tied": ["EVG","DnQ","DnR","DnS"],
  "tie your shoe": ["EZ6","DnS"],
  "tie your shoes": ["CoZ"],
  "tied": ["EVG"],
  "tied my laces": ["EVG"],
  "tiger": ["DOx","D6x","Cob","Cod","Coe","Coc","Coa"],
  "tigers": ["Cog","Cof"],
  "tigers are dangerous": ["EhU"],
  "tight": ["DOz"],
  "tighter": ["DOy"],
  "timber": ["Coj"],
  "time": ["E4O"],
  "time is money": ["EO3"],
  "timetable": ["Cok"],
  "timid": ["E4P"],
  "tin": ["Col"],
  "tiny": ["EO4"],
  "tip": ["E4Q"],
  "tire": ["DvY","Cur","Cus","Cut"],
  "tired": ["DO0","Con","EiF","Com","EO5","EiE"],
  "tiring": ["E4R"],
  "tissue": ["Coo"],
  "tissues": ["DO1","D6y"],
  "titanic": ["Coq","Cop"],
  "to play": ["E4V"],
  "toad": ["Cou","Cos","Cor","Cot"],
  "toads": ["Cow","Cov"],
  "toast": ["Co5","Cox","EhB","DO3","Coy","Coz"],
  "toaster": ["DO2","D6z","Co3","Co2","Co0","Co1"],
  "today": ["E4S"],
  "toe": ["DO6"],
  "toenail": ["DO4"],
  "toenails": ["DO5"],
  "toes": ["DO7","D60","Co9","Co8","Co6","Co7"],
  "tofu": ["CpC","CpB","CpA"],
  "together": ["CpD","CpE"],
  "toil": ["CpO"],
  "toilet": ["DO9","CpG","CpH","D62","CpN","CpF"],
  "toilet paper": ["DO8","CpM","D61","CpI","CpL","CpJ"],
  "told": ["ETS"],
  "told her something": ["ETS"],
  "toll": ["E4T"],
  "tomato": ["DPB","CpQ","EhC","CpY","CpP"],
  "tomato pasta": ["CpW","CpX"],
  "tomato sauce": ["Cpb","Cpa"],
  "tomato soup": ["Cpe"],
  "tomatoes": ["DPA","CpR","CpV","D63","CpT","CpU","CpS"],
  "tomb": ["Cpg","Cpf"],
  "tomorrow": ["E4U"],
  "tongue": ["DPC","D64","Cpj","Cpk","Cph"],
  "too big": ["EhE"],
  "too bright": ["EhI"],
  "too cold": ["EhP","EhQ"],
  "too fast": ["Ehd"],
  "too fat": ["Ehe"],
  "too heavy": ["Ehl"],
  "too large": ["EhE"],
  "too small": ["Eh5","Eh6"],
  "too tall": ["EiD"],
  "took": ["EVH"],
  "took a pizza slice": ["EVH"],
  "tool": ["Cpo"],
  "toolbox": ["Cpm","Cpn","Cpl"],
  "tools": ["Cpr","Cps","Cpp","Cpq"],
  "tooth": ["Cp4","Cpt","Cpu"],
  "toothache": ["Cpv","Cpw"],
  "toothbrush": ["DPD","Cpy","D65","Cp0","Cpx","Cpz"],
  "toothpaste": ["DPE","Cp3","Cp2","Cp1","D66"],
  "top": ["Ddf"],
  "top up": ["E4W"],
  "torch": ["Cp8","Cp5","Cp7"],
  "tore": ["EVI"],
  "tore some money": ["EVI"],
  "tornado": ["Cp9","DPF","CqA","CqB","D67"],
  "tortoise": ["DPG","CqF","D68","CqC","CqG","CqD","CqE"],
  "toucan": ["CqJ","CqI","CqH"],
  "touch": ["CqM","DnT","CqL","CqK","EZ7"],
  "touch touched": ["DnT"],
  "touch your toes": ["DnT","EZ7"],
  "touching": ["DnT"],
  "touching your toes": ["DnT"],
  "tour": ["DvZ"],
  "tour bus": ["CqN"],
  "tour guide": ["DPH","CqQ","DPI","EPA"],
  "tourist": ["CqS","CqR"],
  "towel": ["DPJ","DPK","CqV","D7A","CqT","CqU"],
  "towels": ["CqW","CqY","CqZ"],
  "tower": ["Cqc","Cqb","Cqa"],
  "town": ["Cqi","Cqd","Cqe"],
  "town hall": ["Cqf","Cqg"],
  "town house": ["Dva"],
  "town square": ["Cqj","Cql","Cqk"],
  "toxic waste": ["Cqm"],
  "toy": ["Cqo","Cqu","Cqp"],
  "toy box": ["Cqq","Cqr"],
  "toy car": ["Cqs","Cqt"],
  "toy shop": ["Cqy","Cqx"],
  "toy soldier": ["Cqz","Cq0"],
  "toy soldiers": ["Cq1"],
  "toy store": ["Cq7","Cq6","Cq8"],
  "toy train": ["CrA","CrB","Cq9"],
  "toys": ["Cq5","Cqw","Cqv"],
  "trachea": ["CrC"],
  "track": ["CrD","CrE"],
  "tracks": ["CrG"],
  "tracksuit": ["DPL","CrJ","D7B","CrH","CrI"],
  "tractor": ["DPM","CrN","CrO","CrK","CrL","D7C","CrM"],
  "trade": ["E4X"],
  "tradition": ["Dvb"],
  "traditional": ["E4Y"],
  "traffic": ["Dvc"],
  "traffic cone": ["DPN"],
  "traffic jam": ["CrR","CrP","CrQ"],
  "traffic light": ["DPO","D7E","CrS","CrU","CrT"],
  "traffic lights": ["CrW","CrX","Crb","CrY","CrZ","Cra"],
  "trail": ["Dvd"],
  "train": ["DPP","Cri","Crd","D7F","Crc","Cre"],
  "train people": ["EPC"],
  "train station": ["Crj","DPQ","Crk","D7G","Crm","Crl","Crn"],
  "trainer": ["Crf"],
  "trainers": ["Crh","Crg"],
  "tram": ["Cro","Crq","Crp"],
  "trampoline": ["Crr","Crt","Cru","Crs"],
  "transform": ["DYw"],
  "translate": ["DnU","EZ8"],
  "translate chinese to english": ["EZ8"],
  "translate translated": ["DnU"],
  "translating": ["DnU"],
  "translator": ["DPR","DPS"],
  "trap": ["Crx","Crv"],
  "trapezium": ["Crw"],
  "trash": ["Cr7","Cr0","Cry","Crz"],
  "trash can": ["DPT","Cr1","Cr2","Cr5","Cr3","D7H"],
  "trash collection": ["Cr6"],
  "travel": ["CsA"],
  "travel agent": ["DPV","EPG","EPF"],
  "traveling": ["Cr8","Cr9"],
  "travelling": ["Cr9","Cr8"],
  "travels": ["CsB","CsC"],
  "tray": ["DPW","CsD","D7I","CsG","CsE","CsH","CsF"],
  "treadmill": ["CsL","CsJ"],
  "treasure": ["CsM","CsP","CsN"],
  "tree": ["DPX","Csa","D7J","CsT","CsV","CsQ","CsR","EiG","CsS","CsU"],
  "tree hollow": ["E4Z"],
  "tree house": ["CsW","CsY","CsX","CsZ"],
  "trees": ["Csi","Csb","Csg","Csc","Csd","Csf","Csh"],
  "trekking": ["Csl","Csk"],
  "trench": ["Csn","Css"],
  "trench coat": ["Cso","Csp","Csq","Csr"],
  "triangle": ["Csw","Csv"],
  "tribe": ["Csy","Csx"],
  "trick": ["E4a"],
  "trick or treat": ["Dve"],
  "trickortreaters": ["EPH"],
  "tried": ["EUT"],
  "tried on a dress": ["EUT"],
  "Trinidad and Tobago": ["Cs2"],
  "trio": ["Cs4","Cs3"],
  "trip": ["Cs7","Cs6","Cs5"],
  "troll": ["Cs8","Cs9","CtD"],
  "troll face": ["CtC"],
  "trolley": ["CtA","CtB"],
  "trophy": ["CtI","CtF","CtE","CtH","CtG"],
  "tropical": ["CtK"],
  "tropical fish": ["CtM"],
  "trousers": ["DPZ","CtQ","DPY","CtP","CtR","CtO","CtS"],
  "truck": ["DPc","CtW","D7L","CtT","CtY","CtV","CtU"],
  "truck driver": ["DPb","EPJ"],
  "trumpet": ["DPd","Ctd","Ctc","D7M","Cta","CtZ"],
  "trunk": ["DPe","Cte","Ctf"],
  "trust": ["Ctg"],
  "truth": ["E4b"],
  "try": ["Ecx"],
  "try on": ["DnV","EPK"],
  "try on a dress": ["Ecx"],
  "try on tried on": ["DnV"],
  "try tried": ["EUT"],
  "trying": ["Ecx"],
  "trying on": ["DnV"],
  "tshirt": ["DPg","Cto","D7N","Ctm","DPf","Ctk","Cti"],
  "tsunami": ["Ctq","Cts","Ctp","Ctr"],
  "tub": ["Ctz","Ctu","Ctt"],
  "tuba": ["Ctv","Ctw","Cty"],
  "tube": ["Dvf"],
  "Tuesday": ["DPj","DPh","DPi"],
  "tuk tuk": ["E4d"],
  "tulip": ["Ct2","Ct1"],
  "tulips": ["Ct5","Ct3"],
  "tummy": ["E4e"],
  "tuna": ["DPk","Ct9","Ct8","Ct6","Ct7"],
  "tundra": ["E4f"],
  "tune": ["CuA"],
  "tunnel": ["DPl","D7O","CuE","CuB","CuD"],
  "Turkey": ["DPn","CuK","EPM","CuF","D7P","CuG"],
  "turkey": ["CuH","CuI","CuJ","EiH","EPL"],
  "Turkey flag": ["DPm"],
  "Turkish": ["DPo","EeW"],
  "turn down": ["DnW","EPN","Ecy"],
  "turn down cake": ["Ecy","DnW"],
  "turn down turned down": ["DnW"],
  "turn into": ["DnX"],
  "turn into turned into": ["DnX"],
  "turn left": ["E4g"],
  "turn off": ["DnY","EZ9","EPP"],
  "turn off the light": ["DnY","EZ9"],
  "turn off turned off": ["DnY"],
  "turn on": ["Dna","DnZ","Ecz","EaA","Dnb","EPQ","Ebn"],
  "turn on a TV": ["DnZ"],
  "turn on the AC": ["Dnb","EaA"],
  "turn on the light": ["Ecz"],
  "turn on the tv": ["Ebn"],
  "turn on turned on": ["DnZ","Dna","Dnb"],
  "turn over": ["Dnc","EPR"],
  "turn over turned over": ["Dnc"],
  "turn right": ["E4h"],
  "turned on": ["EUU"],
  "turned on a light": ["EUU"],
  "turning down": ["Ecy","DnW"],
  "turning down cake": ["DnW","Ecy"],
  "turning into": ["DnX"],
  "turning off": ["DnY"],
  "turning off the light": ["DnY"],
  "turning on": ["Ecz","Ebn","Dna","DnZ","Dnb"],
  "turning on a TV": ["DnZ"],
  "turning on the AC": ["Dnb"],
  "turning over": ["Dnc"],
  "turquoise": ["DPp"],
  "turtle": ["CuQ","DPq","CuL","D7Q","CuN","CuM"],
  "turtleneck": ["CuP"],
  "turtlenecked": ["CuO"],
  "turtles": ["CuR"],
  "tusk": ["CuS","CuT"],
  "tutor": ["DPr","Dnd","DPs","EaB"],
  "tutor a student": ["EaB"],
  "tutor tutored": ["Dnd"],
  "tutoring": ["Dnd"],
  "Tuvalu": ["CuW"],
  "tv": ["DPt","D7S"],
  "TV presenter": ["DPv","DPu"],
  "twelve": ["Dcr","Dcp"],
  "twelve hundred": ["Dcq"],
  "twenty": ["Dcy","Dcs"],
  "twenty eight": ["Dct"],
  "twenty five": ["Dcu"],
  "twenty five past eleven": ["Efh","Dea"],
  "twenty five past six": ["Deb"],
  "twenty five past ten": ["Dec"],
  "twenty five to ten": ["Ded","Efi"],
  "twenty four": ["Dcv"],
  "twenty nine": ["Dcw"],
  "twenty one": ["Dcx"],
  "twenty past two": ["Dee","Efj"],
  "twenty seven": ["Dcz"],
  "twenty six": ["Dc0"],
  "twenty thousand": ["Dc1"],
  "twenty three": ["Dc2"],
  "twenty to four": ["Def","Efk"],
  "twenty two": ["Dc3"],
  "twig": ["Cua","CuX","CuY"],
  "twin": ["Cuc"],
  "twin bed": ["Cub"],
  "twin room": ["Cud"],
  "twin sister": ["DZh","EPW"],
  "twins": ["Cue","Cui","Cuf","Cuh","Cug"],
  "twinsister": ["EPW"],
  "twisted": ["E4i"],
  "two": ["Dc6","Dc4"],
  "two hundred": ["Dc5"],
  "two o'clock": ["Deg"],
  "two thousand": ["Dc7"],
  "tying": ["DnR","DnQ","DnS"],
  "tying her shoes": ["DnQ"],
  "tying your shoe": ["DnS"],
  "type": ["Dng","Dne","Dnf","Ebo","EaC","Cul"],
  "type on a keyboard": ["EaC"],
  "type typed": ["EVJ","Dne","Dnf","Dng"],
  "typed": ["EVJ"],
  "typewriter": ["Cum","Cun"],
  "typhoon": ["Cup"],
  "typing": ["Dng","Dne","Ebo","Dnf"],
  "typist": ["Cuq"],
  "tyre": ["Cut","DvY","Cur","Cus"],
  "u": ["DaP","DaQ"],
  "u turn": ["E4n"],
  "ufo": ["Cuv","Cuw"],
  "uglier": ["DPw"],
  "ugly": ["Cuz","EPX","DPx","Cuy","Cux"],
  "ukelele": ["Cu3","Cu2"],
  "Ukraine": ["Cu6","Cu4","Cu5"],
  "uluru": ["Cu8","Cu7"],
  "umbrella": ["Cu9","DPy","D7T","DPz","CvA"],
  "umpire": ["CvB"],
  "uncle": ["DZi","EPZ"],
  "under": ["Ddg","Ddh","Ef2","Ef3","Ddi"],
  "under the bridge": ["E4j"],
  "under the chair": ["Ef2"],
  "under the sofa": ["Ef3"],
  "under the water": ["E4k"],
  "under the weather": ["EPa","EPb","EPc"],
  "underground": ["Dvg"],
  "understand": ["Dvh"],
  "underwater": ["CvC"],
  "unfriendly": ["EPd"],
  "unhappy": ["Dvi","Eh1","EPe","Eh2"],
  "unhealthy": ["CvE","EPf","CvD"],
  "unicorn": ["CvH","CvF","CvG","CvI"],
  "uniform": ["CvL","CvK","CvM","CvJ"],
  "United Kingdom": ["CvQ","CvN","EPg","CvO"],
  "United States": ["CvU","CvR","EPk","CvT","DwN"],
  "universe": ["CvV","CvW","CvX"],
  "university": ["CvY","Cva","CvZ"],
  "university lecturer": ["DP1","EPi","EPh","DP0"],
  "unload": ["Cvb"],
  "untidy": ["Cvc"],
  "unusual": ["Dvj"],
  "up": ["Dvl","Dvk"],
  "upload": ["Cve","Cvd"],
  "upset": ["Cvf","EPj"],
  "upside down": ["Cvg","Cvh","EiI","DP2"],
  "upstairs": ["Cvi"],
  "uranus": ["Cvj"],
  "USA": ["AEp","EPk","AEV","DwN","C4p","AEX","AEY","AEZ"],
  "usa dollar": ["Cvk","Cvl"],
  "USA flag": ["DP3"],
  "usb stick": ["DP4","Cvm","D7U","Cvn"],
  "use": ["Dnm","Dnh","Dni","Ec1","Dnl","Ebq","Ebp","EaG","EaD","Dnj","EaF"],
  "use a computer": ["Dnh","EPl","Ec1"],
  "use a hairdryer": ["EaD"],
  "use a key": ["DP6"],
  "use a laptop": ["EPm"],
  "use a microwave": ["DP7"],
  "use a mirror": ["DP8"],
  "use a pen": ["DP9"],
  "use a phone": ["Dni","DQA","Ebq"],
  "use a ruler": ["DQB"],
  "use a spoon": ["DQC"],
  "use a tablet": ["Ebp","Dnj"],
  "use a tissue": ["DQD"],
  "use a wheelchair": ["EaF","Dnk"],
  "use chopsticks": ["Dnl","DQE","EaG"],
  "use scissors": ["DQF"],
  "use the computer": ["E4m"],
  "use the Internet": ["Dnn"],
  "use used": ["Dnh","ETT","EVx","Dni","Dnj","Dnm"],
  "used": ["EVx","ETT"],
  "used chopsticks": ["EVx"],
  "used his phone": ["ETT"],
  "useful": ["Dvm"],
  "useless": ["E4l"],
  "using": ["Ebp","Ec1","Ebq","Dnm","Dnh","Dni","Dnj","Dnl"],
  "using a computer": ["Dnh","Ec1"],
  "using a phone": ["Dni","Ebq"],
  "using a tablet": ["Ebp","Dnj"],
  "using a wheelchair": ["Dnk"],
  "using chopsticks": ["Dnl"],
  "using the Internet": ["Dnn"],
  "v": ["DaR","DaS"],
  "vacation": ["Cvo"],
  "vacuum": ["Cvq"],
  "vacuum cleaner": ["DQG","Cvp","D7V"],
  "valley": ["DYx","Cvr","Cvt","Cvs"],
  "valuable": ["DYy","Cvu"],
  "valve": ["DYz","Cvw","Cvv"],
  "vampire": ["Cvy","Cvx","Cvz","EPo"],
  "van": ["Cv3","DQH","Cv0","D7W"],
  "vandalism": ["Cv1","Cv2"],
  "vanilla": ["Dvn"],
  "variety": ["E4o"],
  "various": ["E4p"],
  "vase": ["DQI","Cv8","Cv6","Cv7","Cv5","Cv4","D7X"],
  "vast": ["CwA"],
  "Vatican city": ["CwB"],
  "vegetable": ["CwF","CwC"],
  "vegetable garden": ["CwD","CwE"],
  "vegetables": ["DQJ","EPp","CwK","CwH","CwG","CwI","CwJ"],
  "vehicle": ["E4q"],
  "veins": ["CwL"],
  "velocity": ["CwM"],
  "vending machine": ["E4r"],
  "vendor": ["CwN","CwO"],
  "Venezuela": ["CwR","CwP","EPq"],
  "venus": ["CwS"],
  "vermillion": ["DQK"],
  "vertical": ["CwT"],
  "vessel": ["CwU"],
  "vest": ["CwY","CwZ","DQL","CwX","D7Y"],
  "vet": ["DQM","DQN","Cwc","EPr","EPs","D7Z","Cwa"],
  "veterinarian": ["Cwb"],
  "video": ["Cwd"],
  "video game": ["E4s"],
  "video games": ["E4t"],
  "Vietnam": ["Cwj","Cwe","EPt","Cwh","Cwg"],
  "Vietnam flag": ["DQO"],
  "view": ["Cwk"],
  "village": ["Cwm","Cwn","Cwl"],
  "villain": ["Cwo"],
  "vinegar": ["Cwp"],
  "violet": ["DQP"],
  "violin": ["DQQ","Cww","D7a","Cwt","Cwr","Cwq","Cws"],
  "violinist": ["Cwv"],
  "virus": ["E4u"],
  "visit": ["Dno","Ec2"],
  "visit grandparents": ["Dno","Ec2"],
  "visit my grandma": ["E4v"],
  "visit visited": ["Dno","EWD","EUV"],
  "visited": ["EUV","EWD"],
  "visited france": ["EWD"],
  "visited her grandparents": ["EUV"],
  "visiting": ["Dno","Ec2"],
  "visiting grandparents": ["Dno","Ec2"],
  "visitor": ["E4w"],
  "voice": ["E4x"],
  "volcano": ["DQT","Cw2","Cwx","Cwz","Cw0","D7b","DQR","Cw1","Cwy","DQS"],
  "volleyball": ["DQU","Cw3","Cw7","Cw6","D7c","Cw5","Cw4"],
  "volunteer": ["Dvo"],
  "voting": ["Dvp"],
  "voucher": ["Cw8"],
  "voyage": ["Dvq"],
  "vulture": ["CxC","Cw9"],
  "w": ["DaT","DaU"],
  "waffle": ["EhD"],
  "waffles": ["DQV","CxD","D7d","CxE","CxF"],
  "wagon": ["CxI","CxG"],
  "wait": ["Dns","EaH","Edm","Dnr","Dnp","CxJ","CxL","CxQ","CxK"],
  "wait at the lights": ["Dnp"],
  "wait for": ["Dnq"],
  "wait for a bus": ["Dnq","Edm","EaH"],
  "wait for a train": ["Dnr"],
  "wait in line": ["CxP"],
  "wait waited": ["Dns","EWS","EVC","Dnp","Dnq","Dnr"],
  "waited": ["EWS","EVC"],
  "waited for a bus": ["EVC"],
  "waiter": ["DQX","EPv","DQW","CxN","EPu","CxO","CxM","D7e"],
  "waiting": ["Dns","Edm","Dnr","Dnp"],
  "waiting at the lights": ["Dnp"],
  "waiting for": ["Dnq"],
  "waiting for a bus": ["Dnq","Edm"],
  "waiting for a train": ["Dnr"],
  "waiting room": ["E4y"],
  "waitress": ["CxT","CxS","CxR"],
  "wake up": ["Dnt","Dnu","Ec3","CxV","CxU","EPx","EPw"],
  "wake up woke up": ["Dnt","Dnu"],
  "waking up": ["Dnu","Dnt","Ec3"],
  "Wales": ["EPy"],
  "walk": ["Dnx","Dny","Dnv","EP0","CxX","Ec4","CxW","Dnw","EaK","Cxc"],
  "walk a dog": ["Dnv"],
  "walk in the countryside": ["EPz"],
  "walk in the park": ["Dnw"],
  "walk slowly": ["ERV"],
  "walk the": ["Ec4"],
  "walk the dog": ["Cxf","Cxd","Ec4","EaK","Cxe","Cxg"],
  "walk to class": ["Dny"],
  "walk to school": ["Dvr"],
  "walk walked": ["ETU","Dnx","Dnv","Dny","Dnw"],
  "walked": ["ETU"],
  "walking": ["Dnx","Dnv","Ec4","Dnw","Dny","Cxa","CxY","CxZ"],
  "walking a dog": ["Dnv"],
  "walking in the park": ["Dnw"],
  "walking stick": ["D7f","DQY"],
  "walking to class": ["Dny"],
  "wall": ["DQa","Cxh","Cxo","D7h","Cxi"],
  "wallet": ["DQZ","Cxj","D7g","Cxl","Cxn","Cxk","Cxm"],
  "walnut": ["D7i"],
  "walnuts": ["Cxs","Cxq"],
  "walrus": ["Cxt","Cxv","Cxu"],
  "waltz": ["Cxw"],
  "wand": ["Cxx"],
  "want": ["E4z"],
  "war": ["Dvs"],
  "wardrobe": ["Cx0","Cxz","Cxy"],
  "warm": ["Cx1","Cx2","EP2"],
  "warmer": ["DQb"],
  "was": ["EUW"],
  "was sad": ["EUW"],
  "wash": ["Dn2","Dnz","Dn4","Dn7","Dn0","Ebt","Cx8","Ebr","Dn1","Dn6","Ebs","Cx3","EaL","Dn5","EaN","EaM","Dn3"],
  "wash dishes": ["Dnz","Dn0"],
  "wash face": ["Dvt","Ebr"],
  "wash hands": ["Ebs"],
  "wash his face": ["Dn1"],
  "wash my face": ["E40"],
  "wash my hands": ["E41"],
  "wash the car": ["CyB"],
  "wash the dishes": ["CyC","Dn3","EaL","Ebt","CyD"],
  "wash up": ["Dvu"],
  "wash washed": ["Dnz","Dn2","EVO","EVN","EWE","ETV","Dn0","Dn1"],
  "wash your car": ["Dn4"],
  "wash your face": ["Dn5","EaM","EP4"],
  "wash your hair": ["Dn6","EaN"],
  "wash your hands": ["Dn7"],
  "washbasin": ["Cx4"],
  "washed": ["EWE","EVO","EVN","ETV"],
  "washed her hair": ["EWE"],
  "washed his car": ["EVN"],
  "washed his hands": ["ETV"],
  "washed the dishes": ["EVO"],
  "washing": ["Dn2","Dn4","Dn0","Dn7","Ebt","Ebs","Ebr","Dnz","Dn1","Dn3","Dn5","Dn6"],
  "washing dishes": ["Dn0","Dnz"],
  "washing his face": ["Dn1"],
  "washing machine": ["DQc","Cx6","D7j","Cx7"],
  "washing the dishes": ["Dn3","Ebt"],
  "washing your car": ["Dn4"],
  "washing your face": ["Dn5"],
  "washing your hair": ["Dn6"],
  "washing your hands": ["Dn7"],
  "Washington": ["EP3"],
  "washroom": ["CyA","Cx9"],
  "wasp": ["CyF","CyH","CyE"],
  "waste": ["CyI","CyM","CyJ"],
  "waste basket": ["CyK","CyL"],
  "wastebasket": ["E42"],
  "watch": ["DQe","Dn9","Dn8","DQd","EaO","D7k","D7l","CyP","CyN","CyU","Edn","DoA","CyO"],
  "watch a film": ["E43"],
  "watch a movie": ["E44"],
  "watch movies": ["Dvv"],
  "watch strap": ["CyV","CyW"],
  "watch TV": ["Dn9","EaO","DoA","Edn","CyX","CyY"],
  "watch tv": ["CyX","CyY","Dn9","EaO","Edn","DoA"],
  "watch watched": ["EVh","DoA","Dn8","Dn9","EVD"],
  "watched": ["EVh","EVD"],
  "watched tv": ["EVh","EVD"],
  "watches": ["CyQ"],
  "watching": ["Dn9","Dn8","DoA","Edn"],
  "watching TV": ["Dn9","DoA","Edn","CyT","CyS"],
  "watching tv": ["CyT","CyS","DoA","Dn9","Edn"],
  "water": ["DQh","Cya","D7o","CyZ","DoB","CzA","EaP"],
  "water balloon": ["Cyb"],
  "water bottle": ["Cyc","Cye","Cyd"],
  "water bucket": ["Cyf"],
  "water cycle": ["DY0"],
  "water dispenser": ["DQf","D7m"],
  "water lily": ["Cyu"],
  "water park": ["Cy3","DY1","Cy8","Cy5"],
  "water plants": ["EaP"],
  "water shortage": ["DY2","CzB"],
  "water ski": ["Dvw"],
  "water skiing": ["CzF","CzH","CzE"],
  "water slide": ["CzJ","CzK"],
  "water the flowers": ["E45"],
  "water the lawn": ["CzL","CzM"],
  "water the plants": ["E46"],
  "water vegetables": ["DoB"],
  "water watered": ["DoB"],
  "waterfall": ["Cyj","Cyk","Cym","Cyl","Cyi"],
  "waterfalls": ["Cyn"],
  "watering": ["DoB","Cyt"],
  "watering can": ["Cyp","Cys","Cyr"],
  "watering vegetables": ["DoB"],
  "watermelon": ["DQg","Cyy","Cyx","D7n","Cy1","Cy0","Cyz","Cyw"],
  "watermelons": ["Cy2"],
  "waterpark": ["Cy6","Cy9","Cy7"],
  "waterwheel": ["Dvx"],
  "wave": ["CzQ","DoE","DoD","CzO","Ec5","CzP","EaQ","CzN","DoC"],
  "wave her hand": ["DoD"],
  "wave to a friend": ["EaQ"],
  "wave waved": ["ETW","DoC","DoD","DoE"],
  "waved": ["ETW"],
  "waves": ["CzR"],
  "waving": ["DoE","Ec5","DoC","DoD"],
  "waving her hand": ["DoD"],
  "wavy": ["Dvy"],
  "wavy hair": ["CzS","CzT"],
  "wax": ["CzU"],
  "way": ["E47"],
  "we": ["E5D"],
  "weak": ["CzV","EP7","CzW"],
  "weaker": ["DQi"],
  "wear": ["DoF","DoJ","EaS","DoI","DoG","EaR","DoH"],
  "wear a black dress": ["Ef4"],
  "wear a blue hat": ["Ef5"],
  "wear a brown belt": ["Ef6"],
  "wear a brown coat": ["Ef7"],
  "wear a coat": ["DoF"],
  "wear a costume": ["EP8"],
  "wear a green scarf": ["Ef8"],
  "wear a mask": ["DoG","DoH","EaR"],
  "wear a pink shirt": ["EgA"],
  "wear a raincoat": ["DoI","EaS"],
  "wear a red jacket": ["EgB"],
  "wear a yellow skirt": ["EgC"],
  "wear a yellow tie": ["EgD"],
  "wear an orange shirt": ["Ef9"],
  "wear black gloves": ["EgE"],
  "wear blue coats": ["EgF"],
  "wear blue pants": ["EgG"],
  "wear brown pants": ["EgH"],
  "wear glasses": ["DoJ"],
  "wear green shorts": ["EgI"],
  "wear orange hats": ["EgJ"],
  "wear purple socks": ["EgK"],
  "wear red glasses": ["EgL"],
  "wear red shoes": ["EgM"],
  "wear wore": ["DoI","DoJ","DoF","EUb","DoG"],
  "wear worn": ["EWU","EWF"],
  "wear yellow shorts": ["EgN"],
  "wearing": ["DoF","DoI","DoJ","DoG","DoH"],
  "wearing a coat": ["DoF"],
  "wearing a mask": ["DoG","DoH"],
  "wearing a raincoat": ["DoI"],
  "wearing glasses": ["DoJ"],
  "weather": ["CzX","DY3","CzY"],
  "weather vane": ["CzZ"],
  "web": ["Cza","Czg"],
  "web designer": ["Czd"],
  "web developer": ["DQj"],
  "webbed feet": ["E48"],
  "webcam": ["Czc","Czb"],
  "website": ["E49"],
  "wedding": ["Czm","Czh","Czl","Czi","Czj","Czk"],
  "Wednesday": ["DQn","DQl","DQm"],
  "weed": ["Czn","Czo"],
  "weeds": ["Czs","Czr","Czp"],
  "week": ["E5B"],
  "weekend": ["E5A"],
  "weep": ["Czt"],
  "weigh": ["Czu"],
  "weight": ["Dvz"],
  "weight lifting": ["Czv","Czw"],
  "weight scale": ["Czy","Czx"],
  "weightlifting": ["DQo"],
  "weights": ["DQp"],
  "weird": ["E5C"],
  "welcome": ["DY4"],
  "well": ["Cz0","ERE","DY6","Czz"],
  "well built": ["DY5"],
  "went": ["EVE"],
  "went to school": ["EVE"],
  "were": ["EVF"],
  "were happy": ["EVF"],
  "werewolf": ["Cz3","Cz4","Cz2","Cz1"],
  "western": ["Cz6","Cz7"],
  "wet": ["DQs","DQr","DQq","Cz8","EQD","EiJ","C0E"],
  "wet dog": ["EiJ"],
  "wetland": ["C0C","C0A","C0D","C0B"],
  "wetter": ["DQt"],
  "whale": ["DQu","D7q","C0I","C0L","C0F","C0H","C0K","C0G","C0J"],
  "what": ["Ddt","Dds","Ddr"],
  "what color": ["Ddq"],
  "what color is the bike": ["EQE","Ddq"],
  "what colour": ["Ddq"],
  "what colour is the bike": ["EQE","Ddq"],
  "what do you like to drink": ["EQF"],
  "what do you like to eat": ["EQG"],
  "what is the time": ["Ddr"],
  "what is the weather like": ["EQH"],
  "what is your favorite country": ["EQI"],
  "what is your favourite country": ["EQI"],
  "what is your phone number": ["Dds"],
  "what phone do you have": ["Ddt"],
  "what sport do you like": ["EQL"],
  "what time": ["Ddv"],
  "what time do you go to bed": ["EQM"],
  "what time do you wake up": ["Ddv"],
  "what's the weather like": ["Ddu"],
  "wheat": ["C0M","C0O","C0P","C0Q"],
  "wheel": ["C0g","C0T","C0R","C0U","C0V","C0S"],
  "wheelbarrow": ["DQv","C0Y","C0a","C0Z"],
  "wheelchair": ["DQw","C0e","D7s","C0b","C0d"],
  "when": ["Ddw"],
  "when do you brush your teeth": ["EQN"],
  "When do you go to bed": ["Ddw"],
  "when do you study": ["EQO"],
  "when do you take a shower": ["EQP"],
  "when do you wake up": ["EQQ"],
  "when is Christmas": ["EQR"],
  "when is lunch": ["EQS"],
  "when is the meeting": ["EQT"],
  "when is your exam": ["EQU"],
  "where": ["Ddx","Ddz","Ddy","Dd3"],
  "where are you from": ["Ddx","EQV"],
  "where are you going": ["Ddy"],
  "where do you live": ["EQY","Ddz"],
  "where does she come from": ["EQX"],
  "where is he from": ["EQZ"],
  "where is italy": ["EQa"],
  "where is she from": ["Dd0"],
  "where is the bus stop": ["Dd1"],
  "where is the hospital": ["EQc"],
  "where is the remote": ["Dd2"],
  "where is the WC": ["Dd3"],
  "which": ["Dd4"],
  "which donut would you like": ["EQe"],
  "which ice cream would you like": ["EQf"],
  "which team do you like": ["Dd4"],
  "whip": ["C0h"],
  "whisk": ["Dv0"],
  "whiskers": ["C0j","C0i"],
  "whisper": ["C0l","DoK","C0k"],
  "whisper whispered": ["ETX","DoK"],
  "whispered": ["ETX"],
  "whispering": ["DoK"],
  "whistle": ["DQx","D7t","C0m","C0o","C0n"],
  "white": ["DQz"],
  "whiteboard": ["C0s","C0p","DQy","C0t","C0q","C0r","D7u"],
  "who": ["Dd6","Dd5"],
  "who do you love": ["Dd5"],
  "who is playing the violin": ["EQi"],
  "who is she": ["Dd6"],
  "who is the manager": ["EQj"],
  "who is the oldest": ["EQk"],
  "who is the president": ["EQl"],
  "who is your favorite singer": ["EQm"],
  "who is your favourite singer": ["EQm"],
  "who is your friend": ["EQn"],
  "whom": ["E5E"],
  "whose": ["E5F"],
  "why": ["E5G"],
  "wide": ["Dv1"],
  "wider": ["DQ0"],
  "wife": ["DZj","C0x","C0w","C0u","C0v","EQo","EQp"],
  "wifi": ["C01","C0y","C00","C0z"],
  "wig": ["C03","C02"],
  "wild": ["C1C","C04","C05"],
  "wild animals": ["C09","C07","C08","C06"],
  "wildlife": ["C1B","C1A"],
  "win": ["DoM","DoL","C1D","C2F","C1E"],
  "win the cup": ["DoM"],
  "win win won": ["DoM"],
  "win won": ["EWT","EUa","DoL"],
  "wind": ["DQ5","C1G","C1e","D7y","C1F"],
  "wind farm": ["DY7","C1H","C1I"],
  "wind vane": ["DY8"],
  "windmill": ["DQ1","C1J","C1L","C1M"],
  "window": ["DQ4","C1W","D7x","C1N","C1P","C1Q","C1O"],
  "window blind": ["C1R"],
  "window blinds": ["C1U","C1V"],
  "window cleaner": ["DQ3","EQr","EQq","DQ2"],
  "windows": ["C1X","C1d"],
  "windsurf": ["C1g","C1k","C1f"],
  "windsurfing": ["C1h","C1j","C1i"],
  "windy": ["DQ7","EQs","C1o","C1l","C1p","C1n","C1m","DQ6"],
  "wine": ["C1q","C1s","D70","C1v","C1u","C1r","C1t"],
  "wine glass": ["DQ8"],
  "wing": ["C10","C1x","C1z","C1w","C1y"],
  "wings": ["DQ9","D71","C16","C11","C13","C14","C15"],
  "wink": ["C17","DY9","C2A","C2B","C19"],
  "winner": ["DZA","C2D"],
  "winnie the pooh": ["C2E"],
  "winning": ["DoL","DoM"],
  "winning the cup": ["DoM"],
  "winter": ["Dv2","C2J","C2H","C2G","C2I"],
  "wipe": ["DoN","Ec6"],
  "wipe the table": ["DoN","Ec6"],
  "wipe wiped": ["EUX"],
  "wipe wipes": ["DoN"],
  "wiped": ["EUX"],
  "wiped the table": ["EUX"],
  "wiping": ["Ec6","DoN"],
  "wiping the table": ["DoN","Ec6"],
  "wire": ["C2K","C2M","C2L"],
  "wire stripper": ["C2N"],
  "wise": ["Dv3"],
  "wish": ["E5H"],
  "witch": ["C2R","C2Q","C2P","EQu","C2O"],
  "witches": ["EQt"],
  "with": ["Dv4"],
  "withdraw": ["DoO","Ec7"],
  "withdraw money": ["DoO","Ec7"],
  "withdraw withdrew": ["EUY","DoO"],
  "withdrawing": ["Ec7","DoO"],
  "withdrawing money": ["DoO","Ec7"],
  "withdrew": ["EUY"],
  "withdrew money": ["EUY"],
  "wither": ["DZB"],
  "witness": ["E5I"],
  "wizard": ["DZC","C2W","EQv","C2T","C2V","EQw","C2U"],
  "woke up": ["EUZ"],
  "wolf": ["DRA","C2b","C2Y","C2Z","C2X","EQx","D72","C2a"],
  "wolly jumper": ["DZD"],
  "wolves": ["C2f","C2e","C2d"],
  "woman": ["C2m","C2h","C2g","C2k","C2i","C2l","C2j"],
  "women": ["C2q","C2o","C2p","C2n"],
  "won": ["EWT","EUa"],
  "won a prize": ["EUa"],
  "won the cup": ["EWT"],
  "wonderful": ["Dv5"],
  "wood": ["C2s","C2t","C21","C2u","C2r"],
  "wood screw": ["C22","C23","C24"],
  "wooden": ["C2v","C2y","C2w"],
  "wooden paddle": ["C2x"],
  "woodlouse": ["C20"],
  "woods": ["Dv6"],
  "wool": ["C27","C26","C25"],
  "words": ["C28"],
  "wordsheet": ["DZE"],
  "wore": ["EUb"],
  "wore a coat": ["EUb"],
  "work": ["DoQ","DoT","DoP","EaV","C3A","EaU","C3B","EQ2","C3C","EQy","EaT","DoR","C29"],
  "work ": ["EQz"],
  "work happily": ["ERW"],
  "work hard": ["ERX"],
  "work in a clothes store": ["EaT","DoR"],
  "work in an office": ["EaU"],
  "work on a computer": ["EaV"],
  "work out": ["DoS","EQ1"],
  "work out worked out": ["DoS"],
  "work quietly": ["ERY"],
  "work worked": ["DoT","DoP","DoQ","DoR"],
  "worker": ["E5J"],
  "working": ["DoT","DoP","DoQ","DoR"],
  "working in a clothes store": ["DoR"],
  "working out": ["DoS"],
  "world": ["C3D","DZF"],
  "world heritage site": ["E5K"],
  "worldwide": ["E5L"],
  "worm": ["C3E","C3G","C3F"],
  "worn": ["EWU","EWF"],
  "worn a costume": ["EWU"],
  "worn glasses": ["EWF"],
  "worn out": ["Ehr"],
  "worried": ["C3J","C3I","C3H"],
  "worry": ["C3L","C3K"],
  "worse": ["DRB","ERZ"],
  "would you like some fruit": ["EQ3"],
  "wrap": ["DRC"],
  "wrappers": ["DZG"],
  "wreath": ["DZH","EiK","C3N","EQ4","C3M","C3P"],
  "wrench": ["C3T","C3Q"],
  "wrench set": ["C3V"],
  "wrestling": ["C3Y","DRD","C3W","D73"],
  "wrist": ["DRE","D74"],
  "write": ["DoW","DoU","Ec8","DoV","C3Z","C3b","EaY","C3a","DoX","EaX"],
  "write an email": ["Dv7"],
  "write books": ["EQ5"],
  "write computer software": ["EaX"],
  "write different languages": ["EQ6"],
  "write on the board": ["DoV","EaY"],
  "write software": ["DoX"],
  "write wrote": ["EUc","DoU","DoV","DoW"],
  "writer": ["Dv8"],
  "writing": ["DoU","DoW","Ec8","C3c","C3e","DoV","C3d","DoX"],
  "writing on the board": ["DoV"],
  "writing software": ["DoX"],
  "wrong": ["EQ7"],
  "wrote": ["EUc"],
  "x": ["DaV","DaW"],
  "x ray": ["DRF","C3f","C3g","D75"],
  "xylophone": ["C3i","C3h"],
  "y": ["DaY","DaX"],
  "yacht": ["C3m","C3k","C3l","C3j"],
  "yak": ["C3r","C3n","C3p","C3q","C3o"],
  "yam": ["C3s","C3t"],
  "yard": ["C3u","C3w","C3v"],
  "yarn": ["C3z","C3y","C3x"],
  "yawn": ["DoZ","Ebv","C30","C33","C31","DoY","C32"],
  "yawn yawned": ["EUd","DoY","DoZ"],
  "yawned": ["EUd"],
  "yawning": ["DoZ","DoY","Ebv"],
  "year": ["E5M"],
  "yell": ["C34"],
  "yellow": ["DRG"],
  "yellow shorts": ["DRH","EgN"],
  "yellow skirt": ["DRI","EgC"],
  "yellow tie": ["DRJ","EgD"],
  "yes": ["Dv9"],
  "yesterday": ["E5N"],
  "yin and yang": ["C35"],
  "yo yo": ["E5P","DwC"],
  "yoga": ["C4A","C37","C39","C36","C38"],
  "yoghurt": ["DwA"],
  "yogurt": ["DRK","C4B"],
  "yorkshire pudding": ["C4C"],
  "you": ["E5O"],
  "young": ["C4D"],
  "younger": ["DRL"],
  "youtube": ["DwB"],
  "yoyo": ["DwD"],
  "z": ["Daa","DaZ"],
  "zebra": ["DRM","C4J","D76","C4G","C4E","C4F"],
  "zebra crossing": ["C4H","C4I"],
  "zebras": ["C4L","C4K"],
  "zero": ["Dc9","Dc8"],
  "zigzag": ["DwE"],
  "zip": ["DRN","C4N","D77","C4Q"],
  "zipper": ["C4O","C4P"],
  "zombie": ["C4R","C4T","C4S","EQ8"],
  "zoo": ["DRP","D78"],
  "zookeeper": ["DwF"],
  "zoom call": ["DRO"],
  "zucchini": ["C4U","C4V","C4Y","C4X","C4W"]
}